// import React, { useState, useEffect, useMemo, useRef } from 'react';
// import { Pie, Bar, getElementAtEvent } from 'react-chartjs-2';
// import {
//     Chart as ChartJS,
//     CategoryScale,
//     LinearScale,
//     BarElement,
//     Title,
//     Tooltip,
//     Legend,
//     ArcElement
// } from 'chart.js';
// import ChartDataLabels from 'chartjs-plugin-datalabels';
// import './Dashboard.css'; // Renamed CSS import
 
// ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement, ChartDataLabels);
 
// // ====================================================================
// // --- Component for Work Order Table ---
// // ====================================================================
// const FilteredWorkOrderTable = ({ workOrders, apiToken }) => {
//     const [activeTab, setActiveTab] = useState('assets');
//     const [assets, setAssets] = useState([]);
//     const [assetsLoading, setAssetsLoading] = useState(false);
//     const [assetsError, setAssetsError] = useState(null);
 
//     useEffect(() => {
//         const fetchAssets = async () => {
//             if (!workOrders || workOrders.length === 0) {
//                 setAssets([]);
//                 return;
//             }
//             const assetIdSet = new Set(workOrders.map(wo => wo.asset_id).filter(id => id != null));
//             const assetIds = Array.from(assetIdSet);
//             if (assetIds.length === 0) {
//                 setAssets([]);
//                 return;
//             }
           
//             setAssetsLoading(true);
//             setAssetsError(null);
           
//             const ASSET_API_URL = `${process.env.REACT_APP_ASSET_SERVICE_BASE_URL}/api/assets/`;
//             const ASSET_HEADERS = { 'accept': 'application/json', 'Authorization': apiToken };
 
//             try {
//                 const assetPromises = assetIds.map(id =>
//                     fetch(`${ASSET_API_URL}${id}`, { headers: ASSET_HEADERS }).then(res => {
//                         if (!res.ok) {
//                             console.error(`Failed to fetch asset ${id}, status: ${res.status}`);
//                             return null;
//                         }
//                         return res.json();
//                     })
//                 );
//                 const fetchedAssetsResults = await Promise.all(assetPromises);
//                 setAssets(fetchedAssetsResults.filter(asset => asset !== null));
//             } catch (error) {
//                 console.error("Failed to fetch assets:", error);
//                 setAssetsError(error.message);
//             } finally {
//                 setAssetsLoading(false);
//             }
//         };
//         fetchAssets();
//     }, [workOrders, apiToken]);
 
//     const displayedWorkOrders = useMemo(() => {
//         if (!workOrders || !Array.isArray(workOrders)) return [];
//         return [...workOrders].sort((a, b) => new Date(b.add_date) - new Date(a.add_date));
//     }, [workOrders]);
 
//     const formatData = (value) => {
//         if (value === null || typeof value === 'undefined') return 'N/A';
//         if (typeof value === 'boolean') return value ? 'Yes' : 'No';
//         if (typeof value === 'string' && value.includes('T')) {
//             const date = new Date(value);
//             if (!isNaN(date)) return date.toLocaleDateString('en-GB');
//         }
//         return value;
//     };
 
//     const displayColumns = [
//         { header: 'Doc No', key: 'doc_no' }, { header: 'WO No', key: 'wo_no' },
//         { header: 'Status', key: 'wo_open_close' }, { header: 'Total Value', key: 'tot_value' },
//         { header: 'Customer Name', key: 'customer_name' }, { header: 'Customer ID', key: 'cust_id' },
//         { header: 'Project Name', key: 'project_name' }, { header: 'Project ID', key: 'project_id' },
//         { header: 'Sector Name', key: 'sector_name' }, { header: 'Sector ID', key: 'sector' },
//         { header: 'Asset ID', key: 'asset_id' }, { header: 'WO Date', key: 'wo_date' },
//         { header: 'WO Start', key: 'wo_start' }, { header: 'WO End', key: 'wo_end' },
//     ];
 
//     return (
//         <div className="filtered-table-container">
//             <div className="table-header"><h3>All Work Orders</h3></div>
//             <div className="table-controls">
//                 <div className="tabs">
//                     <button className={`tab-btn ${activeTab === 'assets' ? 'active' : ''}`} onClick={() => setActiveTab('assets')}>Assets</button>
//                     <button className={`tab-btn ${activeTab === 'workorder' ? 'active' : ''}`} onClick={() => setActiveTab('workorder')}>Workorder</button>
//                 </div>
//             </div>
//             <div className="table-content-wrapper">
//                 {activeTab === 'workorder' ? (
//                     <>
//                         {displayedWorkOrders.length > 0 ? (
//                             <div className="table-scroll-container">
//                                 <table className="data-table wide-table">
//                                     <thead><tr>{displayColumns.map(col => <th key={col.key}>{col.header}</th>)}</tr></thead>
//                                     <tbody>
//                                         {displayedWorkOrders.map((order, index) => (
//                                             <tr key={`${order.id}-${index}`}>
//                                                 {displayColumns.map(col => (
//                                                     <td key={col.key}>{col.key === 'tot_value' ? parseFloat(order[col.key] || 0).toLocaleString('en-US') : formatData(order[col.key])}</td>
//                                                 ))}
//                                             </tr>
//                                         ))}
//                                     </tbody>
//                                 </table>
//                             </div>
//                         ) : (<p className="no-data-message">No work orders found for the current filter.</p>)}
//                     </>
//                 ) : (
//                     <>
//                         {assetsLoading && <p className="loading-message">Loading Assets...</p>}
//                         {assetsError && <p className="error-message">Error: {assetsError}</p>}
//                         {!assetsLoading && !assetsError && (
//                             <>
//                                 {assets.length > 0 ? (
//                                     <div className="table-scroll-container">
//                                         <table className="data-table wide-table">
//                                             <thead>
//                                                 {/* UPDATED: Added Registration No. column */}
//                                                 <tr><th>Asset Name</th><th>Asset Type</th><th>Capacity (MT)</th><th>Year of Purchase</th><th>Year of Manufacture</th></tr>
//                                             </thead>
//                                             <tbody>
//                                                 {assets.map(asset => {
//                                                     const combinedAssetName = [asset.name, asset.serial_number, asset.asset_code, asset.registration_number].filter(Boolean).join(' | ');
//                                                     return (
//                                                         <tr key={asset.id}>
//                                                             <td>{combinedAssetName || 'N/A'}</td>
//                                                             {/* UPDATED: Added registration_number data cell */}
//                                                             <td>{formatData(asset.asset_type)}</td>
                                                           
                                                           
//                                                             <td>{formatData(asset.capacity_mt)}</td>
//                                                             <td>{formatData(asset.year_of_purchase)}</td>
//                                                             <td>{formatData(asset.year_of_manufacture)}</td>
//                                                         </tr>
//                                                     );
//                                                 })}
//                                             </tbody>
//                                         </table>
//                                     </div>
//                                 ) : (<p className="no-data-message">No assets found for the current work orders.</p>)}
//                             </>
//                         )}
//                     </>
//                 )}
//             </div>
//         </div>
//     );
// };
 
// // ====================================================================
// // --- Component for Asset Availability Table ---
// // ====================================================================
// const AssetAvailabilityTable = ({ workOrders, apiToken }) => {
//     const [combinedAssets, setCombinedAssets] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);
//     const [filterDays, setFilterDays] = useState(null);
//     const [customDays, setCustomDays] = useState('');
 
//     useEffect(() => {
//         const fetchAndCombineData = async () => {
//             setLoading(true);
//             setError(null);
           
//             const workOrderInfoMap = new Map();
//             if (workOrders && Array.isArray(workOrders)) {
//                 workOrders.forEach(wo => {
//                     if (wo.asset_id != null) {
//                         workOrderInfoMap.set(Number(wo.asset_id), { wo_start: wo.wo_start, wo_end: wo.wo_end, wo_no: wo.wo_no });
//                     }
//                 });
//             }
           
//             const ASSET_API_URL = `${process.env.REACT_APP_ASSET_SERVICE_BASE_URL}/api/assets/`;
//             const ASSET_HEADERS = { 'accept': 'application/json', 'Authorization': apiToken };
 
//             try {
//                 const response = await fetch(ASSET_API_URL, { headers: ASSET_HEADERS });
//                 if (!response.ok) {
//                     throw new Error(`Failed to fetch assets, status: ${response.status}`);
//                 }
//                 const allAssets = await response.json();
//                 const activeAssets = allAssets.filter(asset => asset.active === true);
 
//                 const combinedData = activeAssets.map(asset => {
//                     const workOrderInfo = workOrderInfoMap.get(asset.id) || { wo_start: null, wo_end: null, wo_no: null };
//                     return { ...asset, ...workOrderInfo };
//                 });
               
//                 setCombinedAssets(combinedData);
//             } catch (error) {
//                 console.error("Failed to fetch asset data:", error);
//                 setError(error.message);
//             } finally {
//                 setLoading(false);
//             }
//         };
 
//         fetchAndCombineData();
//     }, [workOrders, apiToken]);
 
//     const filteredAssets = useMemo(() => {
//         if (filterDays === null) return combinedAssets;
//         const targetDate = new Date();
//         targetDate.setDate(targetDate.getDate() + filterDays);
//         targetDate.setHours(23, 59, 59, 999);
//         return combinedAssets.filter(asset => {
//             if (!asset.wo_end) return true;
//             const woEndDate = new Date(asset.wo_end);
//             return isNaN(woEndDate.getTime()) || woEndDate <= targetDate;
//         });
//     }, [combinedAssets, filterDays]);
 
//     const formatData = (value) => {
//         if (value === null || typeof value === 'undefined') return 'N/A';
//         if (typeof value === 'boolean') return value ? 'Yes' : 'No';
//         if (typeof value === 'string' && value.includes('T')) {
//             const date = new Date(value);
//             if (!isNaN(date)) return date.toLocaleDateString('en-GB');
//         }
//         return value;
//     };
 
//     const handleCustomFilter = () => {
//         const days = parseInt(customDays, 10);
//         if (days > 0) setFilterDays(days);
//     };
 
//     const clearFilter = () => {
//         setFilterDays(null);
//         setCustomDays('');
//     };
 
//     return (
//         <div className="filtered-table-container">
//             <div className="table-header with-controls">
//                 <h3>Asset Availability</h3>
//                 <div className="availability-filter-controls">
//                     <span>Available In:</span>
//                     {[3, 7, 15, 30].map(days => (
//                         <button key={days} onClick={() => setFilterDays(days)} className={filterDays === days ? 'active' : ''}>{days} Days</button>
//                     ))}
//                     <div className="custom-filter">
//                         <input type="number" placeholder="Custom" value={customDays} onChange={(e) => setCustomDays(e.target.value)} min="1"/>
//                         <button onClick={handleCustomFilter}>Go</button>
//                     </div>
//                     <button onClick={clearFilter}>Clear Filter</button>
//                 </div>
//             </div>
//             <div className="table-content-wrapper">
//                 {loading && <p className="loading-message">Loading Assets...</p>}
//                 {error && <p className="error-message">Error: {error}</p>}
//                 {!loading && !error && (
//                     <>
//                         {filteredAssets.length > 0 ? (
//                             <div className="table-scroll-container">
//                                 <table className="data-table wide-table">
//                                     <thead>
//                                         {/* UPDATED: Added Registration No. header */}
//                                         <tr><th>ID</th><th>Asset Name</th><th>Asset Type</th><th>Capacity (MT)</th><th>Year of Purchase</th><th>Year of Manufacture</th><th>WO No</th><th>WO Start</th><th>WO End</th></tr>
//                                     </thead>
//                                     <tbody>
//                                         {filteredAssets.map(asset => {
//                                             const combinedAssetName = [asset.name, asset.serial_number, asset.asset_code, asset.registration_number].filter(Boolean).join(' | ');
//                                             return (
//                                                 <tr key={asset.id}>
//                                                     <td>{formatData(asset.id)}</td>
//                                                     <td>{combinedAssetName || 'N/A'}</td>
//                                                     {/* UPDATED: Added registration_number data cell */}
//                                                     <td>{formatData(asset.asset_type)}</td>
                                                   
                                                   
//                                                     <td>{formatData(asset.capacity_mt)}</td>
//                                                     <td>{formatData(asset.year_of_purchase)}</td>
//                                                     <td>{formatData(asset.year_of_manufacture)}</td>
//                                                     <td>{formatData(asset.wo_no)}</td>
//                                                     <td>{formatData(asset.wo_start)}</td>
//                                                     <td>{formatData(asset.wo_end)}</td>
//                                                 </tr>
//                                             );
//                                         })}
//                                     </tbody>
//                                 </table>
//                             </div>
//                         ) : (<p className="no-data-message">{filterDays !== null ? "No assets match the current availability filter." : "No active assets found."}</p>)}
//                     </>
//                 )}
//             </div>
//         </div>
//     );
// };
 
// // ====================================================================
// // --- Component for the Work Orders Tab Content ---
// // ====================================================================
// const WorkOrderDashboardContent = ({
//     loading, error, statusPieChartData, sectorBarChartData,
//     topCustomersData, filteredWorkOrders, filters, onChartClick, onClearFilters, apiToken
// }) => {
//     const statusChartRef = useRef();
//     const sectorChartRef = useRef();
//     const customerChartRef = useRef();
 
//     const handleChartClick = (filterType, chartData, event, chartRef) => {
//         if (!chartRef.current) return;
//         const elements = getElementAtEvent(chartRef.current, event);
//         if (elements.length > 0) {
//             const clickedLabel = chartData.labels[elements[0].index];
//             onChartClick(filterType, clickedLabel);
//         }
//     };
 
//     const hasFilters = Object.keys(filters).length > 0;
   
//     if (loading) return <div className="loading-error-container"><h2>Loading Dashboard...</h2></div>;
//     if (error) return <div className="loading-error-container"><h2>Dashboard Error</h2><p>{error}</p></div>;
 
//     return (
//         <main className="main-content">
//              <div className="dashboard-title-bar">
//                 <h1 className="dashboard-header">Work Orders Dashboard</h1>
//                 {hasFilters && (<button onClick={onClearFilters} className="clear-filters-btn">Clear Filters</button>)}
//             </div>
//             <div className="dashboard-grid">
//                 <div className="chart-card">
//                     <h3>Work Orders by Status</h3>
//                     <Pie ref={statusChartRef} data={statusPieChartData} options={{ responsive: true, plugins: { legend: { position: 'top' }, datalabels: { color: '#343a40', font: { weight: 'bold', size: 16 }, formatter: (value) => (value > 0 ? value : null) } } }} onClick={(event) => handleChartClick('status', statusPieChartData, event, statusChartRef)}/>
//                 </div>
//                 <div className="chart-card">
//                     <h3>Work Orders by Sector</h3>
//                     <Bar ref={sectorChartRef} data={sectorBarChartData} options={{ responsive: true, scales: { y: { beginAtZero: true } } }} onClick={(event) => handleChartClick('sector', sectorBarChartData, event, sectorChartRef)}/>
//                 </div>
//                 <div className="chart-card">
//                     <h3>Top Customers by Order Value</h3>
//                      <Bar ref={customerChartRef} data={topCustomersData} options={{ responsive: true, scales: { y: { beginAtZero: true } } }} onClick={(event) => handleChartClick('customer', topCustomersData, event, customerChartRef)}/>
//                 </div>
//                 {/* MAP REMOVED FROM HERE */}
//                 <div className="chart-card table-card">
//                     <FilteredWorkOrderTable workOrders={filteredWorkOrders} apiToken={apiToken} />
//                 </div>
//                 <div className="chart-card table-card">
//                      <AssetAvailabilityTable workOrders={filteredWorkOrders} apiToken={apiToken} />
//                 </div>
//             </div>
//         </main>
//     );
// };
 
// // ====================================================================
// // --- Component for the Invoices Tab ---
// // ====================================================================
// const InvoiceDashboardContent = ({ invoices, loading, error }) => {
//     const today = new Date();
//     const thirtyDaysAgo = new Date(new Date().setDate(today.getDate() - 30));
//     const formatDateForInput = (date) => date.toISOString().split('T')[0];
   
//     const [startDate, setStartDate] = useState(formatDateForInput(thirtyDaysAgo));
//     const [endDate, setEndDate] = useState(formatDateForInput(new Date()));
 
//     const filteredInvoices = useMemo(() => {
//         if (!Array.isArray(invoices) || !startDate || !endDate) return [];
//         const start = new Date(startDate);
//         const end = new Date(endDate);
//         end.setHours(23, 59, 59, 999);
//         return invoices.filter(inv => {
//             const invoiceDate = new Date(inv.invoice_date || inv.add_date);
//             return !isNaN(invoiceDate) && invoiceDate >= start && invoiceDate <= end;
//         });
//     }, [invoices, startDate, endDate]);
 
//     const dashboardData = useMemo(() => {
//         const EMPTY_CHART_DATA = { labels: [], datasets: [{ data: [] }] };
//         if (filteredInvoices.length === 0) {
//             return {
//                 kpis: { totalInvoices: 0, totalTaxable: 0, totalGst: 0, avgCreditPeriod: 0 },
//                 customerData: EMPTY_CHART_DATA, lifecycleData: EMPTY_CHART_DATA,
//                 compliance: { irn: EMPTY_CHART_DATA, digiSign: EMPTY_CHART_DATA, print: EMPTY_CHART_DATA, email: EMPTY_CHART_DATA }
//             };
//         }
 
//         const totalInvoices = filteredInvoices.length;
//         const totalTaxable = filteredInvoices.reduce((sum, inv) => sum + (Number(inv.taxable_amt) || 0), 0);
//         const totalGst = filteredInvoices.reduce((sum, inv) => sum + (Number(inv.tot_cgst) || 0) + (Number(inv.tot_sgst) || 0) + (Number(inv.tot_igst) || 0) + (Number(inv.tot_cess) || 0) + (Number(inv.tot_kkc) || 0), 0);
//         const creditPeriods = filteredInvoices.map(inv => Number(inv.cr_period)).filter(p => p > 0);
//         const avgCreditPeriod = creditPeriods.length > 0 ? (creditPeriods.reduce((a, b) => a + b, 0) / creditPeriods.length).toFixed(2) : 0;
       
//         const customerAggregates = filteredInvoices.reduce((acc, inv) => {
//             const customerId = `Customer ${inv.cust_id}`;
//             acc[customerId] = (acc[customerId] || 0) + (Number(inv.taxable_amt) || 0);
//             return acc;
//         }, {});
//         const sortedCustomers = Object.entries(customerAggregates).sort(([,a], [,b]) => b - a).slice(0, 10);
//         const customerData = { labels: sortedCustomers.map(([id]) => id), datasets: [{ label: 'Total Taxable Amount', data: sortedCustomers.map(([, amount]) => amount), backgroundColor: 'rgba(153, 102, 255, 0.6)' }] };
 
//         const lifecycleCounts = filteredInvoices.reduce((acc, inv) => { inv.inv_complete ? acc.completed++ : acc.pending++; return acc; }, { pending: 0, completed: 0 });
//         const lifecycleData = { labels: ['Pending', 'Completed'], datasets: [{ data: [lifecycleCounts.pending, lifecycleCounts.completed], backgroundColor: ['#FF6384', '#36A2EB'], borderColor: '#fff', borderWidth: 2 }] };
       
//         const createComplianceData = (key, trueLabel, falseLabel) => filteredInvoices.reduce((acc, inv) => { const status = inv[key] ? trueLabel : falseLabel; acc[status] = (acc[status] || 0) + 1; return acc; }, {});
//         const createPieData = (data) => ({ labels: Object.keys(data), datasets: [{ data: Object.values(data), backgroundColor: ['#FFCE56', '#4BC0C0'] }] });
 
//         return {
//             kpis: { totalInvoices, totalTaxable, totalGst, avgCreditPeriod },
//             customerData, lifecycleData,
//             compliance: {
//                 irn: createPieData(createComplianceData('irn_gen_status', 'Generated', 'Not Generated')),
//                 digiSign: createPieData(createComplianceData('digisign_status', 'Signed', 'Not Signed')),
//                 print: createPieData(createComplianceData('inv_print', 'Printed', 'Not Printed')),
//                 email: createPieData(createComplianceData('email_sent_to_cust', 'Sent', 'Not Sent'))
//             }
//         };
//     }, [filteredInvoices]);
 
//     if (loading) return <div className="loading-error-container"><h2>Loading Invoice Dashboard...</h2></div>;
//     if (error) return <div className="loading-error-container"><h2>Dashboard Error</h2><p>{error}</p></div>;
 
//     const formatCurrency = (value) => new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(value);
//     const pieOptions = { responsive: true, plugins: { legend: { position: 'bottom' }, datalabels: { color: '#fff', font: { weight: 'bold' }, formatter: (value) => (value > 0 ? value : '') } } };
 
//     return (
//         <main className="main-content">
//             <h1 className="dashboard-header">Invoice Dashboard</h1>
//             <div className="filter-bar">
//                 <div className="filter-item"><label htmlFor="start-date">Start Date:</label><input type="date" id="start-date" value={startDate} onChange={(e) => setStartDate(e.target.value)} /></div>
//                 <div className="filter-item"><label htmlFor="end-date">End Date:</label><input type="date" id="end-date" value={endDate} onChange={(e) => setEndDate(e.target.value)} /></div>
//             </div>
           
//             <div className="kpi-grid">
//                 <div className="kpi-card"><h4>Total Invoices</h4><p>{dashboardData.kpis.totalInvoices}</p></div>
//                 <div className="kpi-card"><h4>Total Taxable Amount</h4><p>{formatCurrency(dashboardData.kpis.totalTaxable)}</p></div>
//                 <div className="kpi-card"><h4>Total GST Collected</h4><p>{formatCurrency(dashboardData.kpis.totalGst)}</p></div>
//                 <div className="kpi-card"><h4>Avg. Credit Period</h4><p>{dashboardData.kpis.avgCreditPeriod} Days</p></div>
//             </div>
           
//             <div className="dashboard-grid">
//                 <div className="chart-card large-card">
//                   <h3>Customer Wise Invoices (Top 10 by Amount)</h3>
//                   {filteredInvoices.length > 0 ? <Bar data={dashboardData.customerData} options={{ responsive: true, scales: { y: { beginAtZero: true } } }} /> : <p className="no-data-message">No data for selected date range.</p>}
//                 </div>
//                 <div className="chart-card">
//                   <h3>Pending vs Completed Invoices</h3>
//                   {filteredInvoices.length > 0 ? <Pie data={dashboardData.lifecycleData} options={pieOptions} /> : <p className="no-data-message">No data available.</p>}
//                 </div>
                
//             </div>
//         </main>
//     );
// };
 
 
// // ====================================================================
// // --- Main Dashboard Component ---
// // ====================================================================
// const Dashboard = () => {
//     const [activeTab, setActiveTab] = useState('workOrder');
//     const [workOrderTableReport, setWorkOrderTableReport] = useState({ columns: [], data: [] });
//     const [invoices, setInvoices] = useState([]);
//     const [filters, setFilters] = useState({});
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
 
//     const API_TOKEN = 'Bearer ' + localStorage.getItem('zTaskAuthToken');
 
//     const handleApiResponse = async (response) => {
//         if (!response.ok) {
//             const errorText = await response.text();
//             const truncatedError = errorText.length > 200 ? errorText.substring(0, 200) + '...' : errorText;
//             throw new Error(`API call to ${response.url} failed with status ${response.status}: ${response.statusText}. Response: ${truncatedError}`);
//         }
//         return response.json();
//     };
 
//     useEffect(() => {
//         const fetchAllData = async () => {
//             setLoading(true);
//             setError(null);
 
//             const REPORT_API_URL = `${process.env.REACT_APP_REPORTS_API_URL}/api/reports/run`;
//             const INVOICE_API_URL = `${process.env.REACT_APP_NODE_SERVICE_BASE_URL}/invoice/api/invoices/`;
 
//             const HEADERS = { 'accept': 'application/json', 'Authorization': API_TOKEN };
//             const TABLE_REPORT_BODY = { "report_name": "work_order_table", "module_name": "Workorder" };
           
//             try {
//                 // Removed map-related API calls
//                 const [tableReportJson, invoiceJson] = await Promise.all([
//                     fetch(REPORT_API_URL, { method: 'POST', headers: { ...HEADERS, 'Content-Type': 'application/json' }, body: JSON.stringify(TABLE_REPORT_BODY) }).then(handleApiResponse),
//                     fetch(INVOICE_API_URL, { headers: HEADERS }).then(handleApiResponse)
//                 ]);
               
//                 if (tableReportJson && tableReportJson.columns && tableReportJson.data) setWorkOrderTableReport(tableReportJson);
//                 setInvoices(Array.isArray(invoiceJson) ? invoiceJson : []);
//             } catch (e) {
//                 console.error("Failed to fetch dashboard data:", e);
//                 setError(e.message);
//             } finally {
//                 setLoading(false);
//             }
//         };
//         fetchAllData();
//     }, []);
 
//     const handleChartClick = (filterType, clickedLabel) => setFilters(prev => ({ ...prev, [filterType]: clickedLabel }));
//     const clearFilters = () => setFilters({});
   
//     const uniqueWorkOrders = useMemo(() => {
//         const data = workOrderTableReport.data;
//         if (!Array.isArray(data)) return [];
//         const uniqueWoMap = new Map();
//         data.forEach(order => {
//             if (!uniqueWoMap.has(order.wo_id)) {
//                 uniqueWoMap.set(order.wo_id, { ...order, tot_value: parseFloat(order.tot_value) || 0 });
//             }
//         });
//         return Array.from(uniqueWoMap.values());
//     }, [workOrderTableReport.data]);
 
//     const statusPieChartData = useMemo(() => {
//         const statusCounts = uniqueWorkOrders.reduce((acc, order) => {
//             const status = order.wo_open_close || 'Unknown';
//             acc[status] = (acc[status] || 0) + 1;
//             return acc;
//         }, { 'Open': 0, 'Closed': 0 });
//         return { labels: Object.keys(statusCounts), datasets: [{ data: Object.values(statusCounts), backgroundColor: ['#ff8a80', '#80d8ff'], borderColor: '#ffffff', borderWidth: 3 }] };
//     }, [uniqueWorkOrders]);
 
//     const sectorBarChartData = useMemo(() => {
//         const sectorData = uniqueWorkOrders.reduce((acc, wo) => {
//             const sectorName = wo.sector_name || 'Unknown Sector';
//             if (!acc[sectorName]) acc[sectorName] = { count: 0, totalValue: 0 };
//             acc[sectorName].count += 1;
//             acc[sectorName].totalValue += wo.tot_value;
//             return acc;
//         }, {});
//         const labels = Object.keys(sectorData).sort();
//         return { labels, datasets: [
//             { label: 'Number of Orders', data: labels.map(l => sectorData[l].count), backgroundColor: 'rgba(255, 159, 64, 0.8)' },
//             { label: 'Total Value', data: labels.map(l => sectorData[l].totalValue), backgroundColor: 'rgba(75, 192, 192, 0.8)' }
//         ] };
//     }, [uniqueWorkOrders]);
   
//     const topCustomersData = useMemo(() => {
//         const customerAggregates = uniqueWorkOrders.reduce((acc, wo) => {
//             const customerName = wo.customer_name || 'Unknown Customer';
//             acc[customerName] = (acc[customerName] || 0) + wo.tot_value;
//             return acc;
//         }, {});
//         const sortedCustomers = Object.entries(customerAggregates).sort(([, a], [, b]) => b - a).slice(0, 5);
//         return { labels: sortedCustomers.map(([label]) => label), datasets: [{ label: 'Total Order Value', data: sortedCustomers.map(([, value]) => value), backgroundColor: 'rgba(54, 162, 235, 0.8)' }] };
//     }, [uniqueWorkOrders]);
 
//     // Removed assetLocationData useMemo hook
 
//     const filteredWorkOrders = useMemo(() => {
//         let data = workOrderTableReport.data || [];
//         if (Object.keys(filters).length === 0) return data;
//         const woIdsToKeep = new Set(uniqueWorkOrders
//             .filter(wo => (!filters.status || wo.wo_open_close === filters.status) && (!filters.sector || wo.sector_name === filters.sector) && (!filters.customer || wo.customer_name === filters.customer))
//             .map(wo => wo.wo_id)
//         );
//         return data.filter(order => woIdsToKeep.has(order.wo_id));
//     }, [workOrderTableReport.data, uniqueWorkOrders, filters]);
 
//     return (
//         <div className="dashboard-container">
//             <div className="tabs-container">
//                 <button className={`tab-button ${activeTab === 'workOrder' ? 'active' : ''}`} onClick={() => setActiveTab('workOrder')}>Work Orders</button>
//                 <button className={`tab-button ${activeTab === 'invoice' ? 'active' : ''}`} onClick={() => setActiveTab('invoice')}>Invoices</button>
//             </div>
//             <div className="tab-content">
//                 {activeTab === 'workOrder' && (
//                     <WorkOrderDashboardContent
//                         loading={loading} error={error} statusPieChartData={statusPieChartData}
//                         sectorBarChartData={sectorBarChartData}
//                         topCustomersData={topCustomersData} filteredWorkOrders={filteredWorkOrders}
//                         filters={filters} onChartClick={handleChartClick} onClearFilters={clearFilters}
//                         apiToken={API_TOKEN}
//                     />
//                 )}
//                 {activeTab === 'invoice' && (<InvoiceDashboardContent invoices={invoices} loading={loading} error={error} />)}
//             </div>
//         </div>
//     );
// };
 
// export default Dashboard;









// import React, { useState, useEffect, useMemo, useRef } from 'react';
// import { Pie, Bar, getElementAtEvent } from 'react-chartjs-2';
// import {
//     Chart as ChartJS,
//     CategoryScale,
//     LinearScale,
//     BarElement,
//     Title,
//     Tooltip,
//     Legend,
//     ArcElement
// } from 'chart.js';
// import ChartDataLabels from 'chartjs-plugin-datalabels';
// import './Dashboard.css'; // Renamed CSS import
 
// ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement, ChartDataLabels);
 
// // ====================================================================
// // --- Component for Work Order Table ---
// // ====================================================================
// const FilteredWorkOrderTable = ({ workOrders, apiToken }) => {
//     const [activeTab, setActiveTab] = useState('assets');
//     const [assets, setAssets] = useState([]);
//     const [assetsLoading, setAssetsLoading] = useState(false);
//     const [assetsError, setAssetsError] = useState(null);
 
//     useEffect(() => {
//         const fetchAssets = async () => {
//             if (!workOrders || workOrders.length === 0) {
//                 setAssets([]);
//                 return;
//             }
//             const assetIdSet = new Set(workOrders.map(wo => wo.asset_id).filter(id => id != null));
//             const assetIds = Array.from(assetIdSet);
//             if (assetIds.length === 0) {
//                 setAssets([]);
//                 return;
//             }
           
//             setAssetsLoading(true);
//             setAssetsError(null);
           
//             const ASSET_API_URL = `${process.env.REACT_APP_ASSET_SERVICE_BASE_URL}/api/assets/`;
//             const ASSET_HEADERS = { 'accept': 'application/json', 'Authorization': apiToken };
 
//             try {
//                 const assetPromises = assetIds.map(id =>
//                     fetch(`${ASSET_API_URL}${id}`, { headers: ASSET_HEADERS }).then(res => {
//                         if (!res.ok) {
//                             console.error(`Failed to fetch asset ${id}, status: ${res.status}`);
//                             return null;
//                         }
//                         return res.json();
//                     })
//                 );
//                 const fetchedAssetsResults = await Promise.all(assetPromises);
//                 setAssets(fetchedAssetsResults.filter(asset => asset !== null));
//             } catch (error) {
//                 console.error("Failed to fetch assets:", error);
//                 setAssetsError(error.message);
//             } finally {
//                 setAssetsLoading(false);
//             }
//         };
//         fetchAssets();
//     }, [workOrders, apiToken]);
 
//     const displayedWorkOrders = useMemo(() => {
//         if (!workOrders || !Array.isArray(workOrders)) return [];
//         return [...workOrders].sort((a, b) => new Date(b.add_date) - new Date(a.add_date));
//     }, [workOrders]);
 
//     const formatData = (value) => {
//         if (value === null || typeof value === 'undefined') return 'N/A';
//         if (typeof value === 'boolean') return value ? 'Yes' : 'No';
//         if (typeof value === 'string' && value.includes('T')) {
//             const date = new Date(value);
//             if (!isNaN(date)) return date.toLocaleDateString('en-GB');
//         }
//         return value;
//     };
 
//     const displayColumns = [
//         { header: 'Doc No', key: 'doc_no' }, { header: 'WO No', key: 'wo_no' },
//         { header: 'Status', key: 'wo_open_close' }, { header: 'Total Value', key: 'tot_value' },
//         { header: 'Customer Name', key: 'customer_name' }, { header: 'Customer ID', key: 'cust_id' },
//         { header: 'Project Name', key: 'project_name' }, { header: 'Project ID', key: 'project_id' },
//         { header: 'Sector Name', key: 'sector_name' }, { header: 'Sector ID', key: 'sector' },
//         { header: 'Asset ID', key: 'asset_id' }, { header: 'WO Date', key: 'wo_date' },
//         { header: 'WO Start', key: 'wo_start' }, { header: 'WO End', key: 'wo_end' },
//     ];
 
//     return (
//         <div className="filtered-table-container">
//             <div className="table-header"><h3>All Work Orders</h3></div>
//             <div className="table-controls">
//                 <div className="tabs">
//                     <button className={`tab-btn ${activeTab === 'assets' ? 'active' : ''}`} onClick={() => setActiveTab('assets')}>Assets</button>
//                     <button className={`tab-btn ${activeTab === 'workorder' ? 'active' : ''}`} onClick={() => setActiveTab('workorder')}>Workorder</button>
//                 </div>
//             </div>
//             <div className="table-content-wrapper">
//                 {activeTab === 'workorder' ? (
//                     <>
//                         {displayedWorkOrders.length > 0 ? (
//                             <div className="table-scroll-container">
//                                 <table className="data-table wide-table">
//                                     <thead><tr>{displayColumns.map(col => <th key={col.key}>{col.header}</th>)}</tr></thead>
//                                     <tbody>
//                                         {displayedWorkOrders.map((order, index) => (
//                                             <tr key={`${order.id}-${index}`}>
//                                                 {displayColumns.map(col => (
//                                                     <td key={col.key}>{col.key === 'tot_value' ? parseFloat(order[col.key] || 0).toLocaleString('en-US') : formatData(order[col.key])}</td>
//                                                 ))}
//                                             </tr>
//                                         ))}
//                                     </tbody>
//                                 </table>
//                             </div>
//                         ) : (<p className="no-data-message">No work orders found for the current filter.</p>)}
//                     </>
//                 ) : (
//                     <>
//                         {assetsLoading && <p className="loading-message">Loading Assets...</p>}
//                         {assetsError && <p className="error-message">Error: {assetsError}</p>}
//                         {!assetsLoading && !assetsError && (
//                             <>
//                                 {assets.length > 0 ? (
//                                     <div className="table-scroll-container">
//                                         <table className="data-table wide-table">
//                                             <thead>
//                                                 {/* UPDATED: Added Registration No. column */}
//                                                 <tr><th>Asset Name</th><th>Asset Type</th><th>Capacity (MT)</th><th>Year of Purchase</th><th>Year of Manufacture</th></tr>
//                                             </thead>
//                                             <tbody>
//                                                 {assets.map(asset => {
//                                                     const combinedAssetName = [asset.name, asset.serial_number, asset.asset_code, asset.registration_number].filter(Boolean).join(' | ');
//                                                     return (
//                                                         <tr key={asset.id}>
//                                                             <td>{combinedAssetName || 'N/A'}</td>
//                                                             {/* UPDATED: Added registration_number data cell */}
//                                                             <td>{formatData(asset.asset_type)}</td>
                                                           
                                                           
//                                                             <td>{formatData(asset.capacity_mt)}</td>
//                                                             <td>{formatData(asset.year_of_purchase)}</td>
//                                                             <td>{formatData(asset.year_of_manufacture)}</td>
//                                                         </tr>
//                                                     );
//                                                 })}
//                                             </tbody>
//                                         </table>
//                                     </div>
//                                 ) : (<p className="no-data-message">No assets found for the current work orders.</p>)}
//                             </>
//                         )}
//                     </>
//                 )}
//             </div>
//         </div>
//     );
// };
 
// // ====================================================================
// // --- Component for Asset Availability Table ---
// // ====================================================================
// const AssetAvailabilityTable = ({ workOrders, apiToken }) => {
//     const [combinedAssets, setCombinedAssets] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);
//     const [filterDays, setFilterDays] = useState(null);
//     const [customDays, setCustomDays] = useState('');
 
//     useEffect(() => {
//         const fetchAndCombineData = async () => {
//             setLoading(true);
//             setError(null);
           
//             const workOrderInfoMap = new Map();
//             if (workOrders && Array.isArray(workOrders)) {
//                 workOrders.forEach(wo => {
//                     if (wo.asset_id != null) {
//                         workOrderInfoMap.set(Number(wo.asset_id), { wo_start: wo.wo_start, wo_end: wo.wo_end, wo_no: wo.wo_no });
//                     }
//                 });
//             }
           
//             const ASSET_API_URL = `${process.env.REACT_APP_ASSET_SERVICE_BASE_URL}/api/assets/`;
//             const ASSET_HEADERS = { 'accept': 'application/json', 'Authorization': apiToken };
 
//             try {
//                 const response = await fetch(ASSET_API_URL, { headers: ASSET_HEADERS });
//                 if (!response.ok) {
//                     throw new Error(`Failed to fetch assets, status: ${response.status}`);
//                 }
//                 const allAssets = await response.json();
//                 const activeAssets = allAssets.filter(asset => asset.active === true);
 
//                 const combinedData = activeAssets.map(asset => {
//                     const workOrderInfo = workOrderInfoMap.get(asset.id) || { wo_start: null, wo_end: null, wo_no: null };
//                     return { ...asset, ...workOrderInfo };
//                 });
               
//                 setCombinedAssets(combinedData);
//             } catch (error) {
//                 console.error("Failed to fetch asset data:", error);
//                 setError(error.message);
//             } finally {
//                 setLoading(false);
//             }
//         };
 
//         fetchAndCombineData();
//     }, [workOrders, apiToken]);
 
//     const filteredAssets = useMemo(() => {
//         if (filterDays === null) return combinedAssets;
//         const targetDate = new Date();
//         targetDate.setDate(targetDate.getDate() + filterDays);
//         targetDate.setHours(23, 59, 59, 999);
//         return combinedAssets.filter(asset => {
//             if (!asset.wo_end) return true;
//             const woEndDate = new Date(asset.wo_end);
//             return isNaN(woEndDate.getTime()) || woEndDate <= targetDate;
//         });
//     }, [combinedAssets, filterDays]);
 
//     const formatData = (value) => {
//         if (value === null || typeof value === 'undefined') return 'N/A';
//         if (typeof value === 'boolean') return value ? 'Yes' : 'No';
//         if (typeof value === 'string' && value.includes('T')) {
//             const date = new Date(value);
//             if (!isNaN(date)) return date.toLocaleDateString('en-GB');
//         }
//         return value;
//     };
 
//     const handleCustomFilter = () => {
//         const days = parseInt(customDays, 10);
//         if (days > 0) setFilterDays(days);
//     };
 
//     const clearFilter = () => {
//         setFilterDays(null);
//         setCustomDays('');
//     };
 
//     return (
//         <div className="filtered-table-container">
//             <div className="table-header with-controls">
//                 <h3>Asset Availability</h3>
//                 <div className="availability-filter-controls">
//                     <span>Available In:</span>
//                     {[3, 7, 15, 30].map(days => (
//                         <button key={days} onClick={() => setFilterDays(days)} className={filterDays === days ? 'active' : ''}>{days} Days</button>
//                     ))}
//                     <div className="custom-filter">
//                         <input type="number" placeholder="Custom" value={customDays} onChange={(e) => setCustomDays(e.target.value)} min="1"/>
//                         <button onClick={handleCustomFilter}>Go</button>
//                     </div>
//                     <button onClick={clearFilter}>Clear Filter</button>
//                 </div>
//             </div>
//             <div className="table-content-wrapper">
//                 {loading && <p className="loading-message">Loading Assets...</p>}
//                 {error && <p className="error-message">Error: {error}</p>}
//                 {!loading && !error && (
//                     <>
//                         {filteredAssets.length > 0 ? (
//                             <div className="table-scroll-container">
//                                 <table className="data-table wide-table">
//                                     <thead>
//                                         {/* UPDATED: Added Registration No. header */}
//                                         <tr><th>ID</th><th>Asset Name</th><th>Asset Type</th><th>Capacity (MT)</th><th>Year of Purchase</th><th>Year of Manufacture</th><th>WO No</th><th>WO Start</th><th>WO End</th></tr>
//                                     </thead>
//                                     <tbody>
//                                         {filteredAssets.map(asset => {
//                                             const combinedAssetName = [asset.name, asset.serial_number, asset.asset_code, asset.registration_number].filter(Boolean).join(' | ');
//                                             return (
//                                                 <tr key={asset.id}>
//                                                     <td>{formatData(asset.id)}</td>
//                                                     <td>{combinedAssetName || 'N/A'}</td>
//                                                     {/* UPDATED: Added registration_number data cell */}
//                                                     <td>{formatData(asset.asset_type)}</td>
                                                   
                                                   
//                                                     <td>{formatData(asset.capacity_mt)}</td>
//                                                     <td>{formatData(asset.year_of_purchase)}</td>
//                                                     <td>{formatData(asset.year_of_manufacture)}</td>
//                                                     <td>{formatData(asset.wo_no)}</td>
//                                                     <td>{formatData(asset.wo_start)}</td>
//                                                     <td>{formatData(asset.wo_end)}</td>
//                                                 </tr>
//                                             );
//                                         })}
//                                     </tbody>
//                                 </table>
//                             </div>
//                         ) : (<p className="no-data-message">{filterDays !== null ? "No assets match the current availability filter." : "No active assets found."}</p>)}
//                     </>
//                 )}
//             </div>
//         </div>
//     );
// };
 
// // ====================================================================
// // --- Component for the Work Orders Tab Content ---
// // ====================================================================
// const WorkOrderDashboardContent = ({
//     loading, error, statusPieChartData, sectorBarChartData,
//     topCustomersData, filteredWorkOrders, filters, onChartClick, onClearFilters, apiToken
// }) => {
//     const statusChartRef = useRef();
//     const sectorChartRef = useRef();
//     const customerChartRef = useRef();
 
//     const handleChartClick = (filterType, chartData, event, chartRef) => {
//         if (!chartRef.current) return;
//         const elements = getElementAtEvent(chartRef.current, event);
//         if (elements.length > 0) {
//             const clickedLabel = chartData.labels[elements[0].index];
//             onChartClick(filterType, clickedLabel);
//         }
//     };
 
//     const hasFilters = Object.keys(filters).length > 0;
   
//     if (loading) return <div className="loading-error-container"><h2>Loading Dashboard...</h2></div>;
//     if (error) return <div className="loading-error-container"><h2>Dashboard Error</h2><p>{error}</p></div>;
 
//     return (
//         <main className="main-content">
//              <div className="dashboard-title-bar">
//                 <h1 className="dashboard-header">Work Orders Dashboard</h1>
//                 {hasFilters && (<button onClick={onClearFilters} className="clear-filters-btn">Clear Filters</button>)}
//             </div>
//             <div className="dashboard-grid">
//                 <div className="chart-card">
//                     <h3>Work Orders by Status</h3>
//                     <Pie ref={statusChartRef} data={statusPieChartData} options={{ responsive: true, plugins: { legend: { position: 'top' }, datalabels: { color: '#343a40', font: { weight: 'bold', size: 16 }, formatter: (value) => (value > 0 ? value : null) } } }} onClick={(event) => handleChartClick('status', statusPieChartData, event, statusChartRef)}/>
//                 </div>
//                 <div className="chart-card">
//                     <h3>Work Orders by Sector</h3>
//                     <Bar ref={sectorChartRef} data={sectorBarChartData} options={{ responsive: true, scales: { y: { beginAtZero: true } } }} onClick={(event) => handleChartClick('sector', sectorBarChartData, event, sectorChartRef)}/>
//                 </div>
//                 <div className="chart-card">
//                     <h3>Top Customers by Order Value</h3>
//                      <Bar ref={customerChartRef} data={topCustomersData} options={{ responsive: true, scales: { y: { beginAtZero: true } } }} onClick={(event) => handleChartClick('customer', topCustomersData, event, customerChartRef)}/>
//                 </div>
//                 {/* MAP REMOVED FROM HERE */}
//                 <div className="chart-card table-card">
//                     <FilteredWorkOrderTable workOrders={filteredWorkOrders} apiToken={apiToken} />
//                 </div>
//                 <div className="chart-card table-card">
//                      <AssetAvailabilityTable workOrders={filteredWorkOrders} apiToken={apiToken} />
//                 </div>
//             </div>
//         </main>
//     );
// };
 
// // ====================================================================
// // --- Component for the Invoices Tab ---
// // ====================================================================
// // UPDATED: Added workOrders prop to get customer names
// const InvoiceDashboardContent = ({ invoices, workOrders, loading, error }) => {
//     const today = new Date();
//     const thirtyDaysAgo = new Date(new Date().setDate(today.getDate() - 30));
//     const formatDateForInput = (date) => date.toISOString().split('T')[0];
   
//     const [startDate, setStartDate] = useState(formatDateForInput(thirtyDaysAgo));
//     const [endDate, setEndDate] = useState(formatDateForInput(new Date()));
 
//     const filteredInvoices = useMemo(() => {
//         if (!Array.isArray(invoices) || !startDate || !endDate) return [];
//         const start = new Date(startDate);
//         const end = new Date(endDate);
//         end.setHours(23, 59, 59, 999);
//         return invoices.filter(inv => {
//             const invoiceDate = new Date(inv.invoice_date || inv.add_date);
//             return !isNaN(invoiceDate) && invoiceDate >= start && invoiceDate <= end;
//         });
//     }, [invoices, startDate, endDate]);
 
//     const dashboardData = useMemo(() => {
//         const EMPTY_CHART_DATA = { labels: [], datasets: [{ data: [] }] };
//         if (filteredInvoices.length === 0) {
//             return {
//                 kpis: { totalInvoices: 0, totalTaxable: 0, totalGst: 0, avgCreditPeriod: 0 },
//                 customerData: EMPTY_CHART_DATA, lifecycleData: EMPTY_CHART_DATA
//             };
//         }

//         // UPDATED: Create a map of customer IDs to customer names from work order data
//         const customerNameMap = new Map();
//         if (Array.isArray(workOrders)) {
//             workOrders.forEach(wo => {
//                 if (wo.cust_id && wo.customer_name) {
//                     customerNameMap.set(wo.cust_id, wo.customer_name);
//                 }
//             });
//         }
 
//         const totalInvoices = filteredInvoices.length;
//         const totalTaxable = filteredInvoices.reduce((sum, inv) => sum + (Number(inv.taxable_amt) || 0), 0);
//         const totalGst = filteredInvoices.reduce((sum, inv) => sum + (Number(inv.tot_cgst) || 0) + (Number(inv.tot_sgst) || 0) + (Number(inv.tot_igst) || 0) + (Number(inv.tot_cess) || 0) + (Number(inv.tot_kkc) || 0), 0);
//         const creditPeriods = filteredInvoices.map(inv => Number(inv.cr_period)).filter(p => p > 0);
//         const avgCreditPeriod = creditPeriods.length > 0 ? (creditPeriods.reduce((a, b) => a + b, 0) / creditPeriods.length).toFixed(2) : 0;
       
//         // UPDATED: Use the customer name map to get names for the chart
//         const customerAggregates = filteredInvoices.reduce((acc, inv) => {
//             const customerName = customerNameMap.get(inv.cust_id) || `Customer ${inv.cust_id}` || 'Unknown Customer';
//             acc[customerName] = (acc[customerName] || 0) + (Number(inv.taxable_amt) || 0);
//             return acc;
//         }, {});
//         const sortedCustomers = Object.entries(customerAggregates).sort(([,a], [,b]) => b - a).slice(0, 10);
//         const customerData = { labels: sortedCustomers.map(([name]) => name), datasets: [{ label: 'Total Taxable Amount', data: sortedCustomers.map(([, amount]) => amount), backgroundColor: 'rgba(153, 102, 255, 0.6)' }] };
 
//         const lifecycleCounts = filteredInvoices.reduce((acc, inv) => { inv.inv_complete ? acc.completed++ : acc.pending++; return acc; }, { pending: 0, completed: 0 });
//         const lifecycleData = { labels: ['Pending', 'Completed'], datasets: [{ data: [lifecycleCounts.pending, lifecycleCounts.completed], backgroundColor: ['#FF6384', '#36A2EB'], borderColor: '#fff', borderWidth: 2 }] };
       
//         return {
//             kpis: { totalInvoices, totalTaxable, totalGst, avgCreditPeriod },
//             customerData, lifecycleData
//         };
//     }, [filteredInvoices, workOrders]); // UPDATED: Added workOrders to dependency array
 
//     if (loading) return <div className="loading-error-container"><h2>Loading Invoice Dashboard...</h2></div>;
//     if (error) return <div className="loading-error-container"><h2>Dashboard Error</h2><p>{error}</p></div>;
 
//     const formatCurrency = (value) => new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(value);
//     const pieOptions = { responsive: true, plugins: { legend: { position: 'bottom' }, datalabels: { color: '#fff', font: { weight: 'bold' }, formatter: (value) => (value > 0 ? value : '') } } };
 
//     return (
//         <main className="main-content">
//             <h1 className="dashboard-header">Invoice Dashboard</h1>
//             <div className="filter-bar">
//                 <div className="filter-item"><label htmlFor="start-date">Start Date:</label><input type="date" id="start-date" value={startDate} onChange={(e) => setStartDate(e.target.value)} /></div>
//                 <div className="filter-item"><label htmlFor="end-date">End Date:</label><input type="date" id="end-date" value={endDate} onChange={(e) => setEndDate(e.target.value)} /></div>
//             </div>
           
//             <div className="kpi-grid">
//                 <div className="kpi-card"><h4>Total Invoices</h4><p>{dashboardData.kpis.totalInvoices}</p></div>
//                 <div className="kpi-card"><h4>Total Taxable Amount</h4><p>{formatCurrency(dashboardData.kpis.totalTaxable)}</p></div>
//                 <div className="kpi-card"><h4>Total GST Collected</h4><p>{formatCurrency(dashboardData.kpis.totalGst)}</p></div>
//                 <div className="kpi-card"><h4>Avg. Credit Period</h4><p>{dashboardData.kpis.avgCreditPeriod} Days</p></div>
//             </div>
           
//             <div className="dashboard-grid">
//                 <div className="chart-card large-card">
//                   <h3>Customer Wise Invoices (Top 10 by Amount)</h3>
//                   {filteredInvoices.length > 0 ? <Bar data={dashboardData.customerData} options={{ responsive: true, scales: { y: { beginAtZero: true } } }} /> : <p className="no-data-message">No data for selected date range.</p>}
//                 </div>
//                 <div className="chart-card">
//                   <h3>Pending vs Completed Invoices</h3>
//                   {filteredInvoices.length > 0 ? <Pie data={dashboardData.lifecycleData} options={pieOptions} /> : <p className="no-data-message">No data available.</p>}
//                 </div>
//             </div>
//         </main>
//     );
// };
 
 
// // ====================================================================
// // --- Main Dashboard Component ---
// // ====================================================================
// const Dashboard = () => {
//     const [activeTab, setActiveTab] = useState('workOrder');
//     const [workOrderTableReport, setWorkOrderTableReport] = useState({ columns: [], data: [] });
//     const [invoices, setInvoices] = useState([]);
//     const [filters, setFilters] = useState({});
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
 
//     const API_TOKEN = 'Bearer ' + localStorage.getItem('zTaskAuthToken');
 
//     const handleApiResponse = async (response) => {
//         if (!response.ok) {
//             const errorText = await response.text();
//             const truncatedError = errorText.length > 200 ? errorText.substring(0, 200) + '...' : errorText;
//             throw new Error(`API call to ${response.url} failed with status ${response.status}: ${response.statusText}. Response: ${truncatedError}`);
//         }
//         return response.json();
//     };
 
//     useEffect(() => {
//         const fetchAllData = async () => {
//             setLoading(true);
//             setError(null);
 
//             const REPORT_API_URL = `${process.env.REACT_APP_REPORTS_API_URL}/api/reports/run`;
//             const INVOICE_API_URL = `${process.env.REACT_APP_NODE_SERVICE_BASE_URL}/invoice/api/invoices/`;
 
//             const HEADERS = { 'accept': 'application/json', 'Authorization': API_TOKEN };
//             const TABLE_REPORT_BODY = { "report_name": "work_order_table", "module_name": "Workorder" };
           
//             try {
//                 // Removed map-related API calls
//                 const [tableReportJson, invoiceJson] = await Promise.all([
//                     fetch(REPORT_API_URL, { method: 'POST', headers: { ...HEADERS, 'Content-Type': 'application/json' }, body: JSON.stringify(TABLE_REPORT_BODY) }).then(handleApiResponse),
//                     fetch(INVOICE_API_URL, { headers: HEADERS }).then(handleApiResponse)
//                 ]);
               
//                 if (tableReportJson && tableReportJson.columns && tableReportJson.data) setWorkOrderTableReport(tableReportJson);
//                 setInvoices(Array.isArray(invoiceJson) ? invoiceJson : []);
//             } catch (e) {
//                 console.error("Failed to fetch dashboard data:", e);
//                 setError(e.message);
//             } finally {
//                 setLoading(false);
//             }
//         };
//         fetchAllData();
//     }, []);
 
//     const handleChartClick = (filterType, clickedLabel) => setFilters(prev => ({ ...prev, [filterType]: clickedLabel }));
//     const clearFilters = () => setFilters({});
   
//     const uniqueWorkOrders = useMemo(() => {
//         const data = workOrderTableReport.data;
//         if (!Array.isArray(data)) return [];
//         const uniqueWoMap = new Map();
//         data.forEach(order => {
//             if (!uniqueWoMap.has(order.wo_id)) {
//                 uniqueWoMap.set(order.wo_id, { ...order, tot_value: parseFloat(order.tot_value) || 0 });
//             }
//         });
//         return Array.from(uniqueWoMap.values());
//     }, [workOrderTableReport.data]);
 
//     const statusPieChartData = useMemo(() => {
//         const statusCounts = uniqueWorkOrders.reduce((acc, order) => {
//             const status = order.wo_open_close || 'Unknown';
//             acc[status] = (acc[status] || 0) + 1;
//             return acc;
//         }, { 'Open': 0, 'Closed': 0 });
//         return { labels: Object.keys(statusCounts), datasets: [{ data: Object.values(statusCounts), backgroundColor: ['#ff8a80', '#80d8ff'], borderColor: '#ffffff', borderWidth: 3 }] };
//     }, [uniqueWorkOrders]);
 
//     const sectorBarChartData = useMemo(() => {
//         const sectorData = uniqueWorkOrders.reduce((acc, wo) => {
//             const sectorName = wo.sector_name || 'Unknown Sector';
//             if (!acc[sectorName]) acc[sectorName] = { count: 0, totalValue: 0 };
//             acc[sectorName].count += 1;
//             acc[sectorName].totalValue += wo.tot_value;
//             return acc;
//         }, {});
//         const labels = Object.keys(sectorData).sort();
//         return { labels, datasets: [
//             { label: 'Number of Orders', data: labels.map(l => sectorData[l].count), backgroundColor: 'rgba(255, 159, 64, 0.8)' },
//             { label: 'Total Value', data: labels.map(l => sectorData[l].totalValue), backgroundColor: 'rgba(75, 192, 192, 0.8)' }
//         ] };
//     }, [uniqueWorkOrders]);
   
//     const topCustomersData = useMemo(() => {
//         const customerAggregates = uniqueWorkOrders.reduce((acc, wo) => {
//             const customerName = wo.customer_name || 'Unknown Customer';
//             acc[customerName] = (acc[customerName] || 0) + wo.tot_value;
//             return acc;
//         }, {});
//         const sortedCustomers = Object.entries(customerAggregates).sort(([, a], [, b]) => b - a).slice(0, 5);
//         return { labels: sortedCustomers.map(([label]) => label), datasets: [{ label: 'Total Order Value', data: sortedCustomers.map(([, value]) => value), backgroundColor: 'rgba(54, 162, 235, 0.8)' }] };
//     }, [uniqueWorkOrders]);
 
//     const filteredWorkOrders = useMemo(() => {
//         let data = workOrderTableReport.data || [];
//         if (Object.keys(filters).length === 0) return data;
//         const woIdsToKeep = new Set(uniqueWorkOrders
//             .filter(wo => (!filters.status || wo.wo_open_close === filters.status) && (!filters.sector || wo.sector_name === filters.sector) && (!filters.customer || wo.customer_name === filters.customer))
//             .map(wo => wo.wo_id)
//         );
//         return data.filter(order => woIdsToKeep.has(order.wo_id));
//     }, [workOrderTableReport.data, uniqueWorkOrders, filters]);
 
//     return (
//         <div className="dashboard-container">
//             <div className="tabs-container">
//                 <button className={`tab-button ${activeTab === 'workOrder' ? 'active' : ''}`} onClick={() => setActiveTab('workOrder')}>Work Orders</button>
//                 <button className={`tab-button ${activeTab === 'invoice' ? 'active' : ''}`} onClick={() => setActiveTab('invoice')}>Invoices</button>
//             </div>
//             <div className="tab-content">
//                 {activeTab === 'workOrder' && (
//                     <WorkOrderDashboardContent
//                         loading={loading} error={error} statusPieChartData={statusPieChartData}
//                         sectorBarChartData={sectorBarChartData}
//                         topCustomersData={topCustomersData} filteredWorkOrders={filteredWorkOrders}
//                         filters={filters} onChartClick={handleChartClick} onClearFilters={clearFilters}
//                         apiToken={API_TOKEN}
//                     />
//                 )}
//                 {activeTab === 'invoice' && (
//                     <InvoiceDashboardContent 
//                         invoices={invoices} 
//                         workOrders={workOrderTableReport.data} // UPDATED: Pass work order data
//                         loading={loading} 
//                         error={error} 
//                     />
//                 )}
//             </div>
//         </div>
//     );
// };
 
// export default Dashboard;















// import React, { useState, useEffect, useMemo, useRef } from 'react';
// import { Pie, Bar, getElementAtEvent } from 'react-chartjs-2';
// import {
//     Chart as ChartJS,
//     CategoryScale,
//     LinearScale,
//     BarElement,
//     Title,
//     Tooltip,
//     Legend,
//     ArcElement
// } from 'chart.js';
// import ChartDataLabels from 'chartjs-plugin-datalabels';
// import './Dashboard.css'; // Renamed CSS import
 
// ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement, ChartDataLabels);
 
// // ====================================================================
// // --- Component for Work Order Table ---
// // ====================================================================
// const FilteredWorkOrderTable = ({ workOrders, apiToken }) => {
//     const [activeTab, setActiveTab] = useState('assets');
//     const [assets, setAssets] = useState([]);
//     const [assetsLoading, setAssetsLoading] = useState(false);
//     const [assetsError, setAssetsError] = useState(null);
 
//     useEffect(() => {
//         const fetchAssets = async () => {
//             if (!workOrders || workOrders.length === 0) {
//                 setAssets([]);
//                 return;
//             }
//             const assetIdSet = new Set(workOrders.map(wo => wo.asset_id).filter(id => id != null));
//             const assetIds = Array.from(assetIdSet);
//             if (assetIds.length === 0) {
//                 setAssets([]);
//                 return;
//             }
           
//             setAssetsLoading(true);
//             setAssetsError(null);
           
//             const ASSET_API_URL = `${process.env.REACT_APP_ASSET_SERVICE_BASE_URL}/api/assets/`;
//             const ASSET_HEADERS = { 'accept': 'application/json', 'Authorization': apiToken };
 
//             try {
//                 const assetPromises = assetIds.map(id =>
//                     fetch(`${ASSET_API_URL}${id}`, { headers: ASSET_HEADERS }).then(res => {
//                         if (!res.ok) {
//                             console.error(`Failed to fetch asset ${id}, status: ${res.status}`);
//                             return null;
//                         }
//                         return res.json();
//                     })
//                 );
//                 const fetchedAssetsResults = await Promise.all(assetPromises);
//                 setAssets(fetchedAssetsResults.filter(asset => asset !== null));
//             } catch (error) {
//                 console.error("Failed to fetch assets:", error);
//                 setAssetsError(error.message);
//             } finally {
//                 setAssetsLoading(false);
//             }
//         };
//         fetchAssets();
//     }, [workOrders, apiToken]);
 
//     const displayedWorkOrders = useMemo(() => {
//         if (!workOrders || !Array.isArray(workOrders)) return [];
//         return [...workOrders].sort((a, b) => new Date(b.add_date) - new Date(a.add_date));
//     }, [workOrders]);
 
//     const formatData = (value) => {
//         if (value === null || typeof value === 'undefined') return 'N/A';
//         if (typeof value === 'boolean') return value ? 'Yes' : 'No';
//         if (typeof value === 'string' && value.includes('T')) {
//             const date = new Date(value);
//             if (!isNaN(date)) return date.toLocaleDateString('en-GB');
//         }
//         return value;
//     };
 
//     const displayColumns = [
//         { header: 'Doc No', key: 'doc_no' }, { header: 'WO No', key: 'wo_no' },
//         { header: 'Status', key: 'wo_open_close' }, { header: 'Total Value', key: 'tot_value' },
//         { header: 'Customer Name', key: 'customer_name' }, { header: 'Customer ID', key: 'cust_id' },
//         { header: 'Project Name', key: 'project_name' }, { header: 'Project ID', key: 'project_id' },
//         { header: 'Sector Name', key: 'sector_name' }, { header: 'Sector ID', key: 'sector' },
//         { header: 'Asset ID', key: 'asset_id' }, { header: 'WO Date', key: 'wo_date' },
//         { header: 'WO Start', key: 'wo_start' }, { header: 'WO End', key: 'wo_end' },
//     ];
 
//     return (
//         <div className="filtered-table-container">
//             <div className="table-header"><h3>All Work Orders</h3></div>
//             <div className="table-controls">
//                 <div className="tabs">
//                     <button className={`tab-btn ${activeTab === 'assets' ? 'active' : ''}`} onClick={() => setActiveTab('assets')}>Assets</button>
//                     <button className={`tab-btn ${activeTab === 'workorder' ? 'active' : ''}`} onClick={() => setActiveTab('workorder')}>Workorder</button>
//                 </div>
//             </div>
//             <div className="table-content-wrapper">
//                 {activeTab === 'workorder' ? (
//                     <>
//                         {displayedWorkOrders.length > 0 ? (
//                             <div className="table-scroll-container">
//                                 <table className="data-table wide-table">
//                                     <thead><tr>{displayColumns.map(col => <th key={col.key}>{col.header}</th>)}</tr></thead>
//                                     <tbody>
//                                         {displayedWorkOrders.map((order, index) => (
//                                             <tr key={`${order.id}-${index}`}>
//                                                 {displayColumns.map(col => (
//                                                     <td key={col.key}>{col.key === 'tot_value' ? parseFloat(order[col.key] || 0).toLocaleString('en-US') : formatData(order[col.key])}</td>
//                                                 ))}
//                                             </tr>
//                                         ))}
//                                     </tbody>
//                                 </table>
//                             </div>
//                         ) : (<p className="no-data-message">No work orders found for the current filter.</p>)}
//                     </>
//                 ) : (
//                     <>
//                         {assetsLoading && <p className="loading-message">Loading Assets...</p>}
//                         {assetsError && <p className="error-message">Error: {assetsError}</p>}
//                         {!assetsLoading && !assetsError && (
//                             <>
//                                 {assets.length > 0 ? (
//                                     <div className="table-scroll-container">
//                                         <table className="data-table wide-table">
//                                             <thead>
//                                                 <tr><th>Asset Name</th><th>Asset Type</th><th>Capacity (MT)</th><th>Year of Purchase</th><th>Year of Manufacture</th></tr>
//                                             </thead>
//                                             <tbody>
//                                                 {assets.map(asset => {
//                                                     const combinedAssetName = [asset.name, asset.serial_number, asset.asset_code, asset.registration_number].filter(Boolean).join(' | ');
//                                                     return (
//                                                         <tr key={asset.id}>
//                                                             <td>{combinedAssetName || 'N/A'}</td>
//                                                             <td>{formatData(asset.asset_type)}</td>
//                                                             <td>{formatData(asset.capacity_mt)}</td>
//                                                             <td>{formatData(asset.year_of_purchase)}</td>
//                                                             <td>{formatData(asset.year_of_manufacture)}</td>
//                                                         </tr>
//                                                     );
//                                                 })}
//                                             </tbody>
//                                         </table>
//                                     </div>
//                                 ) : (<p className="no-data-message">No assets found for the current work orders.</p>)}
//                             </>
//                         )}
//                     </>
//                 )}
//             </div>
//         </div>
//     );
// };
 
// // ====================================================================
// // --- Component for Asset Availability Table ---
// // ====================================================================
// const AssetAvailabilityTable = ({ workOrders, apiToken }) => {
//     const [combinedAssets, setCombinedAssets] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);
//     const [filterDays, setFilterDays] = useState(null);
//     const [customDays, setCustomDays] = useState('');
 
//     useEffect(() => {
//         const fetchAndCombineData = async () => {
//             setLoading(true);
//             setError(null);
           
//             const workOrderInfoMap = new Map();
//             if (workOrders && Array.isArray(workOrders)) {
//                 workOrders.forEach(wo => {
//                     if (wo.asset_id != null) {
//                         workOrderInfoMap.set(Number(wo.asset_id), { wo_start: wo.wo_start, wo_end: wo.wo_end, wo_no: wo.wo_no });
//                     }
//                 });
//             }
           
//             const ASSET_API_URL = `${process.env.REACT_APP_ASSET_SERVICE_BASE_URL}/api/assets/`;
//             const ASSET_HEADERS = { 'accept': 'application/json', 'Authorization': apiToken };
 
//             try {
//                 const response = await fetch(ASSET_API_URL, { headers: ASSET_HEADERS });
//                 if (!response.ok) {
//                     throw new Error(`Failed to fetch assets, status: ${response.status}`);
//                 }
//                 const allAssets = await response.json();
//                 const activeAssets = allAssets.filter(asset => asset.active === true);
 
//                 const combinedData = activeAssets.map(asset => {
//                     const workOrderInfo = workOrderInfoMap.get(asset.id) || { wo_start: null, wo_end: null, wo_no: null };
//                     return { ...asset, ...workOrderInfo };
//                 });
               
//                 setCombinedAssets(combinedData);
//             } catch (error) {
//                 console.error("Failed to fetch asset data:", error);
//                 setError(error.message);
//             } finally {
//                 setLoading(false);
//             }
//         };
 
//         fetchAndCombineData();
//     }, [workOrders, apiToken]);
 
//     const filteredAssets = useMemo(() => {
//         if (filterDays === null) return combinedAssets;
//         const targetDate = new Date();
//         targetDate.setDate(targetDate.getDate() + filterDays);
//         targetDate.setHours(23, 59, 59, 999);
//         return combinedAssets.filter(asset => {
//             if (!asset.wo_end) return true;
//             const woEndDate = new Date(asset.wo_end);
//             return isNaN(woEndDate.getTime()) || woEndDate <= targetDate;
//         });
//     }, [combinedAssets, filterDays]);
 
//     const formatData = (value) => {
//         if (value === null || typeof value === 'undefined') return 'N/A';
//         if (typeof value === 'boolean') return value ? 'Yes' : 'No';
//         if (typeof value === 'string' && value.includes('T')) {
//             const date = new Date(value);
//             if (!isNaN(date)) return date.toLocaleDateString('en-GB');
//         }
//         return value;
//     };
 
//     const handleCustomFilter = () => {
//         const days = parseInt(customDays, 10);
//         if (days > 0) setFilterDays(days);
//     };
 
//     const clearFilter = () => {
//         setFilterDays(null);
//         setCustomDays('');
//     };
 
//     return (
//         <div className="filtered-table-container">
//             <div className="table-header with-controls">
//                 <h3>Asset Availability</h3>
//                 <div className="availability-filter-controls">
//                     <span>Available In:</span>
//                     {[3, 7, 15, 30].map(days => (
//                         <button key={days} onClick={() => setFilterDays(days)} className={filterDays === days ? 'active' : ''}>{days} Days</button>
//                     ))}
//                     <div className="custom-filter">
//                         <input type="number" placeholder="Custom" value={customDays} onChange={(e) => setCustomDays(e.target.value)} min="1"/>
//                         <button onClick={handleCustomFilter}>Go</button>
//                     </div>
//                     <button onClick={clearFilter}>Clear Filter</button>
//                 </div>
//             </div>
//             <div className="table-content-wrapper">
//                 {loading && <p className="loading-message">Loading Assets...</p>}
//                 {error && <p className="error-message">Error: {error}</p>}
//                 {!loading && !error && (
//                     <>
//                         {filteredAssets.length > 0 ? (
//                             <div className="table-scroll-container">
//                                 <table className="data-table wide-table">
//                                     <thead>
//                                         <tr><th>ID</th><th>Asset Name</th><th>Asset Type</th><th>Capacity (MT)</th><th>Year of Purchase</th><th>Year of Manufacture</th><th>WO No</th><th>WO Start</th><th>WO End</th></tr>
//                                     </thead>
//                                     <tbody>
//                                         {filteredAssets.map(asset => {
//                                             const combinedAssetName = [asset.name, asset.serial_number, asset.asset_code, asset.registration_number].filter(Boolean).join(' | ');
//                                             return (
//                                                 <tr key={asset.id}>
//                                                     <td>{formatData(asset.id)}</td>
//                                                     <td>{combinedAssetName || 'N/A'}</td>
//                                                     <td>{formatData(asset.asset_type)}</td>
//                                                     <td>{formatData(asset.capacity_mt)}</td>
//                                                     <td>{formatData(asset.year_of_purchase)}</td>
//                                                     <td>{formatData(asset.year_of_manufacture)}</td>
//                                                     <td>{formatData(asset.wo_no)}</td>
//                                                     <td>{formatData(asset.wo_start)}</td>
//                                                     <td>{formatData(asset.wo_end)}</td>
//                                                 </tr>
//                                             );
//                                         })}
//                                     </tbody>
//                                 </table>
//                             </div>
//                         ) : (<p className="no-data-message">{filterDays !== null ? "No assets match the current availability filter." : "No active assets found."}</p>)}
//                     </>
//                 )}
//             </div>
//         </div>
//     );
// };
 
// // ====================================================================
// // --- Component for the Work Orders Tab Content ---
// // ====================================================================
// const WorkOrderDashboardContent = ({
//     loading, error, statusPieChartData, sectorBarChartData,
//     topCustomersData, filteredWorkOrders, filters, onChartClick, onClearFilters, apiToken
// }) => {
//     const statusChartRef = useRef();
//     const sectorChartRef = useRef();
//     const customerChartRef = useRef();
 
//     const handleChartClick = (filterType, chartData, event, chartRef) => {
//         if (!chartRef.current) return;
//         const elements = getElementAtEvent(chartRef.current, event);
//         if (elements.length > 0) {
//             const clickedLabel = chartData.labels[elements[0].index];
//             onChartClick(filterType, clickedLabel);
//         }
//     };
 
//     const hasFilters = Object.keys(filters).length > 0;
   
//     if (loading) return <div className="loading-error-container"><h2>Loading Dashboard...</h2></div>;
//     if (error) return <div className="loading-error-container"><h2>Dashboard Error</h2><p>{error}</p></div>;
 
//     return (
//         <main className="main-content">
//              <div className="dashboard-title-bar">
//                 <h1 className="dashboard-header">Work Orders Dashboard</h1>
//                 {hasFilters && (<button onClick={onClearFilters} className="clear-filters-btn">Clear Filters</button>)}
//             </div>
//             <div className="dashboard-grid">
//                 <div className="chart-card">
//                     <h3>Work Orders by Status</h3>
//                     <Pie ref={statusChartRef} data={statusPieChartData} options={{ responsive: true, plugins: { legend: { position: 'top' }, datalabels: { color: '#343a40', font: { weight: 'bold', size: 16 }, formatter: (value) => (value > 0 ? value : null) } } }} onClick={(event) => handleChartClick('status', statusPieChartData, event, statusChartRef)}/>
//                 </div>
//                 <div className="chart-card">
//                     <h3>Work Orders by Sector</h3>
//                     <Bar ref={sectorChartRef} data={sectorBarChartData} options={{ responsive: true, scales: { y: { beginAtZero: true } } }} onClick={(event) => handleChartClick('sector', sectorBarChartData, event, sectorChartRef)}/>
//                 </div>
//                 <div className="chart-card">
//                     <h3>Top Customers by Order Value</h3>
//                      <Bar ref={customerChartRef} data={topCustomersData} options={{ responsive: true, scales: { y: { beginAtZero: true } } }} onClick={(event) => handleChartClick('customer', topCustomersData, event, customerChartRef)}/>
//                 </div>
//                 <div className="chart-card table-card">
//                     <FilteredWorkOrderTable workOrders={filteredWorkOrders} apiToken={apiToken} />
//                 </div>
//                 <div className="chart-card table-card">
//                      <AssetAvailabilityTable workOrders={filteredWorkOrders} apiToken={apiToken} />
//                 </div>
//             </div>
//         </main>
//     );
// };

// // ====================================================================
// // --- Component for Invoice Data Table ---
// // ====================================================================
// const InvoiceDataTable = ({ invoices, workOrders }) => {
//     const customerNameMap = useMemo(() => {
//         const map = new Map();
//         if (Array.isArray(workOrders)) {
//             workOrders.forEach(wo => {
//                 if (wo.cust_id && wo.customer_name) {
//                     map.set(wo.cust_id, wo.customer_name);
//                 }
//             });
//         }
//         return map;
//     }, [workOrders]);

//     const columns = [
//         { header: 'ID', key: 'id' },
//         { header: 'Doc No', key: 'doc_no' },
//         { header: 'Customer ID', key: 'cust_id' },
//         { header: 'Customer Name', key: 'customer_name' },
//         { header: 'Work Order ID', key: 'wo_id' },
//         { header: 'Invoice Date', key: 'inv_date' },
//         { header: 'Due Date', key: 'due_date' },
//         { header: 'Start Date', key: 'start_date' },
//         { header: 'End Date', key: 'end_date' },
//         { header: 'Taxable Amt', key: 'taxable_amt' },
//         { header: 'CGST', key: 'tot_cgst' },
//         { header: 'SGST', key: 'tot_sgst' },
//         { header: 'IGST', key: 'tot_igst' },
//         { header: 'Total Amount', key: 'amount' },
//         { header: 'Approval Status', key: 'inv_approval_status' },
//         { header: 'Current Status', key: 'current_status' },
//         { header: 'Stage', key: 'stage' },
//         { header: 'Created By', key: 'added_by' },
//         { header: 'Created Date', key: 'add_date' },
//         { header: 'Updated By', key: 'updated_by' },
//         { header: 'Updated Date', key: 'update_date' },
//     ];

//     const formatData = (value, key) => {
//         if (value === null || typeof value === 'undefined') return 'N/A';

//         const currencyKeys = ['taxable_amt', 'amount', 'tot_cgst', 'tot_sgst', 'tot_igst'];
//         if (currencyKeys.includes(key)) {
//             const numberValue = parseFloat(value);
//             return isNaN(numberValue) ? 'N/A' : numberValue.toLocaleString('en-IN', { style: 'currency', currency: 'INR' });
//         }

//         if (typeof value === 'string' && value.includes('T')) {
//             const date = new Date(value);
//             return !isNaN(date) ? date.toLocaleDateString('en-GB') : 'N/A';
//         }

//         return value;
//     };

//     const sortedInvoices = useMemo(() => {
//         if (!Array.isArray(invoices)) return [];
//         return [...invoices].sort((a, b) => new Date(b.inv_date || b.add_date) - new Date(a.inv_date || a.add_date));
//     }, [invoices]);

//     if (sortedInvoices.length === 0) {
//         return (
//             <div className="filtered-table-container">
//                  <div className="table-header"><h3>All Invoices</h3></div>
//                  <p className="no-data-message" style={{ padding: '20px' }}>No invoice data matching the current filter.</p>
//             </div>
//         )
//     }

//     return (
//         <div className="filtered-table-container">
//             <div className="table-header"><h3>All Invoices</h3></div>
//             <div className="table-content-wrapper">
//                 <div className="table-scroll-container">
//                     <table className="data-table wide-table">
//                         <thead>
//                             <tr>
//                                 {columns.map(col => <th key={col.key}>{col.header}</th>)}
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {sortedInvoices.map((invoice) => (
//                                 <tr key={invoice.id}>
//                                     {columns.map(col => {
//                                         let cellValue;
//                                         if (col.key === 'customer_name') {
//                                             cellValue = customerNameMap.get(invoice.cust_id) || 'N/A';
//                                         } else {
//                                             cellValue = formatData(invoice[col.key], col.key);
//                                         }
//                                         return <td key={col.key}>{cellValue}</td>;
//                                     })}
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         </div>
//     );
// };
 
// // ====================================================================
// // --- Component for the Invoices Tab (UPDATED) ---
// // ====================================================================
// const InvoiceDashboardContent = ({ invoices, workOrders, loading, error }) => {
//     const today = new Date();
//     const thirtyDaysAgo = new Date(new Date().setDate(today.getDate() - 30));
//     const formatDateForInput = (date) => date.toISOString().split('T')[0];
   
//     const [startDate, setStartDate] = useState(formatDateForInput(thirtyDaysAgo));
//     const [endDate, setEndDate] = useState(formatDateForInput(new Date()));
//     const [statusFilter, setStatusFilter] = useState(null); // State for card filter
//     const tableRef = useRef(null); // Ref for scrolling to the table

//     const filteredInvoicesByDate = useMemo(() => {
//         if (!Array.isArray(invoices) || !startDate || !endDate) return [];
//         const start = new Date(startDate);
//         const end = new Date(endDate);
//         end.setHours(23, 59, 59, 999);
//         return invoices.filter(inv => {
//             const invoiceDate = new Date(inv.inv_date || inv.add_date);
//             return !isNaN(invoiceDate) && invoiceDate >= start && invoiceDate <= end;
//         });
//     }, [invoices, startDate, endDate]);
 
//     const dashboardData = useMemo(() => {
//         const EMPTY_CHART_DATA = { labels: [], datasets: [{ data: [] }] };
//         const baseKpis = {
//             totalInvoices: 0, totalTaxable: 0, totalGst: 0, avgCreditPeriod: 0,
//             draftedCount: 0, waitingForDigisignCount: 0, rejectedCount: 0, completedCount: 0
//         };

//         if (filteredInvoicesByDate.length === 0) {
//             return { kpis: baseKpis, customerData: EMPTY_CHART_DATA, lifecycleData: EMPTY_CHART_DATA };
//         }

//         const customerNameMap = new Map();
//         if (Array.isArray(workOrders)) {
//             workOrders.forEach(wo => {
//                 if (wo.cust_id && wo.customer_name) {
//                     customerNameMap.set(wo.cust_id, wo.customer_name);
//                 }
//             });
//         }
 
//         const totalInvoices = filteredInvoicesByDate.length;
//         const totalTaxable = filteredInvoicesByDate.reduce((sum, inv) => sum + (Number(inv.taxable_amt) || 0), 0);
//         const totalGst = filteredInvoicesByDate.reduce((sum, inv) => sum + (Number(inv.tot_cgst) || 0) + (Number(inv.tot_sgst) || 0) + (Number(inv.tot_igst) || 0) + (Number(inv.tot_cess) || 0) + (Number(inv.tot_kkc) || 0), 0);
//         const creditPeriods = filteredInvoicesByDate.map(inv => Number(inv.cr_period)).filter(p => p > 0);
//         const avgCreditPeriod = creditPeriods.length > 0 ? (creditPeriods.reduce((a, b) => a + b, 0) / creditPeriods.length).toFixed(2) : 0;
       
//         const statusCounts = filteredInvoicesByDate.reduce((acc, inv) => {
//             const status = inv.current_status || 'Unknown';
//             acc[status] = (acc[status] || 0) + 1;
//             return acc;
//         }, {});

//         const customerAggregates = filteredInvoicesByDate.reduce((acc, inv) => {
//             const customerName = customerNameMap.get(inv.cust_id) || `Customer ${inv.cust_id}` || 'Unknown Customer';
//             acc[customerName] = (acc[customerName] || 0) + (Number(inv.taxable_amt) || 0);
//             return acc;
//         }, {});
//         const sortedCustomers = Object.entries(customerAggregates).sort(([,a], [,b]) => b - a).slice(0, 10);
//         const customerData = { labels: sortedCustomers.map(([name]) => name), datasets: [{ label: 'Total Taxable Amount', data: sortedCustomers.map(([, amount]) => amount), backgroundColor: 'rgba(153, 102, 255, 0.6)' }] };
 
//         const lifecycleCounts = filteredInvoicesByDate.reduce((acc, inv) => { inv.inv_complete ? acc.completed++ : acc.pending++; return acc; }, { pending: 0, completed: 0 });
//         const lifecycleData = { labels: ['Pending', 'Completed'], datasets: [{ data: [lifecycleCounts.pending, lifecycleCounts.completed], backgroundColor: ['#FF6384', '#36A2EB'], borderColor: '#fff', borderWidth: 2 }] };
       
//         return {
//             kpis: {
//                 totalInvoices, totalTaxable, totalGst, avgCreditPeriod,
//                 // ACTION REQUIRED: Check if these strings match your API's `current_status` values EXACTLY.
//                 draftedCount: statusCounts['Drafted'] || 0,
//                 waitingForDigisignCount: statusCounts['Waiting for Digisign'] || 0,
//                 rejectedCount: statusCounts['Rejected'] || 0,
//                 completedCount: statusCounts['Completed'] || 0,
//             },
//             customerData, lifecycleData
//         };
//     }, [filteredInvoicesByDate, workOrders]);
    
//     // This derived state will hold the final list of invoices for the table
//     const finalFilteredInvoices = useMemo(() => {
//         if (!statusFilter) {
//             return filteredInvoicesByDate; // If no card is clicked, show all (date-filtered) invoices
//         }
//         return filteredInvoicesByDate.filter(inv => inv.current_status === statusFilter);
//     }, [filteredInvoicesByDate, statusFilter]);

//     const handleCardClick = (status) => {
//         setStatusFilter(status);
//         // Scroll to the table after a short delay to allow the state to update
//         setTimeout(() => {
//             tableRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
//         }, 100);
//     };

//     if (loading) return <div className="loading-error-container"><h2>Loading Invoice Dashboard...</h2></div>;
//     if (error) return <div className="loading-error-container"><h2>Dashboard Error</h2><p>{error}</p></div>;
 
//     const formatCurrency = (value) => new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(value);
//     const pieOptions = { responsive: true, plugins: { legend: { position: 'bottom' }, datalabels: { color: '#fff', font: { weight: 'bold' }, formatter: (value) => (value > 0 ? value : '') } } };
 
//     return (
//         <main className="main-content">
//             <div className="dashboard-title-bar">
//                 <h1 className="dashboard-header">Invoice Dashboard</h1>
//                 {statusFilter && (<button onClick={() => setStatusFilter(null)} className="clear-filters-btn">Clear Filter</button>)}
//             </div>
//             <div className="filter-bar">
//                 <div className="filter-item"><label htmlFor="start-date">Start Date:</label><input type="date" id="start-date" value={startDate} onChange={(e) => setStartDate(e.target.value)} /></div>
//                 <div className="filter-item"><label htmlFor="end-date">End Date:</label><input type="date" id="end-date" value={endDate} onChange={(e) => setEndDate(e.target.value)} /></div>
//             </div>
           
//             <div className="kpi-grid">
//                 <div className={`kpi-card ${statusFilter === null ? 'active' : ''}`} onClick={() => setStatusFilter(null)}><h4>Total Invoices</h4><p>{dashboardData.kpis.totalInvoices}</p></div>
//                 <div className="kpi-card"><h4>Total Taxable Amount</h4><p>{formatCurrency(dashboardData.kpis.totalTaxable)}</p></div>
//                 <div className="kpi-card"><h4>Total GST Collected</h4><p>{formatCurrency(dashboardData.kpis.totalGst)}</p></div>
//                 <div className="kpi-card"><h4>Avg. Credit Period</h4><p>{dashboardData.kpis.avgCreditPeriod} Days</p></div>
//                 {/* Clickable KPI Cards */}
//                 <div className={`kpi-card ${statusFilter === 'Drafted' ? 'active' : ''}`} onClick={() => handleCardClick('Drafted')}><h4>Drafted</h4><p>{dashboardData.kpis.draftedCount}</p></div>
//                 <div className={`kpi-card ${statusFilter === 'Waiting for Digisign' ? 'active' : ''}`} onClick={() => handleCardClick('Waiting for Digisign')}><h4>Waiting for Digisign</h4><p>{dashboardData.kpis.waitingForDigisignCount}</p></div>
//                 <div className={`kpi-card ${statusFilter === 'Rejected' ? 'active' : ''}`} onClick={() => handleCardClick('Rejected')}><h4>Rejected</h4><p>{dashboardData.kpis.rejectedCount}</p></div>
//                 <div className={`kpi-card ${statusFilter === 'Completed' ? 'active' : ''}`} onClick={() => handleCardClick('Completed')}><h4>Completed</h4><p>{dashboardData.kpis.completedCount}</p></div>
//             </div>
           
//             <div className="dashboard-grid">
//                 <div className="chart-card large-card">
//                   <h3>Customer Wise Invoices (Top 10 by Amount)</h3>
//                   {finalFilteredInvoices.length > 0 ? <Bar data={dashboardData.customerData} options={{ responsive: true, scales: { y: { beginAtZero: true } } }} /> : <p className="no-data-message">No data for selected date range.</p>}
//                 </div>
//                 <div className="chart-card">
//                   <h3>Pending vs Completed Invoices</h3>
//                   {finalFilteredInvoices.length > 0 ? <Pie data={dashboardData.lifecycleData} options={pieOptions} /> : <p className="no-data-message">No data available.</p>}
//                 </div>
//             </div>

//             <div ref={tableRef} className="invoice-table-section" style={{ marginTop: '2rem' }}>
//                 <InvoiceDataTable invoices={finalFilteredInvoices} workOrders={workOrders} />
//             </div>
//         </main>
//     );
// };
 
 
// // ====================================================================
// // --- Main Dashboard Component ---
// // ====================================================================
// const Dashboard = () => {
//     const [activeTab, setActiveTab] = useState('workOrder');
//     const [workOrderTableReport, setWorkOrderTableReport] = useState({ columns: [], data: [] });
//     const [invoices, setInvoices] = useState([]);
//     const [filters, setFilters] = useState({});
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
 
//     const API_TOKEN = 'Bearer ' + localStorage.getItem('zTaskAuthToken');
 
//     const handleApiResponse = async (response) => {
//         if (!response.ok) {
//             const errorText = await response.text();
//             const truncatedError = errorText.length > 200 ? errorText.substring(0, 200) + '...' : errorText;
//             throw new Error(`API call to ${response.url} failed with status ${response.status}: ${response.statusText}. Response: ${truncatedError}`);
//         }
//         return response.json();
//     };
 
//     useEffect(() => {
//         const fetchAllData = async () => {
//             setLoading(true);
//             setError(null);
 
//             const REPORT_API_URL = `${process.env.REACT_APP_REPORTS_API_URL}/api/reports/run`;
//             const INVOICE_API_URL = `${process.env.REACT_APP_NODE_SERVICE_BASE_URL}/invoice/api/invoices/`;
 
//             const HEADERS = { 'accept': 'application/json', 'Authorization': API_TOKEN };
//             const TABLE_REPORT_BODY = { "report_name": "work_order_table", "module_name": "Workorder" };
           
//             try {
//                 const [tableReportJson, invoiceJson] = await Promise.all([
//                     fetch(REPORT_API_URL, { method: 'POST', headers: { ...HEADERS, 'Content-Type': 'application/json' }, body: JSON.stringify(TABLE_REPORT_BODY) }).then(handleApiResponse),
//                     fetch(INVOICE_API_URL, { headers: HEADERS }).then(handleApiResponse)
//                 ]);
               
//                 if (tableReportJson && tableReportJson.columns && tableReportJson.data) setWorkOrderTableReport(tableReportJson);
//                 setInvoices(Array.isArray(invoiceJson) ? invoiceJson : []);
//             } catch (e) {
//                 console.error("Failed to fetch dashboard data:", e);
//                 setError(e.message);
//             } finally {
//                 setLoading(false);
//             }
//         };
//         fetchAllData();
//     }, []);
 
//     const handleChartClick = (filterType, clickedLabel) => setFilters(prev => ({ ...prev, [filterType]: clickedLabel }));
//     const clearFilters = () => setFilters({});
   
//     const uniqueWorkOrders = useMemo(() => {
//         const data = workOrderTableReport.data;
//         if (!Array.isArray(data)) return [];
//         const uniqueWoMap = new Map();
//         data.forEach(order => {
//             if (!uniqueWoMap.has(order.wo_id)) {
//                 uniqueWoMap.set(order.wo_id, { ...order, tot_value: parseFloat(order.tot_value) || 0 });
//             }
//         });
//         return Array.from(uniqueWoMap.values());
//     }, [workOrderTableReport.data]);
 
//     const statusPieChartData = useMemo(() => {
//         const statusCounts = uniqueWorkOrders.reduce((acc, order) => {
//             const status = order.wo_open_close || 'Unknown';
//             acc[status] = (acc[status] || 0) + 1;
//             return acc;
//         }, { 'Open': 0, 'Closed': 0 });
//         return { labels: Object.keys(statusCounts), datasets: [{ data: Object.values(statusCounts), backgroundColor: ['#ff8a80', '#80d8ff'], borderColor: '#ffffff', borderWidth: 3 }] };
//     }, [uniqueWorkOrders]);
 
//     const sectorBarChartData = useMemo(() => {
//         const sectorData = uniqueWorkOrders.reduce((acc, wo) => {
//             const sectorName = wo.sector_name || 'Unknown Sector';
//             if (!acc[sectorName]) acc[sectorName] = { count: 0, totalValue: 0 };
//             acc[sectorName].count += 1;
//             acc[sectorName].totalValue += wo.tot_value;
//             return acc;
//         }, {});
//         const labels = Object.keys(sectorData).sort();
//         return { labels, datasets: [
//             { label: 'Number of Orders', data: labels.map(l => sectorData[l].count), backgroundColor: 'rgba(255, 159, 64, 0.8)' },
//             { label: 'Total Value', data: labels.map(l => sectorData[l].totalValue), backgroundColor: 'rgba(75, 192, 192, 0.8)' }
//         ] };
//     }, [uniqueWorkOrders]);
   
//     const topCustomersData = useMemo(() => {
//         const customerAggregates = uniqueWorkOrders.reduce((acc, wo) => {
//             const customerName = wo.customer_name || 'Unknown Customer';
//             acc[customerName] = (acc[customerName] || 0) + wo.tot_value;
//             return acc;
//         }, {});
//         const sortedCustomers = Object.entries(customerAggregates).sort(([, a], [, b]) => b - a).slice(0, 5);
//         return { labels: sortedCustomers.map(([label]) => label), datasets: [{ label: 'Total Order Value', data: sortedCustomers.map(([, value]) => value), backgroundColor: 'rgba(54, 162, 235, 0.8)' }] };
//     }, [uniqueWorkOrders]);
 
//     const filteredWorkOrders = useMemo(() => {
//         let data = workOrderTableReport.data || [];
//         if (Object.keys(filters).length === 0) return data;
//         const woIdsToKeep = new Set(uniqueWorkOrders
//             .filter(wo => (!filters.status || wo.wo_open_close === filters.status) && (!filters.sector || wo.sector_name === filters.sector) && (!filters.customer || wo.customer_name === filters.customer))
//             .map(wo => wo.wo_id)
//         );
//         return data.filter(order => woIdsToKeep.has(order.wo_id));
//     }, [workOrderTableReport.data, uniqueWorkOrders, filters]);
 
//     return (
//         <div className="dashboard-container">
//             <div className="tabs-container">
//                 <button className={`tab-button ${activeTab === 'workOrder' ? 'active' : ''}`} onClick={() => setActiveTab('workOrder')}>Work Orders</button>
//                 <button className={`tab-button ${activeTab === 'invoice' ? 'active' : ''}`} onClick={() => setActiveTab('invoice')}>Invoices</button>
//             </div>
//             <div className="tab-content">
//                 {activeTab === 'workOrder' && (
//                     <WorkOrderDashboardContent
//                         loading={loading} error={error} statusPieChartData={statusPieChartData}
//                         sectorBarChartData={sectorBarChartData}
//                         topCustomersData={topCustomersData} filteredWorkOrders={filteredWorkOrders}
//                         filters={filters} onChartClick={handleChartClick} onClearFilters={clearFilters}
//                         apiToken={API_TOKEN}
//                     />
//                 )}
//                 {activeTab === 'invoice' && (
//                     <InvoiceDashboardContent 
//                         invoices={invoices} 
//                         workOrders={workOrderTableReport.data}
//                         loading={loading} 
//                         error={error} 
//                     />
//                 )}
//             </div>
//         </div>
//     );
// };
 
// export default Dashboard;










// import React, { useState, useEffect, useMemo, useRef } from 'react';
// import { Pie, Bar, getElementAtEvent } from 'react-chartjs-2';
// import {
//     Chart as ChartJS,
//     CategoryScale,
//     LinearScale,
//     BarElement,
//     Title,
//     Tooltip,
//     Legend,
//     ArcElement
// } from 'chart.js';
// import ChartDataLabels from 'chartjs-plugin-datalabels';
// import './Dashboard.css'; // Renamed CSS import
 
// ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement, ChartDataLabels);
 
// // ====================================================================
// // --- Component for Work Order Table ---
// // ====================================================================
// const FilteredWorkOrderTable = ({ workOrders, apiToken }) => {
//     const [activeTab, setActiveTab] = useState('assets');
//     const [assets, setAssets] = useState([]);
//     const [assetsLoading, setAssetsLoading] = useState(false);
//     const [assetsError, setAssetsError] = useState(null);
 
//     useEffect(() => {
//         const fetchAssets = async () => {
//             if (!workOrders || workOrders.length === 0) {
//                 setAssets([]);
//                 return;
//             }
//             const assetIdSet = new Set(workOrders.map(wo => wo.asset_id).filter(id => id != null));
//             const assetIds = Array.from(assetIdSet);
//             if (assetIds.length === 0) {
//                 setAssets([]);
//                 return;
//             }
           
//             setAssetsLoading(true);
//             setAssetsError(null);
           
//             const ASSET_API_URL = `${process.env.REACT_APP_ASSET_SERVICE_BASE_URL}/api/assets/`;
//             const ASSET_HEADERS = { 'accept': 'application/json', 'Authorization': apiToken };
 
//             try {
//                 const assetPromises = assetIds.map(id =>
//                     fetch(`${ASSET_API_URL}${id}`, { headers: ASSET_HEADERS }).then(res => {
//                         if (!res.ok) {
//                             console.error(`Failed to fetch asset ${id}, status: ${res.status}`);
//                             return null;
//                         }
//                         return res.json();
//                     })
//                 );
//                 const fetchedAssetsResults = await Promise.all(assetPromises);
//                 setAssets(fetchedAssetsResults.filter(asset => asset !== null));
//             } catch (error) {
//                 console.error("Failed to fetch assets:", error);
//                 setAssetsError(error.message);
//             } finally {
//                 setAssetsLoading(false);
//             }
//         };
//         fetchAssets();
//     }, [workOrders, apiToken]);
 
//     const displayedWorkOrders = useMemo(() => {
//         if (!workOrders || !Array.isArray(workOrders)) return [];
//         return [...workOrders].sort((a, b) => new Date(b.add_date) - new Date(a.add_date));
//     }, [workOrders]);
 
//     const formatData = (value) => {
//         if (value === null || typeof value === 'undefined') return 'N/A';
//         if (typeof value === 'boolean') return value ? 'Yes' : 'No';
//         if (typeof value === 'string' && value.includes('T')) {
//             const date = new Date(value);
//             if (!isNaN(date)) return date.toLocaleDateString('en-GB');
//         }
//         return value;
//     };
 
//     const displayColumns = [
//         { header: 'Doc No', key: 'doc_no' }, { header: 'WO No', key: 'wo_no' },
//         { header: 'Status', key: 'wo_open_close' }, { header: 'Total Value', key: 'tot_value' },
//         { header: 'Customer Name', key: 'customer_name' }, { header: 'Customer ID', key: 'cust_id' },
//         { header: 'Project Name', key: 'project_name' }, { header: 'Project ID', key: 'project_id' },
//         { header: 'Sector Name', key: 'sector_name' }, { header: 'Sector ID', key: 'sector' },
//         { header: 'Asset ID', key: 'asset_id' }, { header: 'WO Date', key: 'wo_date' },
//         { header: 'WO Start', key: 'wo_start' }, { header: 'WO End', key: 'wo_end' },
//     ];
 
//     return (
//         <div className="filtered-table-container">
//             <div className="table-header"><h3>All Work Orders</h3></div>
//             <div className="table-controls">
//                 <div className="tabs">
//                     <button className={`tab-btn ${activeTab === 'assets' ? 'active' : ''}`} onClick={() => setActiveTab('assets')}>Assets</button>
//                     <button className={`tab-btn ${activeTab === 'workorder' ? 'active' : ''}`} onClick={() => setActiveTab('workorder')}>Workorder</button>
//                 </div>
//             </div>
//             <div className="table-content-wrapper">
//                 {activeTab === 'workorder' ? (
//                     <>
//                         {displayedWorkOrders.length > 0 ? (
//                             <div className="table-scroll-container">
//                                 <table className="data-table wide-table">
//                                     <thead><tr>{displayColumns.map(col => <th key={col.key}>{col.header}</th>)}</tr></thead>
//                                     <tbody>
//                                         {displayedWorkOrders.map((order, index) => (
//                                             <tr key={`${order.id}-${index}`}>
//                                                 {displayColumns.map(col => (
//                                                     <td key={col.key}>{col.key === 'tot_value' ? parseFloat(order[col.key] || 0).toLocaleString('en-US') : formatData(order[col.key])}</td>
//                                                 ))}
//                                             </tr>
//                                         ))}
//                                     </tbody>
//                                 </table>
//                             </div>
//                         ) : (<p className="no-data-message">No work orders found for the current filter.</p>)}
//                     </>
//                 ) : (
//                     <>
//                         {assetsLoading && <p className="loading-message">Loading Assets...</p>}
//                         {assetsError && <p className="error-message">Error: {assetsError}</p>}
//                         {!assetsLoading && !assetsError && (
//                             <>
//                                 {assets.length > 0 ? (
//                                     <div className="table-scroll-container">
//                                         <table className="data-table wide-table">
//                                             <thead>
//                                                 <tr><th>Asset Name</th><th>Asset Type</th><th>Capacity (MT)</th><th>Year of Purchase</th><th>Year of Manufacture</th></tr>
//                                             </thead>
//                                             <tbody>
//                                                 {assets.map(asset => {
//                                                     const combinedAssetName = [asset.name, asset.serial_number, asset.asset_code, asset.registration_number].filter(Boolean).join(' | ');
//                                                     return (
//                                                         <tr key={asset.id}>
//                                                             <td>{combinedAssetName || 'N/A'}</td>
//                                                             <td>{formatData(asset.asset_type)}</td>
//                                                             <td>{formatData(asset.capacity_mt)}</td>
//                                                             <td>{formatData(asset.year_of_purchase)}</td>
//                                                             <td>{formatData(asset.year_of_manufacture)}</td>
//                                                         </tr>
//                                                     );
//                                                 })}
//                                             </tbody>
//                                         </table>
//                                     </div>
//                                 ) : (<p className="no-data-message">No assets found for the current work orders.</p>)}
//                             </>
//                         )}
//                     </>
//                 )}
//             </div>
//         </div>
//     );
// };
 
// // ====================================================================
// // --- Component for Asset Availability Table ---
// // ====================================================================
// const AssetAvailabilityTable = ({ workOrders, apiToken }) => {
//     const [combinedAssets, setCombinedAssets] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);
//     const [filterDays, setFilterDays] = useState(null);
//     const [customDays, setCustomDays] = useState('');
 
//     useEffect(() => {
//         const fetchAndCombineData = async () => {
//             setLoading(true);
//             setError(null);
           
//             const workOrderInfoMap = new Map();
//             if (workOrders && Array.isArray(workOrders)) {
//                 workOrders.forEach(wo => {
//                     if (wo.asset_id != null) {
//                         workOrderInfoMap.set(Number(wo.asset_id), { wo_start: wo.wo_start, wo_end: wo.wo_end, wo_no: wo.wo_no });
//                     }
//                 });
//             }
           
//             const ASSET_API_URL = `${process.env.REACT_APP_ASSET_SERVICE_BASE_URL}/api/assets/`;
//             const ASSET_HEADERS = { 'accept': 'application/json', 'Authorization': apiToken };
 
//             try {
//                 const response = await fetch(ASSET_API_URL, { headers: ASSET_HEADERS });
//                 if (!response.ok) {
//                     throw new Error(`Failed to fetch assets, status: ${response.status}`);
//                 }
//                 const allAssets = await response.json();
//                 const activeAssets = allAssets.filter(asset => asset.active === true);
 
//                 const combinedData = activeAssets.map(asset => {
//                     const workOrderInfo = workOrderInfoMap.get(asset.id) || { wo_start: null, wo_end: null, wo_no: null };
//                     return { ...asset, ...workOrderInfo };
//                 });
               
//                 setCombinedAssets(combinedData);
//             } catch (error) {
//                 console.error("Failed to fetch asset data:", error);
//                 setError(error.message);
//             } finally {
//                 setLoading(false);
//             }
//         };
 
//         fetchAndCombineData();
//     }, [workOrders, apiToken]);
 
//     const filteredAssets = useMemo(() => {
//         if (filterDays === null) return combinedAssets;
//         const targetDate = new Date();
//         targetDate.setDate(targetDate.getDate() + filterDays);
//         targetDate.setHours(23, 59, 59, 999);
//         return combinedAssets.filter(asset => {
//             if (!asset.wo_end) return true;
//             const woEndDate = new Date(asset.wo_end);
//             return isNaN(woEndDate.getTime()) || woEndDate <= targetDate;
//         });
//     }, [combinedAssets, filterDays]);
 
//     const formatData = (value) => {
//         if (value === null || typeof value === 'undefined') return 'N/A';
//         if (typeof value === 'boolean') return value ? 'Yes' : 'No';
//         if (typeof value === 'string' && value.includes('T')) {
//             const date = new Date(value);
//             if (!isNaN(date)) return date.toLocaleDateString('en-GB');
//         }
//         return value;
//     };
 
//     const handleCustomFilter = () => {
//         const days = parseInt(customDays, 10);
//         if (days > 0) setFilterDays(days);
//     };
 
//     const clearFilter = () => {
//         setFilterDays(null);
//         setCustomDays('');
//     };
 
//     return (
//         <div className="filtered-table-container">
//             <div className="table-header with-controls">
//                 <h3>Asset Availability</h3>
//                 <div className="availability-filter-controls">
//                     <span>Available In:</span>
//                     {[3, 7, 15, 30].map(days => (
//                         <button key={days} onClick={() => setFilterDays(days)} className={filterDays === days ? 'active' : ''}>{days} Days</button>
//                     ))}
//                     <div className="custom-filter">
//                         <input type="number" placeholder="Custom" value={customDays} onChange={(e) => setCustomDays(e.target.value)} min="1"/>
//                         <button onClick={handleCustomFilter}>Go</button>
//                     </div>
//                     <button onClick={clearFilter}>Clear Filter</button>
//                 </div>
//             </div>
//             <div className="table-content-wrapper">
//                 {loading && <p className="loading-message">Loading Assets...</p>}
//                 {error && <p className="error-message">Error: {error}</p>}
//                 {!loading && !error && (
//                     <>
//                         {filteredAssets.length > 0 ? (
//                             <div className="table-scroll-container">
//                                 <table className="data-table wide-table">
//                                     <thead>
//                                         <tr><th>ID</th><th>Asset Name</th><th>Asset Type</th><th>Capacity (MT)</th><th>Year of Purchase</th><th>Year of Manufacture</th><th>WO No</th><th>WO Start</th><th>WO End</th></tr>
//                                     </thead>
//                                     <tbody>
//                                         {filteredAssets.map(asset => {
//                                             const combinedAssetName = [asset.name, asset.serial_number, asset.asset_code, asset.registration_number].filter(Boolean).join(' | ');
//                                             return (
//                                                 <tr key={asset.id}>
//                                                     <td>{formatData(asset.id)}</td>
//                                                     <td>{combinedAssetName || 'N/A'}</td>
//                                                     <td>{formatData(asset.asset_type)}</td>
//                                                     <td>{formatData(asset.capacity_mt)}</td>
//                                                     <td>{formatData(asset.year_of_purchase)}</td>
//                                                     <td>{formatData(asset.year_of_manufacture)}</td>
//                                                     <td>{formatData(asset.wo_no)}</td>
//                                                     <td>{formatData(asset.wo_start)}</td>
//                                                     <td>{formatData(asset.wo_end)}</td>
//                                                 </tr>
//                                             );
//                                         })}
//                                     </tbody>
//                                 </table>
//                             </div>
//                         ) : (<p className="no-data-message">{filterDays !== null ? "No assets match the current availability filter." : "No active assets found."}</p>)}
//                     </>
//                 )}
//             </div>
//         </div>
//     );
// };
 
// // ====================================================================
// // --- Component for the Work Orders Tab Content ---
// // ====================================================================
// const WorkOrderDashboardContent = ({
//     loading, error, statusPieChartData, sectorBarChartData,
//     topCustomersData, filteredWorkOrders, filters, onChartClick, onClearFilters, apiToken
// }) => {
//     const statusChartRef = useRef();
//     const sectorChartRef = useRef();
//     const customerChartRef = useRef();
 
//     const handleChartClick = (filterType, chartData, event, chartRef) => {
//         if (!chartRef.current) return;
//         const elements = getElementAtEvent(chartRef.current, event);
//         if (elements.length > 0) {
//             const clickedLabel = chartData.labels[elements[0].index];
//             onChartClick(filterType, clickedLabel);
//         }
//     };
 
//     const hasFilters = Object.keys(filters).length > 0;
   
//     if (loading) return <div className="loading-error-container"><h2>Loading Dashboard...</h2></div>;
//     if (error) return <div className="loading-error-container"><h2>Dashboard Error</h2><p>{error}</p></div>;
 
//     return (
//         <main className="main-content">
//              <div className="dashboard-title-bar">
//                 <h1 className="dashboard-header">Work Orders Dashboard</h1>
//                 {hasFilters && (<button onClick={onClearFilters} className="clear-filters-btn">Clear Filters</button>)}
//             </div>
//             <div className="dashboard-grid">
//                 <div className="chart-card">
//                     <h3>Work Orders by Status</h3>
//                     <Pie ref={statusChartRef} data={statusPieChartData} options={{ responsive: true, plugins: { legend: { position: 'top' }, datalabels: { color: '#343a40', font: { weight: 'bold', size: 16 }, formatter: (value) => (value > 0 ? value : null) } } }} onClick={(event) => handleChartClick('status', statusPieChartData, event, statusChartRef)}/>
//                 </div>
//                 <div className="chart-card">
//                     <h3>Work Orders by Sector</h3>
//                     <Bar ref={sectorChartRef} data={sectorBarChartData} options={{ responsive: true, scales: { y: { beginAtZero: true } } }} onClick={(event) => handleChartClick('sector', sectorBarChartData, event, sectorChartRef)}/>
//                 </div>
//                 <div className="chart-card">
//                     <h3>Top Customers by Order Value</h3>
//                      <Bar ref={customerChartRef} data={topCustomersData} options={{ responsive: true, scales: { y: { beginAtZero: true } } }} onClick={(event) => handleChartClick('customer', topCustomersData, event, customerChartRef)}/>
//                 </div>
//                 <div className="chart-card table-card">
//                     <FilteredWorkOrderTable workOrders={filteredWorkOrders} apiToken={apiToken} />
//                 </div>
//                 <div className="chart-card table-card">
//                      <AssetAvailabilityTable workOrders={filteredWorkOrders} apiToken={apiToken} />
//                 </div>
//             </div>
//         </main>
//     );
// };

// // ====================================================================
// // --- Component for Invoice Data Table ---
// // ====================================================================
// const InvoiceDataTable = ({ invoices, workOrders }) => {
//     const customerNameMap = useMemo(() => {
//         const map = new Map();
//         if (Array.isArray(workOrders)) {
//             workOrders.forEach(wo => {
//                 if (wo.cust_id && wo.customer_name) {
//                     map.set(wo.cust_id, wo.customer_name);
//                 }
//             });
//         }
//         return map;
//     }, [workOrders]);

//     // --- NEW: Create a map for work order data, keyed by wo_id for efficient lookup ---
//     const workOrderMap = useMemo(() => {
//         const map = new Map();
//         if (Array.isArray(workOrders)) {
//             workOrders.forEach(wo => {
//                 // Use wo_id as the key, and store the whole work order object.
//                 // If multiple entries exist for the same wo_id, the first one is used.
//                 if (wo.wo_id && !map.has(wo.wo_id)) {
//                     map.set(wo.wo_id, wo);
//                 }
//             });
//         }
//         return map;
//     }, [workOrders]);

//     // --- MODIFIED: Added new columns related to the work order ---
//     const columns = [
//         { header: 'ID', key: 'id' },
//         { header: 'Doc No', key: 'doc_no' },
//         { header: 'Customer ID', key: 'cust_id' },
//         { header: 'Customer Name', key: 'customer_name' },
//         { header: 'Work Order ID', key: 'wo_id' },
//         // --- NEW COLUMNS START ---
//         { header: 'Work Order No', key: 'wo_no' },
//         { header: 'Work Order Date', key: 'wo_date' },
//         { header: 'Project ID', key: 'project_id' },
//         { header: 'Project Name', key: 'project_name' },
//         // --- NEW COLUMNS END ---
//         { header: 'Invoice Date', key: 'inv_date' },
//         { header: 'Due Date', key: 'due_date' },
//         { header: 'Start Date', key: 'start_date' },
//         { header: 'End Date', key: 'end_date' },
//         { header: 'Taxable Amt', key: 'taxable_amt' },
//         { header: 'CGST', key: 'tot_cgst' },
//         { header: 'SGST', key: 'tot_sgst' },
//         { header: 'IGST', key: 'tot_igst' },
//         { header: 'Total Amount', key: 'amount' },
//         { header: 'Approval Status', key: 'inv_approval_status' },
//         { header: 'Current Status', key: 'current_status' },
//         { header: 'Stage', key: 'stage' },
//         { header: 'Created By', key: 'added_by' },
//         { header: 'Created Date', key: 'add_date' },
//         { header: 'Updated By', key: 'updated_by' },
//         { header: 'Updated Date', key: 'update_date' },
//     ];

//     const formatData = (value, key) => {
//         if (value === null || typeof value === 'undefined') return 'N/A';

//         const currencyKeys = ['taxable_amt', 'amount', 'tot_cgst', 'tot_sgst', 'tot_igst'];
//         if (currencyKeys.includes(key)) {
//             const numberValue = parseFloat(value);
//             return isNaN(numberValue) ? 'N/A' : numberValue.toLocaleString('en-IN', { style: 'currency', currency: 'INR' });
//         }

//         if (typeof value === 'string' && value.includes('T')) {
//             const date = new Date(value);
//             return !isNaN(date) ? date.toLocaleDateString('en-GB') : 'N/A';
//         }

//         return value;
//     };

//     const sortedInvoices = useMemo(() => {
//         if (!Array.isArray(invoices)) return [];
//         return [...invoices].sort((a, b) => new Date(b.inv_date || b.add_date) - new Date(a.inv_date || a.add_date));
//     }, [invoices]);

//     if (sortedInvoices.length === 0) {
//         return (
//             <div className="filtered-table-container">
//                  <div className="table-header"><h3>All Invoices</h3></div>
//                  <p className="no-data-message" style={{ padding: '20px' }}>No invoice data matching the current filter.</p>
//             </div>
//         )
//     }

//     return (
//         <div className="filtered-table-container">
//             <div className="table-header"><h3>All Invoices</h3></div>
//             <div className="table-content-wrapper">
//                 <div className="table-scroll-container">
//                     <table className="data-table wide-table">
//                         <thead>
//                             <tr>
//                                 {columns.map(col => <th key={col.key}>{col.header}</th>)}
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {/* --- MODIFIED: Updated rendering logic to pull data from workOrderMap for new columns --- */}
//                             {sortedInvoices.map((invoice) => {
//                                 const relatedWorkOrder = workOrderMap.get(invoice.wo_id) || {}; // Get related WO, default to empty obj

//                                 return (
//                                     <tr key={invoice.id}>
//                                         {columns.map(col => {
//                                             let cellValue;
//                                             if (col.key === 'customer_name') {
//                                                 cellValue = customerNameMap.get(invoice.cust_id) || 'N/A';
//                                             } else if (['project_id', 'project_name', 'wo_no', 'wo_date'].includes(col.key)) {
//                                                 // Get data from the mapped work order
//                                                 cellValue = formatData(relatedWorkOrder[col.key], col.key);
//                                             } else {
//                                                 // Get data from the invoice object itself
//                                                 cellValue = formatData(invoice[col.key], col.key);
//                                             }
//                                             return <td key={col.key}>{cellValue}</td>;
//                                         })}
//                                     </tr>
//                                 );
//                             })}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         </div>
//     );
// };
 
// // ====================================================================
// // --- Component for the Invoices Tab (UPDATED) ---
// // ====================================================================
// const InvoiceDashboardContent = ({ invoices, workOrders, loading, error }) => {
//     const today = new Date();
//     const thirtyDaysAgo = new Date(new Date().setDate(today.getDate() - 30));
//     const formatDateForInput = (date) => date.toISOString().split('T')[0];
   
//     const [startDate, setStartDate] = useState(formatDateForInput(thirtyDaysAgo));
//     const [endDate, setEndDate] = useState(formatDateForInput(new Date()));
//     const [statusFilter, setStatusFilter] = useState(null); // State for card filter
//     const tableRef = useRef(null); // Ref for scrolling to the table

//     const filteredInvoicesByDate = useMemo(() => {
//         if (!Array.isArray(invoices) || !startDate || !endDate) return [];
//         const start = new Date(startDate);
//         const end = new Date(endDate);
//         end.setHours(23, 59, 59, 999);
//         return invoices.filter(inv => {
//             const invoiceDate = new Date(inv.inv_date || inv.add_date);
//             return !isNaN(invoiceDate) && invoiceDate >= start && invoiceDate <= end;
//         });
//     }, [invoices, startDate, endDate]);
 
//     const dashboardData = useMemo(() => {
//         const EMPTY_CHART_DATA = { labels: [], datasets: [{ data: [] }] };
//         const baseKpis = {
//             totalInvoices: 0, totalTaxable: 0, totalGst: 0, avgCreditPeriod: 0,
//             draftedCount: 0, waitingForDigisignCount: 0, rejectedCount: 0, completedCount: 0
//         };

//         if (filteredInvoicesByDate.length === 0) {
//             return { kpis: baseKpis, customerData: EMPTY_CHART_DATA, lifecycleData: EMPTY_CHART_DATA };
//         }

//         const customerNameMap = new Map();
//         if (Array.isArray(workOrders)) {
//             workOrders.forEach(wo => {
//                 if (wo.cust_id && wo.customer_name) {
//                     customerNameMap.set(wo.cust_id, wo.customer_name);
//                 }
//             });
//         }
 
//         const totalInvoices = filteredInvoicesByDate.length;
//         const totalTaxable = filteredInvoicesByDate.reduce((sum, inv) => sum + (Number(inv.taxable_amt) || 0), 0);
//         const totalGst = filteredInvoicesByDate.reduce((sum, inv) => sum + (Number(inv.tot_cgst) || 0) + (Number(inv.tot_sgst) || 0) + (Number(inv.tot_igst) || 0) + (Number(inv.tot_cess) || 0) + (Number(inv.tot_kkc) || 0), 0);
//         const creditPeriods = filteredInvoicesByDate.map(inv => Number(inv.cr_period)).filter(p => p > 0);
//         const avgCreditPeriod = creditPeriods.length > 0 ? (creditPeriods.reduce((a, b) => a + b, 0) / creditPeriods.length).toFixed(2) : 0;
       
//         const statusCounts = filteredInvoicesByDate.reduce((acc, inv) => {
//             const status = inv.current_status || 'Unknown';
//             acc[status] = (acc[status] || 0) + 1;
//             return acc;
//         }, {});

//         const customerAggregates = filteredInvoicesByDate.reduce((acc, inv) => {
//             const customerName = customerNameMap.get(inv.cust_id) || `Customer ${inv.cust_id}` || 'Unknown Customer';
//             acc[customerName] = (acc[customerName] || 0) + (Number(inv.taxable_amt) || 0);
//             return acc;
//         }, {});
//         const sortedCustomers = Object.entries(customerAggregates).sort(([,a], [,b]) => b - a).slice(0, 10);
//         const customerData = { labels: sortedCustomers.map(([name]) => name), datasets: [{ label: 'Total Taxable Amount', data: sortedCustomers.map(([, amount]) => amount), backgroundColor: 'rgba(153, 102, 255, 0.6)' }] };
 
//         const lifecycleCounts = filteredInvoicesByDate.reduce((acc, inv) => { inv.inv_complete ? acc.completed++ : acc.pending++; return acc; }, { pending: 0, completed: 0 });
//         const lifecycleData = { labels: ['Pending', 'Completed'], datasets: [{ data: [lifecycleCounts.pending, lifecycleCounts.completed], backgroundColor: ['#FF6384', '#36A2EB'], borderColor: '#fff', borderWidth: 2 }] };
       
//         return {
//             kpis: {
//                 totalInvoices, totalTaxable, totalGst, avgCreditPeriod,
//                 // ACTION REQUIRED: Check if these strings match your API's `current_status` values EXACTLY.
//                 draftedCount: statusCounts['Drafted'] || 0,
//                 waitingForDigisignCount: statusCounts['Waiting for Digisign'] || 0,
//                 rejectedCount: statusCounts['Rejected'] || 0,
//                 completedCount: statusCounts['Completed'] || 0,
//             },
//             customerData, lifecycleData
//         };
//     }, [filteredInvoicesByDate, workOrders]);
    
//     // This derived state will hold the final list of invoices for the table
//     const finalFilteredInvoices = useMemo(() => {
//         if (!statusFilter) {
//             return filteredInvoicesByDate; // If no card is clicked, show all (date-filtered) invoices
//         }
//         return filteredInvoicesByDate.filter(inv => inv.current_status === statusFilter);
//     }, [filteredInvoicesByDate, statusFilter]);

//     const handleCardClick = (status) => {
//         setStatusFilter(status);
//         // Scroll to the table after a short delay to allow the state to update
//         setTimeout(() => {
//             tableRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
//         }, 100);
//     };

//     if (loading) return <div className="loading-error-container"><h2>Loading Invoice Dashboard...</h2></div>;
//     if (error) return <div className="loading-error-container"><h2>Dashboard Error</h2><p>{error}</p></div>;
 
//     const formatCurrency = (value) => new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(value);
//     const pieOptions = { responsive: true, plugins: { legend: { position: 'bottom' }, datalabels: { color: '#fff', font: { weight: 'bold' }, formatter: (value) => (value > 0 ? value : '') } } };
 
//     return (
//         <main className="main-content">
            
//             <div className="filter-bar">
//                 <div className="filter-item"><label htmlFor="start-date">Start Date:</label><input type="date" id="start-date" value={startDate} onChange={(e) => setStartDate(e.target.value)} /></div>
//                 <div className="filter-item"><label htmlFor="end-date">End Date:</label><input type="date" id="end-date" value={endDate} onChange={(e) => setEndDate(e.target.value)} /></div>
//             </div>
           
//             <div className="kpi-grid">
//                 <div className={`kpi-card ${statusFilter === null ? 'active' : ''}`} onClick={() => setStatusFilter(null)}><h4>Total Invoices</h4><p>{dashboardData.kpis.totalInvoices}</p></div>
//                 <div className="kpi-card"><h4>Total Taxable Amount</h4><p>{formatCurrency(dashboardData.kpis.totalTaxable)}</p></div>
//                 <div className="kpi-card"><h4>Total GST Collected</h4><p>{formatCurrency(dashboardData.kpis.totalGst)}</p></div>
//                 <div className="kpi-card"><h4>Avg. Credit Period</h4><p>{dashboardData.kpis.avgCreditPeriod} Days</p></div>
//                 {/* Clickable KPI Cards */}
//                 <div className={`kpi-card ${statusFilter === 'Drafted' ? 'active' : ''}`} onClick={() => handleCardClick('Drafted')}><h4>Drafted</h4><p>{dashboardData.kpis.draftedCount}</p></div>
//                 <div className={`kpi-card ${statusFilter === 'Waiting for Digisign' ? 'active' : ''}`} onClick={() => handleCardClick('Waiting for Digisign')}><h4>Waiting for Digisign</h4><p>{dashboardData.kpis.waitingForDigisignCount}</p></div>
//                 <div className={`kpi-card ${statusFilter === 'Rejected' ? 'active' : ''}`} onClick={() => handleCardClick('Rejected')}><h4>Rejected</h4><p>{dashboardData.kpis.rejectedCount}</p></div>
//                 <div className={`kpi-card ${statusFilter === 'Completed' ? 'active' : ''}`} onClick={() => handleCardClick('Completed')}><h4>Completed</h4><p>{dashboardData.kpis.completedCount}</p></div>
//             </div>
           
//             <div className="dashboard-grid">
//                 <div className="chart-card large-card">
//                   <h3>Customer Wise Invoices (Top 10 by Amount)</h3>
//                   {finalFilteredInvoices.length > 0 ? <Bar data={dashboardData.customerData} options={{ responsive: true, scales: { y: { beginAtZero: true } } }} /> : <p className="no-data-message">No data for selected date range.</p>}
//                 </div>
//                 <div className="chart-card">
//                   <h3>Pending vs Completed Invoices</h3>
//                   {finalFilteredInvoices.length > 0 ? <Pie data={dashboardData.lifecycleData} options={pieOptions} /> : <p className="no-data-message">No data available.</p>}
//                 </div>
//             </div>

//             <div ref={tableRef} className="invoice-table-section" style={{ marginTop: '2rem' }}>
//                 <InvoiceDataTable invoices={finalFilteredInvoices} workOrders={workOrders} />
//             </div>
//         </main>
//     );
// };
 
 
// // ====================================================================
// // --- Main Dashboard Component ---
// // ====================================================================
// const Dashboard = () => {
//     const [activeTab, setActiveTab] = useState('workOrder');
//     const [workOrderTableReport, setWorkOrderTableReport] = useState({ columns: [], data: [] });
//     const [invoices, setInvoices] = useState([]);
//     const [filters, setFilters] = useState({});
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
 
//     const API_TOKEN = 'Bearer ' + localStorage.getItem('zTaskAuthToken');
 
//     const handleApiResponse = async (response) => {
//         if (!response.ok) {
//             const errorText = await response.text();
//             const truncatedError = errorText.length > 200 ? errorText.substring(0, 200) + '...' : errorText;
//             throw new Error(`API call to ${response.url} failed with status ${response.status}: ${response.statusText}. Response: ${truncatedError}`);
//         }
//         return response.json();
//     };
 
//     useEffect(() => {
//         const fetchAllData = async () => {
//             setLoading(true);
//             setError(null);
 
//             const REPORT_API_URL = `${process.env.REACT_APP_REPORTS_API_URL}/api/reports/run`;
//             const INVOICE_API_URL = `${process.env.REACT_APP_NODE_SERVICE_BASE_URL}/invoice/api/invoices/`;
 
//             const HEADERS = { 'accept': 'application/json', 'Authorization': API_TOKEN };
//             const TABLE_REPORT_BODY = { "report_name": "work_order_table", "module_name": "Workorder" };
           
//             try {
//                 const [tableReportJson, invoiceJson] = await Promise.all([
//                     fetch(REPORT_API_URL, { method: 'POST', headers: { ...HEADERS, 'Content-Type': 'application/json' }, body: JSON.stringify(TABLE_REPORT_BODY) }).then(handleApiResponse),
//                     fetch(INVOICE_API_URL, { headers: HEADERS }).then(handleApiResponse)
//                 ]);
               
//                 if (tableReportJson && tableReportJson.columns && tableReportJson.data) setWorkOrderTableReport(tableReportJson);
//                 setInvoices(Array.isArray(invoiceJson) ? invoiceJson : []);
//             } catch (e) {
//                 console.error("Failed to fetch dashboard data:", e);
//                 setError(e.message);
//             } finally {
//                 setLoading(false);
//             }
//         };
//         fetchAllData();
//     }, []);
 
//     const handleChartClick = (filterType, clickedLabel) => setFilters(prev => ({ ...prev, [filterType]: clickedLabel }));
//     const clearFilters = () => setFilters({});
   
//     const uniqueWorkOrders = useMemo(() => {
//         const data = workOrderTableReport.data;
//         if (!Array.isArray(data)) return [];
//         const uniqueWoMap = new Map();
//         data.forEach(order => {
//             if (!uniqueWoMap.has(order.wo_id)) {
//                 uniqueWoMap.set(order.wo_id, { ...order, tot_value: parseFloat(order.tot_value) || 0 });
//             }
//         });
//         return Array.from(uniqueWoMap.values());
//     }, [workOrderTableReport.data]);
 
//     const statusPieChartData = useMemo(() => {
//         const statusCounts = uniqueWorkOrders.reduce((acc, order) => {
//             const status = order.wo_open_close || 'Unknown';
//             acc[status] = (acc[status] || 0) + 1;
//             return acc;
//         }, { 'Open': 0, 'Closed': 0 });
//         return { labels: Object.keys(statusCounts), datasets: [{ data: Object.values(statusCounts), backgroundColor: ['#ff8a80', '#80d8ff'], borderColor: '#ffffff', borderWidth: 3 }] };
//     }, [uniqueWorkOrders]);
 
//     const sectorBarChartData = useMemo(() => {
//         const sectorData = uniqueWorkOrders.reduce((acc, wo) => {
//             const sectorName = wo.sector_name || 'Unknown Sector';
//             if (!acc[sectorName]) acc[sectorName] = { count: 0, totalValue: 0 };
//             acc[sectorName].count += 1;
//             acc[sectorName].totalValue += wo.tot_value;
//             return acc;
//         }, {});
//         const labels = Object.keys(sectorData).sort();
//         return { labels, datasets: [
//             { label: 'Number of Orders', data: labels.map(l => sectorData[l].count), backgroundColor: 'rgba(255, 159, 64, 0.8)' },
//             { label: 'Total Value', data: labels.map(l => sectorData[l].totalValue), backgroundColor: 'rgba(75, 192, 192, 0.8)' }
//         ] };
//     }, [uniqueWorkOrders]);
   
//     const topCustomersData = useMemo(() => {
//         const customerAggregates = uniqueWorkOrders.reduce((acc, wo) => {
//             const customerName = wo.customer_name || 'Unknown Customer';
//             acc[customerName] = (acc[customerName] || 0) + wo.tot_value;
//             return acc;
//         }, {});
//         const sortedCustomers = Object.entries(customerAggregates).sort(([, a], [, b]) => b - a).slice(0, 5);
//         return { labels: sortedCustomers.map(([label]) => label), datasets: [{ label: 'Total Order Value', data: sortedCustomers.map(([, value]) => value), backgroundColor: 'rgba(54, 162, 235, 0.8)' }] };
//     }, [uniqueWorkOrders]);
 
//     const filteredWorkOrders = useMemo(() => {
//         let data = workOrderTableReport.data || [];
//         if (Object.keys(filters).length === 0) return data;
//         const woIdsToKeep = new Set(uniqueWorkOrders
//             .filter(wo => (!filters.status || wo.wo_open_close === filters.status) && (!filters.sector || wo.sector_name === filters.sector) && (!filters.customer || wo.customer_name === filters.customer))
//             .map(wo => wo.wo_id)
//         );
//         return data.filter(order => woIdsToKeep.has(order.wo_id));
//     }, [workOrderTableReport.data, uniqueWorkOrders, filters]);
 
//     return (
//         <div className="dashboard-container">
//             <div className="tabs-container">
//                 <button className={`tab-button ${activeTab === 'workOrder' ? 'active' : ''}`} onClick={() => setActiveTab('workOrder')}>Work Orders</button>
//                 <button className={`tab-button ${activeTab === 'invoice' ? 'active' : ''}`} onClick={() => setActiveTab('invoice')}>Invoices</button>
//             </div>
//             <div className="tab-content">
//                 {activeTab === 'workOrder' && (
//                     <WorkOrderDashboardContent
//                         loading={loading} error={error} statusPieChartData={statusPieChartData}
//                         sectorBarChartData={sectorBarChartData}
//                         topCustomersData={topCustomersData} filteredWorkOrders={filteredWorkOrders}
//                         filters={filters} onChartClick={handleChartClick} onClearFilters={clearFilters}
//                         apiToken={API_TOKEN}
//                     />
//                 )}
//                 {activeTab === 'invoice' && (
//                     <InvoiceDashboardContent 
//                         invoices={invoices} 
//                         workOrders={workOrderTableReport.data}
//                         loading={loading} 
//                         error={error} 
//                     />
//                 )}
//             </div>
//         </div>
//     );
// };
 
// export default Dashboard;








// import React, { useState, useEffect, useMemo, useRef } from 'react';
// import { Pie, Bar, getElementAtEvent } from 'react-chartjs-2';
// import {
//     Chart as ChartJS,
//     CategoryScale,
//     LinearScale,
//     BarElement,
//     Title,
//     Tooltip,
//     Legend,
//     ArcElement
// } from 'chart.js';
// import ChartDataLabels from 'chartjs-plugin-datalabels';
// import './Dashboard.css'; // Renamed CSS import
 
// ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement, ChartDataLabels);
 
// // ====================================================================
// // --- Component for Work Order Table ---
// // ====================================================================
// const FilteredWorkOrderTable = ({ workOrders, apiToken }) => {
//     const [activeTab, setActiveTab] = useState('assets');
//     const [assets, setAssets] = useState([]);
//     const [assetsLoading, setAssetsLoading] = useState(false);
//     const [assetsError, setAssetsError] = useState(null);
 
//     useEffect(() => {
//         const fetchAssets = async () => {
//             if (!workOrders || workOrders.length === 0) {
//                 setAssets([]);
//                 return;
//             }
//             const assetIdSet = new Set(workOrders.map(wo => wo.asset_id).filter(id => id != null));
//             const assetIds = Array.from(assetIdSet);
//             if (assetIds.length === 0) {
//                 setAssets([]);
//                 return;
//             }
           
//             setAssetsLoading(true);
//             setAssetsError(null);
           
//             const ASSET_API_URL = `${process.env.REACT_APP_ASSET_SERVICE_BASE_URL}/api/assets/`;
//             const ASSET_HEADERS = { 'accept': 'application/json', 'Authorization': apiToken };
 
//             try {
//                 const assetPromises = assetIds.map(id =>
//                     fetch(`${ASSET_API_URL}${id}`, { headers: ASSET_HEADERS }).then(res => {
//                         if (!res.ok) {
//                             console.error(`Failed to fetch asset ${id}, status: ${res.status}`);
//                             return null;
//                         }
//                         return res.json();
//                     })
//                 );
//                 const fetchedAssetsResults = await Promise.all(assetPromises);
//                 setAssets(fetchedAssetsResults.filter(asset => asset !== null));
//             } catch (error) {
//                 console.error("Failed to fetch assets:", error);
//                 setAssetsError(error.message);
//             } finally {
//                 setAssetsLoading(false);
//             }
//         };
//         fetchAssets();
//     }, [workOrders, apiToken]);
 
//     const displayedWorkOrders = useMemo(() => {
//         if (!workOrders || !Array.isArray(workOrders)) return [];
//         return [...workOrders].sort((a, b) => new Date(b.add_date) - new Date(a.add_date));
//     }, [workOrders]);
 
//     const formatData = (value) => {
//         if (value === null || typeof value === 'undefined') return 'N/A';
//         if (typeof value === 'boolean') return value ? 'Yes' : 'No';
//         if (typeof value === 'string' && value.includes('T')) {
//             const date = new Date(value);
//             if (!isNaN(date)) return date.toLocaleDateString('en-GB');
//         }
//         return value;
//     };
 
//     const displayColumns = [
//         { header: 'Doc No', key: 'doc_no' }, { header: 'WO No', key: 'wo_no' },
//         { header: 'Status', key: 'wo_open_close' }, { header: 'Total Value', key: 'tot_value' },
//         { header: 'Customer Name', key: 'customer_name' }, { header: 'Customer ID', key: 'cust_id' },
//         { header: 'Project Name', key: 'project_name' }, { header: 'Project ID', key: 'project_id' },
//         { header: 'Sector Name', key: 'sector_name' }, { header: 'Sector ID', key: 'sector' },
//         { header: 'Asset ID', key: 'asset_id' }, { header: 'WO Date', key: 'wo_date' },
//         { header: 'WO Start', key: 'wo_start' }, { header: 'WO End', key: 'wo_end' },
//     ];
 
//     return (
//         <div className="filtered-table-container">
//             <div className="table-header"><h3>All Work Orders</h3></div>
//             <div className="table-controls">
//                 <div className="tabs">
//                     <button className={`tab-btn ${activeTab === 'assets' ? 'active' : ''}`} onClick={() => setActiveTab('assets')}>Assets</button>
//                     <button className={`tab-btn ${activeTab === 'workorder' ? 'active' : ''}`} onClick={() => setActiveTab('workorder')}>Workorder</button>
//                 </div>
//             </div>
//             <div className="table-content-wrapper">
//                 {activeTab === 'workorder' ? (
//                     <>
//                         {displayedWorkOrders.length > 0 ? (
//                             <div className="table-scroll-container">
//                                 <table className="data-table wide-table">
//                                     <thead><tr>{displayColumns.map(col => <th key={col.key}>{col.header}</th>)}</tr></thead>
//                                     <tbody>
//                                         {displayedWorkOrders.map((order, index) => (
//                                             <tr key={`${order.id}-${index}`}>
//                                                 {displayColumns.map(col => (
//                                                     <td key={col.key}>{col.key === 'tot_value' ? parseFloat(order[col.key] || 0).toLocaleString('en-US') : formatData(order[col.key])}</td>
//                                                 ))}
//                                             </tr>
//                                         ))}
//                                     </tbody>
//                                 </table>
//                             </div>
//                         ) : (<p className="no-data-message">No work orders found for the current filter.</p>)}
//                     </>
//                 ) : (
//                     <>
//                         {assetsLoading && <p className="loading-message">Loading Assets...</p>}
//                         {assetsError && <p className="error-message">Error: {assetsError}</p>}
//                         {!assetsLoading && !assetsError && (
//                             <>
//                                 {assets.length > 0 ? (
//                                     <div className="table-scroll-container">
//                                         <table className="data-table wide-table">
//                                             <thead>
//                                                 <tr><th>Asset Name</th><th>Asset Type</th><th>Capacity (MT)</th><th>Year of Purchase</th><th>Year of Manufacture</th></tr>
//                                             </thead>
//                                             <tbody>
//                                                 {assets.map(asset => {
//                                                     const combinedAssetName = [asset.name, asset.serial_number, asset.asset_code, asset.registration_number].filter(Boolean).join(' | ');
//                                                     return (
//                                                         <tr key={asset.id}>
//                                                             <td>{combinedAssetName || 'N/A'}</td>
//                                                             <td>{formatData(asset.asset_type)}</td>
//                                                             <td>{formatData(asset.capacity_mt)}</td>
//                                                             <td>{formatData(asset.year_of_purchase)}</td>
//                                                             <td>{formatData(asset.year_of_manufacture)}</td>
//                                                         </tr>
//                                                     );
//                                                 })}
//                                             </tbody>
//                                         </table>
//                                     </div>
//                                 ) : (<p className="no-data-message">No assets found for the current work orders.</p>)}
//                             </>
//                         )}
//                     </>
//                 )}
//             </div>
//         </div>
//     );
// };
 
// // ====================================================================
// // --- Component for Asset Availability Table ---
// // ====================================================================
// const AssetAvailabilityTable = ({ workOrders, apiToken }) => {
//     const [combinedAssets, setCombinedAssets] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);
//     const [filterDays, setFilterDays] = useState(null);
//     const [customDays, setCustomDays] = useState('');
 
//     useEffect(() => {
//         const fetchAndCombineData = async () => {
//             setLoading(true);
//             setError(null);
           
//             const workOrderInfoMap = new Map();
//             if (workOrders && Array.isArray(workOrders)) {
//                 workOrders.forEach(wo => {
//                     if (wo.asset_id != null) {
//                         workOrderInfoMap.set(Number(wo.asset_id), { wo_start: wo.wo_start, wo_end: wo.wo_end, wo_no: wo.wo_no });
//                     }
//                 });
//             }
           
//             const ASSET_API_URL = `${process.env.REACT_APP_ASSET_SERVICE_BASE_URL}/api/assets/`;
//             const ASSET_HEADERS = { 'accept': 'application/json', 'Authorization': apiToken };
 
//             try {
//                 const response = await fetch(ASSET_API_URL, { headers: ASSET_HEADERS });
//                 if (!response.ok) {
//                     throw new Error(`Failed to fetch assets, status: ${response.status}`);
//                 }
//                 const allAssets = await response.json();
//                 const activeAssets = allAssets.filter(asset => asset.active === true);
 
//                 const combinedData = activeAssets.map(asset => {
//                     const workOrderInfo = workOrderInfoMap.get(asset.id) || { wo_start: null, wo_end: null, wo_no: null };
//                     return { ...asset, ...workOrderInfo };
//                 });
               
//                 setCombinedAssets(combinedData);
//             } catch (error) {
//                 console.error("Failed to fetch asset data:", error);
//                 setError(error.message);
//             } finally {
//                 setLoading(false);
//             }
//         };
 
//         fetchAndCombineData();
//     }, [workOrders, apiToken]);
 
//     const filteredAssets = useMemo(() => {
//         if (filterDays === null) return combinedAssets;
//         const targetDate = new Date();
//         targetDate.setDate(targetDate.getDate() + filterDays);
//         targetDate.setHours(23, 59, 59, 999);
//         return combinedAssets.filter(asset => {
//             if (!asset.wo_end) return true;
//             const woEndDate = new Date(asset.wo_end);
//             return isNaN(woEndDate.getTime()) || woEndDate <= targetDate;
//         });
//     }, [combinedAssets, filterDays]);
 
//     const formatData = (value) => {
//         if (value === null || typeof value === 'undefined') return 'N/A';
//         if (typeof value === 'boolean') return value ? 'Yes' : 'No';
//         if (typeof value === 'string' && value.includes('T')) {
//             const date = new Date(value);
//             if (!isNaN(date)) return date.toLocaleDateString('en-GB');
//         }
//         return value;
//     };
 
//     const handleCustomFilter = () => {
//         const days = parseInt(customDays, 10);
//         if (days > 0) setFilterDays(days);
//     };
 
//     const clearFilter = () => {
//         setFilterDays(null);
//         setCustomDays('');
//     };
 
//     return (
//         <div className="filtered-table-container">
//             <div className="table-header with-controls">
//                 <h3>Asset Availability</h3>
//                 <div className="availability-filter-controls">
//                     <span>Available In:</span>
//                     {[3, 7, 15, 30].map(days => (
//                         <button key={days} onClick={() => setFilterDays(days)} className={filterDays === days ? 'active' : ''}>{days} Days</button>
//                     ))}
//                     <div className="custom-filter">
//                         <input type="number" placeholder="Custom" value={customDays} onChange={(e) => setCustomDays(e.target.value)} min="1"/>
//                         <button onClick={handleCustomFilter}>Go</button>
//                     </div>
//                     <button onClick={clearFilter}>Clear Filter</button>
//                 </div>
//             </div>
//             <div className="table-content-wrapper">
//                 {loading && <p className="loading-message">Loading Assets...</p>}
//                 {error && <p className="error-message">Error: {error}</p>}
//                 {!loading && !error && (
//                     <>
//                         {filteredAssets.length > 0 ? (
//                             <div className="table-scroll-container">
//                                 <table className="data-table wide-table">
//                                     <thead>
//                                         <tr><th>ID</th><th>Asset Name</th><th>Asset Type</th><th>Capacity (MT)</th><th>Year of Purchase</th><th>Year of Manufacture</th><th>WO No</th><th>WO Start</th><th>WO End</th></tr>
//                                     </thead>
//                                     <tbody>
//                                         {filteredAssets.map(asset => {
//                                             const combinedAssetName = [asset.name, asset.serial_number, asset.asset_code, asset.registration_number].filter(Boolean).join(' | ');
//                                             return (
//                                                 <tr key={asset.id}>
//                                                     <td>{formatData(asset.id)}</td>
//                                                     <td>{combinedAssetName || 'N/A'}</td>
//                                                     <td>{formatData(asset.asset_type)}</td>
//                                                     <td>{formatData(asset.capacity_mt)}</td>
//                                                     <td>{formatData(asset.year_of_purchase)}</td>
//                                                     <td>{formatData(asset.year_of_manufacture)}</td>
//                                                     <td>{formatData(asset.wo_no)}</td>
//                                                     <td>{formatData(asset.wo_start)}</td>
//                                                     <td>{formatData(asset.wo_end)}</td>
//                                                 </tr>
//                                             );
//                                         })}
//                                     </tbody>
//                                 </table>
//                             </div>
//                         ) : (<p className="no-data-message">{filterDays !== null ? "No assets match the current availability filter." : "No active assets found."}</p>)}
//                     </>
//                 )}
//             </div>
//         </div>
//     );
// };
 
// // ====================================================================
// // --- Component for the Work Orders Tab Content ---
// // ====================================================================
// const WorkOrderDashboardContent = ({
//     loading, error, statusPieChartData, sectorBarChartData,
//     topCustomersData, filteredWorkOrders, filters, onChartClick, onClearFilters, apiToken
// }) => {
//     const statusChartRef = useRef();
//     const sectorChartRef = useRef();
//     const customerChartRef = useRef();
 
//     const handleChartClick = (filterType, chartData, event, chartRef) => {
//         if (!chartRef.current) return;
//         const elements = getElementAtEvent(chartRef.current, event);
//         if (elements.length > 0) {
//             const clickedLabel = chartData.labels[elements[0].index];
//             onChartClick(filterType, clickedLabel);
//         }
//     };
 
//     const hasFilters = Object.keys(filters).length > 0;
   
//     if (loading) return <div className="loading-error-container"><h2>Loading Dashboard...</h2></div>;
//     if (error) return <div className="loading-error-container"><h2>Dashboard Error</h2><p>{error}</p></div>;
 
//     return (
//         <main className="main-content">
//              <div className="dashboard-title-bar">
//                 <h1 className="dashboard-header">Work Orders Dashboard</h1>
//                 {hasFilters && (<button onClick={onClearFilters} className="clear-filters-btn">Clear Filters</button>)}
//             </div>
//             <div className="dashboard-grid">
//                 <div className="chart-card">
//                     <h3>Work Orders by Status</h3>
//                     <Pie ref={statusChartRef} data={statusPieChartData} options={{ responsive: true, plugins: { legend: { position: 'top' }, datalabels: { color: '#343a40', font: { weight: 'bold', size: 16 }, formatter: (value) => (value > 0 ? value : null) } } }} onClick={(event) => handleChartClick('status', statusPieChartData, event, statusChartRef)}/>
//                 </div>
//                 <div className="chart-card">
//                     <h3>Work Orders by Sector</h3>
//                     <Bar ref={sectorChartRef} data={sectorBarChartData} options={{ responsive: true, scales: { y: { beginAtZero: true } } }} onClick={(event) => handleChartClick('sector', sectorBarChartData, event, sectorChartRef)}/>
//                 </div>
//                 <div className="chart-card">
//                     <h3>Top Customers by Order Value</h3>
//                      <Bar ref={customerChartRef} data={topCustomersData} options={{ responsive: true, scales: { y: { beginAtZero: true } } }} onClick={(event) => handleChartClick('customer', topCustomersData, event, customerChartRef)}/>
//                 </div>
//                 <div className="chart-card table-card">
//                     <FilteredWorkOrderTable workOrders={filteredWorkOrders} apiToken={apiToken} />
//                 </div>
//                 <div className="chart-card table-card">
//                      <AssetAvailabilityTable workOrders={filteredWorkOrders} apiToken={apiToken} />
//                 </div>
//             </div>
//         </main>
//     );
// };

// // ====================================================================
// // --- Component for Invoice Data Table ---
// // ====================================================================
// const InvoiceDataTable = ({ invoices, workOrders, customerMap }) => {
//     // --- Create a map for work order data, keyed by wo_id for efficient lookup ---
//     const workOrderMap = useMemo(() => {
//         const map = new Map();
//         if (Array.isArray(workOrders)) {
//             workOrders.forEach(wo => {
//                 if (wo.wo_id && !map.has(wo.wo_id)) {
//                     map.set(wo.wo_id, wo);
//                 }
//             });
//         }
//         return map;
//     }, [workOrders]);

//     // --- MODIFIED: Reordered columns to show Customer Name before Customer ID ---
//     const columns = [
//         { header: 'ID', key: 'id' },
//         { header: 'Doc No', key: 'doc_no' },
//         { header: 'Customer Name', key: 'customer_name' },
//         { header: 'Customer ID', key: 'cust_id' },
//         { header: 'Work Order ID', key: 'wo_id' },
//         { header: 'Work Order No', key: 'wo_no' },
//         { header: 'Work Order Date', key: 'wo_date' },
//         { header: 'Project ID', key: 'project_id' },
//         { header: 'Project Name', key: 'project_name' },
//         { header: 'Invoice Date', key: 'inv_date' },
//         { header: 'Due Date', key: 'due_date' },
//         { header: 'Start Date', key: 'start_date' },
//         { header: 'End Date', key: 'end_date' },
//         { header: 'Taxable Amt', key: 'taxable_amt' },
//         { header: 'CGST', key: 'tot_cgst' },
//         { header: 'SGST', key: 'tot_sgst' },
//         { header: 'IGST', key: 'tot_igst' },
//         { header: 'Total Amount', key: 'amount' },
//         { header: 'Approval Status', key: 'inv_approval_status' },
//         { header: 'Current Status', key: 'current_status' },
//         { header: 'Stage', key: 'stage' },
//         { header: 'Created By', key: 'added_by' },
//         { header: 'Created Date', key: 'add_date' },
//         { header: 'Updated By', key: 'updated_by' },
//         { header: 'Updated Date', key: 'update_date' },
//     ];

//     const formatData = (value, key) => {
//         if (value === null || typeof value === 'undefined') return 'N/A';

//         const currencyKeys = ['taxable_amt', 'amount', 'tot_cgst', 'tot_sgst', 'tot_igst'];
//         if (currencyKeys.includes(key)) {
//             const numberValue = parseFloat(value);
//             return isNaN(numberValue) ? 'N/A' : numberValue.toLocaleString('en-IN', { style: 'currency', currency: 'INR' });
//         }

//         if (typeof value === 'string' && value.includes('T')) {
//             const date = new Date(value);
//             return !isNaN(date) ? date.toLocaleDateString('en-GB') : 'N/A';
//         }

//         return value;
//     };

//     const sortedInvoices = useMemo(() => {
//         if (!Array.isArray(invoices)) return [];
//         return [...invoices].sort((a, b) => new Date(b.inv_date || b.add_date) - new Date(a.inv_date || a.add_date));
//     }, [invoices]);

//     if (sortedInvoices.length === 0) {
//         return (
//             <div className="filtered-table-container">
//                  <div className="table-header"><h3>All Invoices</h3></div>
//                  <p className="no-data-message" style={{ padding: '20px' }}>No invoice data matching the current filter.</p>
//             </div>
//         )
//     }

//     return (
//         <div className="filtered-table-container">
//             <div className="table-header"><h3>All Invoices</h3></div>
//             <div className="table-content-wrapper">
//                 <div className="table-scroll-container">
//                     <table className="data-table wide-table">
//                         <thead>
//                             <tr>
//                                 {columns.map(col => <th key={col.key}>{col.header}</th>)}
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {/* --- MODIFIED: Updated rendering logic to pull data from customerMap and workOrderMap --- */}
//                             {sortedInvoices.map((invoice) => {
//                                 const relatedWorkOrder = workOrderMap.get(invoice.wo_id) || {}; // Get related WO, default to empty obj

//                                 return (
//                                     <tr key={invoice.id}>
//                                         {columns.map(col => {
//                                             let cellValue;
//                                             if (col.key === 'customer_name') {
//                                                 cellValue = customerMap.get(invoice.cust_id) || 'N/A';
//                                             } else if (['project_id', 'project_name', 'wo_no', 'wo_date'].includes(col.key)) {
//                                                 // Get data from the mapped work order
//                                                 cellValue = formatData(relatedWorkOrder[col.key], col.key);
//                                             } else {
//                                                 // Get data from the invoice object itself
//                                                 cellValue = formatData(invoice[col.key], col.key);
//                                             }
//                                             return <td key={col.key}>{cellValue}</td>;
//                                         })}
//                                     </tr>
//                                 );
//                             })}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         </div>
//     );
// };
 
// // ====================================================================
// // --- Component for the Invoices Tab (UPDATED) ---
// // ====================================================================
// const InvoiceDashboardContent = ({ invoices, workOrders, loading, error, customerMap }) => {
//     const today = new Date();
//     const thirtyDaysAgo = new Date(new Date().setDate(today.getDate() - 30));
//     const formatDateForInput = (date) => date.toISOString().split('T')[0];
   
//     const [startDate, setStartDate] = useState(formatDateForInput(thirtyDaysAgo));
//     const [endDate, setEndDate] = useState(formatDateForInput(new Date()));
//     const [statusFilter, setStatusFilter] = useState(null); // State for card filter
//     const tableRef = useRef(null); // Ref for scrolling to the table

//     const filteredInvoicesByDate = useMemo(() => {
//         if (!Array.isArray(invoices) || !startDate || !endDate) return [];
//         const start = new Date(startDate);
//         const end = new Date(endDate);
//         end.setHours(23, 59, 59, 999);
//         return invoices.filter(inv => {
//             const invoiceDate = new Date(inv.inv_date || inv.add_date);
//             return !isNaN(invoiceDate) && invoiceDate >= start && invoiceDate <= end;
//         });
//     }, [invoices, startDate, endDate]);
 
//     const dashboardData = useMemo(() => {
//         const EMPTY_CHART_DATA = { labels: [], datasets: [{ data: [] }] };
//         const baseKpis = {
//             totalInvoices: 0, totalTaxable: 0, totalGst: 0, avgCreditPeriod: 0,
//             draftedCount: 0, waitingForDigisignCount: 0, rejectedCount: 0, completedCount: 0
//         };

//         if (filteredInvoicesByDate.length === 0) {
//             return { kpis: baseKpis, customerData: EMPTY_CHART_DATA, lifecycleData: EMPTY_CHART_DATA };
//         }
 
//         const totalInvoices = filteredInvoicesByDate.length;
//         const totalTaxable = filteredInvoicesByDate.reduce((sum, inv) => sum + (Number(inv.taxable_amt) || 0), 0);
//         const totalGst = filteredInvoicesByDate.reduce((sum, inv) => sum + (Number(inv.tot_cgst) || 0) + (Number(inv.tot_sgst) || 0) + (Number(inv.tot_igst) || 0) + (Number(inv.tot_cess) || 0) + (Number(inv.tot_kkc) || 0), 0);
//         const creditPeriods = filteredInvoicesByDate.map(inv => Number(inv.cr_period)).filter(p => p > 0);
//         const avgCreditPeriod = creditPeriods.length > 0 ? (creditPeriods.reduce((a, b) => a + b, 0) / creditPeriods.length).toFixed(2) : 0;
       
//         const statusCounts = filteredInvoicesByDate.reduce((acc, inv) => {
//             const status = inv.current_status || 'Unknown';
//             acc[status] = (acc[status] || 0) + 1;
//             return acc;
//         }, {});

//         const customerAggregates = filteredInvoicesByDate.reduce((acc, inv) => {
//             const customerName = customerMap.get(inv.cust_id) || `Customer ID: ${inv.cust_id}`;
//             acc[customerName] = (acc[customerName] || 0) + (Number(inv.amount) || 0);
//             return acc;
//         }, {});

//         const sortedCustomers = Object.entries(customerAggregates).sort(([,a], [,b]) => b - a).slice(0, 10);
//         const customerData = { 
//             labels: sortedCustomers.map(([name]) => name), 
//             datasets: [{ 
//                 label: 'Total Invoice Amount', 
//                 data: sortedCustomers.map(([, amount]) => amount), 
//                 backgroundColor: 'rgba(153, 102, 255, 0.6)' 
//             }] 
//         };
 
//         const lifecycleCounts = filteredInvoicesByDate.reduce((acc, inv) => { inv.inv_complete ? acc.completed++ : acc.pending++; return acc; }, { pending: 0, completed: 0 });
//         const lifecycleData = { labels: ['Pending', 'Completed'], datasets: [{ data: [lifecycleCounts.pending, lifecycleCounts.completed], backgroundColor: ['#FF6384', '#36A2EB'], borderColor: '#fff', borderWidth: 2 }] };
       
//         return {
//             kpis: {
//                 totalInvoices, totalTaxable, totalGst, avgCreditPeriod,
//                 draftedCount: statusCounts['Drafted'] || 0,
//                 waitingForDigisignCount: statusCounts['Waiting for Digisign'] || 0,
//                 rejectedCount: statusCounts['Rejected'] || 0,
//                 completedCount: statusCounts['Completed'] || 0,
//             },
//             customerData, lifecycleData
//         };
//     }, [filteredInvoicesByDate, customerMap]);
    
//     // This derived state will hold the final list of invoices for the table
//     const finalFilteredInvoices = useMemo(() => {
//         if (!statusFilter) {
//             return filteredInvoicesByDate; // If no card is clicked, show all (date-filtered) invoices
//         }
//         return filteredInvoicesByDate.filter(inv => inv.current_status === statusFilter);
//     }, [filteredInvoicesByDate, statusFilter]);

//     const handleCardClick = (status) => {
//         setStatusFilter(status);
//         setTimeout(() => {
//             tableRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
//         }, 100);
//     };

//     if (loading) return <div className="loading-error-container"><h2>Loading Invoice Dashboard...</h2></div>;
//     if (error) return <div className="loading-error-container"><h2>Dashboard Error</h2><p>{error}</p></div>;
 
//     const formatCurrency = (value) => new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(value);
//     const pieOptions = { responsive: true, plugins: { legend: { position: 'bottom' }, datalabels: { color: '#fff', font: { weight: 'bold' }, formatter: (value) => (value > 0 ? value : '') } } };
 
//     return (
//         <main className="main-content">
            
//             <div className="filter-bar">
//                 <div className="filter-item"><label htmlFor="start-date">Start Date:</label><input type="date" id="start-date" value={startDate} onChange={(e) => setStartDate(e.target.value)} /></div>
//                 <div className="filter-item"><label htmlFor="end-date">End Date:</label><input type="date" id="end-date" value={endDate} onChange={(e) => setEndDate(e.target.value)} /></div>
//             </div>
           
//             <div className="kpi-grid">
//                 <div className={`kpi-card ${statusFilter === null ? 'active' : ''}`} onClick={() => setStatusFilter(null)}><h4>Total Invoices</h4><p>{dashboardData.kpis.totalInvoices}</p></div>
//                 <div className="kpi-card"><h4>Total Taxable Amount</h4><p>{formatCurrency(dashboardData.kpis.totalTaxable)}</p></div>
//                 <div className="kpi-card"><h4>Total GST Collected</h4><p>{formatCurrency(dashboardData.kpis.totalGst)}</p></div>
//                 <div className="kpi-card"><h4>Avg. Credit Period</h4><p>{dashboardData.kpis.avgCreditPeriod} Days</p></div>
//                 <div className={`kpi-card ${statusFilter === 'Drafted' ? 'active' : ''}`} onClick={() => handleCardClick('Drafted')}><h4>Drafted</h4><p>{dashboardData.kpis.draftedCount}</p></div>
//                 <div className={`kpi-card ${statusFilter === 'Waiting for Digisign' ? 'active' : ''}`} onClick={() => handleCardClick('Waiting for Digisign')}><h4>Waiting for Digisign</h4><p>{dashboardData.kpis.waitingForDigisignCount}</p></div>
//                 <div className={`kpi-card ${statusFilter === 'Rejected' ? 'active' : ''}`} onClick={() => handleCardClick('Rejected')}><h4>Rejected</h4><p>{dashboardData.kpis.rejectedCount}</p></div>
//                 <div className={`kpi-card ${statusFilter === 'Completed' ? 'active' : ''}`} onClick={() => handleCardClick('Completed')}><h4>Completed</h4><p>{dashboardData.kpis.completedCount}</p></div>
//             </div>
           
//             <div className="dashboard-grid">
//                 <div className="chart-card large-card">
//                   <h3>Customer Wise Invoices (Top 10 by Amount)</h3>
//                   {finalFilteredInvoices.length > 0 ? <Bar data={dashboardData.customerData} options={{ responsive: true, scales: { y: { beginAtZero: true } } }} /> : <p className="no-data-message">No data for selected date range.</p>}
//                 </div>
//                 <div className="chart-card">
//                   <h3>Pending vs Completed Invoices</h3>
//                   {finalFilteredInvoices.length > 0 ? <Pie data={dashboardData.lifecycleData} options={pieOptions} /> : <p className="no-data-message">No data available.</p>}
//                 </div>
//             </div>

//             <div ref={tableRef} className="invoice-table-section" style={{ marginTop: '2rem' }}>
//                 <InvoiceDataTable invoices={finalFilteredInvoices} workOrders={workOrders} customerMap={customerMap} />
//             </div>
//         </main>
//     );
// };
 
 
// // ====================================================================
// // --- Main Dashboard Component ---
// // ====================================================================
// const Dashboard = () => {
//     const [activeTab, setActiveTab] = useState('workOrder');
//     const [workOrderTableReport, setWorkOrderTableReport] = useState({ columns: [], data: [] });
//     const [invoices, setInvoices] = useState([]);
//     const [customers, setCustomers] = useState([]); // <-- State for customer names
//     const [filters, setFilters] = useState({});
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
 
//     const API_TOKEN = 'Bearer ' + localStorage.getItem('zTaskAuthToken');
 
//     const handleApiResponse = async (response) => {
//         if (!response.ok) {
//             const errorText = await response.text();
//             const truncatedError = errorText.length > 200 ? errorText.substring(0, 200) + '...' : errorText;
//             throw new Error(`API call to ${response.url} failed with status ${response.status}: ${response.statusText}. Response: ${truncatedError}`);
//         }
//         return response.json();
//     };
 
//     useEffect(() => {
//         const fetchAllData = async () => {
//             setLoading(true);
//             setError(null);
 
//             const REPORT_API_URL = `${process.env.REACT_APP_REPORTS_API_URL}/api/reports/run`;
//             const INVOICE_API_URL = `${process.env.REACT_APP_NODE_SERVICE_BASE_URL}/invoice/api/invoices/`;
//             const CUSTOMER_API_URL = `${process.env.REACT_APP_NODE_SERVICE_BASE_URL}/api/get-column/customers/name`;
 
//             const HEADERS = { 'accept': 'application/json', 'Authorization': API_TOKEN };
//             const TABLE_REPORT_BODY = { "report_name": "work_order_table", "module_name": "Workorder" };
           
//             try {
//                 const [tableReportJson, invoiceJson, customersJson] = await Promise.all([
//                     fetch(REPORT_API_URL, { method: 'POST', headers: { ...HEADERS, 'Content-Type': 'application/json' }, body: JSON.stringify(TABLE_REPORT_BODY) }).then(handleApiResponse),
//                     fetch(INVOICE_API_URL, { headers: HEADERS }).then(handleApiResponse),
//                     fetch(CUSTOMER_API_URL, { headers: HEADERS }).then(handleApiResponse)
//                 ]);
               
//                 if (tableReportJson && tableReportJson.columns && tableReportJson.data) setWorkOrderTableReport(tableReportJson);
//                 setInvoices(Array.isArray(invoiceJson) ? invoiceJson : []);
//                 setCustomers(Array.isArray(customersJson) ? customersJson : []);

//             } catch (e) {
//                 console.error("Failed to fetch dashboard data:", e);
//                 setError(e.message);
//             } finally {
//                 setLoading(false);
//             }
//         };
//         fetchAllData();
//     }, []);
 
//     const handleChartClick = (filterType, clickedLabel) => setFilters(prev => ({ ...prev, [filterType]: clickedLabel }));
//     const clearFilters = () => setFilters({});
   
//     const customerMap = useMemo(() => {
//         const map = new Map();
//         if (customers) {
//             customers.forEach(customer => {
//                 map.set(customer.id, customer.value);
//             });
//         }
//         return map;
//     }, [customers]);

//     const uniqueWorkOrders = useMemo(() => {
//         const data = workOrderTableReport.data;
//         if (!Array.isArray(data)) return [];
//         const uniqueWoMap = new Map();
//         data.forEach(order => {
//             if (!uniqueWoMap.has(order.wo_id)) {
//                 uniqueWoMap.set(order.wo_id, { ...order, tot_value: parseFloat(order.tot_value) || 0 });
//             }
//         });
//         return Array.from(uniqueWoMap.values());
//     }, [workOrderTableReport.data]);
 
//     const statusPieChartData = useMemo(() => {
//         const statusCounts = uniqueWorkOrders.reduce((acc, order) => {
//             const status = order.wo_open_close || 'Unknown';
//             acc[status] = (acc[status] || 0) + 1;
//             return acc;
//         }, { 'Open': 0, 'Closed': 0 });
//         return { labels: Object.keys(statusCounts), datasets: [{ data: Object.values(statusCounts), backgroundColor: ['#ff8a80', '#80d8ff'], borderColor: '#ffffff', borderWidth: 3 }] };
//     }, [uniqueWorkOrders]);
 
//     const sectorBarChartData = useMemo(() => {
//         const sectorData = uniqueWorkOrders.reduce((acc, wo) => {
//             const sectorName = wo.sector_name || 'Unknown Sector';
//             if (!acc[sectorName]) acc[sectorName] = { count: 0, totalValue: 0 };
//             acc[sectorName].count += 1;
//             acc[sectorName].totalValue += wo.tot_value;
//             return acc;
//         }, {});
//         const labels = Object.keys(sectorData).sort();
//         return { labels, datasets: [
//             { label: 'Number of Orders', data: labels.map(l => sectorData[l].count), backgroundColor: 'rgba(255, 159, 64, 0.8)' },
//             { label: 'Total Value', data: labels.map(l => sectorData[l].totalValue), backgroundColor: 'rgba(75, 192, 192, 0.8)' }
//         ] };
//     }, [uniqueWorkOrders]);
   
//     const topCustomersData = useMemo(() => {
//         const customerAggregates = uniqueWorkOrders.reduce((acc, wo) => {
//             const customerName = wo.customer_name || 'Unknown Customer';
//             acc[customerName] = (acc[customerName] || 0) + wo.tot_value;
//             return acc;
//         }, {});
//         const sortedCustomers = Object.entries(customerAggregates).sort(([, a], [, b]) => b - a).slice(0, 5);
//         return { labels: sortedCustomers.map(([label]) => label), datasets: [{ label: 'Total Order Value', data: sortedCustomers.map(([, value]) => value), backgroundColor: 'rgba(54, 162, 235, 0.8)' }] };
//     }, [uniqueWorkOrders]);
 
//     const filteredWorkOrders = useMemo(() => {
//         let data = workOrderTableReport.data || [];
//         if (Object.keys(filters).length === 0) return data;
//         const woIdsToKeep = new Set(uniqueWorkOrders
//             .filter(wo => (!filters.status || wo.wo_open_close === filters.status) && (!filters.sector || wo.sector_name === filters.sector) && (!filters.customer || wo.customer_name === filters.customer))
//             .map(wo => wo.wo_id)
//         );
//         return data.filter(order => woIdsToKeep.has(order.wo_id));
//     }, [workOrderTableReport.data, uniqueWorkOrders, filters]);
 
//     return (
//         <div className="dashboard-container">
//             <div className="tabs-container">
//                 <button className={`tab-button ${activeTab === 'workOrder' ? 'active' : ''}`} onClick={() => setActiveTab('workOrder')}>Work Orders</button>
//                 <button className={`tab-button ${activeTab === 'invoice' ? 'active' : ''}`} onClick={() => setActiveTab('invoice')}>Invoices</button>
//             </div>
//             <div className="tab-content">
//                 {activeTab === 'workOrder' && (
//                     <WorkOrderDashboardContent
//                         loading={loading} error={error} statusPieChartData={statusPieChartData}
//                         sectorBarChartData={sectorBarChartData}
//                         topCustomersData={topCustomersData} filteredWorkOrders={filteredWorkOrders}
//                         filters={filters} onChartClick={handleChartClick} onClearFilters={clearFilters}
//                         apiToken={API_TOKEN}
//                     />
//                 )}
//                 {activeTab === 'invoice' && (
//                     <InvoiceDashboardContent 
//                         invoices={invoices} 
//                         workOrders={workOrderTableReport.data}
//                         loading={loading} 
//                         error={error}
//                         customerMap={customerMap}
//                     />
//                 )}
//             </div>
//         </div>
//     );
// };
 
// export default Dashboard;











// import React, { useState, useEffect, useMemo, useRef } from 'react';
// import { Pie, Bar, getElementAtEvent } from 'react-chartjs-2';
// import {
//     Chart as ChartJS,
//     CategoryScale,
//     LinearScale,
//     BarElement,
//     Title,
//     Tooltip,
//     Legend,
//     ArcElement
// } from 'chart.js';
// import ChartDataLabels from 'chartjs-plugin-datalabels';
// import './Dashboard.css'; // Renamed CSS import
 
// ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement, ChartDataLabels);
 
// // ====================================================================
// // --- Component for Work Order Table ---
// // ====================================================================
// const FilteredWorkOrderTable = ({ workOrders, apiToken }) => {
//     const [activeTab, setActiveTab] = useState('assets');
//     const [assets, setAssets] = useState([]);
//     const [assetsLoading, setAssetsLoading] = useState(false);
//     const [assetsError, setAssetsError] = useState(null);
 
//     useEffect(() => {
//         const fetchAssets = async () => {
//             if (!workOrders || workOrders.length === 0) {
//                 setAssets([]);
//                 return;
//             }
//             const assetIdSet = new Set(workOrders.map(wo => wo.asset_id).filter(id => id != null));
//             const assetIds = Array.from(assetIdSet);
//             if (assetIds.length === 0) {
//                 setAssets([]);
//                 return;
//             }
           
//             setAssetsLoading(true);
//             setAssetsError(null);
           
//             const ASSET_API_URL = `${process.env.REACT_APP_ASSET_SERVICE_BASE_URL}/api/assets/`;
//             const ASSET_HEADERS = { 'accept': 'application/json', 'Authorization': apiToken };
 
//             try {
//                 const assetPromises = assetIds.map(id =>
//                     fetch(`${ASSET_API_URL}${id}`, { headers: ASSET_HEADERS }).then(res => {
//                         if (!res.ok) {
//                             console.error(`Failed to fetch asset ${id}, status: ${res.status}`);
//                             return null;
//                         }
//                         return res.json();
//                     })
//                 );
//                 const fetchedAssetsResults = await Promise.all(assetPromises);
//                 setAssets(fetchedAssetsResults.filter(asset => asset !== null));
//             } catch (error) {
//                 console.error("Failed to fetch assets:", error);
//                 setAssetsError(error.message);
//             } finally {
//                 setAssetsLoading(false);
//             }
//         };
//         fetchAssets();
//     }, [workOrders, apiToken]);
 
//     const displayedWorkOrders = useMemo(() => {
//         if (!workOrders || !Array.isArray(workOrders)) return [];
//         return [...workOrders].sort((a, b) => new Date(b.add_date) - new Date(a.add_date));
//     }, [workOrders]);
 
//     const formatData = (value) => {
//         if (value === null || typeof value === 'undefined') return 'N/A';
//         if (typeof value === 'boolean') return value ? 'Yes' : 'No';
//         if (typeof value === 'string' && value.includes('T')) {
//             const date = new Date(value);
//             if (!isNaN(date)) return date.toLocaleDateString('en-GB');
//         }
//         return value;
//     };
 
//     const displayColumns = [
//         { header: 'Doc No', key: 'doc_no' }, { header: 'WO No', key: 'wo_no' },
//         { header: 'Status', key: 'wo_open_close' }, { header: 'Total Value', key: 'tot_value' },
//         { header: 'Customer Name', key: 'customer_name' }, { header: 'Customer ID', key: 'cust_id' },
//         { header: 'Project Name', key: 'project_name' }, { header: 'Project ID', key: 'project_id' },
//         { header: 'Sector Name', key: 'sector_name' }, { header: 'Sector ID', key: 'sector' },
//         { header: 'Asset ID', key: 'asset_id' }, { header: 'WO Date', key: 'wo_date' },
//         { header: 'WO Start', key: 'wo_start' }, { header: 'WO End', key: 'wo_end' },
//     ];
 
//     return (
//         <div className="filtered-table-container">
//             <div className="table-header"><h3>All Work Orders</h3></div>
//             <div className="table-controls">
//                 <div className="tabs">
//                     <button className={`tab-btn ${activeTab === 'assets' ? 'active' : ''}`} onClick={() => setActiveTab('assets')}>Assets</button>
//                     <button className={`tab-btn ${activeTab === 'workorder' ? 'active' : ''}`} onClick={() => setActiveTab('workorder')}>Workorder</button>
//                 </div>
//             </div>
//             <div className="table-content-wrapper">
//                 {activeTab === 'workorder' ? (
//                     <>
//                         {displayedWorkOrders.length > 0 ? (
//                             <div className="table-scroll-container">
//                                 <table className="data-table wide-table">
//                                     <thead><tr>{displayColumns.map(col => <th key={col.key}>{col.header}</th>)}</tr></thead>
//                                     <tbody>
//                                         {displayedWorkOrders.map((order, index) => (
//                                             <tr key={`${order.id}-${index}`}>
//                                                 {displayColumns.map(col => (
//                                                     <td key={col.key}>{col.key === 'tot_value' ? parseFloat(order[col.key] || 0).toLocaleString('en-US') : formatData(order[col.key])}</td>
//                                                 ))}
//                                             </tr>
//                                         ))}
//                                     </tbody>
//                                 </table>
//                             </div>
//                         ) : (<p className="no-data-message">No work orders found for the current filter.</p>)}
//                     </>
//                 ) : (
//                     <>
//                         {assetsLoading && <p className="loading-message">Loading Assets...</p>}
//                         {assetsError && <p className="error-message">Error: {assetsError}</p>}
//                         {!assetsLoading && !assetsError && (
//                             <>
//                                 {assets.length > 0 ? (
//                                     <div className="table-scroll-container">
//                                         <table className="data-table wide-table">
//                                             <thead>
//                                                 <tr><th>Asset Name</th><th>Asset Type</th><th>Capacity (MT)</th><th>Year of Purchase</th><th>Year of Manufacture</th></tr>
//                                             </thead>
//                                             <tbody>
//                                                 {assets.map(asset => {
//                                                     const combinedAssetName = [asset.name, asset.serial_number, asset.asset_code, asset.registration_number].filter(Boolean).join(' | ');
//                                                     return (
//                                                         <tr key={asset.id}>
//                                                             <td>{combinedAssetName || 'N/A'}</td>
//                                                             <td>{formatData(asset.asset_type)}</td>
//                                                             <td>{formatData(asset.capacity_mt)}</td>
//                                                             <td>{formatData(asset.year_of_purchase)}</td>
//                                                             <td>{formatData(asset.year_of_manufacture)}</td>
//                                                         </tr>
//                                                     );
//                                                 })}
//                                             </tbody>
//                                         </table>
//                                     </div>
//                                 ) : (<p className="no-data-message">No assets found for the current work orders.</p>)}
//                             </>
//                         )}
//                     </>
//                 )}
//             </div>
//         </div>
//     );
// };
 
// // ====================================================================
// // --- Component for Asset Availability Table ---
// // ====================================================================
// const AssetAvailabilityTable = ({ workOrders, apiToken }) => {
//     const [combinedAssets, setCombinedAssets] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);
//     const [filterDays, setFilterDays] = useState(null);
//     const [customDays, setCustomDays] = useState('');
 
//     useEffect(() => {
//         const fetchAndCombineData = async () => {
//             setLoading(true);
//             setError(null);
           
//             const workOrderInfoMap = new Map();
//             if (workOrders && Array.isArray(workOrders)) {
//                 workOrders.forEach(wo => {
//                     if (wo.asset_id != null) {
//                         workOrderInfoMap.set(Number(wo.asset_id), { wo_start: wo.wo_start, wo_end: wo.wo_end, wo_no: wo.wo_no });
//                     }
//                 });
//             }
           
//             const ASSET_API_URL = `${process.env.REACT_APP_ASSET_SERVICE_BASE_URL}/api/assets/`;
//             const ASSET_HEADERS = { 'accept': 'application/json', 'Authorization': apiToken };
 
//             try {
//                 const response = await fetch(ASSET_API_URL, { headers: ASSET_HEADERS });
//                 if (!response.ok) {
//                     throw new Error(`Failed to fetch assets, status: ${response.status}`);
//                 }
//                 const allAssets = await response.json();
//                 const activeAssets = allAssets.filter(asset => asset.active === true);
 
//                 const combinedData = activeAssets.map(asset => {
//                     const workOrderInfo = workOrderInfoMap.get(asset.id) || { wo_start: null, wo_end: null, wo_no: null };
//                     return { ...asset, ...workOrderInfo };
//                 });
               
//                 setCombinedAssets(combinedData);
//             } catch (error) {
//                 console.error("Failed to fetch asset data:", error);
//                 setError(error.message);
//             } finally {
//                 setLoading(false);
//             }
//         };
 
//         fetchAndCombineData();
//     }, [workOrders, apiToken]);
 
//     const filteredAssets = useMemo(() => {
//         if (filterDays === null) return combinedAssets;
//         const targetDate = new Date();
//         targetDate.setDate(targetDate.getDate() + filterDays);
//         targetDate.setHours(23, 59, 59, 999);
//         return combinedAssets.filter(asset => {
//             if (!asset.wo_end) return true;
//             const woEndDate = new Date(asset.wo_end);
//             return isNaN(woEndDate.getTime()) || woEndDate <= targetDate;
//         });
//     }, [combinedAssets, filterDays]);
 
//     const formatData = (value) => {
//         if (value === null || typeof value === 'undefined') return 'N/A';
//         if (typeof value === 'boolean') return value ? 'Yes' : 'No';
//         if (typeof value === 'string' && value.includes('T')) {
//             const date = new Date(value);
//             if (!isNaN(date)) return date.toLocaleDateString('en-GB');
//         }
//         return value;
//     };
 
//     const handleCustomFilter = () => {
//         const days = parseInt(customDays, 10);
//         if (days > 0) setFilterDays(days);
//     };
 
//     const clearFilter = () => {
//         setFilterDays(null);
//         setCustomDays('');
//     };
 
//     return (
//         <div className="filtered-table-container">
//             <div className="table-header with-controls">
//                 <h3>Asset Availability</h3>
//                 <div className="availability-filter-controls">
//                     <span>Available In:</span>
//                     {[3, 7, 15, 30].map(days => (
//                         <button key={days} onClick={() => setFilterDays(days)} className={filterDays === days ? 'active' : ''}>{days} Days</button>
//                     ))}
//                     <div className="custom-filter">
//                         <input type="number" placeholder="Custom" value={customDays} onChange={(e) => setCustomDays(e.target.value)} min="1"/>
//                         <button onClick={handleCustomFilter}>Go</button>
//                     </div>
//                     <button onClick={clearFilter}>Clear Filter</button>
//                 </div>
//             </div>
//             <div className="table-content-wrapper">
//                 {loading && <p className="loading-message">Loading Assets...</p>}
//                 {error && <p className="error-message">Error: {error}</p>}
//                 {!loading && !error && (
//                     <>
//                         {filteredAssets.length > 0 ? (
//                             <div className="table-scroll-container">
//                                 <table className="data-table wide-table">
//                                     <thead>
//                                         <tr><th>ID</th><th>Asset Name</th><th>Asset Type</th><th>Capacity (MT)</th><th>Year of Purchase</th><th>Year of Manufacture</th><th>WO No</th><th>WO Start</th><th>WO End</th></tr>
//                                     </thead>
//                                     <tbody>
//                                         {filteredAssets.map(asset => {
//                                             const combinedAssetName = [asset.name, asset.serial_number, asset.asset_code, asset.registration_number].filter(Boolean).join(' | ');
//                                             return (
//                                                 <tr key={asset.id}>
//                                                     <td>{formatData(asset.id)}</td>
//                                                     <td>{combinedAssetName || 'N/A'}</td>
//                                                     <td>{formatData(asset.asset_type)}</td>
//                                                     <td>{formatData(asset.capacity_mt)}</td>
//                                                     <td>{formatData(asset.year_of_purchase)}</td>
//                                                     <td>{formatData(asset.year_of_manufacture)}</td>
//                                                     <td>{formatData(asset.wo_no)}</td>
//                                                     <td>{formatData(asset.wo_start)}</td>
//                                                     <td>{formatData(asset.wo_end)}</td>
//                                                 </tr>
//                                             );
//                                         })}
//                                     </tbody>
//                                 </table>
//                             </div>
//                         ) : (<p className="no-data-message">{filterDays !== null ? "No assets match the current availability filter." : "No active assets found."}</p>)}
//                     </>
//                 )}
//             </div>
//         </div>
//     );
// };
 
// // ====================================================================
// // --- Component for the Work Orders Tab Content ---
// // ====================================================================
// const WorkOrderDashboardContent = ({
//     loading, error, statusPieChartData, sectorBarChartData,
//     topCustomersData, filteredWorkOrders, filters, onChartClick, onClearFilters, apiToken
// }) => {
//     const statusChartRef = useRef();
//     const sectorChartRef = useRef();
//     const customerChartRef = useRef();
 
//     const handleChartClick = (filterType, chartData, event, chartRef) => {
//         if (!chartRef.current) return;
//         const elements = getElementAtEvent(chartRef.current, event);
//         if (elements.length > 0) {
//             const clickedLabel = chartData.labels[elements[0].index];
//             onChartClick(filterType, clickedLabel);
//         }
//     };
 
//     const hasFilters = Object.keys(filters).length > 0;
   
//     if (loading) return <div className="loading-error-container"><h2>Loading Dashboard...</h2></div>;
//     if (error) return <div className="loading-error-container"><h2>Dashboard Error</h2><p>{error}</p></div>;
 
//     return (
//         <main className="main-content">
//              <div className="dashboard-title-bar">
//                 <h1 className="dashboard-header">Work Orders Dashboard</h1>
//                 {hasFilters && (<button onClick={onClearFilters} className="clear-filters-btn">Clear Filters</button>)}
//             </div>
//             <div className="dashboard-grid">
//                 <div className="chart-card">
//                     <h3>Work Orders by Status</h3>
//                     <Pie ref={statusChartRef} data={statusPieChartData} options={{ responsive: true, plugins: { legend: { position: 'top' }, datalabels: { color: '#343a40', font: { weight: 'bold', size: 16 }, formatter: (value) => (value > 0 ? value : null) } } }} onClick={(event) => handleChartClick('status', statusPieChartData, event, statusChartRef)}/>
//                 </div>
//                 <div className="chart-card">
//                     <h3>Work Orders by Sector</h3>
//                     <Bar ref={sectorChartRef} data={sectorBarChartData} options={{ responsive: true, scales: { y: { beginAtZero: true } } }} onClick={(event) => handleChartClick('sector', sectorBarChartData, event, sectorChartRef)}/>
//                 </div>
//                 <div className="chart-card">
//                     <h3>Top Customers by Order Value</h3>
//                      <Bar ref={customerChartRef} data={topCustomersData} options={{ responsive: true, scales: { y: { beginAtZero: true } } }} onClick={(event) => handleChartClick('customer', topCustomersData, event, customerChartRef)}/>
//                 </div>
//                 <div className="chart-card table-card">
//                     <FilteredWorkOrderTable workOrders={filteredWorkOrders} apiToken={apiToken} />
//                 </div>
//                 <div className="chart-card table-card">
//                      <AssetAvailabilityTable workOrders={filteredWorkOrders} apiToken={apiToken} />
//                 </div>
//             </div>
//         </main>
//     );
// };

// // ====================================================================
// // --- Component for Invoice Data Table ---
// // ====================================================================
// const InvoiceDataTable = ({ invoices, workOrders, customerMap }) => {
//     // --- Create a map for work order data, keyed by wo_id for efficient lookup ---
//     const workOrderMap = useMemo(() => {
//         const map = new Map();
//         if (Array.isArray(workOrders)) {
//             workOrders.forEach(wo => {
//                 if (wo.wo_id && !map.has(wo.wo_id)) {
//                     map.set(wo.wo_id, wo);
//                 }
//             });
//         }
//         return map;
//     }, [workOrders]);

//     // --- MODIFIED: Reordered columns to show Customer Name before Customer ID ---
//     const columns = [
//         { header: 'ID', key: 'id' },
//         { header: 'Doc No', key: 'doc_no' },
//         { header: 'Customer Name', key: 'customer_name' },
//         { header: 'Customer ID', key: 'cust_id' },
//         { header: 'Work Order ID', key: 'wo_id' },
//         { header: 'Work Order No', key: 'wo_no' },
//         { header: 'Work Order Date', key: 'wo_date' },
//         { header: 'Project ID', key: 'project_id' },
//         { header: 'Project Name', key: 'project_name' },
//         { header: 'Invoice Date', key: 'inv_date' },
//         { header: 'Due Date', key: 'due_date' },
//         { header: 'Start Date', key: 'start_date' },
//         { header: 'End Date', key: 'end_date' },
//         { header: 'Taxable Amt', key: 'taxable_amt' },
//         { header: 'CGST', key: 'tot_cgst' },
//         { header: 'SGST', key: 'tot_sgst' },
//         { header: 'IGST', key: 'tot_igst' },
//         { header: 'Total Amount', key: 'amount' },
//         { header: 'Approval Status', key: 'inv_approval_status' },
//         { header: 'Current Status', key: 'current_status' },
//         { header: 'Stage', key: 'stage' },
//         { header: 'Created By', key: 'added_by' },
//         { header: 'Created Date', key: 'add_date' },
//         { header: 'Updated By', key: 'updated_by' },
//         { header: 'Updated Date', key: 'update_date' },
//     ];

//     const formatData = (value, key) => {
//         if (value === null || typeof value === 'undefined') return 'N/A';

//         const currencyKeys = ['taxable_amt', 'amount', 'tot_cgst', 'tot_sgst', 'tot_igst'];
//         if (currencyKeys.includes(key)) {
//             const numberValue = parseFloat(value);
//             return isNaN(numberValue) ? 'N/A' : numberValue.toLocaleString('en-IN', { style: 'currency', currency: 'INR' });
//         }

//         if (typeof value === 'string' && value.includes('T')) {
//             const date = new Date(value);
//             return !isNaN(date) ? date.toLocaleDateString('en-GB') : 'N/A';
//         }

//         return value;
//     };

//     const sortedInvoices = useMemo(() => {
//         if (!Array.isArray(invoices)) return [];
//         return [...invoices].sort((a, b) => new Date(b.inv_date || b.add_date) - new Date(a.inv_date || a.add_date));
//     }, [invoices]);

//     if (sortedInvoices.length === 0) {
//         return (
//             <div className="filtered-table-container">
//                  <p className="no-data-message" style={{ padding: '20px' }}>No invoice data matching the current filter.</p>
//             </div>
//         )
//     }

//     return (
//         <div className="filtered-table-container">
//             <div className="table-content-wrapper">
//                 <div className="table-scroll-container">
//                     <table className="data-table wide-table">
//                         <thead>
//                             <tr>
//                                 {columns.map(col => <th key={col.key}>{col.header}</th>)}
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {/* --- MODIFIED: Updated rendering logic to pull data from customerMap and workOrderMap --- */}
//                             {sortedInvoices.map((invoice) => {
//                                 const relatedWorkOrder = workOrderMap.get(invoice.wo_id) || {}; // Get related WO, default to empty obj

//                                 return (
//                                     <tr key={invoice.id}>
//                                         {columns.map(col => {
//                                             let cellValue;
//                                             if (col.key === 'customer_name') {
//                                                 cellValue = customerMap.get(invoice.cust_id) || 'N/A';
//                                             } else if (['project_id', 'project_name', 'wo_no', 'wo_date'].includes(col.key)) {
//                                                 // Get data from the mapped work order
//                                                 cellValue = formatData(relatedWorkOrder[col.key], col.key);
//                                             } else {
//                                                 // Get data from the invoice object itself
//                                                 cellValue = formatData(invoice[col.key], col.key);
//                                             }
//                                             return <td key={col.key}>{cellValue}</td>;
//                                         })}
//                                     </tr>
//                                 );
//                             })}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         </div>
//     );
// };
 
// // ====================================================================
// // --- Component for the Invoices Tab (UPDATED with Chart Click) ---
// // ====================================================================
// const InvoiceDashboardContent = ({ invoices, workOrders, loading, error, customerMap }) => {
//     const today = new Date();
//     const thirtyDaysAgo = new Date(new Date().setDate(today.getDate() - 30));
//     const formatDateForInput = (date) => date.toISOString().split('T')[0];
   
//     const [startDate, setStartDate] = useState(formatDateForInput(thirtyDaysAgo));
//     const [endDate, setEndDate] = useState(formatDateForInput(new Date()));
//     const [selectedStatusFilter, setSelectedStatusFilter] = useState(null); // <-- NEW: State for pie chart filter
//     const tableRef = useRef(null);
//     const statusPieChartRef = useRef(null); // <-- NEW: Ref for the pie chart

//     const filteredInvoicesByDate = useMemo(() => {
//         if (!Array.isArray(invoices) || !startDate || !endDate) return [];
//         const start = new Date(startDate);
//         const end = new Date(endDate);
//         end.setHours(23, 59, 59, 999);
//         return invoices.filter(inv => {
//             const invoiceDate = new Date(inv.inv_date || inv.add_date);
//             return !isNaN(invoiceDate) && invoiceDate >= start && invoiceDate <= end;
//         });
//     }, [invoices, startDate, endDate]);
 
//     const dashboardData = useMemo(() => {
//         const EMPTY_CHART_DATA = { labels: [], datasets: [{ data: [] }] };
//         const baseKpis = { totalInvoices: 0, totalTaxable: 0, totalGst: 0, avgCreditPeriod: 0 };

//         if (filteredInvoicesByDate.length === 0) {
//             return { kpis: baseKpis, customerData: EMPTY_CHART_DATA, statusPieData: EMPTY_CHART_DATA };
//         }
 
//         const totalInvoices = filteredInvoicesByDate.length;
//         const totalTaxable = filteredInvoicesByDate.reduce((sum, inv) => sum + (Number(inv.taxable_amt) || 0), 0);
//         const totalGst = filteredInvoicesByDate.reduce((sum, inv) => sum + (Number(inv.tot_cgst) || 0) + (Number(inv.tot_sgst) || 0) + (Number(inv.tot_igst) || 0) + (Number(inv.tot_cess) || 0) + (Number(inv.tot_kkc) || 0), 0);
//         const creditPeriods = filteredInvoicesByDate.map(inv => Number(inv.cr_period)).filter(p => p > 0);
//         const avgCreditPeriod = creditPeriods.length > 0 ? (creditPeriods.reduce((a, b) => a + b, 0) / creditPeriods.length).toFixed(2) : 0;
        
//         const customerAggregates = filteredInvoicesByDate.reduce((acc, inv) => {
//             const customerName = customerMap.get(inv.cust_id) || `Customer ID: ${inv.cust_id}`;
//             acc[customerName] = (acc[customerName] || 0) + (Number(inv.amount) || 0);
//             return acc;
//         }, {});

//         const sortedCustomers = Object.entries(customerAggregates).sort(([,a], [,b]) => b - a).slice(0, 10);
//         const customerData = { 
//             labels: sortedCustomers.map(([name]) => name), 
//             datasets: [{ 
//                 label: 'Total Invoice Amount', 
//                 data: sortedCustomers.map(([, amount]) => amount), 
//                 backgroundColor: 'rgba(153, 102, 255, 0.6)' 
//             }] 
//         };
 
//         const statusCountsForPie = filteredInvoicesByDate.reduce((acc, inv) => {
//             const status = inv.current_status || 'Unknown';
//             acc[status] = (acc[status] || 0) + 1;
//             return acc;
//         }, {});

//         const statusPieData = {
//             labels: Object.keys(statusCountsForPie),
//             datasets: [{
//                 data: Object.values(statusCountsForPie),
//                 backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#F7464A'],
//                 borderColor: '#fff',
//                 borderWidth: 2
//             }]
//         };
       
//         return {
//             kpis: { totalInvoices, totalTaxable, totalGst, avgCreditPeriod },
//             customerData, statusPieData
//         };
//     }, [filteredInvoicesByDate, customerMap]);
    
//     // --- UPDATED: This now filters by date AND the selected status from the pie chart ---
//     const finalFilteredInvoices = useMemo(() => {
//         if (!selectedStatusFilter) {
//             return filteredInvoicesByDate; // No status filter applied
//         }
//         return filteredInvoicesByDate.filter(invoice => invoice.current_status === selectedStatusFilter);
//     }, [filteredInvoicesByDate, selectedStatusFilter]);

//     // --- NEW: Click handler for the status pie chart ---
//     const handleStatusPieClick = (event) => {
//         if (!statusPieChartRef.current) return;
//         const elements = getElementAtEvent(statusPieChartRef.current, event);

//         if (elements.length > 0) {
//             const clickedStatus = dashboardData.statusPieData.labels[elements[0].index];
//             // Toggle filter: if clicking the same slice, clear filter. Otherwise, set filter.
//             setSelectedStatusFilter(prevStatus => prevStatus === clickedStatus ? null : clickedStatus);
//             // Scroll to the table after a click
//             setTimeout(() => {
//                 tableRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
//             }, 100);
//         } else {
//             // If clicked outside a slice, clear the filter
//             setSelectedStatusFilter(null);
//         }
//     };

//     if (loading) return <div className="loading-error-container"><h2>Loading Invoice Dashboard...</h2></div>;
//     if (error) return <div className="loading-error-container"><h2>Dashboard Error</h2><p>{error}</p></div>;
 
//     const formatCurrency = (value) => new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(value);
//     const pieOptions = { responsive: true, plugins: { legend: { position: 'bottom' }, datalabels: { color: '#fff', font: { weight: 'bold' }, formatter: (value) => (value > 0 ? value : '') } } };
 
//     return (
//         <main className="main-content">
//             <div className="filter-bar">
//                 <div className="filter-item"><label htmlFor="start-date">Start Date:</label><input type="date" id="start-date" value={startDate} onChange={(e) => setStartDate(e.target.value)} /></div>
//                 <div className="filter-item"><label htmlFor="end-date">End Date:</label><input type="date" id="end-date" value={endDate} onChange={(e) => setEndDate(e.target.value)} /></div>
//             </div>
           
//             <div className="kpi-grid">
//                 <div className="kpi-card"><h4>Total Invoices</h4><p>{dashboardData.kpis.totalInvoices}</p></div>
//                 <div className="kpi-card"><h4>Total Taxable Amount</h4><p>{formatCurrency(dashboardData.kpis.totalTaxable)}</p></div>
//                 <div className="kpi-card"><h4>Total GST Collected</h4><p>{formatCurrency(dashboardData.kpis.totalGst)}</p></div>
//                 <div className="kpi-card"><h4>Avg. Credit Period</h4><p>{dashboardData.kpis.avgCreditPeriod} Days</p></div>
//             </div>
           
//             <div className="dashboard-grid">
//                 <div className="chart-card large-card">
//                   <h3>Customer Wise Invoices (Top 10 by Amount)</h3>
//                   {filteredInvoicesByDate.length > 0 ? <Bar data={dashboardData.customerData} options={{ responsive: true, scales: { y: { beginAtZero: true } } }} /> : <p className="no-data-message">No data for selected date range.</p>}
//                 </div>
//                 <div className="chart-card">
//                   <h3>Invoices by Status</h3>
//                   {filteredInvoicesByDate.length > 0 ? <Pie ref={statusPieChartRef} data={dashboardData.statusPieData} options={pieOptions} onClick={handleStatusPieClick} /> : <p className="no-data-message">No data available.</p>}
//                 </div>
//             </div>

//             <div ref={tableRef} className="invoice-table-section" style={{ marginTop: '2rem' }}>
//                 {/* --- NEW: Dynamic table header with a clear filter button --- */}
//                 <div className="table-header with-controls">
//                     <h3>All Invoices {selectedStatusFilter && `(Status: ${selectedStatusFilter})`}</h3>
//                     {selectedStatusFilter && (
//                         <button onClick={() => setSelectedStatusFilter(null)} className="clear-filters-btn">
//                             Clear Status Filter
//                         </button>
//                     )}
//                 </div>
//                 <InvoiceDataTable invoices={finalFilteredInvoices} workOrders={workOrders} customerMap={customerMap} />
//             </div>
//         </main>
//     );
// };
 
 
// // ====================================================================
// // --- Main Dashboard Component ---
// // ====================================================================
// const Dashboard = () => {
//     const [activeTab, setActiveTab] = useState('workOrder');
//     const [workOrderTableReport, setWorkOrderTableReport] = useState({ columns: [], data: [] });
//     const [invoices, setInvoices] = useState([]);
//     const [customers, setCustomers] = useState([]); // <-- State for customer names
//     const [filters, setFilters] = useState({});
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
 
//     const API_TOKEN = 'Bearer ' + localStorage.getItem('zTaskAuthToken');
 
//     const handleApiResponse = async (response) => {
//         if (!response.ok) {
//             const errorText = await response.text();
//             const truncatedError = errorText.length > 200 ? errorText.substring(0, 200) + '...' : errorText;
//             throw new Error(`API call to ${response.url} failed with status ${response.status}: ${response.statusText}. Response: ${truncatedError}`);
//         }
//         return response.json();
//     };
 
//     useEffect(() => {
//         const fetchAllData = async () => {
//             setLoading(true);
//             setError(null);
 
//             const REPORT_API_URL = `${process.env.REACT_APP_REPORTS_API_URL}/api/reports/run`;
//             const INVOICE_API_URL = `${process.env.REACT_APP_NODE_SERVICE_BASE_URL}/invoice/api/invoices/`;
//             const CUSTOMER_API_URL = `${process.env.REACT_APP_NODE_SERVICE_BASE_URL}/api/get-column/customers/name`;
 
//             const HEADERS = { 'accept': 'application/json', 'Authorization': API_TOKEN };
//             const TABLE_REPORT_BODY = { "report_name": "work_order_table", "module_name": "Workorder" };
           
//             try {
//                 const [tableReportJson, invoiceJson, customersJson] = await Promise.all([
//                     fetch(REPORT_API_URL, { method: 'POST', headers: { ...HEADERS, 'Content-Type': 'application/json' }, body: JSON.stringify(TABLE_REPORT_BODY) }).then(handleApiResponse),
//                     fetch(INVOICE_API_URL, { headers: HEADERS }).then(handleApiResponse),
//                     fetch(CUSTOMER_API_URL, { headers: HEADERS }).then(handleApiResponse)
//                 ]);
               
//                 if (tableReportJson && tableReportJson.columns && tableReportJson.data) setWorkOrderTableReport(tableReportJson);
//                 setInvoices(Array.isArray(invoiceJson) ? invoiceJson : []);
//                 setCustomers(Array.isArray(customersJson) ? customersJson : []);

//             } catch (e) {
//                 console.error("Failed to fetch dashboard data:", e);
//                 setError(e.message);
//             } finally {
//                 setLoading(false);
//             }
//         };
//         fetchAllData();
//     }, []);
 
//     const handleChartClick = (filterType, clickedLabel) => setFilters(prev => ({ ...prev, [filterType]: clickedLabel }));
//     const clearFilters = () => setFilters({});
   
//     const customerMap = useMemo(() => {
//         const map = new Map();
//         if (customers) {
//             customers.forEach(customer => {
//                 map.set(customer.id, customer.value);
//             });
//         }
//         return map;
//     }, [customers]);

//     const uniqueWorkOrders = useMemo(() => {
//         const data = workOrderTableReport.data;
//         if (!Array.isArray(data)) return [];
//         const uniqueWoMap = new Map();
//         data.forEach(order => {
//             if (!uniqueWoMap.has(order.wo_id)) {
//                 uniqueWoMap.set(order.wo_id, { ...order, tot_value: parseFloat(order.tot_value) || 0 });
//             }
//         });
//         return Array.from(uniqueWoMap.values());
//     }, [workOrderTableReport.data]);
 
//     const statusPieChartData = useMemo(() => {
//         const statusCounts = uniqueWorkOrders.reduce((acc, order) => {
//             const status = order.wo_open_close || 'Unknown';
//             acc[status] = (acc[status] || 0) + 1;
//             return acc;
//         }, { 'Open': 0, 'Closed': 0 });
//         return { labels: Object.keys(statusCounts), datasets: [{ data: Object.values(statusCounts), backgroundColor: ['#ff8a80', '#80d8ff'], borderColor: '#ffffff', borderWidth: 3 }] };
//     }, [uniqueWorkOrders]);
 
//     const sectorBarChartData = useMemo(() => {
//         const sectorData = uniqueWorkOrders.reduce((acc, wo) => {
//             const sectorName = wo.sector_name || 'Unknown Sector';
//             if (!acc[sectorName]) acc[sectorName] = { count: 0, totalValue: 0 };
//             acc[sectorName].count += 1;
//             acc[sectorName].totalValue += wo.tot_value;
//             return acc;
//         }, {});
//         const labels = Object.keys(sectorData).sort();
//         return { labels, datasets: [
//             { label: 'Number of Orders', data: labels.map(l => sectorData[l].count), backgroundColor: 'rgba(255, 159, 64, 0.8)' },
//             { label: 'Total Value', data: labels.map(l => sectorData[l].totalValue), backgroundColor: 'rgba(75, 192, 192, 0.8)' }
//         ] };
//     }, [uniqueWorkOrders]);
   
//     const topCustomersData = useMemo(() => {
//         const customerAggregates = uniqueWorkOrders.reduce((acc, wo) => {
//             const customerName = wo.customer_name || 'Unknown Customer';
//             acc[customerName] = (acc[customerName] || 0) + wo.tot_value;
//             return acc;
//         }, {});
//         const sortedCustomers = Object.entries(customerAggregates).sort(([, a], [, b]) => b - a).slice(0, 5);
//         return { labels: sortedCustomers.map(([label]) => label), datasets: [{ label: 'Total Order Value', data: sortedCustomers.map(([, value]) => value), backgroundColor: 'rgba(54, 162, 235, 0.8)' }] };
//     }, [uniqueWorkOrders]);
 
//     const filteredWorkOrders = useMemo(() => {
//         let data = workOrderTableReport.data || [];
//         if (Object.keys(filters).length === 0) return data;
//         const woIdsToKeep = new Set(uniqueWorkOrders
//             .filter(wo => (!filters.status || wo.wo_open_close === filters.status) && (!filters.sector || wo.sector_name === filters.sector) && (!filters.customer || wo.customer_name === filters.customer))
//             .map(wo => wo.wo_id)
//         );
//         return data.filter(order => woIdsToKeep.has(order.wo_id));
//     }, [workOrderTableReport.data, uniqueWorkOrders, filters]);
 
//     return (
//         <div className="dashboard-container">
//             <div className="tabs-container">
//                 <button className={`tab-button ${activeTab === 'workOrder' ? 'active' : ''}`} onClick={() => setActiveTab('workOrder')}>Work Orders</button>
//                 <button className={`tab-button ${activeTab === 'invoice' ? 'active' : ''}`} onClick={() => setActiveTab('invoice')}>Invoices</button>
//             </div>
//             <div className="tab-content">
//                 {activeTab === 'workOrder' && (
//                     <WorkOrderDashboardContent
//                         loading={loading} error={error} statusPieChartData={statusPieChartData}
//                         sectorBarChartData={sectorBarChartData}
//                         topCustomersData={topCustomersData} filteredWorkOrders={filteredWorkOrders}
//                         filters={filters} onChartClick={handleChartClick} onClearFilters={clearFilters}
//                         apiToken={API_TOKEN}
//                     />
//                 )}
//                 {activeTab === 'invoice' && (
//                     <InvoiceDashboardContent 
//                         invoices={invoices} 
//                         workOrders={workOrderTableReport.data}
//                         loading={loading} 
//                         error={error}
//                         customerMap={customerMap}
//                     />
//                 )}
//             </div>
//         </div>
//     );
// };
 
// export default Dashboard;











// import React, { useState, useEffect, useMemo, useRef } from 'react';
// import { Pie, Bar, getElementAtEvent } from 'react-chartjs-2';
// import {
//     Chart as ChartJS,
//     CategoryScale,
//     LinearScale,
//     BarElement,
//     Title,
//     Tooltip,
//     Legend,
//     ArcElement
// } from 'chart.js';
// import ChartDataLabels from 'chartjs-plugin-datalabels';
// import './Dashboard.css'; // Renamed CSS import
 
// ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement, ChartDataLabels);
 
// // ====================================================================
// // --- Component for Work Order Table ---
// // ====================================================================
// const FilteredWorkOrderTable = ({ workOrders, apiToken }) => {
//     const [activeTab, setActiveTab] = useState('assets');
//     const [assets, setAssets] = useState([]);
//     const [assetsLoading, setAssetsLoading] = useState(false);
//     const [assetsError, setAssetsError] = useState(null);
 
//     useEffect(() => {
//         const fetchAssets = async () => {
//             if (!workOrders || workOrders.length === 0) {
//                 setAssets([]);
//                 return;
//             }
//             const assetIdSet = new Set(workOrders.map(wo => wo.asset_id).filter(id => id != null));
//             const assetIds = Array.from(assetIdSet);
//             if (assetIds.length === 0) {
//                 setAssets([]);
//                 return;
//             }
           
//             setAssetsLoading(true);
//             setAssetsError(null);
           
//             const ASSET_API_URL = `${process.env.REACT_APP_ASSET_SERVICE_BASE_URL}/api/assets/`;
//             const ASSET_HEADERS = { 'accept': 'application/json', 'Authorization': apiToken };
 
//             try {
//                 const assetPromises = assetIds.map(id =>
//                     fetch(`${ASSET_API_URL}${id}`, { headers: ASSET_HEADERS }).then(res => {
//                         if (!res.ok) {
//                             console.error(`Failed to fetch asset ${id}, status: ${res.status}`);
//                             return null;
//                         }
//                         return res.json();
//                     })
//                 );
//                 const fetchedAssetsResults = await Promise.all(assetPromises);
//                 setAssets(fetchedAssetsResults.filter(asset => asset !== null));
//             } catch (error) {
//                 console.error("Failed to fetch assets:", error);
//                 setAssetsError(error.message);
//             } finally {
//                 setAssetsLoading(false);
//             }
//         };
//         fetchAssets();
//     }, [workOrders, apiToken]);
 
//     const displayedWorkOrders = useMemo(() => {
//         if (!workOrders || !Array.isArray(workOrders)) return [];
//         return [...workOrders].sort((a, b) => new Date(b.add_date) - new Date(a.add_date));
//     }, [workOrders]);
 
//     const formatData = (value) => {
//         if (value === null || typeof value === 'undefined') return 'N/A';
//         if (typeof value === 'boolean') return value ? 'Yes' : 'No';
//         if (typeof value === 'string' && value.includes('T')) {
//             const date = new Date(value);
//             if (!isNaN(date)) return date.toLocaleDateString('en-GB');
//         }
//         return value;
//     };
 
//     const displayColumns = [
//         { header: 'Doc No', key: 'doc_no' }, { header: 'WO No', key: 'wo_no' },
//         { header: 'Status', key: 'wo_open_close' }, { header: 'Total Value', key: 'tot_value' },
//         { header: 'Customer Name', key: 'customer_name' }, { header: 'Customer ID', key: 'cust_id' },
//         { header: 'Project Name', key: 'project_name' }, { header: 'Project ID', key: 'project_id' },
//         { header: 'Sector Name', key: 'sector_name' }, { header: 'Sector ID', key: 'sector' },
//         { header: 'Asset ID', key: 'asset_id' }, { header: 'WO Date', key: 'wo_date' },
//         { header: 'WO Start', key: 'wo_start' }, { header: 'WO End', key: 'wo_end' },
//     ];
 
//     return (
//         <div className="filtered-table-container">
//             <div className="table-header"><h3>All Work Orders</h3></div>
//             <div className="table-controls">
//                 <div className="tabs">
//                     <button className={`tab-btn ${activeTab === 'assets' ? 'active' : ''}`} onClick={() => setActiveTab('assets')}>Assets</button>
//                     <button className={`tab-btn ${activeTab === 'workorder' ? 'active' : ''}`} onClick={() => setActiveTab('workorder')}>Workorder</button>
//                 </div>
//             </div>
//             <div className="table-content-wrapper">
//                 {activeTab === 'workorder' ? (
//                     <>
//                         {displayedWorkOrders.length > 0 ? (
//                             <div className="table-scroll-container">
//                                 <table className="data-table wide-table">
//                                     <thead><tr>{displayColumns.map(col => <th key={col.key}>{col.header}</th>)}</tr></thead>
//                                     <tbody>
//                                         {displayedWorkOrders.map((order, index) => (
//                                             <tr key={`${order.id}-${index}`}>
//                                                 {displayColumns.map(col => (
//                                                     <td key={col.key}>{col.key === 'tot_value' ? parseFloat(order[col.key] || 0).toLocaleString('en-US') : formatData(order[col.key])}</td>
//                                                 ))}
//                                             </tr>
//                                         ))}
//                                     </tbody>
//                                 </table>
//                             </div>
//                         ) : (<p className="no-data-message">No work orders found for the current filter.</p>)}
//                     </>
//                 ) : (
//                     <>
//                         {assetsLoading && <p className="loading-message">Loading Assets...</p>}
//                         {assetsError && <p className="error-message">Error: {assetsError}</p>}
//                         {!assetsLoading && !assetsError && (
//                             <>
//                                 {assets.length > 0 ? (
//                                     <div className="table-scroll-container">
//                                         <table className="data-table wide-table">
//                                             <thead>
//                                                 <tr><th>Asset Name</th><th>Asset Type</th><th>Capacity (MT)</th><th>Year of Purchase</th><th>Year of Manufacture</th></tr>
//                                             </thead>
//                                             <tbody>
//                                                 {assets.map(asset => {
//                                                     const combinedAssetName = [asset.name, asset.serial_number, asset.asset_code, asset.registration_number].filter(Boolean).join(' | ');
//                                                     return (
//                                                         <tr key={asset.id}>
//                                                             <td>{combinedAssetName || 'N/A'}</td>
//                                                             <td>{formatData(asset.asset_type)}</td>
//                                                             <td>{formatData(asset.capacity_mt)}</td>
//                                                             <td>{formatData(asset.year_of_purchase)}</td>
//                                                             <td>{formatData(asset.year_of_manufacture)}</td>
//                                                         </tr>
//                                                     );
//                                                 })}
//                                             </tbody>
//                                         </table>
//                                     </div>
//                                 ) : (<p className="no-data-message">No assets found for the current work orders.</p>)}
//                             </>
//                         )}
//                     </>
//                 )}
//             </div>
//         </div>
//     );
// };
 
// // ====================================================================
// // --- Component for Asset Availability Table ---
// // ====================================================================
// const AssetAvailabilityTable = ({ workOrders, apiToken }) => {
//     const [combinedAssets, setCombinedAssets] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);
//     const [filterDays, setFilterDays] = useState(null);
//     const [customDays, setCustomDays] = useState('');
 
//     useEffect(() => {
//         const fetchAndCombineData = async () => {
//             setLoading(true);
//             setError(null);
           
//             const workOrderInfoMap = new Map();
//             if (workOrders && Array.isArray(workOrders)) {
//                 workOrders.forEach(wo => {
//                     if (wo.asset_id != null) {
//                         workOrderInfoMap.set(Number(wo.asset_id), { wo_start: wo.wo_start, wo_end: wo.wo_end, wo_no: wo.wo_no });
//                     }
//                 });
//             }
           
//             const ASSET_API_URL = `${process.env.REACT_APP_ASSET_SERVICE_BASE_URL}/api/assets/`;
//             const ASSET_HEADERS = { 'accept': 'application/json', 'Authorization': apiToken };
 
//             try {
//                 const response = await fetch(ASSET_API_URL, { headers: ASSET_HEADERS });
//                 if (!response.ok) {
//                     throw new Error(`Failed to fetch assets, status: ${response.status}`);
//                 }
//                 const allAssets = await response.json();
//                 const activeAssets = allAssets.filter(asset => asset.active === true);
 
//                 const combinedData = activeAssets.map(asset => {
//                     const workOrderInfo = workOrderInfoMap.get(asset.id) || { wo_start: null, wo_end: null, wo_no: null };
//                     return { ...asset, ...workOrderInfo };
//                 });
               
//                 setCombinedAssets(combinedData);
//             } catch (error) {
//                 console.error("Failed to fetch asset data:", error);
//                 setError(error.message);
//             } finally {
//                 setLoading(false);
//             }
//         };
 
//         fetchAndCombineData();
//     }, [workOrders, apiToken]);
 
//     const filteredAssets = useMemo(() => {
//         if (filterDays === null) return combinedAssets;
//         const targetDate = new Date();
//         targetDate.setDate(targetDate.getDate() + filterDays);
//         targetDate.setHours(23, 59, 59, 999);
//         return combinedAssets.filter(asset => {
//             if (!asset.wo_end) return true;
//             const woEndDate = new Date(asset.wo_end);
//             return isNaN(woEndDate.getTime()) || woEndDate <= targetDate;
//         });
//     }, [combinedAssets, filterDays]);
 
//     const formatData = (value) => {
//         if (value === null || typeof value === 'undefined') return 'N/A';
//         if (typeof value === 'boolean') return value ? 'Yes' : 'No';
//         if (typeof value === 'string' && value.includes('T')) {
//             const date = new Date(value);
//             if (!isNaN(date)) return date.toLocaleDateString('en-GB');
//         }
//         return value;
//     };
 
//     const handleCustomFilter = () => {
//         const days = parseInt(customDays, 10);
//         if (days > 0) setFilterDays(days);
//     };
 
//     const clearFilter = () => {
//         setFilterDays(null);
//         setCustomDays('');
//     };
 
//     return (
//         <div className="filtered-table-container">
//             <div className="table-header with-controls">
//                 <h3>Asset Availability</h3>
//                 <div className="availability-filter-controls">
//                     <span>Available In:</span>
//                     {[3, 7, 15, 30].map(days => (
//                         <button key={days} onClick={() => setFilterDays(days)} className={filterDays === days ? 'active' : ''}>{days} Days</button>
//                     ))}
//                     <div className="custom-filter">
//                         <input type="number" placeholder="Custom" value={customDays} onChange={(e) => setCustomDays(e.target.value)} min="1"/>
//                         <button onClick={handleCustomFilter}>Go</button>
//                     </div>
//                     <button onClick={clearFilter}>Clear Filter</button>
//                 </div>
//             </div>
//             <div className="table-content-wrapper">
//                 {loading && <p className="loading-message">Loading Assets...</p>}
//                 {error && <p className="error-message">Error: {error}</p>}
//                 {!loading && !error && (
//                     <>
//                         {filteredAssets.length > 0 ? (
//                             <div className="table-scroll-container">
//                                 <table className="data-table wide-table">
//                                     <thead>
//                                         <tr><th>ID</th><th>Asset Name</th><th>Asset Type</th><th>Capacity (MT)</th><th>Year of Purchase</th><th>Year of Manufacture</th><th>WO No</th><th>WO Start</th><th>WO End</th></tr>
//                                     </thead>
//                                     <tbody>
//                                         {filteredAssets.map(asset => {
//                                             const combinedAssetName = [asset.name, asset.serial_number, asset.asset_code, asset.registration_number].filter(Boolean).join(' | ');
//                                             return (
//                                                 <tr key={asset.id}>
//                                                     <td>{formatData(asset.id)}</td>
//                                                     <td>{combinedAssetName || 'N/A'}</td>
//                                                     <td>{formatData(asset.asset_type)}</td>
//                                                     <td>{formatData(asset.capacity_mt)}</td>
//                                                     <td>{formatData(asset.year_of_purchase)}</td>
//                                                     <td>{formatData(asset.year_of_manufacture)}</td>
//                                                     <td>{formatData(asset.wo_no)}</td>
//                                                     <td>{formatData(asset.wo_start)}</td>
//                                                     <td>{formatData(asset.wo_end)}</td>
//                                                 </tr>
//                                             );
//                                         })}
//                                     </tbody>
//                                 </table>
//                             </div>
//                         ) : (<p className="no-data-message">{filterDays !== null ? "No assets match the current availability filter." : "No active assets found."}</p>)}
//                     </>
//                 )}
//             </div>
//         </div>
//     );
// };
 
// // ====================================================================
// // --- Component for the Work Orders Tab Content ---
// // ====================================================================
// const WorkOrderDashboardContent = ({
//     loading, error, statusPieChartData, sectorBarChartData,
//     topCustomersData, filteredWorkOrders, filters, onChartClick, onClearFilters, apiToken
// }) => {
//     const statusChartRef = useRef();
//     const sectorChartRef = useRef();
//     const customerChartRef = useRef();
 
//     const handleChartClick = (filterType, chartData, event, chartRef) => {
//         if (!chartRef.current) return;
//         const elements = getElementAtEvent(chartRef.current, event);
//         if (elements.length > 0) {
//             const clickedLabel = chartData.labels[elements[0].index];
//             onChartClick(filterType, clickedLabel);
//         }
//     };
 
//     const hasFilters = Object.keys(filters).length > 0;
   
//     if (loading) return <div className="loading-error-container"><h2>Loading Dashboard...</h2></div>;
//     if (error) return <div className="loading-error-container"><h2>Dashboard Error</h2><p>{error}</p></div>;
 
//     return (
//         <main className="main-content">
//              <div className="dashboard-title-bar">
//                 <h1 className="dashboard-header">Work Orders Dashboard</h1>
//                 {hasFilters && (<button onClick={onClearFilters} className="clear-filters-btn">Clear Filters</button>)}
//             </div>
//             <div className="dashboard-grid">
//                 <div className="chart-card">
//                     <h3>Work Orders by Status</h3>
//                     <Pie ref={statusChartRef} data={statusPieChartData} options={{ responsive: true, plugins: { legend: { position: 'top' }, datalabels: { color: '#343a40', font: { weight: 'bold', size: 16 }, formatter: (value) => (value > 0 ? value : null) } } }} onClick={(event) => handleChartClick('status', statusPieChartData, event, statusChartRef)}/>
//                 </div>
//                 <div className="chart-card">
//                     <h3>Work Orders by Sector</h3>
//                     <Bar ref={sectorChartRef} data={sectorBarChartData} options={{ responsive: true, scales: { y: { beginAtZero: true } } }} onClick={(event) => handleChartClick('sector', sectorBarChartData, event, sectorChartRef)}/>
//                 </div>
//                 <div className="chart-card">
//                     <h3>Top Customers by Order Value</h3>
//                      <Bar ref={customerChartRef} data={topCustomersData} options={{ responsive: true, scales: { y: { beginAtZero: true } } }} onClick={(event) => handleChartClick('customer', topCustomersData, event, customerChartRef)}/>
//                 </div>
//                 <div className="chart-card table-card">
//                     <FilteredWorkOrderTable workOrders={filteredWorkOrders} apiToken={apiToken} />
//                 </div>
//                 <div className="chart-card table-card">
//                      <AssetAvailabilityTable workOrders={filteredWorkOrders} apiToken={apiToken} />
//                 </div>
//             </div>
//         </main>
//     );
// };

// // ====================================================================
// // --- Component for Invoice Data Table ---
// // ====================================================================
// const InvoiceDataTable = ({ invoices, workOrderMap, customerMap, userMap }) => {
//     // Columns definition with corrected Created By/Updated By headers
//     const columns = useMemo(() => [
//         { header: 'ID', key: 'id' }, { header: 'Doc No', key: 'doc_no' },
//         { header: 'Customer Name', key: 'customer_name' }, { header: 'Customer ID', key: 'cust_id' },
//         { header: 'Work Order ID', key: 'wo_id' }, { header: 'Work Order No', key: 'wo_no' },
//         { header: 'Work Order Date', key: 'wo_date' }, { header: 'Project ID', key: 'project_id' },
//         { header: 'Project Name', key: 'project_name' }, { header: 'Invoice Date', key: 'inv_date' },
//         { header: 'Due Date', key: 'due_date' }, { header: 'Start Date', key: 'start_date' },
//         { header: 'End Date', key: 'end_date' }, { header: 'Taxable Amt', key: 'taxable_amt' },
//         { header: 'CGST', key: 'tot_cgst' }, { header: 'SGST', key: 'tot_sgst' },
//         { header: 'IGST', key: 'tot_igst' }, { header: 'Total Amount', key: 'amount' },
//         { header: 'Approval Status', key: 'inv_approval_status' }, { header: 'Current Status', key: 'current_status' },
//         { header: 'Stage', key: 'stage' }, { header: 'Created By', key: 'added_by' },
//         { header: 'Created Date', key: 'add_date' }, { header: 'Updated By', key: 'updated_by' },
//         { header: 'Updated Date', key: 'update_date' },
//     ], []);

//     // Generic data formatting function
//     const formatData = (value, key) => {
//         if (value === null || typeof value === 'undefined') return 'N/A';
//         const currencyKeys = ['taxable_amt', 'amount', 'tot_cgst', 'tot_sgst', 'tot_igst'];
//         if (currencyKeys.includes(key)) {
//             const numberValue = parseFloat(value);
//             return isNaN(numberValue) ? 'N/A' : numberValue.toLocaleString('en-IN', { style: 'currency', currency: 'INR' });
//         }
//         if (typeof value === 'string' && (key.includes('date') || key.includes('Date'))) {
//             const date = new Date(value);
//             return !isNaN(date) ? date.toLocaleDateString('en-GB') : value;
//         }
//         return value;
//     };
    
//     // Sort invoices once by date
//     const sortedInvoices = useMemo(() => {
//         if (!Array.isArray(invoices)) return [];
//         return [...invoices].sort((a, b) => new Date(b.inv_date || b.add_date) - new Date(a.inv_date || a.add_date));
//     }, [invoices]);

//     if (sortedInvoices.length === 0) {
//         return (
//             <div className="filtered-table-container">
//                  <p className="no-data-message" style={{ padding: '20px' }}>No invoice data matching the current filter.</p>
//             </div>
//         )
//     }

//     return (
//         <div className="filtered-table-container">
//             <div className="table-content-wrapper">
//                 <div className="table-scroll-container">
//                     <table className="data-table wide-table">
//                         <thead>
//                             <tr>{columns.map(col => <th key={col.key}>{col.header}</th>)}</tr>
//                         </thead>
//                         <tbody>
//                             {sortedInvoices.map((invoice) => {
//                                 const relatedWorkOrder = workOrderMap.get(invoice.wo_id) || {};
//                                 return (
//                                     <tr key={invoice.id}>
//                                         {columns.map(col => {
//                                             let cellValue;
//                                             switch(col.key) {
//                                                 case 'customer_name':
//                                                     cellValue = customerMap.get(invoice.cust_id) || 'N/A';
//                                                     break;
//                                                 case 'added_by':
//                                                     cellValue = userMap.get(String(invoice.added_by)) || invoice.added_by || 'N/A';
//                                                     break;
//                                                 case 'updated_by':
//                                                     cellValue = userMap.get(String(invoice.updated_by)) || invoice.updated_by || 'N/A';
//                                                     break;
//                                                 case 'project_id': case 'project_name': case 'wo_no': case 'wo_date':
//                                                     cellValue = formatData(relatedWorkOrder[col.key], col.key);
//                                                     break;
//                                                 default:
//                                                     cellValue = formatData(invoice[col.key], col.key);
//                                             }
//                                             return <td key={col.key}>{cellValue}</td>;
//                                         })}
//                                     </tr>
//                                 );
//                             })}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         </div>
//     );
// };
 
// // ====================================================================
// // --- Component for the Invoices Tab ---
// // ====================================================================
// const InvoiceDashboardContent = ({ invoices, workOrders, loading, error, customerMap, userMap }) => {
//     const today = new Date();
//     const thirtyDaysAgo = new Date(new Date().setDate(today.getDate() - 30));
//     const formatDateForInput = (date) => date.toISOString().split('T')[0];
   
//     const [startDate, setStartDate] = useState(formatDateForInput(thirtyDaysAgo));
//     const [endDate, setEndDate] = useState(formatDateForInput(today));
//     const [selectedStatusFilter, setSelectedStatusFilter] = useState(null);
//     const [searchTerm, setSearchTerm] = useState(''); // State for search bar
//     const tableRef = useRef(null);
//     const statusPieChartRef = useRef(null);

//     // Memoize the work order map for efficiency
//     const workOrderMap = useMemo(() => {
//         const map = new Map();
//         if (Array.isArray(workOrders)) {
//             workOrders.forEach(wo => {
//                 if (wo.wo_id && !map.has(wo.wo_id)) {
//                     map.set(wo.wo_id, wo);
//                 }
//             });
//         }
//         return map;
//     }, [workOrders]);
    
//     // 1. Filter invoices by the selected date range
//     const filteredInvoicesByDate = useMemo(() => {
//         if (!Array.isArray(invoices) || !startDate || !endDate) return [];
//         const start = new Date(startDate);
//         const end = new Date(endDate);
//         end.setHours(23, 59, 59, 999);
//         return invoices.filter(inv => {
//             const invoiceDate = new Date(inv.inv_date || inv.add_date);
//             return !isNaN(invoiceDate) && invoiceDate >= start && invoiceDate <= end;
//         });
//     }, [invoices, startDate, endDate]);
 
//     // This data is used for the charts and KPIs, based only on date filter
//     const dashboardData = useMemo(() => {
//         const EMPTY_CHART_DATA = { labels: [], datasets: [{ data: [] }] };
//         const baseKpis = { totalInvoices: 0, totalTaxable: 0, totalGst: 0, avgCreditPeriod: 0 };

//         if (filteredInvoicesByDate.length === 0) {
//             return { kpis: baseKpis, customerData: EMPTY_CHART_DATA, statusPieData: EMPTY_CHART_DATA };
//         }
 
//         const statusCountsForPie = filteredInvoicesByDate.reduce((acc, inv) => {
//             const status = inv.current_status || 'Unknown';
//             acc[status] = (acc[status] || 0) + 1;
//             return acc;
//         }, {});

//         const statusPieData = {
//             labels: Object.keys(statusCountsForPie),
//             datasets: [{ data: Object.values(statusCountsForPie), backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#F7464A'], borderColor: '#fff', borderWidth: 2 }]
//         };
        
//         const customerAggregates = filteredInvoicesByDate.reduce((acc, inv) => {
//             const customerName = customerMap.get(inv.cust_id) || `Customer ID: ${inv.cust_id}`;
//             acc[customerName] = (acc[customerName] || 0) + (Number(inv.amount) || 0);
//             return acc;
//         }, {});

//         // --- MODIFICATION START ---
//         // Filter out customers with 0 total amount before sorting and slicing for the chart
//         const sortedCustomers = Object.entries(customerAggregates)
//             .filter(([, amount]) => amount > 0) // Only include customers with a total amount > 0
//             .sort(([,a], [,b]) => b - a)
//             .slice(0, 10);
//         // --- MODIFICATION END ---

//         const customerData = { 
//             labels: sortedCustomers.map(([name]) => name), 
//             datasets: [{ label: 'Total Invoice Amount', data: sortedCustomers.map(([, amount]) => amount), backgroundColor: 'rgba(153, 102, 255, 0.6)' }] 
//         };
       
//         return {
//             kpis: {
//                 totalInvoices: filteredInvoicesByDate.length,
//                 totalTaxable: filteredInvoicesByDate.reduce((sum, inv) => sum + (Number(inv.taxable_amt) || 0), 0),
//                 totalGst: filteredInvoicesByDate.reduce((sum, inv) => sum + (Number(inv.tot_cgst) || 0) + (Number(inv.tot_sgst) || 0) + (Number(inv.tot_igst) || 0), 0),
//                 avgCreditPeriod: (filteredInvoicesByDate.map(inv => Number(inv.cr_period)).filter(p => p > 0).reduce((a, b, _, arr) => a + b / arr.length, 0)).toFixed(2) || 0
//             },
//             customerData, statusPieData
//         };
//     }, [filteredInvoicesByDate, customerMap]);
    
//     // 2. Further filter by status from pie chart click
//     const statusFilteredInvoices = useMemo(() => {
//         if (!selectedStatusFilter) return filteredInvoicesByDate;
//         return filteredInvoicesByDate.filter(invoice => invoice.current_status === selectedStatusFilter);
//     }, [filteredInvoicesByDate, selectedStatusFilter]);

//     // 3. Final filter by search term on top of date and status filters
//     const finalFilteredInvoices = useMemo(() => {
//         if (!searchTerm.trim()) return statusFilteredInvoices;
//         const lowercasedFilter = searchTerm.toLowerCase();
//         return statusFilteredInvoices.filter(invoice => {
//             const workOrder = workOrderMap.get(invoice.wo_id) || {};
//             const searchableFields = [
//                 invoice.id, invoice.doc_no, invoice.cust_id, customerMap.get(invoice.cust_id),
//                 invoice.wo_id, workOrder.wo_no, workOrder.project_id, workOrder.project_name,
//                 invoice.inv_approval_status, invoice.current_status, invoice.stage,
//                 userMap.get(String(invoice.added_by)), userMap.get(String(invoice.updated_by))
//             ];
//             return searchableFields.some(field => field && String(field).toLowerCase().includes(lowercasedFilter));
//         });
//     }, [statusFilteredInvoices, searchTerm, workOrderMap, customerMap, userMap]);

//     const handleStatusPieClick = (event) => {
//         if (!statusPieChartRef.current) return;
//         const elements = getElementAtEvent(statusPieChartRef.current, event);
//         if (elements.length > 0) {
//             const clickedStatus = dashboardData.statusPieData.labels[elements[0].index];
//             setSelectedStatusFilter(prev => prev === clickedStatus ? null : clickedStatus);
//             setTimeout(() => tableRef.current?.scrollIntoView({ behavior: 'smooth' }), 100);
//         } else {
//             setSelectedStatusFilter(null);
//         }
//     };
    
//     // --- CSV Export Logic ---
//     const convertToCSVAndDownload = (dataToExport, filename) => {
//         if (dataToExport.length === 0) {
//             alert("No data available to export.");
//             return;
//         }

//         const columns = [
//             { header: 'ID', key: 'id' }, { header: 'Doc No', key: 'doc_no' },
//             { header: 'Customer Name', key: 'customer_name' }, { header: 'Customer ID', key: 'cust_id' },
//             { header: 'Work Order ID', key: 'wo_id' }, { header: 'Work Order No', key: 'wo_no' },
//             { header: 'Work Order Date', key: 'wo_date' }, { header: 'Project Name', key: 'project_name' },
//             { header: 'Invoice Date', key: 'inv_date' }, { header: 'Due Date', key: 'due_date' },
//             { header: 'Total Amount', key: 'amount' }, { header: 'Current Status', key: 'current_status' },
//             { header: 'Created By', key: 'added_by' }, { header: 'Created Date', key: 'add_date' },
//             { header: 'Updated By', key: 'updated_by' }, { header: 'Updated Date', key: 'update_date' },
//         ];

//         const replacer = (key, value) => value === null ? '' : value;
//         const header = columns.map(c => c.header).join(',');
//         const rows = dataToExport.map(invoice => {
//             const relatedWorkOrder = workOrderMap.get(invoice.wo_id) || {};
//             return columns.map(col => {
//                 let cellData;
//                 switch (col.key) {
//                     case 'customer_name': cellData = customerMap.get(invoice.cust_id) || 'N/A'; break;
//                     case 'added_by': cellData = userMap.get(String(invoice.added_by)) || invoice.added_by || 'N/A'; break;
//                     case 'updated_by': cellData = userMap.get(String(invoice.updated_by)) || invoice.updated_by || 'N/A'; break;
//                     case 'wo_no': case 'wo_date': case 'project_name': cellData = relatedWorkOrder[col.key]; break;
//                     default: cellData = invoice[col.key];
//                 }
//                 const stringValue = JSON.stringify(replacer(col.key, cellData), replacer);
//                 return stringValue.replace(/"/g, '""').replace(/^""|""$/g, '"');
//             }).join(',');
//         });

//         const csv = [header, ...rows].join('\n');
//         const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
//         const link = document.createElement("a");
//         const url = URL.createObjectURL(blob);
//         link.setAttribute("href", url);
//         link.setAttribute("download", `${filename}.csv`);
//         link.style.visibility = 'hidden';
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//     };

//     const handleExportAll = () => convertToCSVAndDownload(statusFilteredInvoices, 'all_invoices_export');
//     const handleExportByFilter = () => convertToCSVAndDownload(finalFilteredInvoices, 'filtered_invoices_export');

//     if (loading) return <div className="loading-error-container"><h2>Loading Invoice Dashboard...</h2></div>;
//     if (error) return <div className="loading-error-container"><h2>Dashboard Error</h2><p>{error}</p></div>;
 
//     const formatCurrency = (value) => new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(value);
//     const pieOptions = { responsive: true, plugins: { legend: { position: 'bottom' }, datalabels: { color: '#fff', font: { weight: 'bold' }, formatter: (value) => (value > 0 ? value : '') } } };
 
//     return (
//         <main className="main-content">
//             <div className="filter-bar">
//                 <div className="filter-item"><label htmlFor="start-date">Start Date:</label><input type="date" id="start-date" value={startDate} onChange={(e) => setStartDate(e.target.value)} /></div>
//                 <div className="filter-item"><label htmlFor="end-date">End Date:</label><input type="date" id="end-date" value={endDate} onChange={(e) => setEndDate(e.target.value)} /></div>
//             </div>
           
//             <div className="kpi-grid">
//                 <div className="kpi-card"><h4>Total Invoices</h4><p>{dashboardData.kpis.totalInvoices}</p></div>
//                 <div className="kpi-card"><h4>Total Taxable Amount</h4><p>{formatCurrency(dashboardData.kpis.totalTaxable)}</p></div>
//                 <div className="kpi-card"><h4>Total GST Collected</h4><p>{formatCurrency(dashboardData.kpis.totalGst)}</p></div>
//                 <div className="kpi-card"><h4>Avg. Credit Period</h4><p>{dashboardData.kpis.avgCreditPeriod} Days</p></div>
//             </div>
           
//             <div className="dashboard-grid">
//                 <div className="chart-card large-card">
//                   <h3>Customer Wise Invoices (Top 10 by Amount)</h3>
//                   {filteredInvoicesByDate.length > 0 && dashboardData.customerData.labels.length > 0 ? (
//                         <Bar data={dashboardData.customerData} options={{ responsive: true, scales: { y: { beginAtZero: true } } }} />
//                     ) : (
//                         <p className="no-data-message">No customer invoice data with positive amounts for selected date range.</p>
//                     )}
//                 </div>
//                 <div className="chart-card">
//                   <h3>Invoices by Status</h3>
//                    {filteredInvoicesByDate.length > 0 ? (
//                         <Pie ref={statusPieChartRef} data={dashboardData.statusPieData} options={pieOptions} onClick={handleStatusPieClick} />
//                     ) : (
//                         <p className="no-data-message">No data available.</p>
//                     )}
//                 </div>
//             </div>

//             <div ref={tableRef} className="invoice-table-section" style={{ marginTop: '2rem' }}>
//                 <div className="table-header with-controls">
//                     <h3>All Invoices {selectedStatusFilter && `(Status: ${selectedStatusFilter})`} {searchTerm && `(Filtered)`}</h3>
//                     <div className="table-actions">
//                         {selectedStatusFilter && (<button onClick={() => setSelectedStatusFilter(null)} className="clear-filters-btn small">Clear Status Filter</button>)}
//                         <input type="text" placeholder="Search invoices..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} className="search-bar" />
//                         <button onClick={handleExportByFilter} className="export-btn">Export by Filter</button>
//                         <button onClick={handleExportAll} className="export-btn">Export All</button>
//                     </div>
//                 </div>
//                 <InvoiceDataTable invoices={finalFilteredInvoices} workOrderMap={workOrderMap} customerMap={customerMap} userMap={userMap} />
//             </div>
//         </main>
//     );
// };
 
 
// // ====================================================================
// // --- Main Dashboard Component ---
// // ====================================================================
// const Dashboard = () => {
//     const [activeTab, setActiveTab] = useState('workOrder');
//     const [workOrderTableReport, setWorkOrderTableReport] = useState({ columns: [], data: [] });
//     const [invoices, setInvoices] = useState([]);
//     const [customers, setCustomers] = useState([]);
//     const [users, setUsers] = useState([]); 
//     const [filters, setFilters] = useState({});
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
 
//     const API_TOKEN = 'Bearer ' + localStorage.getItem('zTaskAuthToken');
 
//     const handleApiResponse = async (response) => {
//         if (!response.ok) {
//             const errorText = await response.text();
//             throw new Error(`API call to ${response.url} failed with status ${response.status}: ${response.statusText}. Response: ${errorText.substring(0, 200)}`);
//         }
//         return response.json();
//     };
 
//     useEffect(() => {
//         const fetchAllData = async () => {
//             setLoading(true);
//             setError(null);
 
//             const REPORT_API_URL = `${process.env.REACT_APP_REPORTS_API_URL}/api/reports/run`;
//             const INVOICE_API_URL = `${process.env.REACT_APP_NODE_SERVICE_BASE_URL}/invoice/api/invoices/`;
//             const CUSTOMER_API_URL = `${process.env.REACT_APP_NODE_SERVICE_BASE_URL}/api/get-column/customers/name`;
//             const USER_API_URL = `${process.env.REACT_APP_NODE_SERVICE_BASE_URL}/api/get-column/users/name`; 
 
//             const HEADERS = { 'accept': 'application/json', 'Authorization': API_TOKEN };
//             const TABLE_REPORT_BODY = { "report_name": "work_order_table", "module_name": "Workorder" };
           
//             try {
//                 const [tableReportJson, invoiceJson, customersJson, usersJson] = await Promise.all([
//                     fetch(REPORT_API_URL, { method: 'POST', headers: { ...HEADERS, 'Content-Type': 'application/json' }, body: JSON.stringify(TABLE_REPORT_BODY) }).then(handleApiResponse),
//                     fetch(INVOICE_API_URL, { headers: HEADERS }).then(handleApiResponse),
//                     fetch(CUSTOMER_API_URL, { headers: HEADERS }).then(handleApiResponse),
//                     fetch(USER_API_URL, { headers: HEADERS }).then(handleApiResponse)
//                 ]);
               
//                 setWorkOrderTableReport(tableReportJson && tableReportJson.columns && tableReportJson.data ? tableReportJson : { columns: [], data: [] });
//                 setInvoices(Array.isArray(invoiceJson) ? invoiceJson : []);
//                 setCustomers(Array.isArray(customersJson) ? customersJson : []);
//                 setUsers(Array.isArray(usersJson) ? usersJson : []);

//             } catch (e) {
//                 console.error("Failed to fetch dashboard data:", e);
//                 setError(e.message);
//             } finally {
//                 setLoading(false);
//             }
//         };
//         fetchAllData();
//     }, []);
 
//     const handleChartClick = (filterType, clickedLabel) => setFilters(prev => ({ ...prev, [filterType]: clickedLabel }));
//     const clearFilters = () => setFilters({});
   
//     const customerMap = useMemo(() => {
//         const map = new Map();
//         customers.forEach(customer => map.set(customer.id, customer.value));
//         return map;
//     }, [customers]);

//     const userMap = useMemo(() => {
//         const map = new Map();
//         users.forEach(user => map.set(user.id, user.value));
//         return map;
//     }, [users]);

//     const uniqueWorkOrders = useMemo(() => {
//         if (!Array.isArray(workOrderTableReport.data)) return [];
//         const uniqueWoMap = new Map();
//         workOrderTableReport.data.forEach(order => {
//             if (order.wo_id && !uniqueWoMap.has(order.wo_id)) {
//                 uniqueWoMap.set(order.wo_id, { ...order, tot_value: parseFloat(order.tot_value) || 0 });
//             }
//         });
//         return Array.from(uniqueWoMap.values());
//     }, [workOrderTableReport.data]);
 
//     const statusPieChartData = useMemo(() => {
//         const statusCounts = uniqueWorkOrders.reduce((acc, order) => {
//             acc[order.wo_open_close || 'Unknown'] = (acc[order.wo_open_close || 'Unknown'] || 0) + 1;
//             return acc;
//         }, { 'Open': 0, 'Closed': 0 });
//         return { labels: Object.keys(statusCounts), datasets: [{ data: Object.values(statusCounts), backgroundColor: ['#ff8a80', '#80d8ff'], borderColor: '#ffffff', borderWidth: 3 }] };
//     }, [uniqueWorkOrders]);
 
//     const sectorBarChartData = useMemo(() => {
//         const sectorData = uniqueWorkOrders.reduce((acc, wo) => {
//             const sectorName = wo.sector_name || 'Unknown Sector';
//             acc[sectorName] = acc[sectorName] || { count: 0, totalValue: 0 };
//             acc[sectorName].count++;
//             acc[sectorName].totalValue += wo.tot_value;
//             return acc;
//         }, {});
//         const labels = Object.keys(sectorData).sort();
//         return { labels, datasets: [
//             { label: 'Number of Orders', data: labels.map(l => sectorData[l].count), backgroundColor: 'rgba(255, 159, 64, 0.8)' },
//             { label: 'Total Value', data: labels.map(l => sectorData[l].totalValue), backgroundColor: 'rgba(75, 192, 192, 0.8)' }
//         ] };
//     }, [uniqueWorkOrders]);
   
//     const topCustomersData = useMemo(() => {
//         const customerAggregates = uniqueWorkOrders.reduce((acc, wo) => {
//             acc[wo.customer_name || 'Unknown Customer'] = (acc[wo.customer_name || 'Unknown Customer'] || 0) + wo.tot_value;
//             return acc;
//         }, {});
//         const sortedCustomers = Object.entries(customerAggregates).sort(([, a], [, b]) => b - a).slice(0, 5);
//         return { labels: sortedCustomers.map(([label]) => label), datasets: [{ label: 'Total Order Value', data: sortedCustomers.map(([, value]) => value), backgroundColor: 'rgba(54, 162, 235, 0.8)' }] };
//     }, [uniqueWorkOrders]);
 
//     const filteredWorkOrders = useMemo(() => {
//         if (Object.keys(filters).length === 0) return workOrderTableReport.data || [];
//         const woIdsToKeep = new Set(uniqueWorkOrders
//             .filter(wo => (!filters.status || wo.wo_open_close === filters.status) && (!filters.sector || wo.sector_name === filters.sector) && (!filters.customer || wo.customer_name === filters.customer))
//             .map(wo => wo.wo_id)
//         );
//         return (workOrderTableReport.data || []).filter(order => woIdsToKeep.has(order.wo_id));
//     }, [workOrderTableReport.data, uniqueWorkOrders, filters]);
 
//     return (
//         <div className="dashboard-container">
//             <div className="tabs-container">
//                 <button className={`tab-button ${activeTab === 'workOrder' ? 'active' : ''}`} onClick={() => setActiveTab('workOrder')}>Work Orders</button>
//                 <button className={`tab-button ${activeTab === 'invoice' ? 'active' : ''}`} onClick={() => setActiveTab('invoice')}>Invoices</button>
//             </div>
//             <div className="tab-content">
//                 {activeTab === 'workOrder' && (
//                     <WorkOrderDashboardContent
//                         loading={loading} error={error} statusPieChartData={statusPieChartData}
//                         sectorBarChartData={sectorBarChartData}
//                         topCustomersData={topCustomersData} filteredWorkOrders={filteredWorkOrders}
//                         filters={filters} onChartClick={handleChartClick} onClearFilters={clearFilters}
//                         apiToken={API_TOKEN}
//                     />
//                 )}
//                 {activeTab === 'invoice' && (
//                     <InvoiceDashboardContent 
//                         invoices={invoices} 
//                         workOrders={workOrderTableReport.data}
//                         loading={loading} 
//                         error={error}
//                         customerMap={customerMap}
//                         userMap={userMap}
//                     />
//                 )}
//             </div>
//         </div>
//     );
// };
 
// export default Dashboard;














// import React, { useState, useEffect, useMemo, useRef } from 'react';
// import { Pie, Bar, getElementAtEvent } from 'react-chartjs-2';
// import {
//     Chart as ChartJS,
//     CategoryScale,
//     LinearScale,
//     BarElement,
//     Title,
//     Tooltip,
//     Legend,
//     ArcElement
// } from 'chart.js';
// import ChartDataLabels from 'chartjs-plugin-datalabels';
// import './Dashboard.css'; // Renamed CSS import
 
// ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement, ChartDataLabels);
 
// // ====================================================================
// // --- Component for Work Order Table ---
// // ====================================================================
// const FilteredWorkOrderTable = ({ workOrders, apiToken }) => {
//     const [activeTab, setActiveTab] = useState('assets');
//     const [assets, setAssets] = useState([]);
//     const [assetsLoading, setAssetsLoading] = useState(false);
//     const [assetsError, setAssetsError] = useState(null);
 
//     useEffect(() => {
//         const fetchAssets = async () => {
//             if (!workOrders || workOrders.length === 0) {
//                 setAssets([]);
//                 return;
//             }
//             const assetIdSet = new Set(workOrders.map(wo => wo.asset_id).filter(id => id != null));
//             const assetIds = Array.from(assetIdSet);
//             if (assetIds.length === 0) {
//                 setAssets([]);
//                 return;
//             }
           
//             setAssetsLoading(true);
//             setAssetsError(null);
           
//             const ASSET_API_URL = `${process.env.REACT_APP_ASSET_SERVICE_BASE_URL}/api/assets/`;
//             const ASSET_HEADERS = { 'accept': 'application/json', 'Authorization': apiToken };
 
//             try {
//                 const assetPromises = assetIds.map(id =>
//                     fetch(`${ASSET_API_URL}${id}`, { headers: ASSET_HEADERS }).then(res => {
//                         if (!res.ok) {
//                             console.error(`Failed to fetch asset ${id}, status: ${res.status}`);
//                             return null;
//                         }
//                         return res.json();
//                     })
//                 );
//                 const fetchedAssetsResults = await Promise.all(assetPromises);
//                 setAssets(fetchedAssetsResults.filter(asset => asset !== null));
//             } catch (error) {
//                 console.error("Failed to fetch assets:", error);
//                 setAssetsError(error.message);
//             } finally {
//                 setAssetsLoading(false);
//             }
//         };
//         fetchAssets();
//     }, [workOrders, apiToken]);
 
//     const displayedWorkOrders = useMemo(() => {
//         if (!workOrders || !Array.isArray(workOrders)) return [];
//         return [...workOrders].sort((a, b) => new Date(b.add_date) - new Date(a.add_date));
//     }, [workOrders]);
 
//     const formatData = (value) => {
//         if (value === null || typeof value === 'undefined') return 'N/A';
//         if (typeof value === 'boolean') return value ? 'Yes' : 'No';
//         if (typeof value === 'string' && value.includes('T')) {
//             const date = new Date(value);
//             if (!isNaN(date)) return date.toLocaleDateString('en-GB');
//         }
//         return value;
//     };
 
//     const displayColumns = [
//         { header: 'Doc No', key: 'doc_no' }, { header: 'WO No', key: 'wo_no' },
//         { header: 'Status', key: 'wo_open_close' }, { header: 'Total Value', key: 'tot_value' },
//         { header: 'Customer Name', key: 'customer_name' }, { header: 'Customer ID', key: 'cust_id' },
//         { header: 'Project Name', key: 'project_name' }, { header: 'Project ID', key: 'project_id' },
//         { header: 'Sector Name', key: 'sector_name' }, { header: 'Sector ID', key: 'sector' },
//         { header: 'Asset ID', key: 'asset_id' }, { header: 'WO Date', key: 'wo_date' },
//         { header: 'WO Start', key: 'wo_start' }, { header: 'WO End', key: 'wo_end' },
//     ];
 
//     return (
//         <div className="filtered-table-container">
//             <div className="table-header"><h3>All Work Orders</h3></div>
//             <div className="table-controls">
//                 <div className="tabs">
//                     <button className={`tab-btn ${activeTab === 'assets' ? 'active' : ''}`} onClick={() => setActiveTab('assets')}>Assets</button>
//                     <button className={`tab-btn ${activeTab === 'workorder' ? 'active' : ''}`} onClick={() => setActiveTab('workorder')}>Workorder</button>
//                 </div>
//             </div>
//             <div className="table-content-wrapper">
//                 {activeTab === 'workorder' ? (
//                     <>
//                         {displayedWorkOrders.length > 0 ? (
//                             <div className="table-scroll-container">
//                                 <table className="data-table wide-table">
//                                     <thead><tr>{displayColumns.map(col => <th key={col.key}>{col.header}</th>)}</tr></thead>
//                                     <tbody>
//                                         {displayedWorkOrders.map((order, index) => (
//                                             <tr key={`${order.id}-${index}`}>
//                                                 {displayColumns.map(col => (
//                                                     <td key={col.key}>{col.key === 'tot_value' ? parseFloat(order[col.key] || 0).toLocaleString('en-US') : formatData(order[col.key])}</td>
//                                                 ))}
//                                             </tr>
//                                         ))}
//                                     </tbody>
//                                 </table>
//                             </div>
//                         ) : (<p className="no-data-message">No work orders found for the current filter.</p>)}
//                     </>
//                 ) : (
//                     <>
//                         {assetsLoading && <p className="loading-message">Loading Assets...</p>}
//                         {assetsError && <p className="error-message">Error: {assetsError}</p>}
//                         {!assetsLoading && !assetsError && (
//                             <>
//                                 {assets.length > 0 ? (
//                                     <div className="table-scroll-container">
//                                         <table className="data-table wide-table">
//                                             <thead>
//                                                 <tr><th>Asset Name</th><th>Asset Type</th><th>Capacity (MT)</th><th>Year of Purchase</th><th>Year of Manufacture</th></tr>
//                                             </thead>
//                                             <tbody>
//                                                 {assets.map(asset => {
//                                                     const combinedAssetName = [asset.name, asset.serial_number, asset.asset_code, asset.registration_number].filter(Boolean).join(' | ');
//                                                     return (
//                                                         <tr key={asset.id}>
//                                                             <td>{combinedAssetName || 'N/A'}</td>
//                                                             <td>{formatData(asset.asset_type)}</td>
//                                                             <td>{formatData(asset.capacity_mt)}</td>
//                                                             <td>{formatData(asset.year_of_purchase)}</td>
//                                                             <td>{formatData(asset.year_of_manufacture)}</td>
//                                                         </tr>
//                                                     );
//                                                 })}
//                                             </tbody>
//                                         </table>
//                                     </div>
//                                 ) : (<p className="no-data-message">No assets found for the current work orders.</p>)}
//                             </>
//                         )}
//                     </>
//                 )}
//             </div>
//         </div>
//     );
// };
 
// // ====================================================================
// // --- Component for Asset Availability Table ---
// // ====================================================================
// const AssetAvailabilityTable = ({ workOrders, apiToken }) => {
//     const [combinedAssets, setCombinedAssets] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);
//     const [filterDays, setFilterDays] = useState(null);
//     const [customDays, setCustomDays] = useState('');
 
//     useEffect(() => {
//         const fetchAndCombineData = async () => {
//             setLoading(true);
//             setError(null);
           
//             const workOrderInfoMap = new Map();
//             if (workOrders && Array.isArray(workOrders)) {
//                 workOrders.forEach(wo => {
//                     if (wo.asset_id != null) {
//                         workOrderInfoMap.set(Number(wo.asset_id), { wo_start: wo.wo_start, wo_end: wo.wo_end, wo_no: wo.wo_no });
//                     }
//                 });
//             }
           
//             const ASSET_API_URL = `${process.env.REACT_APP_ASSET_SERVICE_BASE_URL}/api/assets/`;
//             const ASSET_HEADERS = { 'accept': 'application/json', 'Authorization': apiToken };
 
//             try {
//                 const response = await fetch(ASSET_API_URL, { headers: ASSET_HEADERS });
//                 if (!response.ok) {
//                     throw new Error(`Failed to fetch assets, status: ${response.status}`);
//                 }
//                 const allAssets = await response.json();
//                 const activeAssets = allAssets.filter(asset => asset.active === true);
 
//                 const combinedData = activeAssets.map(asset => {
//                     const workOrderInfo = workOrderInfoMap.get(asset.id) || { wo_start: null, wo_end: null, wo_no: null };
//                     return { ...asset, ...workOrderInfo };
//                 });
               
//                 setCombinedAssets(combinedData);
//             } catch (error) {
//                 console.error("Failed to fetch asset data:", error);
//                 setError(error.message);
//             } finally {
//                 setLoading(false);
//             }
//         };
 
//         fetchAndCombineData();
//     }, [workOrders, apiToken]);
 
//     const filteredAssets = useMemo(() => {
//         if (filterDays === null) return combinedAssets;
//         const targetDate = new Date();
//         targetDate.setDate(targetDate.getDate() + filterDays);
//         targetDate.setHours(23, 59, 59, 999);
//         return combinedAssets.filter(asset => {
//             if (!asset.wo_end) return true;
//             const woEndDate = new Date(asset.wo_end);
//             return isNaN(woEndDate.getTime()) || woEndDate <= targetDate;
//         });
//     }, [combinedAssets, filterDays]);
 
//     const formatData = (value) => {
//         if (value === null || typeof value === 'undefined') return 'N/A';
//         if (typeof value === 'boolean') return value ? 'Yes' : 'No';
//         if (typeof value === 'string' && value.includes('T')) {
//             const date = new Date(value);
//             if (!isNaN(date)) return date.toLocaleDateString('en-GB');
//         }
//         return value;
//     };
 
//     const handleCustomFilter = () => {
//         const days = parseInt(customDays, 10);
//         if (days > 0) setFilterDays(days);
//     };
 
//     const clearFilter = () => {
//         setFilterDays(null);
//         setCustomDays('');
//     };
 
//     return (
//         <div className="filtered-table-container">
//             <div className="table-header with-controls">
//                 <h3>Asset Availability</h3>
//                 <div className="availability-filter-controls">
//                     <span>Available In:</span>
//                     {[3, 7, 15, 30].map(days => (
//                         <button key={days} onClick={() => setFilterDays(days)} className={filterDays === days ? 'active' : ''}>{days} Days</button>
//                     ))}
//                     <div className="custom-filter">
//                         <input type="number" placeholder="Custom" value={customDays} onChange={(e) => setCustomDays(e.target.value)} min="1"/>
//                         <button onClick={handleCustomFilter}>Go</button>
//                     </div>
//                     <button onClick={clearFilter}>Clear Filter</button>
//                 </div>
//             </div>
//             <div className="table-content-wrapper">
//                 {loading && <p className="loading-message">Loading Assets...</p>}
//                 {error && <p className="error-message">Error: {error}</p>}
//                 {!loading && !error && (
//                     <>
//                         {filteredAssets.length > 0 ? (
//                             <div className="table-scroll-container">
//                                 <table className="data-table wide-table">
//                                     <thead>
//                                         <tr><th>ID</th><th>Asset Name</th><th>Asset Type</th><th>Capacity (MT)</th><th>Year of Purchase</th><th>Year of Manufacture</th><th>WO No</th><th>WO Start</th><th>WO End</th></tr>
//                                     </thead>
//                                     <tbody>
//                                         {filteredAssets.map(asset => {
//                                             const combinedAssetName = [asset.name, asset.serial_number, asset.asset_code, asset.registration_number].filter(Boolean).join(' | ');
//                                             return (
//                                                 <tr key={asset.id}>
//                                                     <td>{formatData(asset.id)}</td>
//                                                     <td>{combinedAssetName || 'N/A'}</td>
//                                                     <td>{formatData(asset.asset_type)}</td>
//                                                     <td>{formatData(asset.capacity_mt)}</td>
//                                                     <td>{formatData(asset.year_of_purchase)}</td>
//                                                     <td>{formatData(asset.year_of_manufacture)}</td>
//                                                     <td>{formatData(asset.wo_no)}</td>
//                                                     <td>{formatData(asset.wo_start)}</td>
//                                                     <td>{formatData(asset.wo_end)}</td>
//                                                 </tr>
//                                             );
//                                         })}
//                                     </tbody>
//                                 </table>
//                             </div>
//                         ) : (<p className="no-data-message">{filterDays !== null ? "No assets match the current availability filter." : "No active assets found."}</p>)}
//                     </>
//                 )}
//             </div>
//         </div>
//     );
// };
 
// // ====================================================================
// // --- Component for the Work Orders Tab Content ---
// // ====================================================================
// const WorkOrderDashboardContent = ({
//     loading, error, statusPieChartData, sectorBarChartData,
//     topCustomersData, filteredWorkOrders, filters, onChartClick, onClearFilters, apiToken
// }) => {
//     const statusChartRef = useRef();
//     const sectorChartRef = useRef();
//     const customerChartRef = useRef();
 
//     const handleChartClick = (filterType, chartData, event, chartRef) => {
//         if (!chartRef.current) return;
//         const elements = getElementAtEvent(chartRef.current, event);
//         if (elements.length > 0) {
//             const clickedLabel = chartData.labels[elements[0].index];
//             onChartClick(filterType, clickedLabel);
//         }
//     };
 
//     const hasFilters = Object.keys(filters).length > 0;
   
//     if (loading) return <div className="loading-error-container"><h2>Loading Dashboard...</h2></div>;
//     if (error) return <div className="loading-error-container"><h2>Dashboard Error</h2><p>{error}</p></div>;
 
//     return (
//         <main className="main-content">
//              <div className="dashboard-title-bar">
//                 <h1 className="dashboard-header">Work Orders Dashboard</h1>
//                 {hasFilters && (<button onClick={onClearFilters} className="clear-filters-btn">Clear Filters</button>)}
//             </div>
//             <div className="dashboard-grid">
//                 <div className="chart-card">
//                     <h3>Work Orders by Status</h3>
//                     <Pie ref={statusChartRef} data={statusPieChartData} options={{ responsive: true, plugins: { legend: { position: 'top' }, datalabels: { color: '#343a40', font: { weight: 'bold', size: 16 }, formatter: (value) => (value > 0 ? value : null) } } }} onClick={(event) => handleChartClick('status', statusPieChartData, event, statusChartRef)}/>
//                 </div>
//                 <div className="chart-card">
//                     <h3>Work Orders by Sector</h3>
//                     <Bar ref={sectorChartRef} data={sectorBarChartData} options={{ responsive: true, scales: { y: { beginAtZero: true } } }} onClick={(event) => handleChartClick('sector', sectorBarChartData, event, sectorChartRef)}/>
//                 </div>
//                 <div className="chart-card">
//                     <h3>Top Customers by Order Value</h3>
//                      <Bar ref={customerChartRef} data={topCustomersData} options={{ responsive: true, scales: { y: { beginAtZero: true } } }} onClick={(event) => handleChartClick('customer', topCustomersData, event, customerChartRef)}/>
//                 </div>
//                 <div className="chart-card table-card">
//                     <FilteredWorkOrderTable workOrders={filteredWorkOrders} apiToken={apiToken} />
//                 </div>
//                 <div className="chart-card table-card">
//                      <AssetAvailabilityTable workOrders={filteredWorkOrders} apiToken={apiToken} />
//                 </div>
//             </div>
//         </main>
//     );
// };

// // ====================================================================
// // --- Component for Invoice Data Table ---
// // ====================================================================
// const InvoiceDataTable = ({ invoices, workOrderMap, customerMap, userMap }) => {
//     // Columns definition
//     const columns = useMemo(() => [
//         { header: 'ID', key: 'id' }, { header: 'Doc No', key: 'doc_no' },
//         { header: 'Customer Name', key: 'customer_name' }, { header: 'Customer ID', key: 'cust_id' },
//         { header: 'Work Order ID', key: 'wo_id' }, { header: 'Work Order No', key: 'wo_no' },
//         { header: 'Work Order Date', key: 'wo_date' }, { header: 'Project ID', key: 'project_id' },
//         { header: 'Project Name', key: 'project_name' }, { header: 'Invoice Date', key: 'inv_date' },
//         { header: 'Due Date', key: 'due_date' }, { header: 'Start Date', key: 'start_date' },
//         { header: 'End Date', key: 'end_date' }, { header: 'Taxable Amt', key: 'taxable_amt' },
//         { header: 'CGST', key: 'tot_cgst' }, { header: 'SGST', key: 'tot_sgst' },
//         { header: 'IGST', key: 'tot_igst' }, { header: 'Total Amount', key: 'amount' },
//         { header: 'Approval Status', key: 'inv_approval_status' }, { header: 'Current Status', key: 'current_status' },
//         { header: 'Stage', key: 'stage' }, { header: 'Created By', key: 'added_by' },
//         { header: 'Created Date', key: 'add_date' }, { header: 'Updated By', key: 'updated_by' },
//         { header: 'Updated Date', key: 'update_date' },
//     ], []);

//     // Generic data formatting function
//     const formatData = (value, key) => {
//         if (value === null || typeof value === 'undefined') return 'N/A';
//         const currencyKeys = ['taxable_amt', 'amount', 'tot_cgst', 'tot_sgst', 'tot_igst'];
//         if (currencyKeys.includes(key)) {
//             const numberValue = parseFloat(value);
//             return isNaN(numberValue) ? 'N/A' : numberValue.toLocaleString('en-IN', { style: 'currency', currency: 'INR' });
//         }
//         if (typeof value === 'string' && (key.includes('date') || key.includes('Date'))) {
//             const date = new Date(value);
//             return !isNaN(date) ? date.toLocaleDateString('en-GB') : value;
//         }
//         return value;
//     };
    
//     // Sort invoices once by date
//     const sortedInvoices = useMemo(() => {
//         if (!Array.isArray(invoices)) return [];
//         return [...invoices].sort((a, b) => new Date(b.inv_date || b.add_date) - new Date(a.inv_date || a.add_date));
//     }, [invoices]);

//     if (sortedInvoices.length === 0) {
//         return (
//             <div className="filtered-table-container">
//                  <p className="no-data-message" style={{ padding: '20px' }}>No invoice data matching the current filter.</p>
//             </div>
//         )
//     }

//     return (
//         <div className="filtered-table-container">
//             <div className="table-content-wrapper">
//                 <div className="table-scroll-container">
//                     <table className="data-table wide-table">
//                         <thead>
//                             <tr>{columns.map(col => <th key={col.key}>{col.header}</th>)}</tr>
//                         </thead>
//                         <tbody>
//                             {sortedInvoices.map((invoice) => {
//                                 const relatedWorkOrder = workOrderMap.get(invoice.wo_id) || {};
//                                 return (
//                                     <tr key={invoice.id}>
//                                         {columns.map(col => {
//                                             let cellValue;
//                                             switch(col.key) {
//                                                 case 'customer_name':
//                                                     cellValue = customerMap.get(invoice.cust_id) || 'N/A';
//                                                     break;
//                                                 case 'added_by':
//                                                     cellValue = userMap.get(String(invoice.added_by)) || invoice.added_by || 'N/A';
//                                                     break;
//                                                 case 'updated_by':
//                                                     cellValue = userMap.get(String(invoice.updated_by)) || invoice.updated_by || 'N/A';
//                                                     break;
//                                                 case 'project_id': case 'project_name': case 'wo_no': case 'wo_date':
//                                                     cellValue = formatData(relatedWorkOrder[col.key], col.key);
//                                                     break;
//                                                 default:
//                                                     cellValue = formatData(invoice[col.key], col.key);
//                                             }
//                                             return <td key={col.key}>{cellValue}</td>;
//                                         })}
//                                     </tr>
//                                 );
//                             })}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         </div>
//     );
// };
 
// // ====================================================================
// // --- Component for the Invoices Tab (UPDATED with new filters) ---
// // ====================================================================
// const InvoiceDashboardContent = ({ invoices, workOrders, loading, error, customerMap, userMap }) => {
//     const today = new Date();
//     const thirtyDaysAgo = new Date(new Date().setDate(today.getDate() - 30));
//     const formatDateForInput = (date) => date.toISOString().split('T')[0];
   
//     const [startDate, setStartDate] = useState(formatDateForInput(thirtyDaysAgo));
//     const [endDate, setEndDate] = useState(formatDateForInput(today));
//     const [selectedStatusFilter, setSelectedStatusFilter] = useState(null);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [dateFilterType, setDateFilterType] = useState('invoiceDate'); // 'invoiceDate' or 'invoicePeriod'
//     const tableRef = useRef(null);
//     const statusPieChartRef = useRef(null);

//     // Memoize the work order map for efficiency
//     const workOrderMap = useMemo(() => {
//         const map = new Map();
//         if (Array.isArray(workOrders)) {
//             workOrders.forEach(wo => {
//                 if (wo.wo_id && !map.has(wo.wo_id)) {
//                     map.set(wo.wo_id, wo);
//                 }
//             });
//         }
//         return map;
//     }, [workOrders]);
    
//     // 1. Filter invoices based on the selected date range and filter type
//     const dateFilteredInvoices = useMemo(() => {
//         if (!Array.isArray(invoices) || !startDate || !endDate) return [];
        
//         const rangeStart = new Date(startDate);
//         rangeStart.setHours(0, 0, 0, 0); // Set to start of the day for accurate comparison
//         const rangeEnd = new Date(endDate);
//         rangeEnd.setHours(23, 59, 59, 999); // Set to end of the day

//         return invoices.filter(inv => {
//             if (dateFilterType === 'invoiceDate') {
//                 const invoiceDate = new Date(inv.inv_date || inv.add_date);
//                 return !isNaN(invoiceDate) && invoiceDate >= rangeStart && invoiceDate <= rangeEnd;
//             } else { // 'invoicePeriod'
//                 if (!inv.start_date || !inv.end_date) return false;
                
//                 const periodStart = new Date(inv.start_date);
//                 const periodEnd = new Date(inv.end_date);
                
//                 if (isNaN(periodStart.getTime()) || isNaN(periodEnd.getTime())) return false;
                
//                 // Check if the invoice's period is completely within the user-selected range
//                 return periodStart >= rangeStart && periodEnd <= rangeEnd;
//             }
//         });
//     }, [invoices, startDate, endDate, dateFilterType]); // Dependency array includes the new filter type state
 
//     // This data is used for the charts and KPIs, based on the date-filtered data
//     const dashboardData = useMemo(() => {
//         const EMPTY_CHART_DATA = { labels: [], datasets: [{ data: [] }] };
//         const baseKpis = { totalInvoices: 0, totalTaxable: 0, totalGst: 0, avgCreditPeriod: 0 };

//         if (dateFilteredInvoices.length === 0) {
//             return { kpis: baseKpis, customerData: EMPTY_CHART_DATA, statusPieData: EMPTY_CHART_DATA };
//         }
 
//         const statusCountsForPie = dateFilteredInvoices.reduce((acc, inv) => {
//             const status = inv.current_status || 'Unknown';
//             acc[status] = (acc[status] || 0) + 1;
//             return acc;
//         }, {});
//         const statusPieData = {
//             labels: Object.keys(statusCountsForPie),
//             datasets: [{ data: Object.values(statusCountsForPie), backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#F7464A'], borderColor: '#fff', borderWidth: 2 }]
//         };
        
//         const customerAggregates = dateFilteredInvoices.reduce((acc, inv) => {
//             const customerName = customerMap.get(inv.cust_id) || `Customer ID: ${inv.cust_id}`;
//             acc[customerName] = (acc[customerName] || 0) + (Number(inv.amount) || 0);
//             return acc;
//         }, {});
        
//         const sortedCustomers = Object.entries(customerAggregates)
//             .filter(([, amount]) => amount > 0)
//             .sort(([,a], [,b]) => b - a)
//             .slice(0, 10);
//         const customerData = { 
//             labels: sortedCustomers.map(([name]) => name), 
//             datasets: [{ label: 'Total Invoice Amount', data: sortedCustomers.map(([, amount]) => amount), backgroundColor: 'rgba(153, 102, 255, 0.6)' }] 
//         };
       
//         return {
//             kpis: {
//                 totalInvoices: dateFilteredInvoices.length,
//                 totalTaxable: dateFilteredInvoices.reduce((sum, inv) => sum + (Number(inv.taxable_amt) || 0), 0),
//                 totalGst: dateFilteredInvoices.reduce((sum, inv) => sum + (Number(inv.tot_cgst) || 0) + (Number(inv.tot_sgst) || 0) + (Number(inv.tot_igst) || 0), 0),
//                 avgCreditPeriod: (dateFilteredInvoices.map(inv => Number(inv.cr_period)).filter(p => p > 0).reduce((a, b, _, arr) => a + b / arr.length, 0)).toFixed(2) || 0
//             },
//             customerData, statusPieData
//         };
//     }, [dateFilteredInvoices, customerMap]);
    
//     // 2. Further filter by status from pie chart click
//     const statusFilteredInvoices = useMemo(() => {
//         if (!selectedStatusFilter) return dateFilteredInvoices;
//         return dateFilteredInvoices.filter(invoice => invoice.current_status === selectedStatusFilter);
//     }, [dateFilteredInvoices, selectedStatusFilter]);

//     // 3. Final filter by search term on top of date and status filters
//     const finalFilteredInvoices = useMemo(() => {
//         if (!searchTerm.trim()) return statusFilteredInvoices;
//         const lowercasedFilter = searchTerm.toLowerCase();
//         return statusFilteredInvoices.filter(invoice => {
//             const workOrder = workOrderMap.get(invoice.wo_id) || {};
//             const searchableFields = [
//                 invoice.id, invoice.doc_no, invoice.cust_id, customerMap.get(invoice.cust_id),
//                 invoice.wo_id, workOrder.wo_no, workOrder.project_id, workOrder.project_name,
//                 invoice.inv_approval_status, invoice.current_status, invoice.stage,
//                 userMap.get(String(invoice.added_by)), userMap.get(String(invoice.updated_by))
//             ];
//             return searchableFields.some(field => field && String(field).toLowerCase().includes(lowercasedFilter));
//         });
//     }, [statusFilteredInvoices, searchTerm, workOrderMap, customerMap, userMap]);

//     const handleStatusPieClick = (event) => {
//         if (!statusPieChartRef.current) return;
//         const elements = getElementAtEvent(statusPieChartRef.current, event);
//         if (elements.length > 0) {
//             const clickedStatus = dashboardData.statusPieData.labels[elements[0].index];
//             setSelectedStatusFilter(prev => prev === clickedStatus ? null : clickedStatus);
//             setTimeout(() => tableRef.current?.scrollIntoView({ behavior: 'smooth' }), 100);
//         } else {
//             setSelectedStatusFilter(null);
//         }
//     };
    
//     // --- CSV Export Logic ---
//     const convertToCSVAndDownload = (dataToExport, filename) => {
//         if (dataToExport.length === 0) {
//             alert("No data available to export.");
//             return;
//         }

//         const columns = [
//             { header: 'ID', key: 'id' }, { header: 'Doc No', key: 'doc_no' }, { header: 'Customer Name', key: 'customer_name' },
//             { header: 'Customer ID', key: 'cust_id' }, { header: 'Work Order ID', key: 'wo_id' }, { header: 'Work Order No', key: 'wo_no' },
//             { header: 'Work Order Date', key: 'wo_date' }, { header: 'Project Name', key: 'project_name' }, { header: 'Invoice Date', key: 'inv_date' },
//             { header: 'Due Date', key: 'due_date' }, { header: 'Total Amount', key: 'amount' }, { header: 'Current Status', key: 'current_status' },
//             { header: 'Created By', key: 'added_by' }, { header: 'Created Date', key: 'add_date' }, { header: 'Updated By', key: 'updated_by' },
//             { header: 'Updated Date', key: 'update_date' },
//         ];

//         const replacer = (key, value) => value === null ? '' : value;
//         const header = columns.map(c => c.header).join(',');
//         const rows = dataToExport.map(invoice => {
//             const relatedWorkOrder = workOrderMap.get(invoice.wo_id) || {};
//             return columns.map(col => {
//                 let cellData;
//                 switch (col.key) {
//                     case 'customer_name': cellData = customerMap.get(invoice.cust_id) || 'N/A'; break;
//                     case 'added_by': cellData = userMap.get(String(invoice.added_by)) || invoice.added_by || 'N/A'; break;
//                     case 'updated_by': cellData = userMap.get(String(invoice.updated_by)) || invoice.updated_by || 'N/A'; break;
//                     case 'wo_no': case 'wo_date': case 'project_name': cellData = relatedWorkOrder[col.key]; break;
//                     default: cellData = invoice[col.key];
//                 }
//                 const stringValue = JSON.stringify(replacer(col.key, cellData), replacer);
//                 return stringValue.replace(/"/g, '""').replace(/^""|""$/g, '"');
//             }).join(',');
//         });

//         const csv = [header, ...rows].join('\n');
//         const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
//         const link = document.createElement("a");
//         const url = URL.createObjectURL(blob);
//         link.setAttribute("href", url);
//         link.setAttribute("download", `${filename}.csv`);
//         link.style.visibility = 'hidden';
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//     };

//     const handleExportAll = () => convertToCSVAndDownload(statusFilteredInvoices, 'all_invoices_export');
//     const handleExportByFilter = () => convertToCSVAndDownload(finalFilteredInvoices, 'filtered_invoices_export');

//     if (loading) return <div className="loading-error-container"><h2>Loading Invoice Dashboard...</h2></div>;
//     if (error) return <div className="loading-error-container"><h2>Dashboard Error</h2><p>{error}</p></div>;
 
//     const formatCurrency = (value) => new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(value);
//     const pieOptions = { responsive: true, plugins: { legend: { position: 'bottom' }, datalabels: { color: '#fff', font: { weight: 'bold' }, formatter: (value) => (value > 0 ? value : '') } } };
 
//     return (
//         <main className="main-content">
//             <div className="filter-bar">
//                 <div className="filter-group">
//                     <div className="filter-item">
//                         <input type="radio" id="invoiceDate" name="dateFilterType" value="invoiceDate" checked={dateFilterType === 'invoiceDate'} onChange={(e) => setDateFilterType(e.target.value)} />
//                         <label htmlFor="invoiceDate">Invoice Date</label>
//                     </div>
//                     <div className="filter-item">
//                         <input type="radio" id="invoicePeriod" name="dateFilterType" value="invoicePeriod" checked={dateFilterType === 'invoicePeriod'} onChange={(e) => setDateFilterType(e.target.value)} />
//                         <label htmlFor="invoicePeriod">Invoice Period</label>
//                     </div>
//                 </div>
//                 <div className="filter-item"><label htmlFor="start-date">Start Date:</label><input type="date" id="start-date" value={startDate} onChange={(e) => setStartDate(e.target.value)} /></div>
//                 <div className="filter-item"><label htmlFor="end-date">End Date:</label><input type="date" id="end-date" value={endDate} onChange={(e) => setEndDate(e.target.value)} /></div>
//             </div>
           
//             <div className="kpi-grid">
//                 <div className="kpi-card"><h4>Total Invoices</h4><p>{dashboardData.kpis.totalInvoices}</p></div>
//                 <div className="kpi-card"><h4>Total Taxable Amount</h4><p>{formatCurrency(dashboardData.kpis.totalTaxable)}</p></div>
//                 <div className="kpi-card"><h4>Total GST Collected</h4><p>{formatCurrency(dashboardData.kpis.totalGst)}</p></div>
//                 <div className="kpi-card"><h4>Avg. Credit Period</h4><p>{dashboardData.kpis.avgCreditPeriod} Days</p></div>
//             </div>
           
//             <div className="dashboard-grid">
//                 <div className="chart-card large-card">
//                   <h3>Customer Wise Invoices (Top 10 by Amount)</h3>
//                     {dateFilteredInvoices.length > 0 && dashboardData.customerData.labels.length > 0 ? (
//                         <Bar data={dashboardData.customerData} options={{ responsive: true, scales: { y: { beginAtZero: true } } }} />
//                     ) : (
//                         <p className="no-data-message">No customer invoice data with positive amounts for selected date range.</p>
//                     )}
//                 </div>
//                 <div className="chart-card">
//                   <h3>Invoices by Status</h3>
//                    {dateFilteredInvoices.length > 0 ? (
//                         <Pie ref={statusPieChartRef} data={dashboardData.statusPieData} options={pieOptions} onClick={handleStatusPieClick} />
//                     ) : (
//                         <p className="no-data-message">No data available.</p>
//                     )}
//                 </div>
//             </div>

//             <div ref={tableRef} className="invoice-table-section" style={{ marginTop: '2rem' }}>
//                 <div className="table-header with-controls">
//                     <h3>All Invoices {selectedStatusFilter && `(Status: ${selectedStatusFilter})`} {searchTerm && `(Filtered)`}</h3>
//                     <div className="table-actions">
//                         {selectedStatusFilter && (<button onClick={() => setSelectedStatusFilter(null)} className="clear-filters-btn small">Clear Status Filter</button>)}
//                         <input type="text" placeholder="Search invoices..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} className="search-bar" />
//                         <button onClick={handleExportByFilter} className="export-btn">Export by Filter</button>
//                         <button onClick={handleExportAll} className="export-btn">Export All</button>
//                     </div>
//                 </div>
//                 <InvoiceDataTable invoices={finalFilteredInvoices} workOrderMap={workOrderMap} customerMap={customerMap} userMap={userMap} />
//             </div>
//         </main>
//     );
// };
 
// // ====================================================================
// // --- Main Dashboard Component ---
// // ====================================================================
// const Dashboard = () => {
//     const [activeTab, setActiveTab] = useState('workOrder');
//     const [workOrderTableReport, setWorkOrderTableReport] = useState({ columns: [], data: [] });
//     const [invoices, setInvoices] = useState([]);
//     const [customers, setCustomers] = useState([]);
//     const [users, setUsers] = useState([]); 
//     const [filters, setFilters] = useState({});
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
 
//     const API_TOKEN = 'Bearer ' + localStorage.getItem('zTaskAuthToken');
 
//     const handleApiResponse = async (response) => {
//         if (!response.ok) {
//             const errorText = await response.text();
//             throw new Error(`API call to ${response.url} failed with status ${response.status}: ${response.statusText}. Response: ${errorText.substring(0, 200)}`);
//         }
//         return response.json();
//     };
 
//     useEffect(() => {
//         const fetchAllData = async () => {
//             setLoading(true);
//             setError(null);
 
//             const REPORT_API_URL = `${process.env.REACT_APP_REPORTS_API_URL}/api/reports/run`;
//             const INVOICE_API_URL = `${process.env.REACT_APP_NODE_SERVICE_BASE_URL}/invoice/api/invoices/`;
//             const CUSTOMER_API_URL = `${process.env.REACT_APP_NODE_SERVICE_BASE_URL}/api/get-column/customers/name`;
//             const USER_API_URL = `${process.env.REACT_APP_NODE_SERVICE_BASE_URL}/api/get-column/users/name`; 
 
//             const HEADERS = { 'accept': 'application/json', 'Authorization': API_TOKEN };
//             const TABLE_REPORT_BODY = { "report_name": "work_order_table", "module_name": "Workorder" };
           
//             try {
//                 const [tableReportJson, invoiceJson, customersJson, usersJson] = await Promise.all([
//                     fetch(REPORT_API_URL, { method: 'POST', headers: { ...HEADERS, 'Content-Type': 'application/json' }, body: JSON.stringify(TABLE_REPORT_BODY) }).then(handleApiResponse),
//                     fetch(INVOICE_API_URL, { headers: HEADERS }).then(handleApiResponse),
//                     fetch(CUSTOMER_API_URL, { headers: HEADERS }).then(handleApiResponse),
//                     fetch(USER_API_URL, { headers: HEADERS }).then(handleApiResponse)
//                 ]);
               
//                 setWorkOrderTableReport(tableReportJson && tableReportJson.columns && tableReportJson.data ? tableReportJson : { columns: [], data: [] });
//                 setInvoices(Array.isArray(invoiceJson) ? invoiceJson : []);
//                 setCustomers(Array.isArray(customersJson) ? customersJson : []);
//                 setUsers(Array.isArray(usersJson) ? usersJson : []);

//             } catch (e) {
//                 console.error("Failed to fetch dashboard data:", e);
//                 setError(e.message);
//             } finally {
//                 setLoading(false);
//             }
//         };
//         fetchAllData();
//     }, []);
 
//     const handleChartClick = (filterType, clickedLabel) => setFilters(prev => ({ ...prev, [filterType]: clickedLabel }));
//     const clearFilters = () => setFilters({});
   
//     const customerMap = useMemo(() => {
//         const map = new Map();
//         customers.forEach(customer => map.set(customer.id, customer.value));
//         return map;
//     }, [customers]);

//     const userMap = useMemo(() => {
//         const map = new Map();
//         users.forEach(user => map.set(user.id, user.value));
//         return map;
//     }, [users]);

//     const uniqueWorkOrders = useMemo(() => {
//         if (!Array.isArray(workOrderTableReport.data)) return [];
//         const uniqueWoMap = new Map();
//         workOrderTableReport.data.forEach(order => {
//             if (order.wo_id && !uniqueWoMap.has(order.wo_id)) {
//                 uniqueWoMap.set(order.wo_id, { ...order, tot_value: parseFloat(order.tot_value) || 0 });
//             }
//         });
//         return Array.from(uniqueWoMap.values());
//     }, [workOrderTableReport.data]);
 
//     const statusPieChartData = useMemo(() => {
//         const statusCounts = uniqueWorkOrders.reduce((acc, order) => {
//             acc[order.wo_open_close || 'Unknown'] = (acc[order.wo_open_close || 'Unknown'] || 0) + 1;
//             return acc;
//         }, { 'Open': 0, 'Closed': 0 });
//         return { labels: Object.keys(statusCounts), datasets: [{ data: Object.values(statusCounts), backgroundColor: ['#ff8a80', '#80d8ff'], borderColor: '#ffffff', borderWidth: 3 }] };
//     }, [uniqueWorkOrders]);
 
//     const sectorBarChartData = useMemo(() => {
//         const sectorData = uniqueWorkOrders.reduce((acc, wo) => {
//             const sectorName = wo.sector_name || 'Unknown Sector';
//             acc[sectorName] = acc[sectorName] || { count: 0, totalValue: 0 };
//             acc[sectorName].count++;
//             acc[sectorName].totalValue += wo.tot_value;
//             return acc;
//         }, {});
//         const labels = Object.keys(sectorData).sort();
//         return { labels, datasets: [
//             { label: 'Number of Orders', data: labels.map(l => sectorData[l].count), backgroundColor: 'rgba(255, 159, 64, 0.8)' },
//             { label: 'Total Value', data: labels.map(l => sectorData[l].totalValue), backgroundColor: 'rgba(75, 192, 192, 0.8)' }
//         ] };
//     }, [uniqueWorkOrders]);
   
//     const topCustomersData = useMemo(() => {
//         const customerAggregates = uniqueWorkOrders.reduce((acc, wo) => {
//             acc[wo.customer_name || 'Unknown Customer'] = (acc[wo.customer_name || 'Unknown Customer'] || 0) + wo.tot_value;
//             return acc;
//         }, {});
//         const sortedCustomers = Object.entries(customerAggregates).sort(([, a], [, b]) => b - a).slice(0, 5);
//         return { labels: sortedCustomers.map(([label]) => label), datasets: [{ label: 'Total Order Value', data: sortedCustomers.map(([, value]) => value), backgroundColor: 'rgba(54, 162, 235, 0.8)' }] };
//     }, [uniqueWorkOrders]);
 
//     const filteredWorkOrders = useMemo(() => {
//         if (Object.keys(filters).length === 0) return workOrderTableReport.data || [];
//         const woIdsToKeep = new Set(uniqueWorkOrders
//             .filter(wo => (!filters.status || wo.wo_open_close === filters.status) && (!filters.sector || wo.sector_name === filters.sector) && (!filters.customer || wo.customer_name === filters.customer))
//             .map(wo => wo.wo_id)
//         );
//         return (workOrderTableReport.data || []).filter(order => woIdsToKeep.has(order.wo_id));
//     }, [workOrderTableReport.data, uniqueWorkOrders, filters]);
 
//     return (
//         <div className="dashboard-container">
//             <div className="tabs-container">
//                 <button className={`tab-button ${activeTab === 'workOrder' ? 'active' : ''}`} onClick={() => setActiveTab('workOrder')}>Work Orders</button>
//                 <button className={`tab-button ${activeTab === 'invoice' ? 'active' : ''}`} onClick={() => setActiveTab('invoice')}>Invoices</button>
//             </div>
//             <div className="tab-content">
//                 {activeTab === 'workOrder' && (
//                     <WorkOrderDashboardContent
//                         loading={loading} error={error} statusPieChartData={statusPieChartData}
//                         sectorBarChartData={sectorBarChartData}
//                         topCustomersData={topCustomersData} filteredWorkOrders={filteredWorkOrders}
//                         filters={filters} onChartClick={handleChartClick} onClearFilters={clearFilters}
//                         apiToken={API_TOKEN}
//                     />
//                 )}
//                 {activeTab === 'invoice' && (
//                     <InvoiceDashboardContent 
//                         invoices={invoices} 
//                         workOrders={workOrderTableReport.data}
//                         loading={loading} 
//                         error={error}
//                         customerMap={customerMap}
//                         userMap={userMap}
//                     />
//                 )}
//             </div>
//         </div>
//     );
// };
 
// export default Dashboard;











// import React, { useState, useEffect, useMemo, useRef } from 'react';
// import { Pie, Bar, getElementAtEvent } from 'react-chartjs-2';
// import {
//     Chart as ChartJS,
//     CategoryScale,
//     LinearScale,
//     BarElement,
//     Title,
//     Tooltip,
//     Legend,
//     ArcElement
// } from 'chart.js';
// import ChartDataLabels from 'chartjs-plugin-datalabels';
// import './Dashboard.css'; // Renamed CSS import
 
// ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement, ChartDataLabels);
 
// // ====================================================================
// // --- Component for Work Order Table ---
// // ====================================================================
// const FilteredWorkOrderTable = ({ workOrders, apiToken }) => {
//     const [activeTab, setActiveTab] = useState('assets');
//     const [assets, setAssets] = useState([]);
//     const [assetsLoading, setAssetsLoading] = useState(false);
//     const [assetsError, setAssetsError] = useState(null);
 
//     useEffect(() => {
//         const fetchAssets = async () => {
//             if (!workOrders || workOrders.length === 0) {
//                 setAssets([]);
//                 return;
//             }
//             const assetIdSet = new Set(workOrders.map(wo => wo.asset_id).filter(id => id != null));
//             const assetIds = Array.from(assetIdSet);
//             if (assetIds.length === 0) {
//                 setAssets([]);
//                 return;
//             }
           
//             setAssetsLoading(true);
//             setAssetsError(null);
           
//             const ASSET_API_URL = `${process.env.REACT_APP_ASSET_SERVICE_BASE_URL}/api/assets/`;
//             const ASSET_HEADERS = { 'accept': 'application/json', 'Authorization': apiToken };
 
//             try {
//                 const assetPromises = assetIds.map(id =>
//                     fetch(`${ASSET_API_URL}${id}`, { headers: ASSET_HEADERS }).then(res => {
//                         if (!res.ok) {
//                             console.error(`Failed to fetch asset ${id}, status: ${res.status}`);
//                             return null;
//                         }
//                         return res.json();
//                     })
//                 );
//                 const fetchedAssetsResults = await Promise.all(assetPromises);
//                 setAssets(fetchedAssetsResults.filter(asset => asset !== null));
//             } catch (error) {
//                 console.error("Failed to fetch assets:", error);
//                 setAssetsError(error.message);
//             } finally {
//                 setAssetsLoading(false);
//             }
//         };
//         fetchAssets();
//     }, [workOrders, apiToken]);
 
//     const displayedWorkOrders = useMemo(() => {
//         if (!workOrders || !Array.isArray(workOrders)) return [];
//         return [...workOrders].sort((a, b) => new Date(b.add_date) - new Date(a.add_date));
//     }, [workOrders]);
 
//     const formatData = (value) => {
//         if (value === null || typeof value === 'undefined') return 'N/A';
//         if (typeof value === 'boolean') return value ? 'Yes' : 'No';
//         if (typeof value === 'string' && value.includes('T')) {
//             const date = new Date(value);
//             if (!isNaN(date)) return date.toLocaleDateString('en-GB');
//         }
//         return value;
//     };
 
//     const displayColumns = [
//         { header: 'Doc No', key: 'doc_no' }, { header: 'WO No', key: 'wo_no' },
//         { header: 'Status', key: 'wo_open_close' }, { header: 'Total Value', key: 'tot_value' },
//         { header: 'Customer Name', key: 'customer_name' }, { header: 'Customer ID', key: 'cust_id' },
//         { header: 'Project Name', key: 'project_name' }, { header: 'Project ID', key: 'project_id' },
//         { header: 'Sector Name', key: 'sector_name' }, { header: 'Sector ID', key: 'sector' },
//         { header: 'Asset ID', key: 'asset_id' }, { header: 'WO Date', key: 'wo_date' },
//         { header: 'WO Start', key: 'wo_start' }, { header: 'WO End', key: 'wo_end' },
//     ];
 
//     return (
//         <div className="filtered-table-container">
//             <div className="table-header"><h3>All Work Orders</h3></div>
//             <div className="table-controls">
//                 <div className="tabs">
//                     <button className={`tab-btn ${activeTab === 'assets' ? 'active' : ''}`} onClick={() => setActiveTab('assets')}>Assets</button>
//                     <button className={`tab-btn ${activeTab === 'workorder' ? 'active' : ''}`} onClick={() => setActiveTab('workorder')}>Workorder</button>
//                 </div>
//             </div>
//             <div className="table-content-wrapper">
//                 {activeTab === 'workorder' ? (
//                     <>
//                         {displayedWorkOrders.length > 0 ? (
//                             <div className="table-scroll-container">
//                                 <table className="data-table wide-table">
//                                     <thead><tr>{displayColumns.map(col => <th key={col.key}>{col.header}</th>)}</tr></thead>
//                                     <tbody>
//                                         {displayedWorkOrders.map((order, index) => (
//                                             <tr key={`${order.id}-${index}`}>
//                                                 {displayColumns.map(col => (
//                                                     <td key={col.key}>{col.key === 'tot_value' ? parseFloat(order[col.key] || 0).toLocaleString('en-US') : formatData(order[col.key])}</td>
//                                                 ))}
//                                             </tr>
//                                         ))}
//                                     </tbody>
//                                 </table>
//                             </div>
//                         ) : (<p className="no-data-message">No work orders found for the current filter.</p>)}
//                     </>
//                 ) : (
//                     <>
//                         {assetsLoading && <p className="loading-message">Loading Assets...</p>}
//                         {assetsError && <p className="error-message">Error: {assetsError}</p>}
//                         {!assetsLoading && !assetsError && (
//                             <>
//                                 {assets.length > 0 ? (
//                                     <div className="table-scroll-container">
//                                         <table className="data-table wide-table">
//                                             <thead>
//                                                 <tr><th>Asset Name</th><th>Asset Type</th><th>Capacity (MT)</th><th>Year of Purchase</th><th>Year of Manufacture</th></tr>
//                                             </thead>
//                                             <tbody>
//                                                 {assets.map(asset => {
//                                                     const combinedAssetName = [asset.name, asset.serial_number, asset.asset_code, asset.registration_number].filter(Boolean).join(' | ');
//                                                     return (
//                                                         <tr key={asset.id}>
//                                                             <td>{combinedAssetName || 'N/A'}</td>
//                                                             <td>{formatData(asset.asset_type)}</td>
//                                                             <td>{formatData(asset.capacity_mt)}</td>
//                                                             <td>{formatData(asset.year_of_purchase)}</td>
//                                                             <td>{formatData(asset.year_of_manufacture)}</td>
//                                                         </tr>
//                                                     );
//                                                 })}
//                                             </tbody>
//                                         </table>
//                                     </div>
//                                 ) : (<p className="no-data-message">No assets found for the current work orders.</p>)}
//                             </>
//                         )}
//                     </>
//                 )}
//             </div>
//         </div>
//     );
// };
 
// // ====================================================================
// // --- Component for Asset Availability Table ---
// // ====================================================================
// const AssetAvailabilityTable = ({ workOrders, apiToken }) => {
//     const [combinedAssets, setCombinedAssets] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);
//     const [filterDays, setFilterDays] = useState(null);
//     const [customDays, setCustomDays] = useState('');
 
//     useEffect(() => {
//         const fetchAndCombineData = async () => {
//             setLoading(true);
//             setError(null);
           
//             const workOrderInfoMap = new Map();
//             if (workOrders && Array.isArray(workOrders)) {
//                 workOrders.forEach(wo => {
//                     if (wo.asset_id != null) {
//                         workOrderInfoMap.set(Number(wo.asset_id), { wo_start: wo.wo_start, wo_end: wo.wo_end, wo_no: wo.wo_no });
//                     }
//                 });
//             }
           
//             const ASSET_API_URL = `${process.env.REACT_APP_ASSET_SERVICE_BASE_URL}/api/assets/`;
//             const ASSET_HEADERS = { 'accept': 'application/json', 'Authorization': apiToken };
 
//             try {
//                 const response = await fetch(ASSET_API_URL, { headers: ASSET_HEADERS });
//                 if (!response.ok) {
//                     throw new Error(`Failed to fetch assets, status: ${response.status}`);
//                 }
//                 const allAssets = await response.json();
//                 const activeAssets = allAssets.filter(asset => asset.active === true);
 
//                 const combinedData = activeAssets.map(asset => {
//                     const workOrderInfo = workOrderInfoMap.get(asset.id) || { wo_start: null, wo_end: null, wo_no: null };
//                     return { ...asset, ...workOrderInfo };
//                 });
               
//                 setCombinedAssets(combinedData);
//             } catch (error) {
//                 console.error("Failed to fetch asset data:", error);
//                 setError(error.message);
//             } finally {
//                 setLoading(false);
//             }
//         };
 
//         fetchAndCombineData();
//     }, [workOrders, apiToken]);
 
//     const filteredAssets = useMemo(() => {
//         if (filterDays === null) return combinedAssets;
//         const targetDate = new Date();
//         targetDate.setDate(targetDate.getDate() + filterDays);
//         targetDate.setHours(23, 59, 59, 999);
//         return combinedAssets.filter(asset => {
//             if (!asset.wo_end) return true;
//             const woEndDate = new Date(asset.wo_end);
//             return isNaN(woEndDate.getTime()) || woEndDate <= targetDate;
//         });
//     }, [combinedAssets, filterDays]);
 
//     const formatData = (value) => {
//         if (value === null || typeof value === 'undefined') return 'N/A';
//         if (typeof value === 'boolean') return value ? 'Yes' : 'No';
//         if (typeof value === 'string' && value.includes('T')) {
//             const date = new Date(value);
//             if (!isNaN(date)) return date.toLocaleDateString('en-GB');
//         }
//         return value;
//     };
 
//     const handleCustomFilter = () => {
//         const days = parseInt(customDays, 10);
//         if (days > 0) setFilterDays(days);
//     };
 
//     const clearFilter = () => {
//         setFilterDays(null);
//         setCustomDays('');
//     };
 
//     return (
//         <div className="filtered-table-container">
//             <div className="table-header with-controls">
//                 <h3>Asset Availability</h3>
//                 <div className="availability-filter-controls">
//                     <span>Available In:</span>
//                     {[3, 7, 15, 30].map(days => (
//                         <button key={days} onClick={() => setFilterDays(days)} className={filterDays === days ? 'active' : ''}>{days} Days</button>
//                     ))}
//                     <div className="custom-filter">
//                         <input type="number" placeholder="Custom" value={customDays} onChange={(e) => setCustomDays(e.target.value)} min="1"/>
//                         <button onClick={handleCustomFilter}>Go</button>
//                     </div>
//                     <button onClick={clearFilter}>Clear Filter</button>
//                 </div>
//             </div>
//             <div className="table-content-wrapper">
//                 {loading && <p className="loading-message">Loading Assets...</p>}
//                 {error && <p className="error-message">Error: {error}</p>}
//                 {!loading && !error && (
//                     <>
//                         {filteredAssets.length > 0 ? (
//                             <div className="table-scroll-container">
//                                 <table className="data-table wide-table">
//                                     <thead>
//                                         <tr><th>ID</th><th>Asset Name</th><th>Asset Type</th><th>Capacity (MT)</th><th>Year of Purchase</th><th>Year of Manufacture</th><th>WO No</th><th>WO Start</th><th>WO End</th></tr>
//                                     </thead>
//                                     <tbody>
//                                         {filteredAssets.map(asset => {
//                                             const combinedAssetName = [asset.name, asset.serial_number, asset.asset_code, asset.registration_number].filter(Boolean).join(' | ');
//                                             return (
//                                                 <tr key={asset.id}>
//                                                     <td>{formatData(asset.id)}</td>
//                                                     <td>{combinedAssetName || 'N/A'}</td>
//                                                     <td>{formatData(asset.asset_type)}</td>
//                                                     <td>{formatData(asset.capacity_mt)}</td>
//                                                     <td>{formatData(asset.year_of_purchase)}</td>
//                                                     <td>{formatData(asset.year_of_manufacture)}</td>
//                                                     <td>{formatData(asset.wo_no)}</td>
//                                                     <td>{formatData(asset.wo_start)}</td>
//                                                     <td>{formatData(asset.wo_end)}</td>
//                                                 </tr>
//                                             );
//                                         })}
//                                     </tbody>
//                                 </table>
//                             </div>
//                         ) : (<p className="no-data-message">{filterDays !== null ? "No assets match the current availability filter." : "No active assets found."}</p>)}
//                     </>
//                 )}
//             </div>
//         </div>
//     );
// };
 
// // ====================================================================
// // --- Component for the Work Orders Tab Content ---
// // ====================================================================
// const WorkOrderDashboardContent = ({
//     loading, error, statusPieChartData, sectorBarChartData,
//     topCustomersData, filteredWorkOrders, filters, onChartClick, onClearFilters, apiToken
// }) => {
//     const statusChartRef = useRef();
//     const sectorChartRef = useRef();
//     const customerChartRef = useRef();
 
//     const handleChartClick = (filterType, chartData, event, chartRef) => {
//         if (!chartRef.current) return;
//         const elements = getElementAtEvent(chartRef.current, event);
//         if (elements.length > 0) {
//             const clickedLabel = chartData.labels[elements[0].index];
//             onChartClick(filterType, clickedLabel);
//         }
//     };
 
//     const hasFilters = Object.keys(filters).length > 0;
   
//     if (loading) return <div className="loading-error-container"><h2>Loading Dashboard...</h2></div>;
//     if (error) return <div className="loading-error-container"><h2>Dashboard Error</h2><p>{error}</p></div>;
 
//     return (
//         <main className="main-content">
//              <div className="dashboard-title-bar">
//                 <h1 className="dashboard-header">Work Orders Dashboard</h1>
//                 {hasFilters && (<button onClick={onClearFilters} className="clear-filters-btn">Clear Filters</button>)}
//             </div>
//             <div className="dashboard-grid">
//                 <div className="chart-card">
//                     <h3>Work Orders by Status</h3>
//                     <Pie ref={statusChartRef} data={statusPieChartData} options={{ responsive: true, plugins: { legend: { position: 'top' }, datalabels: { color: '#343a40', font: { weight: 'bold', size: 16 }, formatter: (value) => (value > 0 ? value : null) } } }} onClick={(event) => handleChartClick('status', statusPieChartData, event, statusChartRef)}/>
//                 </div>
//                 <div className="chart-card">
//                     <h3>Work Orders by Sector</h3>
//                     <Bar ref={sectorChartRef} data={sectorBarChartData} options={{ responsive: true, scales: { y: { beginAtZero: true } } }} onClick={(event) => handleChartClick('sector', sectorBarChartData, event, sectorChartRef)}/>
//                 </div>
//                 <div className="chart-card">
//                     <h3>Top Customers by Order Value</h3>
//                      <Bar ref={customerChartRef} data={topCustomersData} options={{ responsive: true, scales: { y: { beginAtZero: true } } }} onClick={(event) => handleChartClick('customer', topCustomersData, event, customerChartRef)}/>
//                 </div>
//                 <div className="chart-card table-card">
//                     <FilteredWorkOrderTable workOrders={filteredWorkOrders} apiToken={apiToken} />
//                 </div>
//                 <div className="chart-card table-card">
//                      <AssetAvailabilityTable workOrders={filteredWorkOrders} apiToken={apiToken} />
//                 </div>
//             </div>
//         </main>
//     );
// };

// // ====================================================================
// // --- Component for Invoice Data Table ---
// // ====================================================================
// const InvoiceDataTable = ({ invoices, workOrderMap, customerMap, userMap }) => {
//     // Columns definition
//     const columns = useMemo(() => [
//         { header: 'ID', key: 'id' }, { header: 'Doc No', key: 'doc_no' },
//         { header: 'Customer Name', key: 'customer_name' }, { header: 'Customer ID', key: 'cust_id' },
//         { header: 'Work Order ID', key: 'wo_id' }, { header: 'Work Order No', key: 'wo_no' },
//         { header: 'Work Order Date', key: 'wo_date' }, { header: 'Project ID', key: 'project_id' },
//         { header: 'Project Name', key: 'project_name' }, { header: 'Invoice Date', key: 'inv_date' },
//         { header: 'Due Date', key: 'due_date' }, { header: 'Start Date', key: 'start_date' },
//         { header: 'End Date', key: 'end_date' }, { header: 'Credit Period', key: 'cr_period' },
//         { header: 'Taxable Amt', key: 'taxable_amt' },
//         { header: 'CGST', key: 'tot_cgst' }, { header: 'SGST', key: 'tot_sgst' },
//         { header: 'IGST', key: 'tot_igst' }, { header: 'Total Amount', key: 'amount' },
//         { header: 'Approval Status', key: 'inv_approval_status' }, { header: 'Current Status', key: 'current_status' },
//         { header: 'Created By', key: 'added_by' },
//         { header: 'Created Date', key: 'add_date' }, { header: 'Updated By', key: 'updated_by' },
//         { header: 'Updated Date', key: 'update_date' },
//     ], []);

//     // Centralized data formatting function
//     const formatData = (value, key) => {
//         const currencyKeys = ['taxable_amt', 'amount', 'tot_cgst', 'tot_sgst', 'tot_igst'];

//         // Handle currency columns
//         if (currencyKeys.includes(key)) {
//             const numberValue = parseFloat(value ?? 0);
//             return numberValue.toLocaleString('en-IN', {
//                 style: 'currency',
//                 currency: 'INR',
//                 minimumFractionDigits: 2,
//                 maximumFractionDigits: 2,
//             });
//         }

//         // Handle credit period
//         if (key === 'cr_period') {
//             return value ?? 0;
//         }

//         // Handle general null/undefined/empty case for all other columns
//         if (value === null || typeof value === 'undefined' || value === '') {
//             return '-';
//         }

//         // Handle date/datetime formatting
//         if (key === 'add_date' || key === 'update_date') {
//             const date = new Date(value);
//             return !isNaN(date) ? date.toLocaleString('en-GB') : '-';
//         }

//         if (typeof value === 'string' && (key.includes('date') || key.includes('Date'))) {
//             const date = new Date(value);
//             return !isNaN(date) ? date.toLocaleDateString('en-GB') : '-';
//         }

//         return value;
//     };
    
//     // Sort invoices once by date
//     const sortedInvoices = useMemo(() => {
//         if (!Array.isArray(invoices)) return [];
//         return [...invoices].sort((a, b) => new Date(b.inv_date || b.add_date) - new Date(a.inv_date || a.add_date));
//     }, [invoices]);

//     if (sortedInvoices.length === 0) {
//         return (
//             <div className="filtered-table-container">
//                  <p className="no-data-message" style={{ padding: '20px' }}>No invoice data matching the current filter.</p>
//             </div>
//         )
//     }

//     return (
//         <div className="filtered-table-container">
//             <div className="table-content-wrapper">
//                 <div className="table-scroll-container">
//                     <table className="data-table wide-table">
//                         <thead>
//                             <tr>{columns.map(col => <th key={col.key}>{col.header}</th>)}</tr>
//                         </thead>
//                         <tbody>
//                             {sortedInvoices.map((invoice) => {
//                                 const relatedWorkOrder = workOrderMap.get(invoice.wo_id) || {};
//                                 return (
//                                     <tr key={invoice.id}>
//                                         {columns.map(col => {
//                                             let rawValue;
//                                             switch(col.key) {
//                                                 case 'customer_name':
//                                                     rawValue = customerMap.get(invoice.cust_id);
//                                                     break;
//                                                 case 'added_by':
//                                                     rawValue = userMap.get(String(invoice.added_by)) ?? invoice.added_by;
//                                                     break;
//                                                 case 'updated_by':
//                                                     rawValue = userMap.get(String(invoice.updated_by)) ?? invoice.updated_by;
//                                                     break;
//                                                 case 'project_id': case 'project_name': case 'wo_no': case 'wo_date':
//                                                     rawValue = relatedWorkOrder[col.key];
//                                                     break;
//                                                 default:
//                                                     rawValue = invoice[col.key];
//                                             }
                                            
//                                             const cellValue = formatData(rawValue, col.key);
//                                             const currencyKeys = ['taxable_amt', 'amount', 'tot_cgst', 'tot_sgst', 'tot_igst'];
//                                             const isAmount = currencyKeys.includes(col.key);
                                            
//                                             return <td key={col.key} style={{ textAlign: isAmount ? 'right' : 'left' }}>{cellValue}</td>;
//                                         })}
//                                     </tr>
//                                 );
//                             })}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         </div>
//     );
// };
 
// // ====================================================================
// // --- Component for the Invoices Tab (UPDATED with new filters) ---
// // ====================================================================
// const InvoiceDashboardContent = ({ invoices, workOrders, loading, error, customerMap, userMap }) => {
//     const today = new Date();
//     const thirtyDaysAgo = new Date(new Date().setDate(today.getDate() - 30));
//     const formatDateForInput = (date) => date.toISOString().split('T')[0];
   
//     const [startDate, setStartDate] = useState(formatDateForInput(thirtyDaysAgo));
//     const [endDate, setEndDate] = useState(formatDateForInput(today));
//     const [selectedStatusFilter, setSelectedStatusFilter] = useState(null);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [dateFilterType, setDateFilterType] = useState('invoiceDate'); // 'invoiceDate' or 'invoicePeriod'
//     const tableRef = useRef(null);
//     const statusPieChartRef = useRef(null);

//     // Memoize the work order map for efficiency
//     const workOrderMap = useMemo(() => {
//         const map = new Map();
//         if (Array.isArray(workOrders)) {
//             workOrders.forEach(wo => {
//                 if (wo.wo_id && !map.has(wo.wo_id)) {
//                     map.set(wo.wo_id, wo);
//                 }
//             });
//         }
//         return map;
//     }, [workOrders]);
    
//     // 1. Filter invoices based on the selected date range and filter type
//     const dateFilteredInvoices = useMemo(() => {
//         if (!Array.isArray(invoices) || !startDate || !endDate) return [];
        
//         const rangeStart = new Date(startDate);
//         rangeStart.setHours(0, 0, 0, 0); // Set to start of the day for accurate comparison
//         const rangeEnd = new Date(endDate);
//         rangeEnd.setHours(23, 59, 59, 999); // Set to end of the day

//         return invoices.filter(inv => {
//             if (dateFilterType === 'invoiceDate') {
//                 const invoiceDate = new Date(inv.inv_date || inv.add_date);
//                 return !isNaN(invoiceDate) && invoiceDate >= rangeStart && invoiceDate <= rangeEnd;
//             } else { // 'invoicePeriod'
//                 if (!inv.start_date || !inv.end_date) return false;
                
//                 const periodStart = new Date(inv.start_date);
//                 const periodEnd = new Date(inv.end_date);
                
//                 if (isNaN(periodStart.getTime()) || isNaN(periodEnd.getTime())) return false;
                
//                 // Check if the invoice's period is completely within the user-selected range
//                 return periodStart >= rangeStart && periodEnd <= rangeEnd;
//             }
//         });
//     }, [invoices, startDate, endDate, dateFilterType]); // Dependency array includes the new filter type state
 
//     // This data is used for the charts and KPIs, based on the date-filtered data
//     const dashboardData = useMemo(() => {
//         const EMPTY_CHART_DATA = { labels: [], datasets: [{ data: [] }] };
//         const baseKpis = { totalInvoices: 0, totalTaxable: 0, totalGst: 0, avgCreditPeriod: 0 };

//         if (dateFilteredInvoices.length === 0) {
//             return { kpis: baseKpis, customerData: EMPTY_CHART_DATA, statusPieData: EMPTY_CHART_DATA };
//         }
 
//         const statusCountsForPie = dateFilteredInvoices.reduce((acc, inv) => {
//             const status = inv.current_status || 'Unknown';
//             acc[status] = (acc[status] || 0) + 1;
//             return acc;
//         }, {});

//         // Sort labels alphabetically for the pie chart
//         const sortedStatusLabels = Object.keys(statusCountsForPie).sort();
        
//         const statusPieData = {
//             labels: sortedStatusLabels,
//             datasets: [{ 
//                 data: sortedStatusLabels.map(label => statusCountsForPie[label]), // Map data in sorted order
//                 backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#F7464A'], 
//                 borderColor: '#fff', 
//                 borderWidth: 2 
//             }]
//         };
        
//         const customerAggregates = dateFilteredInvoices.reduce((acc, inv) => {
//             const customerName = customerMap.get(inv.cust_id) || `Customer ID: ${inv.cust_id}`;
//             acc[customerName] = (acc[customerName] || 0) + (Number(inv.amount) || 0);
//             return acc;
//         }, {});
        
//         const sortedCustomers = Object.entries(customerAggregates)
//             .filter(([, amount]) => amount > 0)
//             .sort(([,a], [,b]) => b - a)
//             .slice(0, 10);
//         const customerData = { 
//             labels: sortedCustomers.map(([name]) => name), 
//             datasets: [{ label: 'Total Invoice Amount', data: sortedCustomers.map(([, amount]) => amount), backgroundColor: 'rgba(153, 102, 255, 0.6)' }] 
//         };
       
//         return {
//             kpis: {
//                 totalInvoices: dateFilteredInvoices.length,
//                 totalTaxable: dateFilteredInvoices.reduce((sum, inv) => sum + (Number(inv.taxable_amt) || 0), 0),
//                 totalGst: dateFilteredInvoices.reduce((sum, inv) => sum + (Number(inv.tot_cgst) || 0) + (Number(inv.tot_sgst) || 0) + (Number(inv.tot_igst) || 0), 0),
//                 avgCreditPeriod: (dateFilteredInvoices.map(inv => Number(inv.cr_period)).filter(p => p > 0).reduce((a, b, _, arr) => a + b / arr.length, 0)).toFixed(2) || 0
//             },
//             customerData, statusPieData
//         };
//     }, [dateFilteredInvoices, customerMap]);
    
//     // 2. Further filter by status from pie chart click
//     const statusFilteredInvoices = useMemo(() => {
//         if (!selectedStatusFilter) return dateFilteredInvoices;
//         return dateFilteredInvoices.filter(invoice => invoice.current_status === selectedStatusFilter);
//     }, [dateFilteredInvoices, selectedStatusFilter]);

//     // 3. Final filter by search term on top of date and status filters
//     const finalFilteredInvoices = useMemo(() => {
//         if (!searchTerm.trim()) return statusFilteredInvoices;
//         const lowercasedFilter = searchTerm.toLowerCase();
//         return statusFilteredInvoices.filter(invoice => {
//             const workOrder = workOrderMap.get(invoice.wo_id) || {};
//             const searchableFields = [
//                 invoice.id, invoice.doc_no, invoice.cust_id, customerMap.get(invoice.cust_id),
//                 invoice.wo_id, workOrder.wo_no, workOrder.project_id, workOrder.project_name,
//                 invoice.inv_approval_status, invoice.current_status,
//                 userMap.get(String(invoice.added_by)), userMap.get(String(invoice.updated_by))
//             ];
//             return searchableFields.some(field => field && String(field).toLowerCase().includes(lowercasedFilter));
//         });
//     }, [statusFilteredInvoices, searchTerm, workOrderMap, customerMap, userMap]);

//     const handleStatusPieClick = (event) => {
//         if (!statusPieChartRef.current) return;
//         const elements = getElementAtEvent(statusPieChartRef.current, event);
//         if (elements.length > 0) {
//             const clickedStatus = dashboardData.statusPieData.labels[elements[0].index];
//             setSelectedStatusFilter(prev => prev === clickedStatus ? null : clickedStatus);
//             setTimeout(() => tableRef.current?.scrollIntoView({ behavior: 'smooth' }), 100);
//         } else {
//             setSelectedStatusFilter(null);
//         }
//     };
    
//     // --- CSV Export Logic ---
//     const convertToCSVAndDownload = (dataToExport, filename) => {
//         if (dataToExport.length === 0) {
//             alert("No data available to export.");
//             return;
//         }

//         const columns = [
//             { header: 'ID', key: 'id' }, { header: 'Doc No', key: 'doc_no' }, { header: 'Customer Name', key: 'customer_name' },
//             { header: 'Customer ID', key: 'cust_id' }, { header: 'Work Order ID', key: 'wo_id' }, { header: 'Work Order No', key: 'wo_no' },
//             { header: 'Work Order Date', key: 'wo_date' }, { header: 'Project Name', key: 'project_name' }, { header: 'Invoice Date', key: 'inv_date' },
//             { header: 'Due Date', key: 'due_date' }, { header: 'Total Amount', key: 'amount' }, { header: 'Current Status', key: 'current_status' },
//             { header: 'Created By', key: 'added_by' }, { header: 'Created Date', key: 'add_date' }, { header: 'Updated By', key: 'updated_by' },
//             { header: 'Updated Date', key: 'update_date' },
//         ];

//         const replacer = (key, value) => value === null ? '' : value;
//         const header = columns.map(c => c.header).join(',');
//         const rows = dataToExport.map(invoice => {
//             const relatedWorkOrder = workOrderMap.get(invoice.wo_id) || {};
//             return columns.map(col => {
//                 let cellData;
//                 switch (col.key) {
//                     case 'customer_name': cellData = customerMap.get(invoice.cust_id) || 'N/A'; break;
//                     case 'added_by': cellData = userMap.get(String(invoice.added_by)) || invoice.added_by || 'N/A'; break;
//                     case 'updated_by': cellData = userMap.get(String(invoice.updated_by)) || invoice.updated_by || 'N/A'; break;
//                     case 'wo_no': case 'wo_date': case 'project_name': cellData = relatedWorkOrder[col.key]; break;
//                     default: cellData = invoice[col.key];
//                 }
//                 const stringValue = JSON.stringify(replacer(col.key, cellData), replacer);
//                 return stringValue.replace(/"/g, '""').replace(/^""|""$/g, '"');
//             }).join(',');
//         });

//         const csv = [header, ...rows].join('\n');
//         const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
//         const link = document.createElement("a");
//         const url = URL.createObjectURL(blob);
//         link.setAttribute("href", url);
//         link.setAttribute("download", `${filename}.csv`);
//         link.style.visibility = 'hidden';
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//     };

//     const handleExportAll = () => convertToCSVAndDownload(statusFilteredInvoices, 'all_invoices_export');
//     const handleExportByFilter = () => convertToCSVAndDownload(finalFilteredInvoices, 'filtered_invoices_export');

//     if (loading) return <div className="loading-error-container"><h2>Loading Invoice Dashboard...</h2></div>;
//     if (error) return <div className="loading-error-container"><h2>Dashboard Error</h2><p>{error}</p></div>;
 
//     const formatCurrency = (value) => new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(value);
//     const pieOptions = { responsive: true, plugins: { legend: { position: 'bottom' }, datalabels: { color: '#fff', font: { weight: 'bold' }, formatter: (value) => (value > 0 ? value : '') } } };
 
//     return (
//         <main className="main-content">
//             <div className="filter-bar">
//                 <div className="filter-group">
//                     <div className="filter-item">
//                         <input type="radio" id="invoiceDate" name="dateFilterType" value="invoiceDate" checked={dateFilterType === 'invoiceDate'} onChange={(e) => setDateFilterType(e.target.value)} />
//                         <label htmlFor="invoiceDate">Invoice Date</label>
//                     </div>
//                     <div className="filter-item">
//                         <input type="radio" id="invoicePeriod" name="dateFilterType" value="invoicePeriod" checked={dateFilterType === 'invoicePeriod'} onChange={(e) => setDateFilterType(e.target.value)} />
//                         <label htmlFor="invoicePeriod">Invoice Period</label>
//                     </div>
//                 </div>
//                 <div className="filter-item"><label htmlFor="start-date">Start Date:</label><input type="date" id="start-date" value={startDate} onChange={(e) => setStartDate(e.target.value)} /></div>
//                 <div className="filter-item"><label htmlFor="end-date">End Date:</label><input type="date" id="end-date" value={endDate} onChange={(e) => setEndDate(e.target.value)} /></div>
//             </div>
           
//             <div className="kpi-grid">
//                 <div className="kpi-card"><h4>Total Invoices</h4><p>{dashboardData.kpis.totalInvoices}</p></div>
//                 <div className="kpi-card"><h4>Total Taxable Amount</h4><p>{formatCurrency(dashboardData.kpis.totalTaxable)}</p></div>
//                 <div className="kpi-card"><h4>Total GST Collected</h4><p>{formatCurrency(dashboardData.kpis.totalGst)}</p></div>
//                 <div className="kpi-card"><h4>Avg. Credit Period</h4><p>{dashboardData.kpis.avgCreditPeriod} Days</p></div>
//             </div>
           
//             <div className="dashboard-grid">
//                 <div className="chart-card large-card">
//                   <h3>Customer Wise Invoices (Top 10 by Amount)</h3>
//                     {dateFilteredInvoices.length > 0 && dashboardData.customerData.labels.length > 0 ? (
//                         <Bar data={dashboardData.customerData} options={{ responsive: true, scales: { y: { beginAtZero: true } } }} />
//                     ) : (
//                         <p className="no-data-message">No customer invoice data with positive amounts for selected date range.</p>
//                     )}
//                 </div>
//                 <div className="chart-card">
//                   <h3>Invoices by Status</h3>
//                    {dateFilteredInvoices.length > 0 ? (
//                         <Pie ref={statusPieChartRef} data={dashboardData.statusPieData} options={pieOptions} onClick={handleStatusPieClick} />
//                     ) : (
//                         <p className="no-data-message">No data available.</p>
//                     )}
//                 </div>
//             </div>

//             <div ref={tableRef} className="invoice-table-section" style={{ marginTop: '2rem' }}>
//                 <div className="table-header with-controls">
//                     <h3>All Invoices {selectedStatusFilter && `(Status: ${selectedStatusFilter})`} {searchTerm && `(Filtered)`}</h3>
//                     <div className="table-actions">
//                         {selectedStatusFilter && (<button onClick={() => setSelectedStatusFilter(null)} className="clear-filters-btn small">Clear Status Filter</button>)}
//                         <input type="text" placeholder="Search invoices..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} className="search-bar" />
//                         <button onClick={handleExportByFilter} className="export-btn">Export by Filter</button>
//                         <button onClick={handleExportAll} className="export-btn">Export All</button>
//                     </div>
//                 </div>
//                 <InvoiceDataTable invoices={finalFilteredInvoices} workOrderMap={workOrderMap} customerMap={customerMap} userMap={userMap} />
//             </div>
//         </main>
//     );
// };
 
// // ====================================================================
// // --- Main Dashboard Component ---
// // ====================================================================
// const Dashboard = () => {
//     const [activeTab, setActiveTab] = useState('workOrder');
//     const [workOrderTableReport, setWorkOrderTableReport] = useState({ columns: [], data: [] });
//     const [invoices, setInvoices] = useState([]);
//     const [customers, setCustomers] = useState([]);
//     const [users, setUsers] = useState([]); 
//     const [filters, setFilters] = useState({});
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
 
//     const API_TOKEN = 'Bearer ' + localStorage.getItem('zTaskAuthToken');
 
//     const handleApiResponse = async (response) => {
//         if (!response.ok) {
//             const errorText = await response.text();
//             throw new Error(`API call to ${response.url} failed with status ${response.status}: ${response.statusText}. Response: ${errorText.substring(0, 200)}`);
//         }
//         return response.json();
//     };
 
//     useEffect(() => {
//         const fetchAllData = async () => {
//             setLoading(true);
//             setError(null);
 
//             const REPORT_API_URL = `${process.env.REACT_APP_REPORTS_API_URL}/api/reports/run`;
//             const INVOICE_API_URL = `${process.env.REACT_APP_NODE_SERVICE_BASE_URL}/invoice/api/invoices/`;
//             const CUSTOMER_API_URL = `${process.env.REACT_APP_NODE_SERVICE_BASE_URL}/api/get-column/customers/name`;
//             const USER_API_URL = `${process.env.REACT_APP_NODE_SERVICE_BASE_URL}/api/get-column/users/name`; 
 
//             const HEADERS = { 'accept': 'application/json', 'Authorization': API_TOKEN };
//             const TABLE_REPORT_BODY = { "report_name": "work_order_table", "module_name": "Workorder" };
           
//             try {
//                 const [tableReportJson, invoiceJson, customersJson, usersJson] = await Promise.all([
//                     fetch(REPORT_API_URL, { method: 'POST', headers: { ...HEADERS, 'Content-Type': 'application/json' }, body: JSON.stringify(TABLE_REPORT_BODY) }).then(handleApiResponse),
//                     fetch(INVOICE_API_URL, { headers: HEADERS }).then(handleApiResponse),
//                     fetch(CUSTOMER_API_URL, { headers: HEADERS }).then(handleApiResponse),
//                     fetch(USER_API_URL, { headers: HEADERS }).then(handleApiResponse)
//                 ]);
               
//                 setWorkOrderTableReport(tableReportJson && tableReportJson.columns && tableReportJson.data ? tableReportJson : { columns: [], data: [] });
//                 setInvoices(Array.isArray(invoiceJson) ? invoiceJson : []);
//                 setCustomers(Array.isArray(customersJson) ? customersJson : []);
//                 setUsers(Array.isArray(usersJson) ? usersJson : []);

//             } catch (e) {
//                 console.error("Failed to fetch dashboard data:", e);
//                 setError(e.message);
//             } finally {
//                 setLoading(false);
//             }
//         };
//         fetchAllData();
//     }, []);
 
//     const handleChartClick = (filterType, clickedLabel) => setFilters(prev => ({ ...prev, [filterType]: clickedLabel }));
//     const clearFilters = () => setFilters({});
   
//     const customerMap = useMemo(() => {
//         const map = new Map();
//         customers.forEach(customer => map.set(customer.id, customer.value));
//         return map;
//     }, [customers]);

//     const userMap = useMemo(() => {
//         const map = new Map();
//         users.forEach(user => map.set(user.id, user.value));
//         return map;
//     }, [users]);

//     const uniqueWorkOrders = useMemo(() => {
//         if (!Array.isArray(workOrderTableReport.data)) return [];
//         const uniqueWoMap = new Map();
//         workOrderTableReport.data.forEach(order => {
//             if (order.wo_id && !uniqueWoMap.has(order.wo_id)) {
//                 uniqueWoMap.set(order.wo_id, { ...order, tot_value: parseFloat(order.tot_value) || 0 });
//             }
//         });
//         return Array.from(uniqueWoMap.values());
//     }, [workOrderTableReport.data]);
 
//     const statusPieChartData = useMemo(() => {
//         const statusCounts = uniqueWorkOrders.reduce((acc, order) => {
//             acc[order.wo_open_close || 'Unknown'] = (acc[order.wo_open_close || 'Unknown'] || 0) + 1;
//             return acc;
//         }, { 'Open': 0, 'Closed': 0 });
//         return { labels: Object.keys(statusCounts), datasets: [{ data: Object.values(statusCounts), backgroundColor: ['#ff8a80', '#80d8ff'], borderColor: '#ffffff', borderWidth: 3 }] };
//     }, [uniqueWorkOrders]);
 
//     const sectorBarChartData = useMemo(() => {
//         const sectorData = uniqueWorkOrders.reduce((acc, wo) => {
//             const sectorName = wo.sector_name || 'Unknown Sector';
//             acc[sectorName] = acc[sectorName] || { count: 0, totalValue: 0 };
//             acc[sectorName].count++;
//             acc[sectorName].totalValue += wo.tot_value;
//             return acc;
//         }, {});
//         const labels = Object.keys(sectorData).sort();
//         return { labels, datasets: [
//             { label: 'Number of Orders', data: labels.map(l => sectorData[l].count), backgroundColor: 'rgba(255, 159, 64, 0.8)' },
//             { label: 'Total Value', data: labels.map(l => sectorData[l].totalValue), backgroundColor: 'rgba(75, 192, 192, 0.8)' }
//         ] };
//     }, [uniqueWorkOrders]);
   
//     const topCustomersData = useMemo(() => {
//         const customerAggregates = uniqueWorkOrders.reduce((acc, wo) => {
//             acc[wo.customer_name || 'Unknown Customer'] = (acc[wo.customer_name || 'Unknown Customer'] || 0) + wo.tot_value;
//             return acc;
//         }, {});
//         const sortedCustomers = Object.entries(customerAggregates).sort(([, a], [, b]) => b - a).slice(0, 5);
//         return { labels: sortedCustomers.map(([label]) => label), datasets: [{ label: 'Total Order Value', data: sortedCustomers.map(([, value]) => value), backgroundColor: 'rgba(54, 162, 235, 0.8)' }] };
//     }, [uniqueWorkOrders]);
 
//     const filteredWorkOrders = useMemo(() => {
//         if (Object.keys(filters).length === 0) return workOrderTableReport.data || [];
//         const woIdsToKeep = new Set(uniqueWorkOrders
//             .filter(wo => (!filters.status || wo.wo_open_close === filters.status) && (!filters.sector || wo.sector_name === filters.sector) && (!filters.customer || wo.customer_name === filters.customer))
//             .map(wo => wo.wo_id)
//         );
//         return (workOrderTableReport.data || []).filter(order => woIdsToKeep.has(order.wo_id));
//     }, [workOrderTableReport.data, uniqueWorkOrders, filters]);
 
//     return (
//         <div className="dashboard-container">
//             <div className="tabs-container">
//                 <button className={`tab-button ${activeTab === 'workOrder' ? 'active' : ''}`} onClick={() => setActiveTab('workOrder')}>Work Orders</button>
//                 <button className={`tab-button ${activeTab === 'invoice' ? 'active' : ''}`} onClick={() => setActiveTab('invoice')}>Invoices</button>
//             </div>
//             <div className="tab-content">
//                 {activeTab === 'workOrder' && (
//                     <WorkOrderDashboardContent
//                         loading={loading} error={error} statusPieChartData={statusPieChartData}
//                         sectorBarChartData={sectorBarChartData}
//                         topCustomersData={topCustomersData} filteredWorkOrders={filteredWorkOrders}
//                         filters={filters} onChartClick={handleChartClick} onClearFilters={clearFilters}
//                         apiToken={API_TOKEN}
//                     />
//                 )}
//                 {activeTab === 'invoice' && (
//                     <InvoiceDashboardContent 
//                         invoices={invoices} 
//                         workOrders={workOrderTableReport.data}
//                         loading={loading} 
//                         error={error}
//                         customerMap={customerMap}
//                         userMap={userMap}
//                     />
//                 )}
//             </div>
//         </div>
//     );
// };
 
// export default Dashboard;












// import React, { useState, useEffect, useMemo, useRef } from 'react';
// import { Pie, Bar, getElementAtEvent } from 'react-chartjs-2';
// import {
//     Chart as ChartJS,
//     CategoryScale,
//     LinearScale,
//     BarElement,
//     Title,
//     Tooltip,
//     Legend,
//     ArcElement
// } from 'chart.js';
// import ChartDataLabels from 'chartjs-plugin-datalabels';
// import './Dashboard.css'; // Renamed CSS import
 
// ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement, ChartDataLabels);
 
// // ====================================================================
// // --- Component for Work Order Table ---
// // ====================================================================
// const FilteredWorkOrderTable = ({ workOrders, apiToken }) => {
//     const [activeTab, setActiveTab] = useState('assets');
//     const [assets, setAssets] = useState([]);
//     const [assetsLoading, setAssetsLoading] = useState(false);
//     const [assetsError, setAssetsError] = useState(null);
 
//     useEffect(() => {
//         const fetchAssets = async () => {
//             if (!workOrders || workOrders.length === 0) {
//                 setAssets([]);
//                 return;
//             }
//             const assetIdSet = new Set(workOrders.map(wo => wo.asset_id).filter(id => id != null));
//             const assetIds = Array.from(assetIdSet);
//             if (assetIds.length === 0) {
//                 setAssets([]);
//                 return;
//             }
           
//             setAssetsLoading(true);
//             setAssetsError(null);
           
//             const ASSET_API_URL = `${process.env.REACT_APP_ASSET_SERVICE_BASE_URL}/api/assets/`;
//             const ASSET_HEADERS = { 'accept': 'application/json', 'Authorization': apiToken };
 
//             try {
//                 const assetPromises = assetIds.map(id =>
//                     fetch(`${ASSET_API_URL}${id}`, { headers: ASSET_HEADERS }).then(res => {
//                         if (!res.ok) {
//                             console.error(`Failed to fetch asset ${id}, status: ${res.status}`);
//                             return null;
//                         }
//                         return res.json();
//                     })
//                 );
//                 const fetchedAssetsResults = await Promise.all(assetPromises);
//                 setAssets(fetchedAssetsResults.filter(asset => asset !== null));
//             } catch (error) {
//                 console.error("Failed to fetch assets:", error);
//                 setAssetsError(error.message);
//             } finally {
//                 setAssetsLoading(false);
//             }
//         };
//         fetchAssets();
//     }, [workOrders, apiToken]);
 
//     const displayedWorkOrders = useMemo(() => {
//         if (!workOrders || !Array.isArray(workOrders)) return [];
//         return [...workOrders].sort((a, b) => new Date(b.add_date) - new Date(a.add_date));
//     }, [workOrders]);
 
//     const formatData = (value) => {
//         if (value === null || typeof value === 'undefined') return 'N/A';
//         if (typeof value === 'boolean') return value ? 'Yes' : 'No';
//         if (typeof value === 'string' && value.includes('T')) {
//             const date = new Date(value);
//             if (!isNaN(date)) return date.toLocaleDateString('en-GB');
//         }
//         return value;
//     };
 
//     const displayColumns = [
//         { header: 'Doc No', key: 'doc_no' }, { header: 'WO No', key: 'wo_no' },
//         { header: 'Status', key: 'wo_open_close' }, { header: 'Total Value', key: 'tot_value' },
//         { header: 'Customer Name', key: 'customer_name' }, { header: 'Customer ID', key: 'cust_id' },
//         { header: 'Project Name', key: 'project_name' }, { header: 'Project ID', key: 'project_id' },
//         { header: 'Sector Name', key: 'sector_name' }, { header: 'Sector ID', key: 'sector' },
//         { header: 'Asset ID', key: 'asset_id' }, { header: 'WO Date', key: 'wo_date' },
//         { header: 'WO Start', key: 'wo_start' }, { header: 'WO End', key: 'wo_end' },
//     ];
 
//     return (
//         <div className="filtered-table-container">
//             <div className="table-header"><h3>All Work Orders</h3></div>
//             <div className="table-controls">
//                 <div className="tabs">
//                     <button className={`tab-btn ${activeTab === 'assets' ? 'active' : ''}`} onClick={() => setActiveTab('assets')}>Assets</button>
//                     <button className={`tab-btn ${activeTab === 'workorder' ? 'active' : ''}`} onClick={() => setActiveTab('workorder')}>Workorder</button>
//                 </div>
//             </div>
//             <div className="table-content-wrapper">
//                 {activeTab === 'workorder' ? (
//                     <>
//                         {displayedWorkOrders.length > 0 ? (
//                             <div className="table-scroll-container">
//                                 <table className="data-table wide-table">
//                                     <thead><tr>{displayColumns.map(col => <th key={col.key}>{col.header}</th>)}</tr></thead>
//                                     <tbody>
//                                         {displayedWorkOrders.map((order, index) => (
//                                             <tr key={`${order.id}-${index}`}>
//                                                 {displayColumns.map(col => (
//                                                     <td key={col.key}>{col.key === 'tot_value' ? parseFloat(order[col.key] || 0).toLocaleString('en-US') : formatData(order[col.key])}</td>
//                                                 ))}
//                                             </tr>
//                                         ))}
//                                     </tbody>
//                                 </table>
//                             </div>
//                         ) : (<p className="no-data-message">No work orders found for the current filter.</p>)}
//                     </>
//                 ) : (
//                     <>
//                         {assetsLoading && <p className="loading-message">Loading Assets...</p>}
//                         {assetsError && <p className="error-message">Error: {assetsError}</p>}
//                         {!assetsLoading && !assetsError && (
//                             <>
//                                 {assets.length > 0 ? (
//                                     <div className="table-scroll-container">
//                                         <table className="data-table wide-table">
//                                             <thead>
//                                                 <tr><th>Asset Name</th><th>Asset Type</th><th>Capacity (MT)</th><th>Year of Purchase</th><th>Year of Manufacture</th></tr>
//                                             </thead>
//                                             <tbody>
//                                                 {assets.map(asset => {
//                                                     const combinedAssetName = [asset.name, asset.serial_number, asset.asset_code, asset.registration_number].filter(Boolean).join(' | ');
//                                                     return (
//                                                         <tr key={asset.id}>
//                                                             <td>{combinedAssetName || 'N/A'}</td>
//                                                             <td>{formatData(asset.asset_type)}</td>
//                                                             <td>{formatData(asset.capacity_mt)}</td>
//                                                             <td>{formatData(asset.year_of_purchase)}</td>
//                                                             <td>{formatData(asset.year_of_manufacture)}</td>
//                                                         </tr>
//                                                     );
//                                                 })}
//                                             </tbody>
//                                         </table>
//                                     </div>
//                                 ) : (<p className="no-data-message">No assets found for the current work orders.</p>)}
//                             </>
//                         )}
//                     </>
//                 )}
//             </div>
//         </div>
//     );
// };
 
// // ====================================================================
// // --- Component for Asset Availability Table ---
// // ====================================================================
// const AssetAvailabilityTable = ({ workOrders, apiToken }) => {
//     const [combinedAssets, setCombinedAssets] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);
//     const [filterDays, setFilterDays] = useState(null);
//     const [customDays, setCustomDays] = useState('');
 
//     useEffect(() => {
//         const fetchAndCombineData = async () => {
//             setLoading(true);
//             setError(null);
           
//             const workOrderInfoMap = new Map();
//             if (workOrders && Array.isArray(workOrders)) {
//                 workOrders.forEach(wo => {
//                     if (wo.asset_id != null) {
//                         workOrderInfoMap.set(Number(wo.asset_id), { wo_start: wo.wo_start, wo_end: wo.wo_end, wo_no: wo.wo_no });
//                     }
//                 });
//             }
           
//             const ASSET_API_URL = `${process.env.REACT_APP_ASSET_SERVICE_BASE_URL}/api/assets/`;
//             const ASSET_HEADERS = { 'accept': 'application/json', 'Authorization': apiToken };
 
//             try {
//                 const response = await fetch(ASSET_API_URL, { headers: ASSET_HEADERS });
//                 if (!response.ok) {
//                     throw new Error(`Failed to fetch assets, status: ${response.status}`);
//                 }
//                 const allAssets = await response.json();
//                 const activeAssets = allAssets.filter(asset => asset.active === true);
 
//                 const combinedData = activeAssets.map(asset => {
//                     const workOrderInfo = workOrderInfoMap.get(asset.id) || { wo_start: null, wo_end: null, wo_no: null };
//                     return { ...asset, ...workOrderInfo };
//                 });
               
//                 setCombinedAssets(combinedData);
//             } catch (error) {
//                 console.error("Failed to fetch asset data:", error);
//                 setError(error.message);
//             } finally {
//                 setLoading(false);
//             }
//         };
 
//         fetchAndCombineData();
//     }, [workOrders, apiToken]);
 
//     const filteredAssets = useMemo(() => {
//         if (filterDays === null) return combinedAssets;
//         const targetDate = new Date();
//         targetDate.setDate(targetDate.getDate() + filterDays);
//         targetDate.setHours(23, 59, 59, 999);
//         return combinedAssets.filter(asset => {
//             if (!asset.wo_end) return true;
//             const woEndDate = new Date(asset.wo_end);
//             return isNaN(woEndDate.getTime()) || woEndDate <= targetDate;
//         });
//     }, [combinedAssets, filterDays]);
 
//     const formatData = (value) => {
//         if (value === null || typeof value === 'undefined') return 'N/A';
//         if (typeof value === 'boolean') return value ? 'Yes' : 'No';
//         if (typeof value === 'string' && value.includes('T')) {
//             const date = new Date(value);
//             if (!isNaN(date)) return date.toLocaleDateString('en-GB');
//         }
//         return value;
//     };
 
//     const handleCustomFilter = () => {
//         const days = parseInt(customDays, 10);
//         if (days > 0) setFilterDays(days);
//     };
 
//     const clearFilter = () => {
//         setFilterDays(null);
//         setCustomDays('');
//     };
 
//     return (
//         <div className="filtered-table-container">
//             <div className="table-header with-controls">
//                 <h3>Asset Availability</h3>
//                 <div className="availability-filter-controls">
//                     <span>Available In:</span>
//                     {[3, 7, 15, 30].map(days => (
//                         <button key={days} onClick={() => setFilterDays(days)} className={filterDays === days ? 'active' : ''}>{days} Days</button>
//                     ))}
//                     <div className="custom-filter">
//                         <input type="number" placeholder="Custom" value={customDays} onChange={(e) => setCustomDays(e.target.value)} min="1"/>
//                         <button onClick={handleCustomFilter}>Go</button>
//                     </div>
//                     <button onClick={clearFilter}>Clear Filter</button>
//                 </div>
//             </div>
//             <div className="table-content-wrapper">
//                 {loading && <p className="loading-message">Loading Assets...</p>}
//                 {error && <p className="error-message">Error: {error}</p>}
//                 {!loading && !error && (
//                     <>
//                         {filteredAssets.length > 0 ? (
//                             <div className="table-scroll-container">
//                                 <table className="data-table wide-table">
//                                     <thead>
//                                         <tr><th>ID</th><th>Asset Name</th><th>Asset Type</th><th>Capacity (MT)</th><th>Year of Purchase</th><th>Year of Manufacture</th><th>WO No</th><th>WO Start</th><th>WO End</th></tr>
//                                     </thead>
//                                     <tbody>
//                                         {filteredAssets.map(asset => {
//                                             const combinedAssetName = [asset.name, asset.serial_number, asset.asset_code, asset.registration_number].filter(Boolean).join(' | ');
//                                             return (
//                                                 <tr key={asset.id}>
//                                                     <td>{formatData(asset.id)}</td>
//                                                     <td>{combinedAssetName || 'N/A'}</td>
//                                                     <td>{formatData(asset.asset_type)}</td>
//                                                     <td>{formatData(asset.capacity_mt)}</td>
//                                                     <td>{formatData(asset.year_of_purchase)}</td>
//                                                     <td>{formatData(asset.year_of_manufacture)}</td>
//                                                     <td>{formatData(asset.wo_no)}</td>
//                                                     <td>{formatData(asset.wo_start)}</td>
//                                                     <td>{formatData(asset.wo_end)}</td>
//                                                 </tr>
//                                             );
//                                         })}
//                                     </tbody>
//                                 </table>
//                             </div>
//                         ) : (<p className="no-data-message">{filterDays !== null ? "No assets match the current availability filter." : "No active assets found."}</p>)}
//                     </>
//                 )}
//             </div>
//         </div>
//     );
// };
 
// // ====================================================================
// // --- Component for the Work Orders Tab Content ---
// // ====================================================================
// const WorkOrderDashboardContent = ({
//     loading, error, statusPieChartData, sectorBarChartData,
//     topCustomersData, filteredWorkOrders, filters, onChartClick, onClearFilters, apiToken
// }) => {
//     const statusChartRef = useRef();
//     const sectorChartRef = useRef();
//     const customerChartRef = useRef();
 
//     const handleChartClick = (filterType, chartData, event, chartRef) => {
//         if (!chartRef.current) return;
//         const elements = getElementAtEvent(chartRef.current, event);
//         if (elements.length > 0) {
//             const clickedLabel = chartData.labels[elements[0].index];
//             onChartClick(filterType, clickedLabel);
//         }
//     };
 
//     const hasFilters = Object.keys(filters).length > 0;
   
//     if (loading) return <div className="loading-error-container"><h2>Loading Dashboard...</h2></div>;
//     if (error) return <div className="loading-error-container"><h2>Dashboard Error</h2><p>{error}</p></div>;
 
//     return (
//         <main className="main-content">
//              <div className="dashboard-title-bar">
//                 <h1 className="dashboard-header">Work Orders Dashboard</h1>
//                 {hasFilters && (<button onClick={onClearFilters} className="clear-filters-btn">Clear Filters</button>)}
//             </div>
//             <div className="dashboard-grid">
//                 <div className="chart-card">
//                     <h3>Work Orders by Status</h3>
//                     <Pie ref={statusChartRef} data={statusPieChartData} options={{ responsive: true, plugins: { legend: { position: 'top' }, datalabels: { color: '#343a40', font: { weight: 'bold', size: 16 }, formatter: (value) => (value > 0 ? value : null) } } }} onClick={(event) => handleChartClick('status', statusPieChartData, event, statusChartRef)}/>
//                 </div>
//                 <div className="chart-card">
//                     <h3>Work Orders by Sector</h3>
//                     <Bar ref={sectorChartRef} data={sectorBarChartData} options={{ responsive: true, scales: { y: { beginAtZero: true } } }} onClick={(event) => handleChartClick('sector', sectorBarChartData, event, sectorChartRef)}/>
//                 </div>
//                 <div className="chart-card">
//                     <h3>Top Customers by Order Value</h3>
//                      <Bar ref={customerChartRef} data={topCustomersData} options={{ responsive: true, scales: { y: { beginAtZero: true } } }} onClick={(event) => handleChartClick('customer', topCustomersData, event, customerChartRef)}/>
//                 </div>
//                 <div className="chart-card table-card">
//                     <FilteredWorkOrderTable workOrders={filteredWorkOrders} apiToken={apiToken} />
//                 </div>
//                 <div className="chart-card table-card">
//                      <AssetAvailabilityTable workOrders={filteredWorkOrders} apiToken={apiToken} />
//                 </div>
//             </div>
//         </main>
//     );
// };

// // ====================================================================
// // --- Component for Invoice Data Table ---
// // ====================================================================
// const InvoiceDataTable = ({ invoices, workOrderMap, customerMap, userMap }) => {
//     // Columns definition
//     const columns = useMemo(() => [
//         { header: 'ID', key: 'id' }, { header: 'Doc No', key: 'doc_no' },
//         { header: 'Customer Name', key: 'customer_name' }, { header: 'Customer ID', key: 'cust_id' },
//         { header: 'Work Order ID', key: 'wo_id' }, { header: 'Work Order No', key: 'wo_no' },
//         { header: 'Work Order Date', key: 'wo_date' }, { header: 'Project ID', key: 'project_id' },
//         { header: 'Project Name', key: 'project_name' }, { header: 'Invoice Date', key: 'inv_date' },
//         { header: 'Due Date', key: 'due_date' }, { header: 'Start Date', key: 'start_date' },
//         { header: 'End Date', key: 'end_date' }, { header: 'Credit Period', key: 'cr_period' },
//         { header: 'Taxable Amount', key: 'taxable_amt' }, // FIX 1: Header name updated
//         { header: 'CGST', key: 'tot_cgst' }, { header: 'SGST', key: 'tot_sgst' },
//         { header: 'IGST', key: 'tot_igst' }, { header: 'Total Amount', key: 'amount' },
//         { header: 'Approval Status', key: 'inv_approval_status' }, { header: 'Current Status', key: 'current_status' },
//         { header: 'Created By', key: 'added_by' },
//         { header: 'Created Date', key: 'add_date' }, { header: 'Updated By', key: 'updated_by' },
//         { header: 'Updated Date', key: 'update_date' },
//     ], []);

//     // Centralized data formatting function
//     const formatData = (value, key) => {
//         const currencyKeys = ['taxable_amt', 'amount', 'tot_cgst', 'tot_sgst', 'tot_igst'];

//         // Handle currency columns
//         if (currencyKeys.includes(key)) {
//             const numberValue = parseFloat(value ?? 0);
//             // FIX 3: Removed currency style to get rid of Rupee symbol
//             return numberValue.toLocaleString('en-IN', {
//                 minimumFractionDigits: 2,
//                 maximumFractionDigits: 2,
//             });
//         }

//         // Handle credit period
//         if (key === 'cr_period') {
//             return value ?? 0;
//         }

//         // Handle general null/undefined/empty case for all other columns
//         if (value === null || typeof value === 'undefined' || value === '') {
//             return '-';
//         }

//         // Handle date/datetime formatting
//         if (key === 'add_date' || key === 'update_date') {
//             const date = new Date(value);
//             return !isNaN(date) ? date.toLocaleString('en-GB') : '-';
//         }

//         if (typeof value === 'string' && (key.includes('date') || key.includes('Date'))) {
//             const date = new Date(value);
//             return !isNaN(date) ? date.toLocaleDateString('en-GB') : '-';
//         }

//         return value;
//     };
    
//     // Sort invoices once by date
//     const sortedInvoices = useMemo(() => {
//         if (!Array.isArray(invoices)) return [];
//         return [...invoices].sort((a, b) => new Date(b.inv_date || b.add_date) - new Date(a.inv_date || a.add_date));
//     }, [invoices]);

//     if (sortedInvoices.length === 0) {
//         return (
//             <div className="filtered-table-container">
//                  <p className="no-data-message" style={{ padding: '20px' }}>No invoice data matching the current filter.</p>
//             </div>
//         )
//     }

//     return (
//         <div className="filtered-table-container">
//             <div className="table-content-wrapper">
//                 <div className="table-scroll-container">
//                     <table className="data-table wide-table">
//                         <thead>
//                             <tr>{columns.map(col => <th key={col.key}>{col.header}</th>)}</tr>
//                         </thead>
//                         <tbody>
//                             {sortedInvoices.map((invoice) => {
//                                 const relatedWorkOrder = workOrderMap.get(invoice.wo_id) || {};
//                                 return (
//                                     <tr key={invoice.id}>
//                                         {columns.map(col => {
//                                             let rawValue;
//                                             switch(col.key) {
//                                                 case 'customer_name':
//                                                     rawValue = customerMap.get(invoice.cust_id);
//                                                     break;
//                                                 case 'added_by':
//                                                     rawValue = userMap.get(String(invoice.added_by)) ?? invoice.added_by;
//                                                     break;
//                                                 case 'updated_by':
//                                                     rawValue = userMap.get(String(invoice.updated_by)) ?? invoice.updated_by;
//                                                     break;
//                                                 case 'project_id': case 'project_name': case 'wo_no': case 'wo_date':
//                                                     rawValue = relatedWorkOrder[col.key];
//                                                     break;
//                                                 default:
//                                                     rawValue = invoice[col.key];
//                                             }
                                            
//                                             const cellValue = formatData(rawValue, col.key);
//                                             // FIX 2: Added 'cr_period' to the list of right-aligned columns
//                                             const rightAlignKeys = ['taxable_amt', 'amount', 'tot_cgst', 'tot_sgst', 'tot_igst', 'cr_period'];
//                                             const shouldRightAlign = rightAlignKeys.includes(col.key);
                                            
//                                             return <td key={col.key} style={{ textAlign: shouldRightAlign ? 'right' : 'left' }}>{cellValue}</td>;
//                                         })}
//                                     </tr>
//                                 );
//                             })}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         </div>
//     );
// };
 
// // ====================================================================
// // --- Component for the Invoices Tab (UPDATED with new filters) ---
// // ====================================================================
// const InvoiceDashboardContent = ({ invoices, workOrders, loading, error, customerMap, userMap }) => {
//     const today = new Date();
//     const thirtyDaysAgo = new Date(new Date().setDate(today.getDate() - 30));
//     const formatDateForInput = (date) => date.toISOString().split('T')[0];
   
//     const [startDate, setStartDate] = useState(formatDateForInput(thirtyDaysAgo));
//     const [endDate, setEndDate] = useState(formatDateForInput(today));
//     const [selectedStatusFilter, setSelectedStatusFilter] = useState(null);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [dateFilterType, setDateFilterType] = useState('invoiceDate'); // 'invoiceDate' or 'invoicePeriod'
//     const tableRef = useRef(null);
//     const statusPieChartRef = useRef(null);

//     // Memoize the work order map for efficiency
//     const workOrderMap = useMemo(() => {
//         const map = new Map();
//         if (Array.isArray(workOrders)) {
//             workOrders.forEach(wo => {
//                 if (wo.wo_id && !map.has(wo.wo_id)) {
//                     map.set(wo.wo_id, wo);
//                 }
//             });
//         }
//         return map;
//     }, [workOrders]);
    
//     // 1. Filter invoices based on the selected date range and filter type
//     const dateFilteredInvoices = useMemo(() => {
//         if (!Array.isArray(invoices) || !startDate || !endDate) return [];
        
//         const rangeStart = new Date(startDate);
//         rangeStart.setHours(0, 0, 0, 0); // Set to start of the day for accurate comparison
//         const rangeEnd = new Date(endDate);
//         rangeEnd.setHours(23, 59, 59, 999); // Set to end of the day

//         return invoices.filter(inv => {
//             if (dateFilterType === 'invoiceDate') {
//                 const invoiceDate = new Date(inv.inv_date || inv.add_date);
//                 return !isNaN(invoiceDate) && invoiceDate >= rangeStart && invoiceDate <= rangeEnd;
//             } else { // 'invoicePeriod'
//                 if (!inv.start_date || !inv.end_date) return false;
                
//                 const periodStart = new Date(inv.start_date);
//                 const periodEnd = new Date(inv.end_date);
                
//                 if (isNaN(periodStart.getTime()) || isNaN(periodEnd.getTime())) return false;
                
//                 // Check if the invoice's period is completely within the user-selected range
//                 return periodStart >= rangeStart && periodEnd <= rangeEnd;
//             }
//         });
//     }, [invoices, startDate, endDate, dateFilterType]); // Dependency array includes the new filter type state
 
//     // This data is used for the charts and KPIs, based on the date-filtered data
//     const dashboardData = useMemo(() => {
//         const EMPTY_CHART_DATA = { labels: [], datasets: [{ data: [] }] };
//         const baseKpis = { totalInvoices: 0, totalTaxable: 0, totalGst: 0, avgCreditPeriod: 0 };

//         if (dateFilteredInvoices.length === 0) {
//             return { kpis: baseKpis, customerData: EMPTY_CHART_DATA, statusPieData: EMPTY_CHART_DATA };
//         }
 
//         const statusCountsForPie = dateFilteredInvoices.reduce((acc, inv) => {
//             const status = inv.current_status || 'Unknown';
//             acc[status] = (acc[status] || 0) + 1;
//             return acc;
//         }, {});

//         // Sort labels alphabetically for the pie chart
//         const sortedStatusLabels = Object.keys(statusCountsForPie).sort();
        
//         const statusPieData = {
//             labels: sortedStatusLabels,
//             datasets: [{ 
//                 data: sortedStatusLabels.map(label => statusCountsForPie[label]), // Map data in sorted order
//                 backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#F7464A'], 
//                 borderColor: '#fff', 
//                 borderWidth: 2 
//             }]
//         };
        
//         const customerAggregates = dateFilteredInvoices.reduce((acc, inv) => {
//             const customerName = customerMap.get(inv.cust_id) || `Customer ID: ${inv.cust_id}`;
//             acc[customerName] = (acc[customerName] || 0) + (Number(inv.amount) || 0);
//             return acc;
//         }, {});
        
//         const sortedCustomers = Object.entries(customerAggregates)
//             .filter(([, amount]) => amount > 0)
//             .sort(([,a], [,b]) => b - a)
//             .slice(0, 10);
//         const customerData = { 
//             labels: sortedCustomers.map(([name]) => name), 
//             datasets: [{ label: 'Total Invoice Amount', data: sortedCustomers.map(([, amount]) => amount), backgroundColor: 'rgba(153, 102, 255, 0.6)' }] 
//         };
       
//         return {
//             kpis: {
//                 totalInvoices: dateFilteredInvoices.length,
//                 totalTaxable: dateFilteredInvoices.reduce((sum, inv) => sum + (Number(inv.taxable_amt) || 0), 0),
//                 totalGst: dateFilteredInvoices.reduce((sum, inv) => sum + (Number(inv.tot_cgst) || 0) + (Number(inv.tot_sgst) || 0) + (Number(inv.tot_igst) || 0), 0),
//                 avgCreditPeriod: (dateFilteredInvoices.map(inv => Number(inv.cr_period)).filter(p => p > 0).reduce((a, b, _, arr) => a + b / arr.length, 0)).toFixed(2) || 0
//             },
//             customerData, statusPieData
//         };
//     }, [dateFilteredInvoices, customerMap]);
    
//     // 2. Further filter by status from pie chart click
//     const statusFilteredInvoices = useMemo(() => {
//         if (!selectedStatusFilter) return dateFilteredInvoices;
//         return dateFilteredInvoices.filter(invoice => invoice.current_status === selectedStatusFilter);
//     }, [dateFilteredInvoices, selectedStatusFilter]);

//     // 3. Final filter by search term on top of date and status filters
//     const finalFilteredInvoices = useMemo(() => {
//         if (!searchTerm.trim()) return statusFilteredInvoices;
//         const lowercasedFilter = searchTerm.toLowerCase();
//         return statusFilteredInvoices.filter(invoice => {
//             const workOrder = workOrderMap.get(invoice.wo_id) || {};
//             const searchableFields = [
//                 invoice.id, invoice.doc_no, invoice.cust_id, customerMap.get(invoice.cust_id),
//                 invoice.wo_id, workOrder.wo_no, workOrder.project_id, workOrder.project_name,
//                 invoice.inv_approval_status, invoice.current_status,
//                 userMap.get(String(invoice.added_by)), userMap.get(String(invoice.updated_by))
//             ];
//             return searchableFields.some(field => field && String(field).toLowerCase().includes(lowercasedFilter));
//         });
//     }, [statusFilteredInvoices, searchTerm, workOrderMap, customerMap, userMap]);

//     const handleStatusPieClick = (event) => {
//         if (!statusPieChartRef.current) return;
//         const elements = getElementAtEvent(statusPieChartRef.current, event);
//         if (elements.length > 0) {
//             const clickedStatus = dashboardData.statusPieData.labels[elements[0].index];
//             setSelectedStatusFilter(prev => prev === clickedStatus ? null : clickedStatus);
//             setTimeout(() => tableRef.current?.scrollIntoView({ behavior: 'smooth' }), 100);
//         } else {
//             setSelectedStatusFilter(null);
//         }
//     };
    
//     // --- CSV Export Logic ---
//     const convertToCSVAndDownload = (dataToExport, filename) => {
//         if (dataToExport.length === 0) {
//             alert("No data available to export.");
//             return;
//         }

//         const columns = [
//             { header: 'ID', key: 'id' }, { header: 'Doc No', key: 'doc_no' }, { header: 'Customer Name', key: 'customer_name' },
//             { header: 'Customer ID', key: 'cust_id' }, { header: 'Work Order ID', key: 'wo_id' }, { header: 'Work Order No', key: 'wo_no' },
//             { header: 'Work Order Date', key: 'wo_date' }, { header: 'Project Name', key: 'project_name' }, { header: 'Invoice Date', key: 'inv_date' },
//             { header: 'Due Date', key: 'due_date' }, { header: 'Total Amount', key: 'amount' }, { header: 'Current Status', key: 'current_status' },
//             { header: 'Created By', key: 'added_by' }, { header: 'Created Date', key: 'add_date' }, { header: 'Updated By', key: 'updated_by' },
//             { header: 'Updated Date', key: 'update_date' },
//         ];

//         const replacer = (key, value) => value === null ? '' : value;
//         const header = columns.map(c => c.header).join(',');
//         const rows = dataToExport.map(invoice => {
//             const relatedWorkOrder = workOrderMap.get(invoice.wo_id) || {};
//             return columns.map(col => {
//                 let cellData;
//                 switch (col.key) {
//                     case 'customer_name': cellData = customerMap.get(invoice.cust_id) || 'N/A'; break;
//                     case 'added_by': cellData = userMap.get(String(invoice.added_by)) || invoice.added_by || 'N/A'; break;
//                     case 'updated_by': cellData = userMap.get(String(invoice.updated_by)) || invoice.updated_by || 'N/A'; break;
//                     case 'wo_no': case 'wo_date': case 'project_name': cellData = relatedWorkOrder[col.key]; break;
//                     default: cellData = invoice[col.key];
//                 }
//                 const stringValue = JSON.stringify(replacer(col.key, cellData), replacer);
//                 return stringValue.replace(/"/g, '""').replace(/^""|""$/g, '"');
//             }).join(',');
//         });

//         const csv = [header, ...rows].join('\n');
//         const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
//         const link = document.createElement("a");
//         const url = URL.createObjectURL(blob);
//         link.setAttribute("href", url);
//         link.setAttribute("download", `${filename}.csv`);
//         link.style.visibility = 'hidden';
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//     };

//     const handleExportAll = () => convertToCSVAndDownload(statusFilteredInvoices, 'all_invoices_export');
//     const handleExportByFilter = () => convertToCSVAndDownload(finalFilteredInvoices, 'filtered_invoices_export');

//     if (loading) return <div className="loading-error-container"><h2>Loading Invoice Dashboard...</h2></div>;
//     if (error) return <div className="loading-error-container"><h2>Dashboard Error</h2><p>{error}</p></div>;
 
//     const formatCurrency = (value) => new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(value);
//     const pieOptions = { responsive: true, plugins: { legend: { position: 'bottom' }, datalabels: { color: '#fff', font: { weight: 'bold' }, formatter: (value) => (value > 0 ? value : '') } } };
 
//     return (
//         <main className="main-content">
//             <div className="filter-bar">
//                 <div className="filter-group">
//                     <div className="filter-item">
//                         <input type="radio" id="invoiceDate" name="dateFilterType" value="invoiceDate" checked={dateFilterType === 'invoiceDate'} onChange={(e) => setDateFilterType(e.target.value)} />
//                         <label htmlFor="invoiceDate">Invoice Date</label>
//                     </div>
//                     <div className="filter-item">
//                         <input type="radio" id="invoicePeriod" name="dateFilterType" value="invoicePeriod" checked={dateFilterType === 'invoicePeriod'} onChange={(e) => setDateFilterType(e.target.value)} />
//                         <label htmlFor="invoicePeriod">Invoice Period</label>
//                     </div>
//                 </div>
//                 <div className="filter-item"><label htmlFor="start-date">Start Date:</label><input type="date" id="start-date" value={startDate} onChange={(e) => setStartDate(e.target.value)} /></div>
//                 <div className="filter-item"><label htmlFor="end-date">End Date:</label><input type="date" id="end-date" value={endDate} onChange={(e) => setEndDate(e.target.value)} /></div>
//             </div>
           
//             <div className="kpi-grid">
//                 <div className="kpi-card"><h4>Total Invoices</h4><p>{dashboardData.kpis.totalInvoices}</p></div>
//                 <div className="kpi-card"><h4>Total Taxable Amount</h4><p>{formatCurrency(dashboardData.kpis.totalTaxable)}</p></div>
//                 <div className="kpi-card"><h4>Total GST Collected</h4><p>{formatCurrency(dashboardData.kpis.totalGst)}</p></div>
//                 <div className="kpi-card"><h4>Avg. Credit Period</h4><p>{dashboardData.kpis.avgCreditPeriod} Days</p></div>
//             </div>
           
//             <div className="dashboard-grid">
//                 <div className="chart-card large-card">
//                   <h3>Customer Wise Invoices (Top 10 by Amount)</h3>
//                     {dateFilteredInvoices.length > 0 && dashboardData.customerData.labels.length > 0 ? (
//                         <Bar data={dashboardData.customerData} options={{ responsive: true, scales: { y: { beginAtZero: true } } }} />
//                     ) : (
//                         <p className="no-data-message">No customer invoice data with positive amounts for selected date range.</p>
//                     )}
//                 </div>
//                 <div className="chart-card">
//                   <h3>Invoices by Status</h3>
//                    {dateFilteredInvoices.length > 0 ? (
//                         <Pie ref={statusPieChartRef} data={dashboardData.statusPieData} options={pieOptions} onClick={handleStatusPieClick} />
//                     ) : (
//                         <p className="no-data-message">No data available.</p>
//                     )}
//                 </div>
//             </div>

//             <div ref={tableRef} className="invoice-table-section" style={{ marginTop: '2rem' }}>
//                 <div className="table-header with-controls">
//                     <h3>All Invoices {selectedStatusFilter && `(Status: ${selectedStatusFilter})`} {searchTerm && `(Filtered)`}</h3>
//                     <div className="table-actions">
//                         {selectedStatusFilter && (<button onClick={() => setSelectedStatusFilter(null)} className="clear-filters-btn small">Clear Status Filter</button>)}
//                         <input type="text" placeholder="Search invoices..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} className="search-bar" />
//                         <button onClick={handleExportByFilter} className="export-btn">Export by Filter</button>
//                         <button onClick={handleExportAll} className="export-btn">Export All</button>
//                     </div>
//                 </div>
//                 <InvoiceDataTable invoices={finalFilteredInvoices} workOrderMap={workOrderMap} customerMap={customerMap} userMap={userMap} />
//             </div>
//         </main>
//     );
// };
 
// // ====================================================================
// // --- Main Dashboard Component ---
// // ====================================================================
// const Dashboard = () => {
//     const [activeTab, setActiveTab] = useState('workOrder');
//     const [workOrderTableReport, setWorkOrderTableReport] = useState({ columns: [], data: [] });
//     const [invoices, setInvoices] = useState([]);
//     const [customers, setCustomers] = useState([]);
//     const [users, setUsers] = useState([]); 
//     const [filters, setFilters] = useState({});
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
 
//     const API_TOKEN = 'Bearer ' + localStorage.getItem('zTaskAuthToken');
 
//     const handleApiResponse = async (response) => {
//         if (!response.ok) {
//             const errorText = await response.text();
//             throw new Error(`API call to ${response.url} failed with status ${response.status}: ${response.statusText}. Response: ${errorText.substring(0, 200)}`);
//         }
//         return response.json();
//     };
 
//     useEffect(() => {
//         const fetchAllData = async () => {
//             setLoading(true);
//             setError(null);
 
//             const REPORT_API_URL = `${process.env.REACT_APP_REPORTS_API_URL}/api/reports/run`;
//             const INVOICE_API_URL = `${process.env.REACT_APP_NODE_SERVICE_BASE_URL}/invoice/api/invoices/`;
//             const CUSTOMER_API_URL = `${process.env.REACT_APP_NODE_SERVICE_BASE_URL}/api/get-column/customers/name`;
//             const USER_API_URL = `${process.env.REACT_APP_NODE_SERVICE_BASE_URL}/api/get-column/users/name`; 
 
//             const HEADERS = { 'accept': 'application/json', 'Authorization': API_TOKEN };
//             const TABLE_REPORT_BODY = { "report_name": "work_order_table", "module_name": "Workorder" };
           
//             try {
//                 const [tableReportJson, invoiceJson, customersJson, usersJson] = await Promise.all([
//                     fetch(REPORT_API_URL, { method: 'POST', headers: { ...HEADERS, 'Content-Type': 'application/json' }, body: JSON.stringify(TABLE_REPORT_BODY) }).then(handleApiResponse),
//                     fetch(INVOICE_API_URL, { headers: HEADERS }).then(handleApiResponse),
//                     fetch(CUSTOMER_API_URL, { headers: HEADERS }).then(handleApiResponse),
//                     fetch(USER_API_URL, { headers: HEADERS }).then(handleApiResponse)
//                 ]);
               
//                 setWorkOrderTableReport(tableReportJson && tableReportJson.columns && tableReportJson.data ? tableReportJson : { columns: [], data: [] });
//                 setInvoices(Array.isArray(invoiceJson) ? invoiceJson : []);
//                 setCustomers(Array.isArray(customersJson) ? customersJson : []);
//                 setUsers(Array.isArray(usersJson) ? usersJson : []);

//             } catch (e) {
//                 console.error("Failed to fetch dashboard data:", e);
//                 setError(e.message);
//             } finally {
//                 setLoading(false);
//             }
//         };
//         fetchAllData();
//     }, []);
 
//     const handleChartClick = (filterType, clickedLabel) => setFilters(prev => ({ ...prev, [filterType]: clickedLabel }));
//     const clearFilters = () => setFilters({});
   
//     const customerMap = useMemo(() => {
//         const map = new Map();
//         customers.forEach(customer => map.set(customer.id, customer.value));
//         return map;
//     }, [customers]);

//     const userMap = useMemo(() => {
//         const map = new Map();
//         users.forEach(user => map.set(user.id, user.value));
//         return map;
//     }, [users]);

//     const uniqueWorkOrders = useMemo(() => {
//         if (!Array.isArray(workOrderTableReport.data)) return [];
//         const uniqueWoMap = new Map();
//         workOrderTableReport.data.forEach(order => {
//             if (order.wo_id && !uniqueWoMap.has(order.wo_id)) {
//                 uniqueWoMap.set(order.wo_id, { ...order, tot_value: parseFloat(order.tot_value) || 0 });
//             }
//         });
//         return Array.from(uniqueWoMap.values());
//     }, [workOrderTableReport.data]);
 
//     const statusPieChartData = useMemo(() => {
//         const statusCounts = uniqueWorkOrders.reduce((acc, order) => {
//             acc[order.wo_open_close || 'Unknown'] = (acc[order.wo_open_close || 'Unknown'] || 0) + 1;
//             return acc;
//         }, { 'Open': 0, 'Closed': 0 });
//         return { labels: Object.keys(statusCounts), datasets: [{ data: Object.values(statusCounts), backgroundColor: ['#ff8a80', '#80d8ff'], borderColor: '#ffffff', borderWidth: 3 }] };
//     }, [uniqueWorkOrders]);
 
//     const sectorBarChartData = useMemo(() => {
//         const sectorData = uniqueWorkOrders.reduce((acc, wo) => {
//             const sectorName = wo.sector_name || 'Unknown Sector';
//             acc[sectorName] = acc[sectorName] || { count: 0, totalValue: 0 };
//             acc[sectorName].count++;
//             acc[sectorName].totalValue += wo.tot_value;
//             return acc;
//         }, {});
//         const labels = Object.keys(sectorData).sort();
//         return { labels, datasets: [
//             { label: 'Number of Orders', data: labels.map(l => sectorData[l].count), backgroundColor: 'rgba(255, 159, 64, 0.8)' },
//             { label: 'Total Value', data: labels.map(l => sectorData[l].totalValue), backgroundColor: 'rgba(75, 192, 192, 0.8)' }
//         ] };
//     }, [uniqueWorkOrders]);
   
//     const topCustomersData = useMemo(() => {
//         const customerAggregates = uniqueWorkOrders.reduce((acc, wo) => {
//             acc[wo.customer_name || 'Unknown Customer'] = (acc[wo.customer_name || 'Unknown Customer'] || 0) + wo.tot_value;
//             return acc;
//         }, {});
//         const sortedCustomers = Object.entries(customerAggregates).sort(([, a], [, b]) => b - a).slice(0, 5);
//         return { labels: sortedCustomers.map(([label]) => label), datasets: [{ label: 'Total Order Value', data: sortedCustomers.map(([, value]) => value), backgroundColor: 'rgba(54, 162, 235, 0.8)' }] };
//     }, [uniqueWorkOrders]);
 
//     const filteredWorkOrders = useMemo(() => {
//         if (Object.keys(filters).length === 0) return workOrderTableReport.data || [];
//         const woIdsToKeep = new Set(uniqueWorkOrders
//             .filter(wo => (!filters.status || wo.wo_open_close === filters.status) && (!filters.sector || wo.sector_name === filters.sector) && (!filters.customer || wo.customer_name === filters.customer))
//             .map(wo => wo.wo_id)
//         );
//         return (workOrderTableReport.data || []).filter(order => woIdsToKeep.has(order.wo_id));
//     }, [workOrderTableReport.data, uniqueWorkOrders, filters]);
 
//     return (
//         <div className="dashboard-container">
//             <div className="tabs-container">
//                 <button className={`tab-button ${activeTab === 'workOrder' ? 'active' : ''}`} onClick={() => setActiveTab('workOrder')}>Work Orders</button>
//                 <button className={`tab-button ${activeTab === 'invoice' ? 'active' : ''}`} onClick={() => setActiveTab('invoice')}>Invoices</button>
//             </div>
//             <div className="tab-content">
//                 {activeTab === 'workOrder' && (
//                     <WorkOrderDashboardContent
//                         loading={loading} error={error} statusPieChartData={statusPieChartData}
//                         sectorBarChartData={sectorBarChartData}
//                         topCustomersData={topCustomersData} filteredWorkOrders={filteredWorkOrders}
//                         filters={filters} onChartClick={handleChartClick} onClearFilters={clearFilters}
//                         apiToken={API_TOKEN}
//                     />
//                 )}
//                 {activeTab === 'invoice' && (
//                     <InvoiceDashboardContent 
//                         invoices={invoices} 
//                         workOrders={workOrderTableReport.data}
//                         loading={loading} 
//                         error={error}
//                         customerMap={customerMap}
//                         userMap={userMap}
//                     />
//                 )}
//             </div>
//         </div>
//     );
// };
 
// export default Dashboard;














// import React, { useState, useEffect, useMemo, useRef } from 'react';
// import { Pie, Bar, getElementAtEvent } from 'react-chartjs-2';
// import {
//     Chart as ChartJS,
//     CategoryScale,
//     LinearScale,
//     BarElement,
//     Title,
//     Tooltip,
//     Legend,
//     ArcElement
// } from 'chart.js';
// import ChartDataLabels from 'chartjs-plugin-datalabels';
// import './Dashboard.css';
 
// ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement, ChartDataLabels);

// // --- Cache Configuration ---
// const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes in milliseconds
// const CACHE_KEYS = {
//   WORK_ORDERS: 'work_orders_cache',
//   INVOICES: 'invoices_cache',
//   CUSTOMERS: 'customers_cache',
//   USERS: 'users_cache',
//   ASSETS: 'assets_cache'
// };

// // --- In-Memory Cache Implementation ---
// const cache = {
//   data: {},
  
//   set(key, value) {
//     this.data[key] = {
//       value,
//       timestamp: Date.now()
//     };
//   },
  
//   get(key) {
//     const cached = this.data[key];
//     if (!cached) return null;
    
//     const isExpired = (Date.now() - cached.timestamp) > CACHE_DURATION;
//     if (isExpired) {
//       delete this.data[key];
//       return null;
//     }
    
//     return cached.value;
//   },
  
//   clear(key) {
//     if (key) {
//       delete this.data[key];
//     } else {
//       this.data = {};
//     }
//   },
  
//   clearAll() {
//     this.data = {};
//   }
// };
 
// // ====================================================================
// // --- Component for Work Order Table ---
// // ====================================================================
// const FilteredWorkOrderTable = ({ workOrders, apiToken }) => {
//     const [activeTab, setActiveTab] = useState('assets');
//     const [assets, setAssets] = useState([]);
//     const [assetsLoading, setAssetsLoading] = useState(false);
//     const [assetsError, setAssetsError] = useState(null);
 
//     useEffect(() => {
//         const fetchAssets = async () => {
//             if (!workOrders || workOrders.length === 0) {
//                 setAssets([]);
//                 return;
//             }
//             const assetIdSet = new Set(workOrders.map(wo => wo.asset_id).filter(id => id != null));
//             const assetIds = Array.from(assetIdSet);
//             if (assetIds.length === 0) {
//                 setAssets([]);
//                 return;
//             }
           
//             // Check cache first
//             const cacheKey = `${CACHE_KEYS.ASSETS}_${assetIds.sort().join('_')}`;
//             const cached = cache.get(cacheKey);
//             if (cached) {
//                 console.log('Using cached assets data for work orders');
//                 setAssets(cached);
//                 return;
//             }

//             setAssetsLoading(true);
//             setAssetsError(null);
           
//             const ASSET_API_URL = `${process.env.REACT_APP_ASSET_SERVICE_BASE_URL}/api/assets/`;
//             const ASSET_HEADERS = { 'accept': 'application/json', 'Authorization': apiToken };
 
//             try {
//                 const assetPromises = assetIds.map(id =>
//                     fetch(`${ASSET_API_URL}${id}`, { headers: ASSET_HEADERS }).then(res => {
//                         if (!res.ok) {
//                             console.error(`Failed to fetch asset ${id}, status: ${res.status}`);
//                             return null;
//                         }
//                         return res.json();
//                     })
//                 );
//                 const fetchedAssetsResults = await Promise.all(assetPromises);
//                 const validAssets = fetchedAssetsResults.filter(asset => asset !== null);
                
//                 // Cache the fetched assets
//                 cache.set(cacheKey, validAssets);
//                 setAssets(validAssets);
//             } catch (error) {
//                 console.error("Failed to fetch assets:", error);
//                 setAssetsError(error.message);
//             } finally {
//                 setAssetsLoading(false);
//             }
//         };
//         fetchAssets();
//     }, [workOrders, apiToken]);
 
//     const displayedWorkOrders = useMemo(() => {
//         if (!workOrders || !Array.isArray(workOrders)) return [];
//         return [...workOrders].sort((a, b) => new Date(b.add_date) - new Date(a.add_date));
//     }, [workOrders]);
 
//     const formatData = (value) => {
//         if (value === null || typeof value === 'undefined') return 'N/A';
//         if (typeof value === 'boolean') return value ? 'Yes' : 'No';
//         if (typeof value === 'string' && value.includes('T')) {
//             const date = new Date(value);
//             if (!isNaN(date)) return date.toLocaleDateString('en-GB');
//         }
//         return value;
//     };
 
//     const displayColumns = [
//         { header: 'Doc No', key: 'doc_no' }, { header: 'WO No', key: 'wo_no' },
//         { header: 'Status', key: 'wo_open_close' }, { header: 'Total Value', key: 'tot_value' },
//         { header: 'Customer Name', key: 'customer_name' }, { header: 'Customer ID', key: 'cust_id' },
//         { header: 'Project Name', key: 'project_name' }, { header: 'Project ID', key: 'project_id' },
//         { header: 'Sector Name', key: 'sector_name' }, { header: 'Sector ID', key: 'sector' },
//         { header: 'Asset ID', key: 'asset_id' }, { header: 'WO Date', key: 'wo_date' },
//         { header: 'WO Start', key: 'wo_start' }, { header: 'WO End', key: 'wo_end' },
//     ];
 
//     return (
//         <div className="filtered-table-container">
//             <div className="table-header"><h3>All Work Orders</h3></div>
//             <div className="table-controls">
//                 <div className="tabs">
//                     <button className={`tab-btn ${activeTab === 'assets' ? 'active' : ''}`} onClick={() => setActiveTab('assets')}>Assets</button>
//                     <button className={`tab-btn ${activeTab === 'workorder' ? 'active' : ''}`} onClick={() => setActiveTab('workorder')}>Workorder</button>
//                 </div>
//             </div>
//             <div className="table-content-wrapper">
//                 {activeTab === 'workorder' ? (
//                     <>
//                         {displayedWorkOrders.length > 0 ? (
//                             <div className="table-scroll-container">
//                                 <table className="data-table wide-table">
//                                     <thead><tr>{displayColumns.map(col => <th key={col.key}>{col.header}</th>)}</tr></thead>
//                                     <tbody>
//                                         {displayedWorkOrders.map((order, index) => (
//                                             <tr key={`${order.id}-${index}`}>
//                                                 {displayColumns.map(col => (
//                                                     <td key={col.key}>{col.key === 'tot_value' ? parseFloat(order[col.key] || 0).toLocaleString('en-US') : formatData(order[col.key])}</td>
//                                                 ))}
//                                             </tr>
//                                         ))}
//                                     </tbody>
//                                 </table>
//                             </div>
//                         ) : (<p className="no-data-message">No work orders found for the current filter.</p>)}
//                     </>
//                 ) : (
//                     <>
//                         {assetsLoading && <p className="loading-message">Loading Assets...</p>}
//                         {assetsError && <p className="error-message">Error: {assetsError}</p>}
//                         {!assetsLoading && !assetsError && (
//                             <>
//                                 {assets.length > 0 ? (
//                                     <div className="table-scroll-container">
//                                         <table className="data-table wide-table">
//                                             <thead>
//                                                 <tr><th>Asset Name</th><th>Asset Type</th><th>Capacity (MT)</th><th>Year of Purchase</th><th>Year of Manufacture</th></tr>
//                                             </thead>
//                                             <tbody>
//                                                 {assets.map(asset => {
//                                                     const combinedAssetName = [asset.name, asset.serial_number, asset.asset_code, asset.registration_number].filter(Boolean).join(' | ');
//                                                     return (
//                                                         <tr key={asset.id}>
//                                                             <td>{combinedAssetName || 'N/A'}</td>
//                                                             <td>{formatData(asset.asset_type)}</td>
//                                                             <td>{formatData(asset.capacity_mt)}</td>
//                                                             <td>{formatData(asset.year_of_purchase)}</td>
//                                                             <td>{formatData(asset.year_of_manufacture)}</td>
//                                                         </tr>
//                                                     );
//                                                 })}
//                                             </tbody>
//                                         </table>
//                                     </div>
//                                 ) : (<p className="no-data-message">No assets found for the current work orders.</p>)}
//                             </>
//                         )}
//                     </>
//                 )}
//             </div>
//         </div>
//     );
// };
 
// // ====================================================================
// // --- Component for Asset Availability Table ---
// // ====================================================================
// const AssetAvailabilityTable = ({ workOrders, apiToken }) => {
//     const [combinedAssets, setCombinedAssets] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);
//     const [filterDays, setFilterDays] = useState(null);
//     const [customDays, setCustomDays] = useState('');
 
//     useEffect(() => {
//         const fetchAndCombineData = async () => {
//             // Check cache first
//             const cached = cache.get(CACHE_KEYS.ASSETS);
//             if (cached && workOrders) {
//                 console.log('Using cached assets data for availability table');
//                 const workOrderInfoMap = new Map();
//                 if (Array.isArray(workOrders)) {
//                     workOrders.forEach(wo => {
//                         if (wo.asset_id != null) {
//                             workOrderInfoMap.set(Number(wo.asset_id), { wo_start: wo.wo_start, wo_end: wo.wo_end, wo_no: wo.wo_no });
//                         }
//                     });
//                 }
                
//                 const activeAssets = cached.filter(asset => asset.active === true);
//                 const combinedData = activeAssets.map(asset => {
//                     const workOrderInfo = workOrderInfoMap.get(asset.id) || { wo_start: null, wo_end: null, wo_no: null };
//                     return { ...asset, ...workOrderInfo };
//                 });
//                 setCombinedAssets(combinedData);
//                 return;
//             }

//             setLoading(true);
//             setError(null);
           
//             const workOrderInfoMap = new Map();
//             if (workOrders && Array.isArray(workOrders)) {
//                 workOrders.forEach(wo => {
//                     if (wo.asset_id != null) {
//                         workOrderInfoMap.set(Number(wo.asset_id), { wo_start: wo.wo_start, wo_end: wo.wo_end, wo_no: wo.wo_no });
//                     }
//                 });
//             }
           
//             const ASSET_API_URL = `${process.env.REACT_APP_ASSET_SERVICE_BASE_URL}/api/assets/`;
//             const ASSET_HEADERS = { 'accept': 'application/json', 'Authorization': apiToken };
 
//             try {
//                 const response = await fetch(ASSET_API_URL, { headers: ASSET_HEADERS });
//                 if (!response.ok) {
//                     throw new Error(`Failed to fetch assets, status: ${response.status}`);
//                 }
//                 const allAssets = await response.json();
                
//                 // Cache all assets
//                 cache.set(CACHE_KEYS.ASSETS, allAssets);
                
//                 const activeAssets = allAssets.filter(asset => asset.active === true);

//                 const combinedData = activeAssets.map(asset => {
//                     const workOrderInfo = workOrderInfoMap.get(asset.id) || { wo_start: null, wo_end: null, wo_no: null };
//                     return { ...asset, ...workOrderInfo };
//                 });
               
//                 setCombinedAssets(combinedData);
//             } catch (error) {
//                 console.error("Failed to fetch asset data:", error);
//                 setError(error.message);
//             } finally {
//                 setLoading(false);
//             }
//         };
 
//         fetchAndCombineData();
//     }, [workOrders, apiToken]);
 
//     const filteredAssets = useMemo(() => {
//         if (filterDays === null) return combinedAssets;
//         const targetDate = new Date();
//         targetDate.setDate(targetDate.getDate() + filterDays);
//         targetDate.setHours(23, 59, 59, 999);
//         return combinedAssets.filter(asset => {
//             if (!asset.wo_end) return true;
//             const woEndDate = new Date(asset.wo_end);
//             return isNaN(woEndDate.getTime()) || woEndDate <= targetDate;
//         });
//     }, [combinedAssets, filterDays]);
 
//     const formatData = (value) => {
//         if (value === null || typeof value === 'undefined') return 'N/A';
//         if (typeof value === 'boolean') return value ? 'Yes' : 'No';
//         if (typeof value === 'string' && value.includes('T')) {
//             const date = new Date(value);
//             if (!isNaN(date)) return date.toLocaleDateString('en-GB');
//         }
//         return value;
//     };
 
//     const handleCustomFilter = () => {
//         const days = parseInt(customDays, 10);
//         if (days > 0) setFilterDays(days);
//     };
 
//     const clearFilter = () => {
//         setFilterDays(null);
//         setCustomDays('');
//     };
 
//     return (
//         <div className="filtered-table-container">
//             <div className="table-header with-controls">
//                 <h3>Asset Availability</h3>
//                 <div className="availability-filter-controls">
//                     <span>Available In:</span>
//                     {[3, 7, 15, 30].map(days => (
//                         <button key={days} onClick={() => setFilterDays(days)} className={filterDays === days ? 'active' : ''}>{days} Days</button>
//                     ))}
//                     <div className="custom-filter">
//                         <input type="number" placeholder="Custom" value={customDays} onChange={(e) => setCustomDays(e.target.value)} min="1"/>
//                         <button onClick={handleCustomFilter}>Go</button>
//                     </div>
//                     <button onClick={clearFilter}>Clear Filter</button>
//                 </div>
//             </div>
//             <div className="table-content-wrapper">
//                 {loading && <p className="loading-message">Loading Assets...</p>}
//                 {error && <p className="error-message">Error: {error}</p>}
//                 {!loading && !error && (
//                     <>
//                         {filteredAssets.length > 0 ? (
//                             <div className="table-scroll-container">
//                                 <table className="data-table wide-table">
//                                     <thead>
//                                         <tr><th>ID</th><th>Asset Name</th><th>Asset Type</th><th>Capacity (MT)</th><th>Year of Purchase</th><th>Year of Manufacture</th><th>WO No</th><th>WO Start</th><th>WO End</th></tr>
//                                     </thead>
//                                     <tbody>
//                                         {filteredAssets.map(asset => {
//                                             const combinedAssetName = [asset.name, asset.serial_number, asset.asset_code, asset.registration_number].filter(Boolean).join(' | ');
//                                             return (
//                                                 <tr key={asset.id}>
//                                                     <td>{formatData(asset.id)}</td>
//                                                     <td>{combinedAssetName || 'N/A'}</td>
//                                                     <td>{formatData(asset.asset_type)}</td>
//                                                     <td>{formatData(asset.capacity_mt)}</td>
//                                                     <td>{formatData(asset.year_of_purchase)}</td>
//                                                     <td>{formatData(asset.year_of_manufacture)}</td>
//                                                     <td>{formatData(asset.wo_no)}</td>
//                                                     <td>{formatData(asset.wo_start)}</td>
//                                                     <td>{formatData(asset.wo_end)}</td>
//                                                 </tr>
//                                             );
//                                         })}
//                                     </tbody>
//                                 </table>
//                             </div>
//                         ) : (<p className="no-data-message">{filterDays !== null ? "No assets match the current availability filter." : "No active assets found."}</p>)}
//                     </>
//                 )}
//             </div>
//         </div>
//     );
// };
 
// // ====================================================================
// // --- Component for the Work Orders Tab Content ---
// // ====================================================================
// const WorkOrderDashboardContent = ({
//     loading, error, statusPieChartData, sectorBarChartData,
//     topCustomersData, filteredWorkOrders, filters, onChartClick, onClearFilters, apiToken
// }) => {
//     const statusChartRef = useRef();
//     const sectorChartRef = useRef();
//     const customerChartRef = useRef();
 
//     const handleChartClick = (filterType, chartData, event, chartRef) => {
//         if (!chartRef.current) return;
//         const elements = getElementAtEvent(chartRef.current, event);
//         if (elements.length > 0) {
//             const clickedLabel = chartData.labels[elements[0].index];
//             onChartClick(filterType, clickedLabel);
//         }
//     };
 
//     const hasFilters = Object.keys(filters).length > 0;
   
//     if (loading) return <div className="loading-error-container"><h2>Loading Dashboard...</h2></div>;
//     if (error) return <div className="loading-error-container"><h2>Dashboard Error</h2><p>{error}</p></div>;
 
//     return (
//         <main className="main-content">
//              <div className="dashboard-title-bar">
//                 <h1 className="dashboard-header">Work Orders Dashboard</h1>
//                 {hasFilters && (<button onClick={onClearFilters} className="clear-filters-btn">Clear Filters</button>)}
//             </div>
//             <div className="dashboard-grid">
//                 <div className="chart-card">
//                     <h3>Work Orders by Status</h3>
//                     <Pie ref={statusChartRef} data={statusPieChartData} options={{ responsive: true, plugins: { legend: { position: 'top' }, datalabels: { color: '#343a40', font: { weight: 'bold', size: 16 }, formatter: (value) => (value > 0 ? value : null) } } }} onClick={(event) => handleChartClick('status', statusPieChartData, event, statusChartRef)}/>
//                 </div>
//                 <div className="chart-card">
//                     <h3>Work Orders by Sector</h3>
//                     <Bar ref={sectorChartRef} data={sectorBarChartData} options={{ responsive: true, scales: { y: { beginAtZero: true } } }} onClick={(event) => handleChartClick('sector', sectorBarChartData, event, sectorChartRef)}/>
//                 </div>
//                 <div className="chart-card">
//                     <h3>Top Customers by Order Value</h3>
//                      <Bar ref={customerChartRef} data={topCustomersData} options={{ responsive: true, scales: { y: { beginAtZero: true } } }} onClick={(event) => handleChartClick('customer', topCustomersData, event, customerChartRef)}/>
//                 </div>
//                 <div className="chart-card table-card">
//                     <FilteredWorkOrderTable workOrders={filteredWorkOrders} apiToken={apiToken} />
//                 </div>
//                 <div className="chart-card table-card">
//                      <AssetAvailabilityTable workOrders={filteredWorkOrders} apiToken={apiToken} />
//                 </div>
//             </div>
//         </main>
//     );
// };

// // ====================================================================
// // --- Component for Invoice Data Table ---
// // ====================================================================
// const InvoiceDataTable = ({ invoices, workOrderMap, customerMap, userMap }) => {
//     // Columns definition
//     const columns = useMemo(() => [
//         { header: 'ID', key: 'id' }, { header: 'Doc No', key: 'doc_no' },
//         { header: 'Customer Name', key: 'customer_name' }, { header: 'Customer ID', key: 'cust_id' },
//         { header: 'Work Order ID', key: 'wo_id' }, { header: 'Work Order No', key: 'wo_no' },
//         { header: 'Work Order Date', key: 'wo_date' }, { header: 'Project ID', key: 'project_id' },
//         { header: 'Project Name', key: 'project_name' }, { header: 'Invoice Date', key: 'inv_date' },
//         { header: 'Due Date', key: 'due_date' }, { header: 'Start Date', key: 'start_date' },
//         { header: 'End Date', key: 'end_date' }, { header: 'Credit Period', key: 'cr_period' },
//         { header: 'Taxable Amount', key: 'taxable_amt' },
//         { header: 'CGST', key: 'tot_cgst' }, { header: 'SGST', key: 'tot_sgst' },
//         { header: 'IGST', key: 'tot_igst' }, { header: 'Total Amount', key: 'amount' },
//         { header: 'Approval Status', key: 'inv_approval_status' }, { header: 'Current Status', key: 'current_status' },
//         { header: 'Created By', key: 'added_by' },
//         { header: 'Created Date', key: 'add_date' }, { header: 'Updated By', key: 'updated_by' },
//         { header: 'Updated Date', key: 'update_date' },
//     ], []);

//     // Centralized data formatting function
//     const formatData = (value, key) => {
//         const currencyKeys = ['taxable_amt', 'amount', 'tot_cgst', 'tot_sgst', 'tot_igst'];

//         // Handle currency columns
//         if (currencyKeys.includes(key)) {
//             const numberValue = parseFloat(value ?? 0);
//             return numberValue.toLocaleString('en-IN', {
//                 minimumFractionDigits: 2,
//                 maximumFractionDigits: 2,
//             });
//         }

//         // Handle credit period
//         if (key === 'cr_period') {
//             return value ?? 0;
//         }

//         // Handle general null/undefined/empty case for all other columns
//         if (value === null || typeof value === 'undefined' || value === '') {
//             return '-';
//         }

//         // Handle date/datetime formatting
//         if (key === 'add_date' || key === 'update_date') {
//             const date = new Date(value);
//             return !isNaN(date) ? date.toLocaleString('en-GB') : '-';
//         }

//         if (typeof value === 'string' && (key.includes('date') || key.includes('Date'))) {
//             const date = new Date(value);
//             return !isNaN(date) ? date.toLocaleDateString('en-GB') : '-';
//         }

//         return value;
//     };
    
//     // Sort invoices once by date
//     const sortedInvoices = useMemo(() => {
//         if (!Array.isArray(invoices)) return [];
//         return [...invoices].sort((a, b) => new Date(b.inv_date || b.add_date) - new Date(a.inv_date || a.add_date));
//     }, [invoices]);

//     if (sortedInvoices.length === 0) {
//         return (
//             <div className="filtered-table-container">
//                  <p className="no-data-message" style={{ padding: '20px' }}>No invoice data matching the current filter.</p>
//             </div>
//         )
//     }

//     return (
//         <div className="filtered-table-container">
//             <div className="table-content-wrapper">
//                 <div className="table-scroll-container">
//                     <table className="data-table wide-table">
//                         <thead>
//                             <tr>{columns.map(col => <th key={col.key}>{col.header}</th>)}</tr>
//                         </thead>
//                         <tbody>
//                             {sortedInvoices.map((invoice) => {
//                                 const relatedWorkOrder = workOrderMap.get(invoice.wo_id) || {};
//                                 return (
//                                     <tr key={invoice.id}>
//                                         {columns.map(col => {
//                                             let rawValue;
//                                             switch(col.key) {
//                                                 case 'customer_name':
//                                                     rawValue = customerMap.get(invoice.cust_id);
//                                                     break;
//                                                 case 'added_by':
//                                                     rawValue = userMap.get(String(invoice.added_by)) ?? invoice.added_by;
//                                                     break;
//                                                 case 'updated_by':
//                                                     rawValue = userMap.get(String(invoice.updated_by)) ?? invoice.updated_by;
//                                                     break;
//                                                 case 'project_id': case 'project_name': case 'wo_no': case 'wo_date':
//                                                     rawValue = relatedWorkOrder[col.key];
//                                                     break;
//                                                 default:
//                                                     rawValue = invoice[col.key];
//                                             }
                                            
//                                             const cellValue = formatData(rawValue, col.key);
//                                             const rightAlignKeys = ['taxable_amt', 'amount', 'tot_cgst', 'tot_sgst', 'tot_igst', 'cr_period'];
//                                             const shouldRightAlign = rightAlignKeys.includes(col.key);
                                            
//                                             return <td key={col.key} style={{ textAlign: shouldRightAlign ? 'right' : 'left' }}>{cellValue}</td>;
//                                         })}
//                                     </tr>
//                                 );
//                             })}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         </div>
//     );
// };
 
// // ====================================================================
// // --- Component for the Invoices Tab ---
// // ====================================================================
// const InvoiceDashboardContent = ({ invoices, workOrders, loading, error, customerMap, userMap }) => {
//     const today = new Date();
//     const thirtyDaysAgo = new Date(new Date().setDate(today.getDate() - 30));
//     const formatDateForInput = (date) => date.toISOString().split('T')[0];
   
//     const [startDate, setStartDate] = useState(formatDateForInput(thirtyDaysAgo));
//     const [endDate, setEndDate] = useState(formatDateForInput(today));
//     const [selectedStatusFilter, setSelectedStatusFilter] = useState(null);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [dateFilterType, setDateFilterType] = useState('invoiceDate');
//     const tableRef = useRef(null);
//     const statusPieChartRef = useRef(null);

//     // Memoize the work order map for efficiency
//     const workOrderMap = useMemo(() => {
//         const map = new Map();
//         if (Array.isArray(workOrders)) {
//             workOrders.forEach(wo => {
//                 if (wo.wo_id && !map.has(wo.wo_id)) {
//                     map.set(wo.wo_id, wo);
//                 }
//             });
//         }
//         return map;
//     }, [workOrders]);
    
//     // 1. Filter invoices based on the selected date range and filter type
//     const dateFilteredInvoices = useMemo(() => {
//         if (!Array.isArray(invoices) || !startDate || !endDate) return [];
        
//         const rangeStart = new Date(startDate);
//         rangeStart.setHours(0, 0, 0, 0);
//         const rangeEnd = new Date(endDate);
//         rangeEnd.setHours(23, 59, 59, 999);

//         return invoices.filter(inv => {
//             if (dateFilterType === 'invoiceDate') {
//                 const invoiceDate = new Date(inv.inv_date || inv.add_date);
//                 return !isNaN(invoiceDate) && invoiceDate >= rangeStart && invoiceDate <= rangeEnd;
//             } else {
//                 if (!inv.start_date || !inv.end_date) return false;
                
//                 const periodStart = new Date(inv.start_date);
//                 const periodEnd = new Date(inv.end_date);
                
//                 if (isNaN(periodStart.getTime()) || isNaN(periodEnd.getTime())) return false;
                
//                 return periodStart >= rangeStart && periodEnd <= rangeEnd;
//             }
//         });
//     }, [invoices, startDate, endDate, dateFilterType]);
 
//     // This data is used for the charts and KPIs, based on the date-filtered data
//     const dashboardData = useMemo(() => {
//         const EMPTY_CHART_DATA = { labels: [], datasets: [{ data: [] }] };
//         const baseKpis = { totalInvoices: 0, totalTaxable: 0, totalGst: 0, avgCreditPeriod: 0 };

//         if (dateFilteredInvoices.length === 0) {
//             return { kpis: baseKpis, customerData: EMPTY_CHART_DATA, statusPieData: EMPTY_CHART_DATA };
//         }
 
//         const statusCountsForPie = dateFilteredInvoices.reduce((acc, inv) => {
//             const status = inv.current_status || 'Unknown';
//             acc[status] = (acc[status] || 0) + 1;
//             return acc;
//         }, {});

//         const sortedStatusLabels = Object.keys(statusCountsForPie).sort();
        
//         const statusPieData = {
//             labels: sortedStatusLabels,
//             datasets: [{ 
//                 data: sortedStatusLabels.map(label => statusCountsForPie[label]),
//                 backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#F7464A'], 
//                 borderColor: '#fff', 
//                 borderWidth: 2 
//             }]
//         };
        
//         const customerAggregates = dateFilteredInvoices.reduce((acc, inv) => {
//             const customerName = customerMap.get(inv.cust_id) || `Customer ID: ${inv.cust_id}`;
//             acc[customerName] = (acc[customerName] || 0) + (Number(inv.amount) || 0);
//             return acc;
//         }, {});
        
//         const sortedCustomers = Object.entries(customerAggregates)
//             .filter(([, amount]) => amount > 0)
//             .sort(([,a], [,b]) => b - a)
//             .slice(0, 10);
//         const customerData = { 
//             labels: sortedCustomers.map(([name]) => name), 
//             datasets: [{ label: 'Total Invoice Amount', data: sortedCustomers.map(([, amount]) => amount), backgroundColor: 'rgba(153, 102, 255, 0.6)' }] 
//         };
       
//         return {
//             kpis: {
//                 totalInvoices: dateFilteredInvoices.length,
//                 totalTaxable: dateFilteredInvoices.reduce((sum, inv) => sum + (Number(inv.taxable_amt) || 0), 0),
//                 totalGst: dateFilteredInvoices.reduce((sum, inv) => sum + (Number(inv.tot_cgst) || 0) + (Number(inv.tot_sgst) || 0) + (Number(inv.tot_igst) || 0), 0),
//                 avgCreditPeriod: (dateFilteredInvoices.map(inv => Number(inv.cr_period)).filter(p => p > 0).reduce((a, b, _, arr) => a + b / arr.length, 0)).toFixed(2) || 0
//             },
//             customerData, statusPieData
//         };
//     }, [dateFilteredInvoices, customerMap]);
    
//     // 2. Further filter by status from pie chart click
//     const statusFilteredInvoices = useMemo(() => {
//         if (!selectedStatusFilter) return dateFilteredInvoices;
//         return dateFilteredInvoices.filter(invoice => invoice.current_status === selectedStatusFilter);
//     }, [dateFilteredInvoices, selectedStatusFilter]);

//     // 3. Final filter by search term on top of date and status filters
//     const finalFilteredInvoices = useMemo(() => {
//         if (!searchTerm.trim()) return statusFilteredInvoices;
//         const lowercasedFilter = searchTerm.toLowerCase();
//         return statusFilteredInvoices.filter(invoice => {
//             const workOrder = workOrderMap.get(invoice.wo_id) || {};
//             const searchableFields = [
//                 invoice.id, invoice.doc_no, invoice.cust_id, customerMap.get(invoice.cust_id),
//                 invoice.wo_id, workOrder.wo_no, workOrder.project_id, workOrder.project_name,
//                 invoice.inv_approval_status, invoice.current_status,
//                 userMap.get(String(invoice.added_by)), userMap.get(String(invoice.updated_by))
//             ];
//             return searchableFields.some(field => field && String(field).toLowerCase().includes(lowercasedFilter));
//         });
//     }, [statusFilteredInvoices, searchTerm, workOrderMap, customerMap, userMap]);

//     const handleStatusPieClick = (event) => {
//         if (!statusPieChartRef.current) return;
//         const elements = getElementAtEvent(statusPieChartRef.current, event);
//         if (elements.length > 0) {
//             const clickedStatus = dashboardData.statusPieData.labels[elements[0].index];
//             setSelectedStatusFilter(prev => prev === clickedStatus ? null : clickedStatus);
//             setTimeout(() => tableRef.current?.scrollIntoView({ behavior: 'smooth' }), 100);
//         } else {
//             setSelectedStatusFilter(null);
//         }
//     };
    
//     // --- CSV Export Logic ---
//     const convertToCSVAndDownload = (dataToExport, filename) => {
//         if (dataToExport.length === 0) {
//             alert("No data available to export.");
//             return;
//         }

//         const columns = [
//             { header: 'ID', key: 'id' }, { header: 'Doc No', key: 'doc_no' }, { header: 'Customer Name', key: 'customer_name' },
//             { header: 'Customer ID', key: 'cust_id' }, { header: 'Work Order ID', key: 'wo_id' }, { header: 'Work Order No', key: 'wo_no' },
//             { header: 'Work Order Date', key: 'wo_date' }, { header: 'Project Name', key: 'project_name' }, { header: 'Invoice Date', key: 'inv_date' },
//             { header: 'Due Date', key: 'due_date' }, { header: 'Total Amount', key: 'amount' }, { header: 'Current Status', key: 'current_status' },
//             { header: 'Created By', key: 'added_by' }, { header: 'Created Date', key: 'add_date' }, { header: 'Updated By', key: 'updated_by' },
//             { header: 'Updated Date', key: 'update_date' },
//         ];

//         const replacer = (key, value) => value === null ? '' : value;
//         const header = columns.map(c => c.header).join(',');
//         const rows = dataToExport.map(invoice => {
//             const relatedWorkOrder = workOrderMap.get(invoice.wo_id) || {};
//             return columns.map(col => {
//                 let cellData;
//                 switch (col.key) {
//                     case 'customer_name': cellData = customerMap.get(invoice.cust_id) || 'N/A'; break;
//                     case 'added_by': cellData = userMap.get(String(invoice.added_by)) || invoice.added_by || 'N/A'; break;
//                     case 'updated_by': cellData = userMap.get(String(invoice.updated_by)) || invoice.updated_by || 'N/A'; break;
//                     case 'wo_no': case 'wo_date': case 'project_name': cellData = relatedWorkOrder[col.key]; break;
//                     default: cellData = invoice[col.key];
//                 }
//                 const stringValue = JSON.stringify(replacer(col.key, cellData), replacer);
//                 return stringValue.replace(/"/g, '""').replace(/^""|""$/g, '"');
//             }).join(',');
//         });

//         const csv = [header, ...rows].join('\n');
//         const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
//         const link = document.createElement("a");
//         const url = URL.createObjectURL(blob);
//         link.setAttribute("href", url);
//         link.setAttribute("download", `${filename}.csv`);
//         link.style.visibility = 'hidden';
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//     };

//     const handleExportAll = () => convertToCSVAndDownload(statusFilteredInvoices, 'all_invoices_export');
//     const handleExportByFilter = () => convertToCSVAndDownload(finalFilteredInvoices, 'filtered_invoices_export');

//     if (loading) return <div className="loading-error-container"><h2>Loading Invoice Dashboard...</h2></div>;
//     if (error) return <div className="loading-error-container"><h2>Dashboard Error</h2><p>{error}</p></div>;
 
//     const formatCurrency = (value) => new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(value);
//     const pieOptions = { responsive: true, plugins: { legend: { position: 'bottom' }, datalabels: { color: '#fff', font: { weight: 'bold' }, formatter: (value) => (value > 0 ? value : '') } } };
 
//     return (
//         <main className="main-content">
//             <div className="filter-bar">
//                 <div className="filter-group">
//                     <div className="filter-item">
//                         <input type="radio" id="invoiceDate" name="dateFilterType" value="invoiceDate" checked={dateFilterType === 'invoiceDate'} onChange={(e) => setDateFilterType(e.target.value)} />
//                         <label htmlFor="invoiceDate">Invoice Date</label>
//                     </div>
//                     <div className="filter-item">
//                         <input type="radio" id="invoicePeriod" name="dateFilterType" value="invoicePeriod" checked={dateFilterType === 'invoicePeriod'} onChange={(e) => setDateFilterType(e.target.value)} />
//                         <label htmlFor="invoicePeriod">Invoice Period</label>
//                     </div>
//                 </div>
//                 <div className="filter-item"><label htmlFor="start-date">Start Date:</label><input type="date" id="start-date" value={startDate} onChange={(e) => setStartDate(e.target.value)} /></div>
//                 <div className="filter-item"><label htmlFor="end-date">End Date:</label><input type="date" id="end-date" value={endDate} onChange={(e) => setEndDate(e.target.value)} /></div>
//             </div>
           
//             <div className="kpi-grid">
//                 <div className="kpi-card"><h4>Total Invoices</h4><p>{dashboardData.kpis.totalInvoices}</p></div>
//                 <div className="kpi-card"><h4>Total Taxable Amount</h4><p>{formatCurrency(dashboardData.kpis.totalTaxable)}</p></div>
//                 <div className="kpi-card"><h4>Total GST Collected</h4><p>{formatCurrency(dashboardData.kpis.totalGst)}</p></div>
//                 <div className="kpi-card"><h4>Avg. Credit Period</h4><p>{dashboardData.kpis.avgCreditPeriod} Days</p></div>
//             </div>
           
//             <div className="dashboard-grid">
//                 <div className="chart-card large-card">
//                   <h3>Customer Wise Invoices (Top 10 by Amount)</h3>
//                     {dateFilteredInvoices.length > 0 && dashboardData.customerData.labels.length > 0 ? (
//                         <Bar data={dashboardData.customerData} options={{ responsive: true, scales: { y: { beginAtZero: true } } }} />
//                     ) : (
//                         <p className="no-data-message">No customer invoice data with positive amounts for selected date range.</p>
//                     )}
//                 </div>
//                 <div className="chart-card">
//                   <h3>Invoices by Status</h3>
//                    {dateFilteredInvoices.length > 0 ? (
//                         <Pie ref={statusPieChartRef} data={dashboardData.statusPieData} options={pieOptions} onClick={handleStatusPieClick} />
//                     ) : (
//                         <p className="no-data-message">No data available.</p>
//                     )}
//                 </div>
//             </div>

//             <div ref={tableRef} className="invoice-table-section" style={{ marginTop: '2rem' }}>
//                 <div className="table-header with-controls">
//                     <h3>All Invoices {selectedStatusFilter && `(Status: ${selectedStatusFilter})`} {searchTerm && `(Filtered)`}</h3>
//                     <div className="table-actions">
//                         {selectedStatusFilter && (<button onClick={() => setSelectedStatusFilter(null)} className="clear-filters-btn small">Clear Status Filter</button>)}
//                         <input type="text" placeholder="Search invoices..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} className="search-bar" />
//                         <button onClick={handleExportByFilter} className="export-btn">Export by Filter</button>
//                         <button onClick={handleExportAll} className="export-btn">Export All</button>
//                     </div>
//                 </div>
//                 <InvoiceDataTable invoices={finalFilteredInvoices} workOrderMap={workOrderMap} customerMap={customerMap} userMap={userMap} />
//             </div>
//         </main>
//     );
// };
 
// // ====================================================================
// // --- Main Dashboard Component ---
// // ====================================================================
// const Dashboard = () => {
//     const [activeTab, setActiveTab] = useState('workOrder');
//     const [workOrderTableReport, setWorkOrderTableReport] = useState({ columns: [], data: [] });
//     const [invoices, setInvoices] = useState([]);
//     const [customers, setCustomers] = useState([]);
//     const [users, setUsers] = useState([]); 
//     const [filters, setFilters] = useState({});
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
 
//     const API_TOKEN = 'Bearer ' + localStorage.getItem('zTaskAuthToken');
 
//     const handleApiResponse = async (response) => {
//         if (!response.ok) {
//             const errorText = await response.text();
//             throw new Error(`API call to ${response.url} failed with status ${response.status}: ${response.statusText}. Response: ${errorText.substring(0, 200)}`);
//         }
//         return response.json();
//     };
 
//     useEffect(() => {
//         const fetchAllData = async () => {
//             setLoading(true);
//             setError(null);
 
//             const REPORT_API_URL = `${process.env.REACT_APP_REPORTS_API_URL}/api/reports/run`;
//             const INVOICE_API_URL = `${process.env.REACT_APP_NODE_SERVICE_BASE_URL}/invoice/api/invoices/`;
//             const CUSTOMER_API_URL = `${process.env.REACT_APP_NODE_SERVICE_BASE_URL}/api/get-column/customers/name`;
//             const USER_API_URL = `${process.env.REACT_APP_NODE_SERVICE_BASE_URL}/api/get-column/users/name`; 
 
//             const HEADERS = { 'accept': 'application/json', 'Authorization': API_TOKEN };
//             const TABLE_REPORT_BODY = { "report_name": "work_order_table", "module_name": "Workorder" };
           
//             try {
//                 // Check cache first for each data type
//                 const cachedWorkOrders = cache.get(CACHE_KEYS.WORK_ORDERS);
//                 const cachedInvoices = cache.get(CACHE_KEYS.INVOICES);
//                 const cachedCustomers = cache.get(CACHE_KEYS.CUSTOMERS);
//                 const cachedUsers = cache.get(CACHE_KEYS.USERS);

//                 // Build promises array only for non-cached items
//                 const promises = [];
//                 const promiseKeys = [];

//                 if (cachedWorkOrders) {
//                     console.log('Using cached work orders data');
//                     setWorkOrderTableReport(cachedWorkOrders);
//                 } else {
//                     promises.push(fetch(REPORT_API_URL, { method: 'POST', headers: { ...HEADERS, 'Content-Type': 'application/json' }, body: JSON.stringify(TABLE_REPORT_BODY) }).then(handleApiResponse));
//                     promiseKeys.push('workOrders');
//                 }

//                 if (cachedInvoices) {
//                     console.log('Using cached invoices data');
//                     setInvoices(cachedInvoices);
//                 } else {
//                     promises.push(fetch(INVOICE_API_URL, { headers: HEADERS }).then(handleApiResponse));
//                     promiseKeys.push('invoices');
//                 }

//                 if (cachedCustomers) {
//                     console.log('Using cached customers data');
//                     setCustomers(cachedCustomers);
//                 } else {
//                     promises.push(fetch(CUSTOMER_API_URL, { headers: HEADERS }).then(handleApiResponse));
//                     promiseKeys.push('customers');
//                 }

//                 if (cachedUsers) {
//                     console.log('Using cached users data');
//                     setUsers(cachedUsers);
//                 } else {
//                     promises.push(fetch(USER_API_URL, { headers: HEADERS }).then(handleApiResponse));
//                     promiseKeys.push('users');
//                 }

//                 // Fetch only non-cached data
//                 if (promises.length > 0) {
//                     const results = await Promise.all(promises);
                    
//                     results.forEach((data, index) => {
//                         const key = promiseKeys[index];
//                         switch(key) {
//                             case 'workOrders':
//                                 const workOrderData = data && data.columns && data.data ? data : { columns: [], data: [] };
//                                 cache.set(CACHE_KEYS.WORK_ORDERS, workOrderData);
//                                 setWorkOrderTableReport(workOrderData);
//                                 break;
//                             case 'invoices':
//                                 const invoiceData = Array.isArray(data) ? data : [];
//                                 cache.set(CACHE_KEYS.INVOICES, invoiceData);
//                                 setInvoices(invoiceData);
//                                 break;
//                             case 'customers':
//                                 const customerData = Array.isArray(data) ? data : [];
//                                 cache.set(CACHE_KEYS.CUSTOMERS, customerData);
//                                 setCustomers(customerData);
//                                 break;
//                             case 'users':
//                                 const userData = Array.isArray(data) ? data : [];
//                                 cache.set(CACHE_KEYS.USERS, userData);
//                                 setUsers(userData);
//                                 break;
//                         }
//                     });
//                 }

//             } catch (e) {
//                 console.error("Failed to fetch dashboard data:", e);
//                 setError(e.message);
//             } finally {
//                 setLoading(false);
//             }
//         };
//         fetchAllData();
//     }, []);
 
//     const handleChartClick = (filterType, clickedLabel) => setFilters(prev => ({ ...prev, [filterType]: clickedLabel }));
//     const clearFilters = () => setFilters({});
   
//     const customerMap = useMemo(() => {
//         const map = new Map();
//         customers.forEach(customer => map.set(customer.id, customer.value));
//         return map;
//     }, [customers]);

//     const userMap = useMemo(() => {
//         const map = new Map();
//         users.forEach(user => map.set(user.id, user.value));
//         return map;
//     }, [users]);

//     const uniqueWorkOrders = useMemo(() => {
//         if (!Array.isArray(workOrderTableReport.data)) return [];
//         const uniqueWoMap = new Map();
//         workOrderTableReport.data.forEach(order => {
//             if (order.wo_id && !uniqueWoMap.has(order.wo_id)) {
//                 uniqueWoMap.set(order.wo_id, { ...order, tot_value: parseFloat(order.tot_value) || 0 });
//             }
//         });
//         return Array.from(uniqueWoMap.values());
//     }, [workOrderTableReport.data]);
 
//     const statusPieChartData = useMemo(() => {
//         const statusCounts = uniqueWorkOrders.reduce((acc, order) => {
//             acc[order.wo_open_close || 'Unknown'] = (acc[order.wo_open_close || 'Unknown'] || 0) + 1;
//             return acc;
//         }, { 'Open': 0, 'Closed': 0 });
//         return { labels: Object.keys(statusCounts), datasets: [{ data: Object.values(statusCounts), backgroundColor: ['#ff8a80', '#80d8ff'], borderColor: '#ffffff', borderWidth: 3 }] };
//     }, [uniqueWorkOrders]);
 
//     const sectorBarChartData = useMemo(() => {
//         const sectorData = uniqueWorkOrders.reduce((acc, wo) => {
//             const sectorName = wo.sector_name || 'Unknown Sector';
//             acc[sectorName] = acc[sectorName] || { count: 0, totalValue: 0 };
//             acc[sectorName].count++;
//             acc[sectorName].totalValue += wo.tot_value;
//             return acc;
//         }, {});
//         const labels = Object.keys(sectorData).sort();
//         return { labels, datasets: [
//             { label: 'Number of Orders', data: labels.map(l => sectorData[l].count), backgroundColor: 'rgba(255, 159, 64, 0.8)' },
//             { label: 'Total Value', data: labels.map(l => sectorData[l].totalValue), backgroundColor: 'rgba(75, 192, 192, 0.8)' }
//         ] };
//     }, [uniqueWorkOrders]);
   
//     const topCustomersData = useMemo(() => {
//         const customerAggregates = uniqueWorkOrders.reduce((acc, wo) => {
//             acc[wo.customer_name || 'Unknown Customer'] = (acc[wo.customer_name || 'Unknown Customer'] || 0) + wo.tot_value;
//             return acc;
//         }, {});
//         const sortedCustomers = Object.entries(customerAggregates).sort(([, a], [, b]) => b - a).slice(0, 5);
//         return { labels: sortedCustomers.map(([label]) => label), datasets: [{ label: 'Total Order Value', data: sortedCustomers.map(([, value]) => value), backgroundColor: 'rgba(54, 162, 235, 0.8)' }] };
//     }, [uniqueWorkOrders]);
 
//     const filteredWorkOrders = useMemo(() => {
//         if (Object.keys(filters).length === 0) return workOrderTableReport.data || [];
//         const woIdsToKeep = new Set(uniqueWorkOrders
//             .filter(wo => (!filters.status || wo.wo_open_close === filters.status) && (!filters.sector || wo.sector_name === filters.sector) && (!filters.customer || wo.customer_name === filters.customer))
//             .map(wo => wo.wo_id)
//         );
//         return (workOrderTableReport.data || []).filter(order => woIdsToKeep.has(order.wo_id));
//     }, [workOrderTableReport.data, uniqueWorkOrders, filters]);
 
//     return (
//         <div className="dashboard-container">
//             <div className="tabs-container">
//                 <button className={`tab-button ${activeTab === 'workOrder' ? 'active' : ''}`} onClick={() => setActiveTab('workOrder')}>Work Orders</button>
//                 <button className={`tab-button ${activeTab === 'invoice' ? 'active' : ''}`} onClick={() => setActiveTab('invoice')}>Invoices</button>
//             </div>
//             <div className="tab-content">
//                 {activeTab === 'workOrder' && (
//                     <WorkOrderDashboardContent
//                         loading={loading} error={error} statusPieChartData={statusPieChartData}
//                         sectorBarChartData={sectorBarChartData}
//                         topCustomersData={topCustomersData} filteredWorkOrders={filteredWorkOrders}
//                         filters={filters} onChartClick={handleChartClick} onClearFilters={clearFilters}
//                         apiToken={API_TOKEN}
//                     />
//                 )}
//                 {activeTab === 'invoice' && (
//                     <InvoiceDashboardContent 
//                         invoices={invoices} 
//                         workOrders={workOrderTableReport.data}
//                         loading={loading} 
//                         error={error}
//                         customerMap={customerMap}
//                         userMap={userMap}
//                     />
//                 )}
//             </div>
//         </div>
//     );
// };
 
// export default Dashboard;










// import React, { useState, useEffect, useMemo, useRef } from 'react';
// import { Pie, Bar, Doughnut, getElementAtEvent } from 'react-chartjs-2';
// import {
//     Chart as ChartJS,
//     CategoryScale,
//     LinearScale,
//     BarElement,
//     Title,
//     Tooltip,
//     Legend,
//     ArcElement
// } from 'chart.js';
// import ChartDataLabels from 'chartjs-plugin-datalabels';
// import './Dashboard.css';
 
// ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement, ChartDataLabels);

// // --- Cache Configuration ---
// const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes in milliseconds
// const CACHE_KEYS = {
//   WORK_ORDERS: 'work_orders_cache',
//   INVOICES: 'invoices_cache',
//   CUSTOMERS: 'customers_cache',
//   USERS: 'users_cache',
//   ASSETS: 'assets_cache'
// };

// // --- In-Memory Cache Implementation ---
// const cache = {
//   data: {},
  
//   set(key, value) {
//     this.data[key] = {
//       value,
//       timestamp: Date.now()
//     };
//   },
  
//   get(key) {
//     const cached = this.data[key];
//     if (!cached) return null;
    
//     const isExpired = (Date.now() - cached.timestamp) > CACHE_DURATION;
//     if (isExpired) {
//       delete this.data[key];
//       return null;
//     }
    
//     return cached.value;
//   },
  
//   clear(key) {
//     if (key) {
//       delete this.data[key];
//     } else {
//       this.data = {};
//     }
//   },
  
//   clearAll() {
//     this.data = {};
//   }
// };

// // ====================================================================
// // --- Reusable Chart Component with Options ---
// // ====================================================================
// const ChartWithOptions = ({ title, chartType, onChartTypeChange, onExport, onFullScreen, children, cardClassName = '' }) => {
//     const [menuOpen, setMenuOpen] = useState(false);
//     const wrapperRef = useRef(null);
//     const [chartTypeSubMenuOpen, setChartTypeSubMenuOpen] = useState(false);

//     useEffect(() => {
//         function handleClickOutside(event) {
//             if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
//                 setMenuOpen(false);
//                 setChartTypeSubMenuOpen(false);
//             }
//         }
//         document.addEventListener("mousedown", handleClickOutside);
//         return () => document.removeEventListener("mousedown", handleClickOutside);
//     }, [wrapperRef]);

//     const handleTypeChange = (type) => {
//         onChartTypeChange(type);
//         setMenuOpen(false);
//         setChartTypeSubMenuOpen(false);
//     };

//     return (
//         <div className={`chart-card ${cardClassName}`}>
//             <div className="chart-card-header">
//                 <h3>{title}</h3>
//                 <div className="chart-options-wrapper" ref={wrapperRef}>
//                     <button className="chart-options-btn" onClick={() => setMenuOpen(!menuOpen)}>
//                         ⋮
//                     </button>
//                     {menuOpen && (
//                         <div className="chart-options-menu">
//                             <div 
//                                 className="chart-options-menu-item with-submenu"
//                                 onMouseEnter={() => setChartTypeSubMenuOpen(true)}
//                                 onMouseLeave={() => setChartTypeSubMenuOpen(false)}
//                             >
//                                 <span>Graph Type</span>
//                                 <span className="submenu-arrow">▶</span>
//                                 {chartTypeSubMenuOpen && (
//                                     <div className="chart-options-submenu">
//                                         <button className={`submenu-item ${chartType === 'bar' ? 'active' : ''}`} onClick={() => handleTypeChange('bar')}>Bar</button>
//                                         <button className={`submenu-item ${chartType === 'pie' ? 'active' : ''}`} onClick={() => handleTypeChange('pie')}>Pie</button>
//                                         <button className={`submenu-item ${chartType === 'doughnut' ? 'active' : ''}`} onClick={() => handleTypeChange('doughnut')}>Donut</button>
//                                         <button className="submenu-item disabled" title="Not available">Packed Bubble</button>
//                                     </div>
//                                 )}
//                             </div>
//                             <button className="chart-options-menu-item" onClick={onFullScreen}>Full Screen</button>
//                             <button className="chart-options-menu-item" onClick={onExport}>Export</button>
//                         </div>
//                     )}
//                 </div>
//             </div>
//             <div className="chart-content">
//                 {children}
//             </div>
//         </div>
//     );
// };

// // ====================================================================
// // --- Component for Work Order Table ---
// // ====================================================================
// const FilteredWorkOrderTable = ({ workOrders, apiToken }) => {
//     // ... (This component remains unchanged)
//     const [activeTab, setActiveTab] = useState('assets');
//     const [assets, setAssets] = useState([]);
//     const [assetsLoading, setAssetsLoading] = useState(false);
//     const [assetsError, setAssetsError] = useState(null);
 
//     useEffect(() => {
//         const fetchAssets = async () => {
//             if (!workOrders || workOrders.length === 0) {
//                 setAssets([]);
//                 return;
//             }
//             const assetIdSet = new Set(workOrders.map(wo => wo.asset_id).filter(id => id != null));
//             const assetIds = Array.from(assetIdSet);
//             if (assetIds.length === 0) {
//                 setAssets([]);
//                 return;
//             }
           
//             const cacheKey = `${CACHE_KEYS.ASSETS}_${assetIds.sort().join('_')}`;
//             const cached = cache.get(cacheKey);
//             if (cached) {
//                 console.log('Using cached assets data for work orders');
//                 setAssets(cached);
//                 return;
//             }

//             setAssetsLoading(true);
//             setAssetsError(null);
           
//             const ASSET_API_URL = `${process.env.REACT_APP_ASSET_SERVICE_BASE_URL}/api/assets/`;
//             const ASSET_HEADERS = { 'accept': 'application/json', 'Authorization': apiToken };
 
//             try {
//                 const assetPromises = assetIds.map(id =>
//                     fetch(`${ASSET_API_URL}${id}`, { headers: ASSET_HEADERS }).then(res => {
//                         if (!res.ok) {
//                             console.error(`Failed to fetch asset ${id}, status: ${res.status}`);
//                             return null;
//                         }
//                         return res.json();
//                     })
//                 );
//                 const fetchedAssetsResults = await Promise.all(assetPromises);
//                 const validAssets = fetchedAssetsResults.filter(asset => asset !== null);
                
//                 cache.set(cacheKey, validAssets);
//                 setAssets(validAssets);
//             } catch (error) {
//                 console.error("Failed to fetch assets:", error);
//                 setAssetsError(error.message);
//             } finally {
//                 setAssetsLoading(false);
//             }
//         };
//         fetchAssets();
//     }, [workOrders, apiToken]);
 
//     const displayedWorkOrders = useMemo(() => {
//         if (!workOrders || !Array.isArray(workOrders)) return [];
//         return [...workOrders].sort((a, b) => new Date(b.add_date) - new Date(a.add_date));
//     }, [workOrders]);
 
//     const formatData = (value) => {
//         if (value === null || typeof value === 'undefined') return 'N/A';
//         if (typeof value === 'boolean') return value ? 'Yes' : 'No';
//         if (typeof value === 'string' && value.includes('T')) {
//             const date = new Date(value);
//             if (!isNaN(date)) return date.toLocaleDateString('en-GB');
//         }
//         return value;
//     };
 
//     const displayColumns = [
//         { header: 'Doc No', key: 'doc_no' }, { header: 'WO No', key: 'wo_no' },
//         { header: 'Status', key: 'wo_open_close' }, { header: 'Total Value', key: 'tot_value' },
//         { header: 'Customer Name', key: 'customer_name' }, { header: 'Customer ID', key: 'cust_id' },
//         { header: 'Project Name', key: 'project_name' }, { header: 'Project ID', key: 'project_id' },
//         { header: 'Sector Name', key: 'sector_name' }, { header: 'Sector ID', key: 'sector' },
//         { header: 'Asset ID', key: 'asset_id' }, { header: 'WO Date', key: 'wo_date' },
//         { header: 'WO Start', key: 'wo_start' }, { header: 'WO End', key: 'wo_end' },
//     ];
 
//     return (
//         <div className="filtered-table-container">
//             <div className="table-header"><h3>All Work Orders</h3></div>
//             <div className="table-controls">
//                 <div className="tabs">
//                     <button className={`tab-btn ${activeTab === 'assets' ? 'active' : ''}`} onClick={() => setActiveTab('assets')}>Assets</button>
//                     <button className={`tab-btn ${activeTab === 'workorder' ? 'active' : ''}`} onClick={() => setActiveTab('workorder')}>Workorder</button>
//                 </div>
//             </div>
//             <div className="table-content-wrapper">
//                 {activeTab === 'workorder' ? (
//                     <>
//                         {displayedWorkOrders.length > 0 ? (
//                             <div className="table-scroll-container">
//                                 <table className="data-table wide-table">
//                                     <thead><tr>{displayColumns.map(col => <th key={col.key}>{col.header}</th>)}</tr></thead>
//                                     <tbody>
//                                         {displayedWorkOrders.map((order, index) => (
//                                             <tr key={`${order.id}-${index}`}>
//                                                 {displayColumns.map(col => (
//                                                     <td key={col.key}>{col.key === 'tot_value' ? parseFloat(order[col.key] || 0).toLocaleString('en-US') : formatData(order[col.key])}</td>
//                                                 ))}
//                                             </tr>
//                                         ))}
//                                     </tbody>
//                                 </table>
//                             </div>
//                         ) : (<p className="no-data-message">No work orders found for the current filter.</p>)}
//                     </>
//                 ) : (
//                     <>
//                         {assetsLoading && <p className="loading-message">Loading Assets...</p>}
//                         {assetsError && <p className="error-message">Error: {assetsError}</p>}
//                         {!assetsLoading && !assetsError && (
//                             <>
//                                 {assets.length > 0 ? (
//                                     <div className="table-scroll-container">
//                                         <table className="data-table wide-table">
//                                             <thead>
//                                                 <tr><th>Asset Name</th><th>Asset Type</th><th>Capacity (MT)</th><th>Year of Purchase</th><th>Year of Manufacture</th></tr>
//                                             </thead>
//                                             <tbody>
//                                                 {assets.map(asset => {
//                                                     const combinedAssetName = [asset.name, asset.serial_number, asset.asset_code, asset.registration_number].filter(Boolean).join(' | ');
//                                                     return (
//                                                         <tr key={asset.id}>
//                                                             <td>{combinedAssetName || 'N/A'}</td>
//                                                             <td>{formatData(asset.asset_type)}</td>
//                                                             <td>{formatData(asset.capacity_mt)}</td>
//                                                             <td>{formatData(asset.year_of_purchase)}</td>
//                                                             <td>{formatData(asset.year_of_manufacture)}</td>
//                                                         </tr>
//                                                     );
//                                                 })}
//                                             </tbody>
//                                         </table>
//                                     </div>
//                                 ) : (<p className="no-data-message">No assets found for the current work orders.</p>)}
//                             </>
//                         )}
//                     </>
//                 )}
//             </div>
//         </div>
//     );
// };
 
// // ====================================================================
// // --- Component for Asset Availability Table ---
// // ====================================================================
// const AssetAvailabilityTable = ({ workOrders, apiToken }) => {
//     // ... (This component remains unchanged)
//     const [combinedAssets, setCombinedAssets] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);
//     const [filterDays, setFilterDays] = useState(null);
//     const [customDays, setCustomDays] = useState('');
 
//     useEffect(() => {
//         const fetchAndCombineData = async () => {
//             const cached = cache.get(CACHE_KEYS.ASSETS);
//             if (cached && workOrders) {
//                 console.log('Using cached assets data for availability table');
//                 const workOrderInfoMap = new Map();
//                 if (Array.isArray(workOrders)) {
//                     workOrders.forEach(wo => {
//                         if (wo.asset_id != null) {
//                             workOrderInfoMap.set(Number(wo.asset_id), { wo_start: wo.wo_start, wo_end: wo.wo_end, wo_no: wo.wo_no });
//                         }
//                     });
//                 }
                
//                 const activeAssets = cached.filter(asset => asset.active === true);
//                 const combinedData = activeAssets.map(asset => {
//                     const workOrderInfo = workOrderInfoMap.get(asset.id) || { wo_start: null, wo_end: null, wo_no: null };
//                     return { ...asset, ...workOrderInfo };
//                 });
//                 setCombinedAssets(combinedData);
//                 return;
//             }

//             setLoading(true);
//             setError(null);
           
//             const workOrderInfoMap = new Map();
//             if (workOrders && Array.isArray(workOrders)) {
//                 workOrders.forEach(wo => {
//                     if (wo.asset_id != null) {
//                         workOrderInfoMap.set(Number(wo.asset_id), { wo_start: wo.wo_start, wo_end: wo.wo_end, wo_no: wo.wo_no });
//                     }
//                 });
//             }
           
//             const ASSET_API_URL = `${process.env.REACT_APP_ASSET_SERVICE_BASE_URL}/api/assets/`;
//             const ASSET_HEADERS = { 'accept': 'application/json', 'Authorization': apiToken };
 
//             try {
//                 const response = await fetch(ASSET_API_URL, { headers: ASSET_HEADERS });
//                 if (!response.ok) {
//                     throw new Error(`Failed to fetch assets, status: ${response.status}`);
//                 }
//                 const allAssets = await response.json();
                
//                 cache.set(CACHE_KEYS.ASSETS, allAssets);
                
//                 const activeAssets = allAssets.filter(asset => asset.active === true);

//                 const combinedData = activeAssets.map(asset => {
//                     const workOrderInfo = workOrderInfoMap.get(asset.id) || { wo_start: null, wo_end: null, wo_no: null };
//                     return { ...asset, ...workOrderInfo };
//                 });
               
//                 setCombinedAssets(combinedData);
//             } catch (error) {
//                 console.error("Failed to fetch asset data:", error);
//                 setError(error.message);
//             } finally {
//                 setLoading(false);
//             }
//         };
 
//         fetchAndCombineData();
//     }, [workOrders, apiToken]);
 
//     const filteredAssets = useMemo(() => {
//         if (filterDays === null) return combinedAssets;
//         const targetDate = new Date();
//         targetDate.setDate(targetDate.getDate() + filterDays);
//         targetDate.setHours(23, 59, 59, 999);
//         return combinedAssets.filter(asset => {
//             if (!asset.wo_end) return true;
//             const woEndDate = new Date(asset.wo_end);
//             return isNaN(woEndDate.getTime()) || woEndDate <= targetDate;
//         });
//     }, [combinedAssets, filterDays]);
 
//     const formatData = (value) => {
//         if (value === null || typeof value === 'undefined') return 'N/A';
//         if (typeof value === 'boolean') return value ? 'Yes' : 'No';
//         if (typeof value === 'string' && value.includes('T')) {
//             const date = new Date(value);
//             if (!isNaN(date)) return date.toLocaleDateString('en-GB');
//         }
//         return value;
//     };
 
//     const handleCustomFilter = () => {
//         const days = parseInt(customDays, 10);
//         if (days > 0) setFilterDays(days);
//     };
 
//     const clearFilter = () => {
//         setFilterDays(null);
//         setCustomDays('');
//     };
 
//     return (
//         <div className="filtered-table-container">
//             <div className="table-header with-controls">
//                 <h3>Asset Availability</h3>
//                 <div className="availability-filter-controls">
//                     <span>Available In:</span>
//                     {[3, 7, 15, 30].map(days => (
//                         <button key={days} onClick={() => setFilterDays(days)} className={filterDays === days ? 'active' : ''}>{days} Days</button>
//                     ))}
//                     <div className="custom-filter">
//                         <input type="number" placeholder="Custom" value={customDays} onChange={(e) => setCustomDays(e.target.value)} min="1"/>
//                         <button onClick={handleCustomFilter}>Go</button>
//                     </div>
//                     <button onClick={clearFilter}>Clear Filter</button>
//                 </div>
//             </div>
//             <div className="table-content-wrapper">
//                 {loading && <p className="loading-message">Loading Assets...</p>}
//                 {error && <p className="error-message">Error: {error}</p>}
//                 {!loading && !error && (
//                     <>
//                         {filteredAssets.length > 0 ? (
//                             <div className="table-scroll-container">
//                                 <table className="data-table wide-table">
//                                     <thead>
//                                         <tr><th>ID</th><th>Asset Name</th><th>Asset Type</th><th>Capacity (MT)</th><th>Year of Purchase</th><th>Year of Manufacture</th><th>WO No</th><th>WO Start</th><th>WO End</th></tr>
//                                     </thead>
//                                     <tbody>
//                                         {filteredAssets.map(asset => {
//                                             const combinedAssetName = [asset.name, asset.serial_number, asset.asset_code, asset.registration_number].filter(Boolean).join(' | ');
//                                             return (
//                                                 <tr key={asset.id}>
//                                                     <td>{formatData(asset.id)}</td>
//                                                     <td>{combinedAssetName || 'N/A'}</td>
//                                                     <td>{formatData(asset.asset_type)}</td>
//                                                     <td>{formatData(asset.capacity_mt)}</td>
//                                                     <td>{formatData(asset.year_of_purchase)}</td>
//                                                     <td>{formatData(asset.year_of_manufacture)}</td>
//                                                     <td>{formatData(asset.wo_no)}</td>
//                                                     <td>{formatData(asset.wo_start)}</td>
//                                                     <td>{formatData(asset.wo_end)}</td>
//                                                 </tr>
//                                             );
//                                         })}
//                                     </tbody>
//                                 </table>
//                             </div>
//                         ) : (<p className="no-data-message">{filterDays !== null ? "No assets match the current availability filter." : "No active assets found."}</p>)}
//                     </>
//                 )}
//             </div>
//         </div>
//     );
// };
 
// // ====================================================================
// // --- Component for the Work Orders Tab Content ---
// // ====================================================================
// const WorkOrderDashboardContent = ({
//     loading, error, statusPieChartData, sectorBarChartData,
//     topCustomersData, filteredWorkOrders, filters, onChartClick, onClearFilters, apiToken, onSetFullScreen
// }) => {
//     const statusChartRef = useRef();
//     const sectorChartRef = useRef();
//     const customerChartRef = useRef();

//     const [statusChartType, setStatusChartType] = useState('pie');
//     const [sectorChartType, setSectorChartType] = useState('bar');
//     const [customerChartType, setCustomerChartType] = useState('bar');

//     const handleChartClick = (filterType, chartData, event, chartRef) => {
//         if (!chartRef.current) return;
//         const elements = getElementAtEvent(chartRef.current, event);
//         if (elements.length > 0) {
//             const clickedLabel = chartData.labels[elements[0].index];
//             onChartClick(filterType, clickedLabel);
//         }
//     };

//     const handleExport = (chartRef, filename) => {
//         if (!chartRef.current) return;
//         const link = document.createElement('a');
//         link.download = `${filename}.png`;
//         link.href = chartRef.current.toBase64Image();
//         link.click();
//     };

//     const renderChart = (type, data, chartRef, onClick, options) => {
//         switch (type) {
//             case 'bar':
//                 return <Bar ref={chartRef} data={data} options={options} onClick={onClick} />;
//             case 'pie':
//                 return <Pie ref={chartRef} data={data} options={options} onClick={onClick} />;
//             case 'doughnut':
//                 return <Doughnut ref={chartRef} data={data} options={options} onClick={onClick} />;
//             default:
//                 return <p>Invalid chart type specified.</p>;
//         }
//     };
 
//     const hasFilters = Object.keys(filters).length > 0;
   
//     if (loading) return <div className="loading-error-container"><h2>Loading Dashboard...</h2></div>;
//     if (error) return <div className="loading-error-container"><h2>Dashboard Error</h2><p>{error}</p></div>;
 
//     const statusChartOptions = { responsive: true, plugins: { legend: { position: 'top' }, datalabels: { color: '#343a40', font: { weight: 'bold', size: 16 }, formatter: (value) => (value > 0 ? value : null) } } };
//     const barChartOptions = { responsive: true, scales: { y: { beginAtZero: true } } };

//     return (
//         <main className="main-content">
//              <div className="dashboard-title-bar">
//                 <h1 className="dashboard-header">Work Orders Dashboard</h1>
//                 {hasFilters && (<button onClick={onClearFilters} className="clear-filters-btn">Clear Filters</button>)}
//             </div>
//             <div className="dashboard-grid">
//                 <ChartWithOptions
//                     title="Work Orders by Status"
//                     chartType={statusChartType}
//                     onChartTypeChange={setStatusChartType}
//                     onExport={() => handleExport(statusChartRef, 'work-orders-by-status')}
//                     onFullScreen={() => onSetFullScreen(statusPieChartData, statusChartOptions, statusChartType, 'Work Orders by Status')}
//                 >
//                     {renderChart(
//                         statusChartType,
//                         statusPieChartData,
//                         statusChartRef,
//                         (event) => handleChartClick('status', statusPieChartData, event, statusChartRef),
//                         statusChartOptions
//                     )}
//                 </ChartWithOptions>
                
//                 <ChartWithOptions
//                     title="Work Orders by Sector"
//                     chartType={sectorChartType}
//                     onChartTypeChange={setSectorChartType}
//                     onExport={() => handleExport(sectorChartRef, 'work-orders-by-sector')}
//                     onFullScreen={() => onSetFullScreen(sectorBarChartData, barChartOptions, sectorChartType, 'Work Orders by Sector')}
//                 >
//                     {renderChart(
//                         sectorChartType,
//                         sectorBarChartData,
//                         sectorChartRef,
//                         (event) => handleChartClick('sector', sectorBarChartData, event, sectorChartRef),
//                         barChartOptions
//                     )}
//                 </ChartWithOptions>

//                 <ChartWithOptions
//                     title="Top Customers by Order Value"
//                     chartType={customerChartType}
//                     onChartTypeChange={setCustomerChartType}
//                     onExport={() => handleExport(customerChartRef, 'top-customers')}
//                     onFullScreen={() => onSetFullScreen(topCustomersData, barChartOptions, customerChartType, 'Top Customers by Order Value')}
//                 >
//                     {renderChart(
//                         customerChartType,
//                         topCustomersData,
//                         customerChartRef,
//                         (event) => handleChartClick('customer', topCustomersData, event, customerChartRef),
//                         barChartOptions
//                     )}
//                 </ChartWithOptions>

//                 <div className="chart-card table-card">
//                     <FilteredWorkOrderTable workOrders={filteredWorkOrders} apiToken={apiToken} />
//                 </div>
//                 <div className="chart-card table-card">
//                      <AssetAvailabilityTable workOrders={filteredWorkOrders} apiToken={apiToken} />
//                 </div>
//             </div>
//         </main>
//     );
// };

// // ====================================================================
// // --- Component for Invoice Data Table ---
// // ====================================================================
// const InvoiceDataTable = ({ invoices, workOrderMap, customerMap, userMap }) => {
//     // ... (This component remains unchanged)
//     const columns = useMemo(() => [
//         { header: 'ID', key: 'id' }, { header: 'Doc No', key: 'doc_no' },
//         { header: 'Customer Name', key: 'customer_name' }, { header: 'Customer ID', key: 'cust_id' },
//         { header: 'Work Order ID', key: 'wo_id' }, { header: 'Work Order No', key: 'wo_no' },
//         { header: 'Work Order Date', key: 'wo_date' }, { header: 'Project ID', key: 'project_id' },
//         { header: 'Project Name', key: 'project_name' }, { header: 'Invoice Date', key: 'inv_date' },
//         { header: 'Due Date', key: 'due_date' }, { header: 'Start Date', key: 'start_date' },
//         { header: 'End Date', key: 'end_date' }, { header: 'Credit Period', key: 'cr_period' },
//         { header: 'Taxable Amount', key: 'taxable_amt' },
//         { header: 'CGST', key: 'tot_cgst' }, { header: 'SGST', key: 'tot_sgst' },
//         { header: 'IGST', key: 'tot_igst' }, { header: 'Total Amount', key: 'amount' },
//         { header: 'Approval Status', key: 'inv_approval_status' }, { header: 'Current Status', key: 'current_status' },
//         { header: 'Created By', key: 'added_by' },
//         { header: 'Created Date', key: 'add_date' }, { header: 'Updated By', key: 'updated_by' },
//         { header: 'Updated Date', key: 'update_date' },
//     ], []);

//     const formatData = (value, key) => {
//         const currencyKeys = ['taxable_amt', 'amount', 'tot_cgst', 'tot_sgst', 'tot_igst'];

//         if (currencyKeys.includes(key)) {
//             const numberValue = parseFloat(value ?? 0);
//             return numberValue.toLocaleString('en-IN', {
//                 minimumFractionDigits: 2,
//                 maximumFractionDigits: 2,
//             });
//         }

//         if (key === 'cr_period') {
//             return value ?? 0;
//         }

//         if (value === null || typeof value === 'undefined' || value === '') {
//             return '-';
//         }

//         if (key === 'add_date' || key === 'update_date') {
//             const date = new Date(value);
//             return !isNaN(date) ? date.toLocaleString('en-GB') : '-';
//         }

//         if (typeof value === 'string' && (key.includes('date') || key.includes('Date'))) {
//             const date = new Date(value);
//             return !isNaN(date) ? date.toLocaleDateString('en-GB') : '-';
//         }

//         return value;
//     };
    
//     const sortedInvoices = useMemo(() => {
//         if (!Array.isArray(invoices)) return [];
//         return [...invoices].sort((a, b) => new Date(b.inv_date || b.add_date) - new Date(a.inv_date || a.add_date));
//     }, [invoices]);

//     if (sortedInvoices.length === 0) {
//         return (
//             <div className="filtered-table-container">
//                  <p className="no-data-message" style={{ padding: '20px' }}>No invoice data matching the current filter.</p>
//             </div>
//         )
//     }

//     return (
//         <div className="filtered-table-container">
//             <div className="table-content-wrapper">
//                 <div className="table-scroll-container">
//                     <table className="data-table wide-table">
//                         <thead>
//                             <tr>{columns.map(col => <th key={col.key}>{col.header}</th>)}</tr>
//                         </thead>
//                         <tbody>
//                             {sortedInvoices.map((invoice) => {
//                                 const relatedWorkOrder = workOrderMap.get(invoice.wo_id) || {};
//                                 return (
//                                     <tr key={invoice.id}>
//                                         {columns.map(col => {
//                                             let rawValue;
//                                             switch(col.key) {
//                                                 case 'customer_name':
//                                                     rawValue = customerMap.get(invoice.cust_id);
//                                                     break;
//                                                 case 'added_by':
//                                                     rawValue = userMap.get(String(invoice.added_by)) ?? invoice.added_by;
//                                                     break;
//                                                 case 'updated_by':
//                                                     rawValue = userMap.get(String(invoice.updated_by)) ?? invoice.updated_by;
//                                                     break;
//                                                 case 'project_id': case 'project_name': case 'wo_no': case 'wo_date':
//                                                     rawValue = relatedWorkOrder[col.key];
//                                                     break;
//                                                 default:
//                                                     rawValue = invoice[col.key];
//                                             }
                                            
//                                             const cellValue = formatData(rawValue, col.key);
//                                             const rightAlignKeys = ['taxable_amt', 'amount', 'tot_cgst', 'tot_sgst', 'tot_igst', 'cr_period'];
//                                             const shouldRightAlign = rightAlignKeys.includes(col.key);
                                            
//                                             return <td key={col.key} style={{ textAlign: shouldRightAlign ? 'right' : 'left' }}>{cellValue}</td>;
//                                         })}
//                                     </tr>
//                                 );
//                             })}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         </div>
//     );
// };
 
// // ====================================================================
// // --- Component for the Invoices Tab ---
// // ====================================================================
// const InvoiceDashboardContent = ({ invoices, workOrders, loading, error, customerMap, userMap, onSetFullScreen }) => {
//     const today = new Date();
//     const thirtyDaysAgo = new Date(new Date().setDate(today.getDate() - 30));
//     const formatDateForInput = (date) => date.toISOString().split('T')[0];
   
//     const [startDate, setStartDate] = useState(formatDateForInput(thirtyDaysAgo));
//     const [endDate, setEndDate] = useState(formatDateForInput(today));
//     const [selectedStatusFilter, setSelectedStatusFilter] = useState(null);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [dateFilterType, setDateFilterType] = useState('invoiceDate');
//     const tableRef = useRef(null);

//     // Chart-specific states and refs
//     const statusPieChartRef = useRef(null);
//     const customerBarChartRef = useRef(null);
//     const [customerChartType, setCustomerChartType] = useState('bar');
//     const [statusChartType, setStatusChartType] = useState('pie');

//     const workOrderMap = useMemo(() => {
//         const map = new Map();
//         if (Array.isArray(workOrders)) {
//             workOrders.forEach(wo => {
//                 if (wo.wo_id && !map.has(wo.wo_id)) {
//                     map.set(wo.wo_id, wo);
//                 }
//             });
//         }
//         return map;
//     }, [workOrders]);
    
//     const dateFilteredInvoices = useMemo(() => {
//         if (!Array.isArray(invoices) || !startDate || !endDate) return [];
        
//         const rangeStart = new Date(startDate);
//         rangeStart.setHours(0, 0, 0, 0);
//         const rangeEnd = new Date(endDate);
//         rangeEnd.setHours(23, 59, 59, 999);

//         return invoices.filter(inv => {
//             if (dateFilterType === 'invoiceDate') {
//                 const invoiceDate = new Date(inv.inv_date || inv.add_date);
//                 return !isNaN(invoiceDate) && invoiceDate >= rangeStart && invoiceDate <= rangeEnd;
//             } else {
//                 if (!inv.start_date || !inv.end_date) return false;
                
//                 const periodStart = new Date(inv.start_date);
//                 const periodEnd = new Date(inv.end_date);
                
//                 if (isNaN(periodStart.getTime()) || isNaN(periodEnd.getTime())) return false;
                
//                 return periodStart >= rangeStart && periodEnd <= rangeEnd;
//             }
//         });
//     }, [invoices, startDate, endDate, dateFilterType]);
 
//     const dashboardData = useMemo(() => {
//         const EMPTY_CHART_DATA = { labels: [], datasets: [{ data: [] }] };
//         const baseKpis = { totalInvoices: 0, totalTaxable: 0, totalGst: 0, avgCreditPeriod: 0 };

//         if (dateFilteredInvoices.length === 0) {
//             return { kpis: baseKpis, customerData: EMPTY_CHART_DATA, statusPieData: EMPTY_CHART_DATA };
//         }
 
//         const statusCountsForPie = dateFilteredInvoices.reduce((acc, inv) => {
//             const status = inv.current_status || 'Unknown';
//             acc[status] = (acc[status] || 0) + 1;
//             return acc;
//         }, {});

//         const sortedStatusLabels = Object.keys(statusCountsForPie).sort();
        
//         const statusPieData = {
//             labels: sortedStatusLabels,
//             datasets: [{ 
//                 data: sortedStatusLabels.map(label => statusCountsForPie[label]),
//                 backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#F7464A'], 
//                 borderColor: '#fff', 
//                 borderWidth: 2 
//             }]
//         };
        
//         const customerAggregates = dateFilteredInvoices.reduce((acc, inv) => {
//             const customerName = customerMap.get(inv.cust_id) || `Customer ID: ${inv.cust_id}`;
//             acc[customerName] = (acc[customerName] || 0) + (Number(inv.amount) || 0);
//             return acc;
//         }, {});
        
//         const sortedCustomers = Object.entries(customerAggregates)
//             .filter(([, amount]) => amount > 0)
//             .sort(([,a], [,b]) => b - a)
//             .slice(0, 10);
//         const customerData = { 
//             labels: sortedCustomers.map(([name]) => name), 
//             datasets: [{ label: 'Total Invoice Amount', data: sortedCustomers.map(([, amount]) => amount), backgroundColor: 'rgba(153, 102, 255, 0.6)' }] 
//         };
       
//         return {
//             kpis: {
//                 totalInvoices: dateFilteredInvoices.length,
//                 totalTaxable: dateFilteredInvoices.reduce((sum, inv) => sum + (Number(inv.taxable_amt) || 0), 0),
//                 totalGst: dateFilteredInvoices.reduce((sum, inv) => sum + (Number(inv.tot_cgst) || 0) + (Number(inv.tot_sgst) || 0) + (Number(inv.tot_igst) || 0), 0),
//                 avgCreditPeriod: (dateFilteredInvoices.map(inv => Number(inv.cr_period)).filter(p => p > 0).reduce((a, b, _, arr) => a + b / arr.length, 0)).toFixed(2) || 0
//             },
//             customerData, statusPieData
//         };
//     }, [dateFilteredInvoices, customerMap]);
    
//     const statusFilteredInvoices = useMemo(() => {
//         if (!selectedStatusFilter) return dateFilteredInvoices;
//         return dateFilteredInvoices.filter(invoice => invoice.current_status === selectedStatusFilter);
//     }, [dateFilteredInvoices, selectedStatusFilter]);

//     const finalFilteredInvoices = useMemo(() => {
//         if (!searchTerm.trim()) return statusFilteredInvoices;
//         const lowercasedFilter = searchTerm.toLowerCase();
//         return statusFilteredInvoices.filter(invoice => {
//             const workOrder = workOrderMap.get(invoice.wo_id) || {};
//             const searchableFields = [
//                 invoice.id, invoice.doc_no, invoice.cust_id, customerMap.get(invoice.cust_id),
//                 invoice.wo_id, workOrder.wo_no, workOrder.project_id, workOrder.project_name,
//                 invoice.inv_approval_status, invoice.current_status,
//                 userMap.get(String(invoice.added_by)), userMap.get(String(invoice.updated_by))
//             ];
//             return searchableFields.some(field => field && String(field).toLowerCase().includes(lowercasedFilter));
//         });
//     }, [statusFilteredInvoices, searchTerm, workOrderMap, customerMap, userMap]);

//     const handleStatusPieClick = (event) => {
//         if (!statusPieChartRef.current) return;
//         const elements = getElementAtEvent(statusPieChartRef.current, event);
//         if (elements.length > 0) {
//             const clickedStatus = dashboardData.statusPieData.labels[elements[0].index];
//             setSelectedStatusFilter(prev => prev === clickedStatus ? null : clickedStatus);
//             setTimeout(() => tableRef.current?.scrollIntoView({ behavior: 'smooth' }), 100);
//         } else {
//             setSelectedStatusFilter(null);
//         }
//     };
    
//     const convertToCSVAndDownload = (dataToExport, filename) => {
//         if (dataToExport.length === 0) {
//             alert("No data available to export.");
//             return;
//         }

//         const columns = [
//             { header: 'ID', key: 'id' }, { header: 'Doc No', key: 'doc_no' }, { header: 'Customer Name', key: 'customer_name' },
//             { header: 'Customer ID', key: 'cust_id' }, { header: 'Work Order ID', key: 'wo_id' }, { header: 'Work Order No', key: 'wo_no' },
//             { header: 'Work Order Date', key: 'wo_date' }, { header: 'Project Name', key: 'project_name' }, { header: 'Invoice Date', key: 'inv_date' },
//             { header: 'Due Date', key: 'due_date' }, { header: 'Total Amount', key: 'amount' }, { header: 'Current Status', key: 'current_status' },
//             { header: 'Created By', key: 'added_by' }, { header: 'Created Date', key: 'add_date' }, { header: 'Updated By', key: 'updated_by' },
//             { header: 'Updated Date', key: 'update_date' },
//         ];

//         const replacer = (key, value) => value === null ? '' : value;
//         const header = columns.map(c => c.header).join(',');
//         const rows = dataToExport.map(invoice => {
//             const relatedWorkOrder = workOrderMap.get(invoice.wo_id) || {};
//             return columns.map(col => {
//                 let cellData;
//                 switch (col.key) {
//                     case 'customer_name': cellData = customerMap.get(invoice.cust_id) || 'N/A'; break;
//                     case 'added_by': cellData = userMap.get(String(invoice.added_by)) || invoice.added_by || 'N/A'; break;
//                     case 'updated_by': cellData = userMap.get(String(invoice.updated_by)) || invoice.updated_by || 'N/A'; break;
//                     case 'wo_no': case 'wo_date': case 'project_name': cellData = relatedWorkOrder[col.key]; break;
//                     default: cellData = invoice[col.key];
//                 }
//                 const stringValue = JSON.stringify(replacer(col.key, cellData), replacer);
//                 return stringValue.replace(/"/g, '""').replace(/^""|""$/g, '"');
//             }).join(',');
//         });

//         const csv = [header, ...rows].join('\n');
//         const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
//         const link = document.createElement("a");
//         const url = URL.createObjectURL(blob);
//         link.setAttribute("href", url);
//         link.setAttribute("download", `${filename}.csv`);
//         link.style.visibility = 'hidden';
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//     };

//     const handleExportAll = () => convertToCSVAndDownload(statusFilteredInvoices, 'all_invoices_export');
//     const handleExportByFilter = () => convertToCSVAndDownload(finalFilteredInvoices, 'filtered_invoices_export');

//     const handleExportChart = (chartRef, filename) => {
//         if (!chartRef.current) return;
//         const link = document.createElement('a');
//         link.download = `${filename}.png`;
//         link.href = chartRef.current.toBase64Image();
//         link.click();
//     };

//     const renderChart = (type, data, chartRef, onClick, options) => {
//         switch (type) {
//             case 'bar':
//                 return <Bar ref={chartRef} data={data} options={options} onClick={onClick} />;
//             case 'pie':
//                 return <Pie ref={chartRef} data={data} options={options} onClick={onClick} />;
//             case 'doughnut':
//                 return <Doughnut ref={chartRef} data={data} options={options} onClick={onClick} />;
//             default:
//                 return <p>Invalid chart type specified.</p>;
//         }
//     };

//     if (loading) return <div className="loading-error-container"><h2>Loading Invoice Dashboard...</h2></div>;
//     if (error) return <div className="loading-error-container"><h2>Dashboard Error</h2><p>{error}</p></div>;
 
//     const formatCurrency = (value) => new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(value);
//     const pieOptions = { responsive: true, plugins: { legend: { position: 'bottom' }, datalabels: { color: '#fff', font: { weight: 'bold' }, formatter: (value) => (value > 0 ? value : '') } } };
//     const barOptions = { responsive: true, scales: { y: { beginAtZero: true } } };
 
//     return (
//         <main className="main-content">
//             <div className="filter-bar">
//                 <div className="filter-group">
//                     <div className="filter-item">
//                         <input type="radio" id="invoiceDate" name="dateFilterType" value="invoiceDate" checked={dateFilterType === 'invoiceDate'} onChange={(e) => setDateFilterType(e.target.value)} />
//                         <label htmlFor="invoiceDate">Invoice Date</label>
//                     </div>
//                     <div className="filter-item">
//                         <input type="radio" id="invoicePeriod" name="dateFilterType" value="invoicePeriod" checked={dateFilterType === 'invoicePeriod'} onChange={(e) => setDateFilterType(e.target.value)} />
//                         <label htmlFor="invoicePeriod">Invoice Period</label>
//                     </div>
//                 </div>
//                 <div className="filter-item"><label htmlFor="start-date">Start Date:</label><input type="date" id="start-date" value={startDate} onChange={(e) => setStartDate(e.target.value)} /></div>
//                 <div className="filter-item"><label htmlFor="end-date">End Date:</label><input type="date" id="end-date" value={endDate} onChange={(e) => setEndDate(e.target.value)} /></div>
//             </div>
           
//             <div className="kpi-grid">
//                 <div className="kpi-card"><h4>Total Invoices</h4><p>{dashboardData.kpis.totalInvoices}</p></div>
//                 <div className="kpi-card"><h4>Total Taxable Amount</h4><p>{formatCurrency(dashboardData.kpis.totalTaxable)}</p></div>
//                 <div className="kpi-card"><h4>Total GST Collected</h4><p>{formatCurrency(dashboardData.kpis.totalGst)}</p></div>
//                 <div className="kpi-card"><h4>Avg. Credit Period</h4><p>{dashboardData.kpis.avgCreditPeriod} Days</p></div>
//             </div>
           
//             <div className="dashboard-grid">
//                 <ChartWithOptions
//                     title="Customer Wise Invoices (Top 10 by Amount)"
//                     cardClassName="large-card"
//                     chartType={customerChartType}
//                     onChartTypeChange={setCustomerChartType}
//                     onExport={() => handleExportChart(customerBarChartRef, 'customer-invoices')}
//                     onFullScreen={() => onSetFullScreen(dashboardData.customerData, barOptions, customerChartType, 'Customer Wise Invoices')}
//                 >
//                     {dateFilteredInvoices.length > 0 && dashboardData.customerData.labels.length > 0 ? (
//                         renderChart(customerChartType, dashboardData.customerData, customerBarChartRef, null, barOptions)
//                     ) : (
//                         <p className="no-data-message">No customer invoice data with positive amounts for selected date range.</p>
//                     )}
//                 </ChartWithOptions>
                
//                 <ChartWithOptions
//                     title="Invoices by Status"
//                     chartType={statusChartType}
//                     onChartTypeChange={setStatusChartType}
//                     onExport={() => handleExportChart(statusPieChartRef, 'invoices-by-status')}
//                     onFullScreen={() => onSetFullScreen(dashboardData.statusPieData, pieOptions, statusChartType, 'Invoices by Status')}
//                 >
//                    {dateFilteredInvoices.length > 0 ? (
//                         renderChart(statusChartType, dashboardData.statusPieData, statusPieChartRef, handleStatusPieClick, pieOptions)
//                     ) : (
//                         <p className="no-data-message">No data available.</p>
//                     )}
//                 </ChartWithOptions>
//             </div>

//             <div ref={tableRef} className="invoice-table-section" style={{ marginTop: '2rem' }}>
//                 <div className="table-header with-controls">
//                     <h3>All Invoices {selectedStatusFilter && `(Status: ${selectedStatusFilter})`} {searchTerm && `(Filtered)`}</h3>
//                     <div className="table-actions">
//                         {selectedStatusFilter && (<button onClick={() => setSelectedStatusFilter(null)} className="clear-filters-btn small">Clear Status Filter</button>)}
//                         <input type="text" placeholder="Search invoices..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} className="search-bar" />
//                         <button onClick={handleExportByFilter} className="export-btn">Export by Filter</button>
//                         <button onClick={handleExportAll} className="export-btn">Export All</button>
//                     </div>
//                 </div>
//                 <InvoiceDataTable invoices={finalFilteredInvoices} workOrderMap={workOrderMap} customerMap={customerMap} userMap={userMap} />
//             </div>
//         </main>
//     );
// };
 
// // ====================================================================
// // --- Main Dashboard Component ---
// // ====================================================================
// const Dashboard = () => {
//     const [activeTab, setActiveTab] = useState('workOrder');
//     const [workOrderTableReport, setWorkOrderTableReport] = useState({ columns: [], data: [] });
//     const [invoices, setInvoices] = useState([]);
//     const [customers, setCustomers] = useState([]);
//     const [users, setUsers] = useState([]); 
//     const [filters, setFilters] = useState({});
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [fullScreenChart, setFullScreenChart] = useState(null);
 
//     const API_TOKEN = 'Bearer ' + localStorage.getItem('zTaskAuthToken');
 
//     const handleApiResponse = async (response) => {
//         if (!response.ok) {
//             const errorText = await response.text();
//             throw new Error(`API call to ${response.url} failed with status ${response.status}: ${response.statusText}. Response: ${errorText.substring(0, 200)}`);
//         }
//         return response.json();
//     };
 
//     useEffect(() => {
//         const fetchAllData = async () => {
//             setLoading(true);
//             setError(null);
 
//             const REPORT_API_URL = `${process.env.REACT_APP_REPORTS_API_URL}/api/reports/run`;
//             const INVOICE_API_URL = `${process.env.REACT_APP_NODE_SERVICE_BASE_URL}/invoice/api/invoices/`;
//             const CUSTOMER_API_URL = `${process.env.REACT_APP_NODE_SERVICE_BASE_URL}/api/get-column/customers/name`;
//             const USER_API_URL = `${process.env.REACT_APP_NODE_SERVICE_BASE_URL}/api/get-column/users/name`; 
 
//             const HEADERS = { 'accept': 'application/json', 'Authorization': API_TOKEN };
//             const TABLE_REPORT_BODY = { "report_name": "work_order_table", "module_name": "Workorder" };
           
//             try {
//                 const cachedWorkOrders = cache.get(CACHE_KEYS.WORK_ORDERS);
//                 const cachedInvoices = cache.get(CACHE_KEYS.INVOICES);
//                 const cachedCustomers = cache.get(CACHE_KEYS.CUSTOMERS);
//                 const cachedUsers = cache.get(CACHE_KEYS.USERS);

//                 const promises = [];
//                 const promiseKeys = [];

//                 if (cachedWorkOrders) {
//                     setWorkOrderTableReport(cachedWorkOrders);
//                 } else {
//                     promises.push(fetch(REPORT_API_URL, { method: 'POST', headers: { ...HEADERS, 'Content-Type': 'application/json' }, body: JSON.stringify(TABLE_REPORT_BODY) }).then(handleApiResponse));
//                     promiseKeys.push('workOrders');
//                 }

//                 if (cachedInvoices) {
//                     setInvoices(cachedInvoices);
//                 } else {
//                     promises.push(fetch(INVOICE_API_URL, { headers: HEADERS }).then(handleApiResponse));
//                     promiseKeys.push('invoices');
//                 }

//                 if (cachedCustomers) {
//                     setCustomers(cachedCustomers);
//                 } else {
//                     promises.push(fetch(CUSTOMER_API_URL, { headers: HEADERS }).then(handleApiResponse));
//                     promiseKeys.push('customers');
//                 }

//                 if (cachedUsers) {
//                     setUsers(cachedUsers);
//                 } else {
//                     promises.push(fetch(USER_API_URL, { headers: HEADERS }).then(handleApiResponse));
//                     promiseKeys.push('users');
//                 }

//                 if (promises.length > 0) {
//                     const results = await Promise.all(promises);
                    
//                     results.forEach((data, index) => {
//                         const key = promiseKeys[index];
//                         switch(key) {
//                             case 'workOrders':
//                                 const workOrderData = data && data.columns && data.data ? data : { columns: [], data: [] };
//                                 cache.set(CACHE_KEYS.WORK_ORDERS, workOrderData);
//                                 setWorkOrderTableReport(workOrderData);
//                                 break;
//                             case 'invoices':
//                                 const invoiceData = Array.isArray(data) ? data : [];
//                                 cache.set(CACHE_KEYS.INVOICES, invoiceData);
//                                 setInvoices(invoiceData);
//                                 break;
//                             case 'customers':
//                                 const customerData = Array.isArray(data) ? data : [];
//                                 cache.set(CACHE_KEYS.CUSTOMERS, customerData);
//                                 setCustomers(customerData);
//                                 break;
//                             case 'users':
//                                 const userData = Array.isArray(data) ? data : [];
//                                 cache.set(CACHE_KEYS.USERS, userData);
//                                 setUsers(userData);
//                                 break;
//                             default:
//                                 break;
//                         }
//                     });
//                 }

//             } catch (e) {
//                 console.error("Failed to fetch dashboard data:", e);
//                 setError(e.message);
//             } finally {
//                 setLoading(false);
//             }
//         };
//         fetchAllData();
//     }, []);
 
//     const handleChartClick = (filterType, clickedLabel) => setFilters(prev => ({ ...prev, [filterType]: clickedLabel }));
//     const clearFilters = () => setFilters({});
    
//     const handleSetFullScreen = (data, options, type, title) => {
//         setFullScreenChart({ data, options, type, title });
//     };
//     const handleCloseFullScreen = () => setFullScreenChart(null);
   
//     const customerMap = useMemo(() => {
//         const map = new Map();
//         customers.forEach(customer => map.set(customer.id, customer.value));
//         return map;
//     }, [customers]);

//     const userMap = useMemo(() => {
//         const map = new Map();
//         users.forEach(user => map.set(user.id, user.value));
//         return map;
//     }, [users]);

//     const uniqueWorkOrders = useMemo(() => {
//         if (!Array.isArray(workOrderTableReport.data)) return [];
//         const uniqueWoMap = new Map();
//         workOrderTableReport.data.forEach(order => {
//             if (order.wo_id && !uniqueWoMap.has(order.wo_id)) {
//                 uniqueWoMap.set(order.wo_id, { ...order, tot_value: parseFloat(order.tot_value) || 0 });
//             }
//         });
//         return Array.from(uniqueWoMap.values());
//     }, [workOrderTableReport.data]);
 
//     const statusPieChartData = useMemo(() => {
//         const statusCounts = uniqueWorkOrders.reduce((acc, order) => {
//             acc[order.wo_open_close || 'Unknown'] = (acc[order.wo_open_close || 'Unknown'] || 0) + 1;
//             return acc;
//         }, { 'Open': 0, 'Closed': 0 });
//         return { labels: Object.keys(statusCounts), datasets: [{ data: Object.values(statusCounts), backgroundColor: ['#ff8a80', '#80d8ff'], borderColor: '#ffffff', borderWidth: 3 }] };
//     }, [uniqueWorkOrders]);
 
//     const sectorBarChartData = useMemo(() => {
//         const sectorData = uniqueWorkOrders.reduce((acc, wo) => {
//             const sectorName = wo.sector_name || 'Unknown Sector';
//             acc[sectorName] = acc[sectorName] || { count: 0, totalValue: 0 };
//             acc[sectorName].count++;
//             acc[sectorName].totalValue += wo.tot_value;
//             return acc;
//         }, {});
//         const labels = Object.keys(sectorData).sort();
//         return { labels, datasets: [
//             { label: 'Number of Orders', data: labels.map(l => sectorData[l].count), backgroundColor: 'rgba(255, 159, 64, 0.8)' },
//             { label: 'Total Value', data: labels.map(l => sectorData[l].totalValue), backgroundColor: 'rgba(75, 192, 192, 0.8)' }
//         ] };
//     }, [uniqueWorkOrders]);
   
//     const topCustomersData = useMemo(() => {
//         const customerAggregates = uniqueWorkOrders.reduce((acc, wo) => {
//             acc[wo.customer_name || 'Unknown Customer'] = (acc[wo.customer_name || 'Unknown Customer'] || 0) + wo.tot_value;
//             return acc;
//         }, {});
//         const sortedCustomers = Object.entries(customerAggregates).sort(([, a], [, b]) => b - a).slice(0, 5);
//         return { labels: sortedCustomers.map(([label]) => label), datasets: [{ label: 'Total Order Value', data: sortedCustomers.map(([, value]) => value), backgroundColor: 'rgba(54, 162, 235, 0.8)' }] };
//     }, [uniqueWorkOrders]);
 
//     const filteredWorkOrders = useMemo(() => {
//         if (Object.keys(filters).length === 0) return workOrderTableReport.data || [];
//         const woIdsToKeep = new Set(uniqueWorkOrders
//             .filter(wo => (!filters.status || wo.wo_open_close === filters.status) && (!filters.sector || wo.sector_name === filters.sector) && (!filters.customer || wo.customer_name === filters.customer))
//             .map(wo => wo.wo_id)
//         );
//         return (workOrderTableReport.data || []).filter(order => woIdsToKeep.has(order.wo_id));
//     }, [workOrderTableReport.data, uniqueWorkOrders, filters]);
 
//     return (
//         <div className="dashboard-container">
//             <div className="tabs-container">
//                 <button className={`tab-button ${activeTab === 'workOrder' ? 'active' : ''}`} onClick={() => setActiveTab('workOrder')}>Work Orders</button>
//                 <button className={`tab-button ${activeTab === 'invoice' ? 'active' : ''}`} onClick={() => setActiveTab('invoice')}>Invoices</button>
//             </div>
//             <div className="tab-content">
//                 {activeTab === 'workOrder' && (
//                     <WorkOrderDashboardContent
//                         loading={loading} error={error} statusPieChartData={statusPieChartData}
//                         sectorBarChartData={sectorBarChartData}
//                         topCustomersData={topCustomersData} filteredWorkOrders={filteredWorkOrders}
//                         filters={filters} onChartClick={handleChartClick} onClearFilters={clearFilters}
//                         apiToken={API_TOKEN}
//                         onSetFullScreen={handleSetFullScreen}
//                     />
//                 )}
//                 {activeTab === 'invoice' && (
//                     <InvoiceDashboardContent 
//                         invoices={invoices} 
//                         workOrders={workOrderTableReport.data}
//                         loading={loading} 
//                         error={error}
//                         customerMap={customerMap}
//                         userMap={userMap}
//                         onSetFullScreen={handleSetFullScreen}
//                     />
//                 )}
//             </div>

//             {fullScreenChart && (
//                 <div className="fullscreen-modal-overlay" onClick={handleCloseFullScreen}>
//                   <div className="fullscreen-modal-content" onClick={(e) => e.stopPropagation()}>
//                     <button className="fullscreen-modal-close" onClick={handleCloseFullScreen}>&times;</button>
//                     <h3 className="fullscreen-modal-title">{fullScreenChart.title}</h3>
//                     <div className="fullscreen-chart-container">
//                       {fullScreenChart.type === 'bar' && <Bar data={fullScreenChart.data} options={{...fullScreenChart.options, maintainAspectRatio: false}} />}
//                       {fullScreenChart.type === 'pie' && <Pie data={fullScreenChart.data} options={{...fullScreenChart.options, maintainAspectRatio: false}} />}
//                       {fullScreenChart.type === 'doughnut' && <Doughnut data={fullScreenChart.data} options={{...fullScreenChart.options, maintainAspectRatio: false}} />}
//                     </div>
//                   </div>
//                 </div>
//               )}
//         </div>
//     );
// };
 
// export default Dashboard;














import React, { useState, useEffect, useMemo, useRef } from 'react';
import { Pie, Bar, Doughnut, getElementAtEvent } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ArcElement
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import './Dashboard.css';
 
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement, ChartDataLabels);

// --- Cache Configuration ---
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes in milliseconds
const CACHE_KEYS = {
  WORK_ORDERS: 'work_orders_cache',
  ALL_WORK_ORDERS_STATUS: 'all_work_orders_status_cache', // Key for the new unfiltered data
  INVOICES: 'invoices_cache',
  CUSTOMERS: 'customers_cache',
  USERS: 'users_cache',
  ASSETS: 'assets_cache'
};

// --- In-Memory Cache Implementation ---
const cache = {
  data: {},
  
  set(key, value) {
    this.data[key] = {
      value,
      timestamp: Date.now()
    };
  },
  
  get(key) {
    const cached = this.data[key];
    if (!cached) return null;
    
    const isExpired = (Date.now() - cached.timestamp) > CACHE_DURATION;
    if (isExpired) {
      delete this.data[key];
      return null;
    }
    
    return cached.value;
  },
  
  clear(key) {
    if (key) {
      delete this.data[key];
    } else {
      this.data = {};
    }
  },
  
  clearAll() {
    this.data = {};
  }
};

// ====================================================================
// --- Reusable Chart Component with Options ---
// ====================================================================
const ChartWithOptions = ({ title, chartType, onChartTypeChange, onExport, onFullScreen, children, cardClassName = '' }) => {
    const [menuOpen, setMenuOpen] = useState(false);
    const wrapperRef = useRef(null);
    const [chartTypeSubMenuOpen, setChartTypeSubMenuOpen] = useState(false);

    useEffect(() => {
        function handleClickOutside(event) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setMenuOpen(false);
                setChartTypeSubMenuOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [wrapperRef]);

    const handleTypeChange = (type) => {
        onChartTypeChange(type);
        setMenuOpen(false);
        setChartTypeSubMenuOpen(false);
    };

    return (
        <div className={`chart-card ${cardClassName}`}>
            <div className="chart-card-header">
                <h3>{title}</h3>
                <div className="chart-options-wrapper" ref={wrapperRef}>
                    <button className="chart-options-btn" onClick={() => setMenuOpen(!menuOpen)}>
                        ⋮
                    </button>
                    {menuOpen && (
                        <div className="chart-options-menu">
                            <div 
                                className="chart-options-menu-item with-submenu"
                                onMouseEnter={() => setChartTypeSubMenuOpen(true)}
                                onMouseLeave={() => setChartTypeSubMenuOpen(false)}
                            >
                                <span>Graph Type</span>
                                <span className="submenu-arrow">▶</span>
                                {chartTypeSubMenuOpen && (
                                    <div className="chart-options-submenu">
                                        <button className={`submenu-item ${chartType === 'bar' ? 'active' : ''}`} onClick={() => handleTypeChange('bar')}>Bar</button>
                                        <button className={`submenu-item ${chartType === 'pie' ? 'active' : ''}`} onClick={() => handleTypeChange('pie')}>Pie</button>
                                        <button className={`submenu-item ${chartType === 'doughnut' ? 'active' : ''}`} onClick={() => handleTypeChange('doughnut')}>Donut</button>
                                        <button className="submenu-item disabled" title="Not available">Packed Bubble</button>
                                    </div>
                                )}
                            </div>
                            <button className="chart-options-menu-item" onClick={onFullScreen}>Full Screen</button>
                            <button className="chart-options-menu-item" onClick={onExport}>Export</button>
                        </div>
                    )}
                </div>
            </div>
            <div className="chart-content">
                {children}
            </div>
        </div>
    );
};

// ====================================================================
// --- Component for Work Order Table ---
// ====================================================================
const FilteredWorkOrderTable = ({ workOrders, apiToken }) => {
    // ... (This component remains unchanged)
    const [activeTab, setActiveTab] = useState('assets');
    const [assets, setAssets] = useState([]);
    const [assetsLoading, setAssetsLoading] = useState(false);
    const [assetsError, setAssetsError] = useState(null);
 
    useEffect(() => {
        const fetchAssets = async () => {
            if (!workOrders || workOrders.length === 0) {
                setAssets([]);
                return;
            }
            const assetIdSet = new Set(workOrders.map(wo => wo.asset_id).filter(id => id != null));
            const assetIds = Array.from(assetIdSet);
            if (assetIds.length === 0) {
                setAssets([]);
                return;
            }
           
            const cacheKey = `${CACHE_KEYS.ASSETS}_${assetIds.sort().join('_')}`;
            const cached = cache.get(cacheKey);
            if (cached) {
                console.log('Using cached assets data for work orders');
                setAssets(cached);
                return;
            }

            setAssetsLoading(true);
            setAssetsError(null);
           
            const ASSET_API_URL = `${process.env.REACT_APP_ASSET_SERVICE_BASE_URL}/api/assets/`;
            const ASSET_HEADERS = { 'accept': 'application/json', 'Authorization': apiToken };
 
            try {
                const assetPromises = assetIds.map(id =>
                    fetch(`${ASSET_API_URL}${id}`, { headers: ASSET_HEADERS }).then(res => {
                        if (!res.ok) {
                            console.error(`Failed to fetch asset ${id}, status: ${res.status}`);
                            return null;
                        }
                        return res.json();
                    })
                );
                const fetchedAssetsResults = await Promise.all(assetPromises);
                const validAssets = fetchedAssetsResults.filter(asset => asset !== null);
                
                cache.set(cacheKey, validAssets);
                setAssets(validAssets);
            } catch (error) {
                console.error("Failed to fetch assets:", error);
                setAssetsError(error.message);
            } finally {
                setAssetsLoading(false);
            }
        };
        fetchAssets();
    }, [workOrders, apiToken]);
 
    const displayedWorkOrders = useMemo(() => {
        if (!workOrders || !Array.isArray(workOrders)) return [];
        return [...workOrders].sort((a, b) => new Date(b.add_date) - new Date(a.add_date));
    }, [workOrders]);
 
    const formatData = (value) => {
        if (value === null || typeof value === 'undefined') return 'N/A';
        if (typeof value === 'boolean') return value ? 'Yes' : 'No';
        if (typeof value === 'string' && value.includes('T')) {
            const date = new Date(value);
            if (!isNaN(date)) return date.toLocaleDateString('en-GB');
        }
        return value;
    };
 
    const displayColumns = [
        { header: 'Doc No', key: 'doc_no' }, { header: 'WO No', key: 'wo_no' },
        { header: 'Status', key: 'wo_open_close' }, { header: 'Total Value', key: 'tot_value' },
        { header: 'Customer Name', key: 'customer_name' }, { header: 'Customer ID', key: 'cust_id' },
        { header: 'Project Name', key: 'project_name' }, { header: 'Project ID', key: 'project_id' },
        { header: 'Sector Name', key: 'sector_name' }, { header: 'Sector ID', key: 'sector' },
        { header: 'Asset ID', key: 'asset_id' }, { header: 'WO Date', key: 'wo_date' },
        { header: 'WO Start', key: 'wo_start' }, { header: 'WO End', key: 'wo_end' },
    ];
 
    return (
        <div className="filtered-table-container">
            <div className="table-header"><h3>All Work Orders</h3></div>
            <div className="table-controls">
                <div className="tabs">
                    <button className={`tab-btn ${activeTab === 'assets' ? 'active' : ''}`} onClick={() => setActiveTab('assets')}>Assets</button>
                    <button className={`tab-btn ${activeTab === 'workorder' ? 'active' : ''}`} onClick={() => setActiveTab('workorder')}>Workorder</button>
                </div>
            </div>
            <div className="table-content-wrapper">
                {activeTab === 'workorder' ? (
                    <>
                        {displayedWorkOrders.length > 0 ? (
                            <div className="table-scroll-container">
                                <table className="data-table wide-table">
                                    <thead><tr>{displayColumns.map(col => <th key={col.key}>{col.header}</th>)}</tr></thead>
                                    <tbody>
                                        {displayedWorkOrders.map((order, index) => (
                                            <tr key={`${order.id}-${index}`}>
                                                {displayColumns.map(col => (
                                                    <td key={col.key}>{col.key === 'tot_value' ? parseFloat(order[col.key] || 0).toLocaleString('en-US') : formatData(order[col.key])}</td>
                                                ))}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : (<p className="no-data-message">No work orders found for the current filter.</p>)}
                    </>
                ) : (
                    <>
                        {assetsLoading && <p className="loading-message">Loading Assets...</p>}
                        {assetsError && <p className="error-message">Error: {assetsError}</p>}
                        {!assetsLoading && !assetsError && (
                            <>
                                {assets.length > 0 ? (
                                    <div className="table-scroll-container">
                                        <table className="data-table wide-table">
                                            <thead>
                                                <tr><th>Asset Name</th><th>Asset Type</th><th>Capacity (MT)</th><th>Year of Purchase</th><th>Year of Manufacture</th></tr>
                                            </thead>
                                            <tbody>
                                                {assets.map(asset => {
                                                    const combinedAssetName = [asset.name, asset.serial_number, asset.asset_code, asset.registration_number].filter(Boolean).join(' | ');
                                                    return (
                                                        <tr key={asset.id}>
                                                            <td>{combinedAssetName || 'N/A'}</td>
                                                            <td>{formatData(asset.asset_type)}</td>
                                                            <td>{formatData(asset.capacity_mt)}</td>
                                                            <td>{formatData(asset.year_of_purchase)}</td>
                                                            <td>{formatData(asset.year_of_manufacture)}</td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : (<p className="no-data-message">No assets found for the current work orders.</p>)}
                            </>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};
 
// ====================================================================
// --- Component for Asset Availability Table ---
// ====================================================================
const AssetAvailabilityTable = ({ workOrders, apiToken }) => {
    // ... (This component remains unchanged)
    const [combinedAssets, setCombinedAssets] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [filterDays, setFilterDays] = useState(null);
    const [customDays, setCustomDays] = useState('');
 
    useEffect(() => {
        const fetchAndCombineData = async () => {
            const cached = cache.get(CACHE_KEYS.ASSETS);
            if (cached && workOrders) {
                console.log('Using cached assets data for availability table');
                const workOrderInfoMap = new Map();
                if (Array.isArray(workOrders)) {
                    workOrders.forEach(wo => {
                        if (wo.asset_id != null) {
                            workOrderInfoMap.set(Number(wo.asset_id), { wo_start: wo.wo_start, wo_end: wo.wo_end, wo_no: wo.wo_no });
                        }
                    });
                }
                
                const activeAssets = cached.filter(asset => asset.active === true);
                const combinedData = activeAssets.map(asset => {
                    const workOrderInfo = workOrderInfoMap.get(asset.id) || { wo_start: null, wo_end: null, wo_no: null };
                    return { ...asset, ...workOrderInfo };
                });
                setCombinedAssets(combinedData);
                return;
            }

            setLoading(true);
            setError(null);
           
            const workOrderInfoMap = new Map();
            if (workOrders && Array.isArray(workOrders)) {
                workOrders.forEach(wo => {
                    if (wo.asset_id != null) {
                        workOrderInfoMap.set(Number(wo.asset_id), { wo_start: wo.wo_start, wo_end: wo.wo_end, wo_no: wo.wo_no });
                    }
                });
            }
           
            const ASSET_API_URL = `${process.env.REACT_APP_ASSET_SERVICE_BASE_URL}/api/assets/`;
            const ASSET_HEADERS = { 'accept': 'application/json', 'Authorization': apiToken };
 
            try {
                const response = await fetch(ASSET_API_URL, { headers: ASSET_HEADERS });
                if (!response.ok) {
                    throw new Error(`Failed to fetch assets, status: ${response.status}`);
                }
                const allAssets = await response.json();
                
                cache.set(CACHE_KEYS.ASSETS, allAssets);
                
                const activeAssets = allAssets.filter(asset => asset.active === true);

                const combinedData = activeAssets.map(asset => {
                    const workOrderInfo = workOrderInfoMap.get(asset.id) || { wo_start: null, wo_end: null, wo_no: null };
                    return { ...asset, ...workOrderInfo };
                });
               
                setCombinedAssets(combinedData);
            } catch (error) {
                console.error("Failed to fetch asset data:", error);
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };
 
        fetchAndCombineData();
    }, [workOrders, apiToken]);
 
    const filteredAssets = useMemo(() => {
        if (filterDays === null) return combinedAssets;
        const targetDate = new Date();
        targetDate.setDate(targetDate.getDate() + filterDays);
        targetDate.setHours(23, 59, 59, 999);
        return combinedAssets.filter(asset => {
            if (!asset.wo_end) return true;
            const woEndDate = new Date(asset.wo_end);
            return isNaN(woEndDate.getTime()) || woEndDate <= targetDate;
        });
    }, [combinedAssets, filterDays]);
 
    const formatData = (value) => {
        if (value === null || typeof value === 'undefined') return 'N/A';
        if (typeof value === 'boolean') return value ? 'Yes' : 'No';
        if (typeof value === 'string' && value.includes('T')) {
            const date = new Date(value);
            if (!isNaN(date)) return date.toLocaleDateString('en-GB');
        }
        return value;
    };
 
    const handleCustomFilter = () => {
        const days = parseInt(customDays, 10);
        if (days > 0) setFilterDays(days);
    };
 
    const clearFilter = () => {
        setFilterDays(null);
        setCustomDays('');
    };
 
    return (
        <div className="filtered-table-container">
            <div className="table-header with-controls">
                <h3>Asset Availability</h3>
                <div className="availability-filter-controls">
                    <span>Available In:</span>
                    {[3, 7, 15, 30].map(days => (
                        <button key={days} onClick={() => setFilterDays(days)} className={filterDays === days ? 'active' : ''}>{days} Days</button>
                    ))}
                    <div className="custom-filter">
                        <input type="number" placeholder="Custom" value={customDays} onChange={(e) => setCustomDays(e.target.value)} min="1"/>
                        <button onClick={handleCustomFilter}>Go</button>
                    </div>
                    <button onClick={clearFilter}>Clear Filter</button>
                </div>
            </div>
            <div className="table-content-wrapper">
                {loading && <p className="loading-message">Loading Assets...</p>}
                {error && <p className="error-message">Error: {error}</p>}
                {!loading && !error && (
                    <>
                        {filteredAssets.length > 0 ? (
                            <div className="table-scroll-container">
                                <table className="data-table wide-table">
                                    <thead>
                                        <tr><th>ID</th><th>Asset Name</th><th>Asset Type</th><th>Capacity (MT)</th><th>Year of Purchase</th><th>Year of Manufacture</th><th>WO No</th><th>WO Start</th><th>WO End</th></tr>
                                    </thead>
                                    <tbody>
                                        {filteredAssets.map(asset => {
                                            const combinedAssetName = [asset.name, asset.serial_number, asset.asset_code, asset.registration_number].filter(Boolean).join(' | ');
                                            return (
                                                <tr key={asset.id}>
                                                    <td>{formatData(asset.id)}</td>
                                                    <td>{combinedAssetName || 'N/A'}</td>
                                                    <td>{formatData(asset.asset_type)}</td>
                                                    <td>{formatData(asset.capacity_mt)}</td>
                                                    <td>{formatData(asset.year_of_purchase)}</td>
                                                    <td>{formatData(asset.year_of_manufacture)}</td>
                                                    <td>{formatData(asset.wo_no)}</td>
                                                    <td>{formatData(asset.wo_start)}</td>
                                                    <td>{formatData(asset.wo_end)}</td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        ) : (<p className="no-data-message">{filterDays !== null ? "No assets match the current availability filter." : "No active assets found."}</p>)}
                    </>
                )}
            </div>
        </div>
    );
};
 
// ====================================================================
// --- Component for the Work Orders Tab Content ---
// ====================================================================
const WorkOrderDashboardContent = ({
    loading, error, statusPieChartData, sectorBarChartData,
    topCustomersData, filteredWorkOrders, filters, onChartClick, onClearFilters, apiToken, onSetFullScreen
}) => {
    const statusChartRef = useRef();
    const sectorChartRef = useRef();
    const customerChartRef = useRef();

    const [statusChartType, setStatusChartType] = useState('pie');
    const [sectorChartType, setSectorChartType] = useState('bar');
    const [customerChartType, setCustomerChartType] = useState('bar');

    const handleChartClick = (filterType, chartData, event, chartRef) => {
        if (!chartRef.current) return;
        const elements = getElementAtEvent(chartRef.current, event);
        if (elements.length > 0) {
            const clickedLabel = chartData.labels[elements[0].index];
            onChartClick(filterType, clickedLabel);
        }
    };

    const handleExport = (chartRef, filename) => {
        if (!chartRef.current) return;
        const link = document.createElement('a');
        link.download = `${filename}.png`;
        link.href = chartRef.current.toBase64Image();
        link.click();
    };

    const renderChart = (type, data, chartRef, onClick, options) => {
        switch (type) {
            case 'bar':
                return <Bar ref={chartRef} data={data} options={options} onClick={onClick} />;
            case 'pie':
                return <Pie ref={chartRef} data={data} options={options} onClick={onClick} />;
            case 'doughnut':
                return <Doughnut ref={chartRef} data={data} options={options} onClick={onClick} />;
            default:
                return <p>Invalid chart type specified.</p>;
        }
    };
 
    const hasFilters = Object.keys(filters).length > 0;
   
    if (loading) return <div className="loading-error-container"><h2>Loading Dashboard...</h2></div>;
    if (error) return <div className="loading-error-container"><h2>Dashboard Error</h2><p>{error}</p></div>;
 
    const statusChartOptions = { responsive: true, plugins: { legend: { position: 'top' }, datalabels: { color: '#343a40', font: { weight: 'bold', size: 16 }, formatter: (value) => (value > 0 ? value : null) } } };
    const barChartOptions = { responsive: true, scales: { y: { beginAtZero: true } } };

    return (
        <main className="main-content">
             <div className="dashboard-title-bar">
                <h1 className="dashboard-header">Work Orders Dashboard</h1>
                {hasFilters && (<button onClick={onClearFilters} className="clear-filters-btn">Clear Filters</button>)}
            </div>
            <div className="dashboard-grid">
                <ChartWithOptions
                    title="Work Orders by Status"
                    chartType={statusChartType}
                    onChartTypeChange={setStatusChartType}
                    onExport={() => handleExport(statusChartRef, 'work-orders-by-status')}
                    onFullScreen={() => onSetFullScreen(statusPieChartData, statusChartOptions, statusChartType, 'Work Orders by Status')}
                >
                    {renderChart(
                        statusChartType,
                        statusPieChartData,
                        statusChartRef,
                        (event) => handleChartClick('status', statusPieChartData, event, statusChartRef),
                        statusChartOptions
                    )}
                </ChartWithOptions>
                
                <ChartWithOptions
                    title="Work Orders by Sector"
                    chartType={sectorChartType}
                    onChartTypeChange={setSectorChartType}
                    onExport={() => handleExport(sectorChartRef, 'work-orders-by-sector')}
                    onFullScreen={() => onSetFullScreen(sectorBarChartData, barChartOptions, sectorChartType, 'Work Orders by Sector')}
                >
                    {renderChart(
                        sectorChartType,
                        sectorBarChartData,
                        sectorChartRef,
                        (event) => handleChartClick('sector', sectorBarChartData, event, sectorChartRef),
                        barChartOptions
                    )}
                </ChartWithOptions>

                <ChartWithOptions
                    title="Top Customers by Order Value"
                    chartType={customerChartType}
                    onChartTypeChange={setCustomerChartType}
                    onExport={() => handleExport(customerChartRef, 'top-customers')}
                    onFullScreen={() => onSetFullScreen(topCustomersData, barChartOptions, customerChartType, 'Top Customers by Order Value')}
                >
                    {renderChart(
                        customerChartType,
                        topCustomersData,
                        customerChartRef,
                        (event) => handleChartClick('customer', topCustomersData, event, customerChartRef),
                        barChartOptions
                    )}
                </ChartWithOptions>

                <div className="chart-card table-card">
                    <FilteredWorkOrderTable workOrders={filteredWorkOrders} apiToken={apiToken} />
                </div>
                <div className="chart-card table-card">
                     <AssetAvailabilityTable workOrders={filteredWorkOrders} apiToken={apiToken} />
                </div>
            </div>
        </main>
    );
};

// ====================================================================
// --- Component for Invoice Data Table ---
// ====================================================================
const InvoiceDataTable = ({ invoices, workOrderMap, customerMap, userMap }) => {
    // ... (This component remains unchanged)
    const columns = useMemo(() => [
        { header: 'ID', key: 'id' }, { header: 'Doc No', key: 'doc_no' },
        { header: 'Customer Name', key: 'customer_name' }, { header: 'Customer ID', key: 'cust_id' },
        { header: 'Work Order ID', key: 'wo_id' }, { header: 'Work Order No', key: 'wo_no' },
        { header: 'Work Order Date', key: 'wo_date' }, { header: 'Project ID', key: 'project_id' },
        { header: 'Project Name', key: 'project_name' }, { header: 'Invoice Date', key: 'inv_date' },
        { header: 'Due Date', key: 'due_date' }, { header: 'Start Date', key: 'start_date' },
        { header: 'End Date', key: 'end_date' }, { header: 'Credit Period', key: 'cr_period' },
        { header: 'Taxable Amount', key: 'taxable_amt' },
        { header: 'CGST', key: 'tot_cgst' }, { header: 'SGST', key: 'tot_sgst' },
        { header: 'IGST', key: 'tot_igst' }, { header: 'Total Amount', key: 'amount' },
        { header: 'Approval Status', key: 'inv_approval_status' }, { header: 'Current Status', key: 'current_status' },
        { header: 'Created By', key: 'added_by' },
        { header: 'Created Date', key: 'add_date' }, { header: 'Updated By', key: 'updated_by' },
        { header: 'Updated Date', key: 'update_date' },
    ], []);

    const formatData = (value, key) => {
        const currencyKeys = ['taxable_amt', 'amount', 'tot_cgst', 'tot_sgst', 'tot_igst'];

        if (currencyKeys.includes(key)) {
            const numberValue = parseFloat(value ?? 0);
            return numberValue.toLocaleString('en-IN', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
        }

        if (key === 'cr_period') {
            return value ?? 0;
        }

        if (value === null || typeof value === 'undefined' || value === '') {
            return '-';
        }

        if (key === 'add_date' || key === 'update_date') {
            const date = new Date(value);
            return !isNaN(date) ? date.toLocaleString('en-GB') : '-';
        }

        if (typeof value === 'string' && (key.includes('date') || key.includes('Date'))) {
            const date = new Date(value);
            return !isNaN(date) ? date.toLocaleDateString('en-GB') : '-';
        }

        return value;
    };
    
    const sortedInvoices = useMemo(() => {
        if (!Array.isArray(invoices)) return [];
        return [...invoices].sort((a, b) => new Date(b.inv_date || b.add_date) - new Date(a.inv_date || a.add_date));
    }, [invoices]);

    if (sortedInvoices.length === 0) {
        return (
            <div className="filtered-table-container">
                 <p className="no-data-message" style={{ padding: '20px' }}>No invoice data matching the current filter.</p>
            </div>
        )
    }

    return (
        <div className="filtered-table-container">
            <div className="table-content-wrapper">
                <div className="table-scroll-container">
                    <table className="data-table wide-table">
                        <thead>
                            <tr>{columns.map(col => <th key={col.key}>{col.header}</th>)}</tr>
                        </thead>
                        <tbody>
                            {sortedInvoices.map((invoice) => {
                                const relatedWorkOrder = workOrderMap.get(invoice.wo_id) || {};
                                return (
                                    <tr key={invoice.id}>
                                        {columns.map(col => {
                                            let rawValue;
                                            switch(col.key) {
                                                case 'customer_name':
                                                    rawValue = customerMap.get(invoice.cust_id);
                                                    break;
                                                case 'added_by':
                                                    rawValue = userMap.get(String(invoice.added_by)) ?? invoice.added_by;
                                                    break;
                                                case 'updated_by':
                                                    rawValue = userMap.get(String(invoice.updated_by)) ?? invoice.updated_by;
                                                    break;
                                                case 'project_id': case 'project_name': case 'wo_no': case 'wo_date':
                                                    rawValue = relatedWorkOrder[col.key];
                                                    break;
                                                default:
                                                    rawValue = invoice[col.key];
                                            }
                                            
                                            const cellValue = formatData(rawValue, col.key);
                                            const rightAlignKeys = ['taxable_amt', 'amount', 'tot_cgst', 'tot_sgst', 'tot_igst', 'cr_period'];
                                            const shouldRightAlign = rightAlignKeys.includes(col.key);
                                            
                                            return <td key={col.key} style={{ textAlign: shouldRightAlign ? 'right' : 'left' }}>{cellValue}</td>;
                                        })}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};
 
// ====================================================================
// --- Component for the Invoices Tab ---
// ====================================================================
const InvoiceDashboardContent = ({ invoices, workOrders, loading, error, customerMap, userMap, onSetFullScreen }) => {
    // ... (This component remains unchanged)
    const today = new Date();
    const thirtyDaysAgo = new Date(new Date().setDate(today.getDate() - 30));
    const formatDateForInput = (date) => date.toISOString().split('T')[0];
   
    const [startDate, setStartDate] = useState(formatDateForInput(thirtyDaysAgo));
    const [endDate, setEndDate] = useState(formatDateForInput(today));
    const [selectedStatusFilter, setSelectedStatusFilter] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [dateFilterType, setDateFilterType] = useState('invoiceDate');
    const tableRef = useRef(null);

    // Chart-specific states and refs
    const statusPieChartRef = useRef(null);
    const customerBarChartRef = useRef(null);
    const [customerChartType, setCustomerChartType] = useState('bar');
    const [statusChartType, setStatusChartType] = useState('pie');

    const workOrderMap = useMemo(() => {
        const map = new Map();
        if (Array.isArray(workOrders)) {
            workOrders.forEach(wo => {
                if (wo.wo_id && !map.has(wo.wo_id)) {
                    map.set(wo.wo_id, wo);
                }
            });
        }
        return map;
    }, [workOrders]);
    
    const dateFilteredInvoices = useMemo(() => {
        if (!Array.isArray(invoices) || !startDate || !endDate) return [];
        
        const rangeStart = new Date(startDate);
        rangeStart.setHours(0, 0, 0, 0);
        const rangeEnd = new Date(endDate);
        rangeEnd.setHours(23, 59, 59, 999);

        return invoices.filter(inv => {
            if (dateFilterType === 'invoiceDate') {
                const invoiceDate = new Date(inv.inv_date || inv.add_date);
                return !isNaN(invoiceDate) && invoiceDate >= rangeStart && invoiceDate <= rangeEnd;
            } else {
                if (!inv.start_date || !inv.end_date) return false;
                
                const periodStart = new Date(inv.start_date);
                const periodEnd = new Date(inv.end_date);
                
                if (isNaN(periodStart.getTime()) || isNaN(periodEnd.getTime())) return false;
                
                return periodStart >= rangeStart && periodEnd <= rangeEnd;
            }
        });
    }, [invoices, startDate, endDate, dateFilterType]);
 
    const dashboardData = useMemo(() => {
        const EMPTY_CHART_DATA = { labels: [], datasets: [{ data: [] }] };
        const baseKpis = { totalInvoices: 0, totalTaxable: 0, totalGst: 0, avgCreditPeriod: 0 };

        if (dateFilteredInvoices.length === 0) {
            return { kpis: baseKpis, customerData: EMPTY_CHART_DATA, statusPieData: EMPTY_CHART_DATA };
        }
 
        const statusCountsForPie = dateFilteredInvoices.reduce((acc, inv) => {
            const status = inv.current_status || 'Unknown';
            acc[status] = (acc[status] || 0) + 1;
            return acc;
        }, {});

        const sortedStatusLabels = Object.keys(statusCountsForPie).sort();
        
        const statusPieData = {
            labels: sortedStatusLabels,
            datasets: [{ 
                data: sortedStatusLabels.map(label => statusCountsForPie[label]),
                backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#F7464A'], 
                borderColor: '#fff', 
                borderWidth: 2 
            }]
        };
        
        const customerAggregates = dateFilteredInvoices.reduce((acc, inv) => {
            const customerName = customerMap.get(inv.cust_id) || `Customer ID: ${inv.cust_id}`;
            acc[customerName] = (acc[customerName] || 0) + (Number(inv.amount) || 0);
            return acc;
        }, {});
        
        const sortedCustomers = Object.entries(customerAggregates)
            .filter(([, amount]) => amount > 0)
            .sort(([,a], [,b]) => b - a)
            .slice(0, 10);
        const customerData = { 
            labels: sortedCustomers.map(([name]) => name), 
            datasets: [{ label: 'Total Invoice Amount', data: sortedCustomers.map(([, amount]) => amount), backgroundColor: 'rgba(153, 102, 255, 0.6)' }] 
        };
       
        return {
            kpis: {
                totalInvoices: dateFilteredInvoices.length,
                totalTaxable: dateFilteredInvoices.reduce((sum, inv) => sum + (Number(inv.taxable_amt) || 0), 0),
                totalGst: dateFilteredInvoices.reduce((sum, inv) => sum + (Number(inv.tot_cgst) || 0) + (Number(inv.tot_sgst) || 0) + (Number(inv.tot_igst) || 0), 0),
                avgCreditPeriod: (dateFilteredInvoices.map(inv => Number(inv.cr_period)).filter(p => p > 0).reduce((a, b, _, arr) => a + b / arr.length, 0)).toFixed(2) || 0
            },
            customerData, statusPieData
        };
    }, [dateFilteredInvoices, customerMap]);
    
    const statusFilteredInvoices = useMemo(() => {
        if (!selectedStatusFilter) return dateFilteredInvoices;
        return dateFilteredInvoices.filter(invoice => invoice.current_status === selectedStatusFilter);
    }, [dateFilteredInvoices, selectedStatusFilter]);

    const finalFilteredInvoices = useMemo(() => {
        if (!searchTerm.trim()) return statusFilteredInvoices;
        const lowercasedFilter = searchTerm.toLowerCase();
        return statusFilteredInvoices.filter(invoice => {
            const workOrder = workOrderMap.get(invoice.wo_id) || {};
            const searchableFields = [
                invoice.id, invoice.doc_no, invoice.cust_id, customerMap.get(invoice.cust_id),
                invoice.wo_id, workOrder.wo_no, workOrder.project_id, workOrder.project_name,
                invoice.inv_approval_status, invoice.current_status,
                userMap.get(String(invoice.added_by)), userMap.get(String(invoice.updated_by))
            ];
            return searchableFields.some(field => field && String(field).toLowerCase().includes(lowercasedFilter));
        });
    }, [statusFilteredInvoices, searchTerm, workOrderMap, customerMap, userMap]);

    const handleStatusPieClick = (event) => {
        if (!statusPieChartRef.current) return;
        const elements = getElementAtEvent(statusPieChartRef.current, event);
        if (elements.length > 0) {
            const clickedStatus = dashboardData.statusPieData.labels[elements[0].index];
            setSelectedStatusFilter(prev => prev === clickedStatus ? null : clickedStatus);
            setTimeout(() => tableRef.current?.scrollIntoView({ behavior: 'smooth' }), 100);
        } else {
            setSelectedStatusFilter(null);
        }
    };
    
    const convertToCSVAndDownload = (dataToExport, filename) => {
        if (dataToExport.length === 0) {
            alert("No data available to export.");
            return;
        }

        const columns = [
            { header: 'ID', key: 'id' }, { header: 'Doc No', key: 'doc_no' }, { header: 'Customer Name', key: 'customer_name' },
            { header: 'Customer ID', key: 'cust_id' }, { header: 'Work Order ID', key: 'wo_id' }, { header: 'Work Order No', key: 'wo_no' },
            { header: 'Work Order Date', key: 'wo_date' }, { header: 'Project Name', key: 'project_name' }, { header: 'Invoice Date', key: 'inv_date' },
            { header: 'Due Date', key: 'due_date' }, { header: 'Total Amount', key: 'amount' }, { header: 'Current Status', key: 'current_status' },
            { header: 'Created By', key: 'added_by' }, { header: 'Created Date', key: 'add_date' }, { header: 'Updated By', key: 'updated_by' },
            { header: 'Updated Date', key: 'update_date' },
        ];

        const replacer = (key, value) => value === null ? '' : value;
        const header = columns.map(c => c.header).join(',');
        const rows = dataToExport.map(invoice => {
            const relatedWorkOrder = workOrderMap.get(invoice.wo_id) || {};
            return columns.map(col => {
                let cellData;
                switch (col.key) {
                    case 'customer_name': cellData = customerMap.get(invoice.cust_id) || 'N/A'; break;
                    case 'added_by': cellData = userMap.get(String(invoice.added_by)) || invoice.added_by || 'N/A'; break;
                    case 'updated_by': cellData = userMap.get(String(invoice.updated_by)) || invoice.updated_by || 'N/A'; break;
                    case 'wo_no': case 'wo_date': case 'project_name': cellData = relatedWorkOrder[col.key]; break;
                    default: cellData = invoice[col.key];
                }
                const stringValue = JSON.stringify(replacer(col.key, cellData), replacer);
                return stringValue.replace(/"/g, '""').replace(/^""|""$/g, '"');
            }).join(',');
        });

        const csv = [header, ...rows].join('\n');
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", `${filename}.csv`);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleExportAll = () => convertToCSVAndDownload(statusFilteredInvoices, 'all_invoices_export');
    const handleExportByFilter = () => convertToCSVAndDownload(finalFilteredInvoices, 'filtered_invoices_export');

    const handleExportChart = (chartRef, filename) => {
        if (!chartRef.current) return;
        const link = document.createElement('a');
        link.download = `${filename}.png`;
        link.href = chartRef.current.toBase64Image();
        link.click();
    };

    const renderChart = (type, data, chartRef, onClick, options) => {
        switch (type) {
            case 'bar':
                return <Bar ref={chartRef} data={data} options={options} onClick={onClick} />;
            case 'pie':
                return <Pie ref={chartRef} data={data} options={options} onClick={onClick} />;
            case 'doughnut':
                return <Doughnut ref={chartRef} data={data} options={options} onClick={onClick} />;
            default:
                return <p>Invalid chart type specified.</p>;
        }
    };

    if (loading) return <div className="loading-error-container"><h2>Loading Invoice Dashboard...</h2></div>;
    if (error) return <div className="loading-error-container"><h2>Dashboard Error</h2><p>{error}</p></div>;
 
    const formatCurrency = (value) => new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(value);
    const pieOptions = { responsive: true, plugins: { legend: { position: 'bottom' }, datalabels: { color: '#fff', font: { weight: 'bold' }, formatter: (value) => (value > 0 ? value : '') } } };
    const barOptions = { responsive: true, scales: { y: { beginAtZero: true } } };
 
    return (
        <main className="main-content">
            <div className="filter-bar">
                <div className="filter-group">
                    <div className="filter-item">
                        <input type="radio" id="invoiceDate" name="dateFilterType" value="invoiceDate" checked={dateFilterType === 'invoiceDate'} onChange={(e) => setDateFilterType(e.target.value)} />
                        <label htmlFor="invoiceDate">Invoice Date</label>
                    </div>
                    <div className="filter-item">
                        <input type="radio" id="invoicePeriod" name="dateFilterType" value="invoicePeriod" checked={dateFilterType === 'invoicePeriod'} onChange={(e) => setDateFilterType(e.target.value)} />
                        <label htmlFor="invoicePeriod">Invoice Period</label>
                    </div>
                </div>
                <div className="filter-item"><label htmlFor="start-date">Start Date:</label><input type="date" id="start-date" value={startDate} onChange={(e) => setStartDate(e.target.value)} /></div>
                <div className="filter-item"><label htmlFor="end-date">End Date:</label><input type="date" id="end-date" value={endDate} onChange={(e) => setEndDate(e.target.value)} /></div>
            </div>
           
            <div className="kpi-grid">
                <div className="kpi-card"><h4>Total Invoices</h4><p>{dashboardData.kpis.totalInvoices}</p></div>
                <div className="kpi-card"><h4>Total Taxable Amount</h4><p>{formatCurrency(dashboardData.kpis.totalTaxable)}</p></div>
                <div className="kpi-card"><h4>Total GST Collected</h4><p>{formatCurrency(dashboardData.kpis.totalGst)}</p></div>
                <div className="kpi-card"><h4>Avg. Credit Period</h4><p>{dashboardData.kpis.avgCreditPeriod} Days</p></div>
            </div>
           
            <div className="dashboard-grid">
                <ChartWithOptions
                    title="Customer Wise Invoices (Top 10 by Amount)"
                    cardClassName="large-card"
                    chartType={customerChartType}
                    onChartTypeChange={setCustomerChartType}
                    onExport={() => handleExportChart(customerBarChartRef, 'customer-invoices')}
                    onFullScreen={() => onSetFullScreen(dashboardData.customerData, barOptions, customerChartType, 'Customer Wise Invoices')}
                >
                    {dateFilteredInvoices.length > 0 && dashboardData.customerData.labels.length > 0 ? (
                        renderChart(customerChartType, dashboardData.customerData, customerBarChartRef, null, barOptions)
                    ) : (
                        <p className="no-data-message">No customer invoice data with positive amounts for selected date range.</p>
                    )}
                </ChartWithOptions>
                
                <ChartWithOptions
                    title="Invoices by Status"
                    chartType={statusChartType}
                    onChartTypeChange={setStatusChartType}
                    onExport={() => handleExportChart(statusPieChartRef, 'invoices-by-status')}
                    onFullScreen={() => onSetFullScreen(dashboardData.statusPieData, pieOptions, statusChartType, 'Invoices by Status')}
                >
                   {dateFilteredInvoices.length > 0 ? (
                        renderChart(statusChartType, dashboardData.statusPieData, statusPieChartRef, handleStatusPieClick, pieOptions)
                    ) : (
                        <p className="no-data-message">No data available.</p>
                    )}
                </ChartWithOptions>
            </div>

            <div ref={tableRef} className="invoice-table-section" style={{ marginTop: '2rem' }}>
                <div className="table-header with-controls">
                    <h3>All Invoices {selectedStatusFilter && `(Status: ${selectedStatusFilter})`} {searchTerm && `(Filtered)`}</h3>
                    <div className="table-actions">
                        {selectedStatusFilter && (<button onClick={() => setSelectedStatusFilter(null)} className="clear-filters-btn small">Clear Status Filter</button>)}
                        <input type="text" placeholder="Search invoices..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} className="search-bar" />
                        <button onClick={handleExportByFilter} className="export-btn">Export by Filter</button>
                        <button onClick={handleExportAll} className="export-btn">Export All</button>
                    </div>
                </div>
                <InvoiceDataTable invoices={finalFilteredInvoices} workOrderMap={workOrderMap} customerMap={customerMap} userMap={userMap} />
            </div>
        </main>
    );
};
 
// ====================================================================
// --- Main Dashboard Component ---
// ====================================================================
const Dashboard = () => {
    const [activeTab, setActiveTab] = useState('workOrder');
    const [workOrderTableReport, setWorkOrderTableReport] = useState({ columns: [], data: [] });
    // START: Added state for the new data source
    const [allWorkOrdersForStatusChart, setAllWorkOrdersForStatusChart] = useState([]);
    // END: Added state for the new data source
    const [invoices, setInvoices] = useState([]);
    const [customers, setCustomers] = useState([]);
    const [users, setUsers] = useState([]); 
    const [filters, setFilters] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [fullScreenChart, setFullScreenChart] = useState(null);
 
    const API_TOKEN = 'Bearer ' + localStorage.getItem('zTaskAuthToken');
 
    const handleApiResponse = async (response) => {
        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`API call to ${response.url} failed with status ${response.status}: ${response.statusText}. Response: ${errorText.substring(0, 200)}`);
        }
        return response.json();
    };
 
    useEffect(() => {
        const fetchAllData = async () => {
            setLoading(true);
            setError(null);
 
            const REPORT_API_URL = `${process.env.REACT_APP_REPORTS_API_URL}/api/reports/run`;
            // START: Added URL for the new API
            const ALL_WORK_ORDERS_API_URL = `${process.env.REACT_APP_NODE_SERVICE_BASE_URL}/work-order/api/work-orders/`;
            // END: Added URL for the new API
            const INVOICE_API_URL = `${process.env.REACT_APP_NODE_SERVICE_BASE_URL}/invoice/api/invoices/`;
            const CUSTOMER_API_URL = `${process.env.REACT_APP_NODE_SERVICE_BASE_URL}/api/get-column/customers/name`;
            const USER_API_URL = `${process.env.REACT_APP_NODE_SERVICE_BASE_URL}/api/get-column/users/name`; 
 
            const HEADERS = { 'accept': 'application/json', 'Authorization': API_TOKEN };
            const TABLE_REPORT_BODY = { "report_name": "work_order_table", "module_name": "Workorder" };
           
            try {
                const cachedWorkOrders = cache.get(CACHE_KEYS.WORK_ORDERS);
                const cachedAllWorkOrdersStatus = cache.get(CACHE_KEYS.ALL_WORK_ORDERS_STATUS);
                const cachedInvoices = cache.get(CACHE_KEYS.INVOICES);
                const cachedCustomers = cache.get(CACHE_KEYS.CUSTOMERS);
                const cachedUsers = cache.get(CACHE_KEYS.USERS);

                const promises = [];
                const promiseKeys = [];

                if (cachedWorkOrders) {
                    setWorkOrderTableReport(cachedWorkOrders);
                } else {
                    promises.push(fetch(REPORT_API_URL, { method: 'POST', headers: { ...HEADERS, 'Content-Type': 'application/json' }, body: JSON.stringify(TABLE_REPORT_BODY) }).then(handleApiResponse));
                    promiseKeys.push('workOrders');
                }
                
                // START: Added fetch logic for the new API
                if (cachedAllWorkOrdersStatus) {
                    setAllWorkOrdersForStatusChart(cachedAllWorkOrdersStatus);
                } else {
                    promises.push(fetch(ALL_WORK_ORDERS_API_URL, { headers: HEADERS }).then(handleApiResponse));
                    promiseKeys.push('allWorkOrdersStatus');
                }
                // END: Added fetch logic for the new API

                if (cachedInvoices) {
                    setInvoices(cachedInvoices);
                } else {
                    promises.push(fetch(INVOICE_API_URL, { headers: HEADERS }).then(handleApiResponse));
                    promiseKeys.push('invoices');
                }

                if (cachedCustomers) {
                    setCustomers(cachedCustomers);
                } else {
                    promises.push(fetch(CUSTOMER_API_URL, { headers: HEADERS }).then(handleApiResponse));
                    promiseKeys.push('customers');
                }

                if (cachedUsers) {
                    setUsers(cachedUsers);
                } else {
                    promises.push(fetch(USER_API_URL, { headers: HEADERS }).then(handleApiResponse));
                    promiseKeys.push('users');
                }

                if (promises.length > 0) {
                    const results = await Promise.all(promises);
                    
                    results.forEach((data, index) => {
                        const key = promiseKeys[index];
                        switch(key) {
                            case 'workOrders':
                                const workOrderData = data && data.columns && data.data ? data : { columns: [], data: [] };
                                cache.set(CACHE_KEYS.WORK_ORDERS, workOrderData);
                                setWorkOrderTableReport(workOrderData);
                                break;
                            // START: Added response handler for the new API
                            case 'allWorkOrdersStatus':
                                const allWoData = Array.isArray(data) ? data : [];
                                cache.set(CACHE_KEYS.ALL_WORK_ORDERS_STATUS, allWoData);
                                setAllWorkOrdersForStatusChart(allWoData);
                                break;
                            // END: Added response handler for the new API
                            case 'invoices':
                                const invoiceData = Array.isArray(data) ? data : [];
                                cache.set(CACHE_KEYS.INVOICES, invoiceData);
                                setInvoices(invoiceData);
                                break;
                            case 'customers':
                                const customerData = Array.isArray(data) ? data : [];
                                cache.set(CACHE_KEYS.CUSTOMERS, customerData);
                                setCustomers(customerData);
                                break;
                            case 'users':
                                const userData = Array.isArray(data) ? data : [];
                                cache.set(CACHE_KEYS.USERS, userData);
                                setUsers(userData);
                                break;
                            default:
                                break;
                        }
                    });
                }

            } catch (e) {
                console.error("Failed to fetch dashboard data:", e);
                setError(e.message);
            } finally {
                setLoading(false);
            }
        };
        fetchAllData();
    }, [API_TOKEN]); // Removed API_TOKEN from dependency array to avoid re-fetch on token change during session
 
    const handleChartClick = (filterType, clickedLabel) => setFilters(prev => ({ ...prev, [filterType]: clickedLabel }));
    const clearFilters = () => setFilters({});
    
    const handleSetFullScreen = (data, options, type, title) => {
        setFullScreenChart({ data, options, type, title });
    };
    const handleCloseFullScreen = () => setFullScreenChart(null);
   
    const customerMap = useMemo(() => {
        const map = new Map();
        customers.forEach(customer => map.set(customer.id, customer.value));
        return map;
    }, [customers]);

    const userMap = useMemo(() => {
        const map = new Map();
        users.forEach(user => map.set(user.id, user.value));
        return map;
    }, [users]);

    const uniqueWorkOrders = useMemo(() => {
        if (!Array.isArray(workOrderTableReport.data)) return [];
        const uniqueWoMap = new Map();
        workOrderTableReport.data.forEach(order => {
            if (order.wo_id && !uniqueWoMap.has(order.wo_id)) {
                uniqueWoMap.set(order.wo_id, { ...order, tot_value: parseFloat(order.tot_value) || 0 });
            }
        });
        return Array.from(uniqueWoMap.values());
    }, [workOrderTableReport.data]);
 
    // START: Updated logic for the status pie chart
    const statusPieChartData = useMemo(() => {
        const labels = ['Open', 'Closed'];
        const statusCounts = allWorkOrdersForStatusChart.reduce((acc, order) => {
            const status = order.wo_open_close;
            if (status === 'Open') {
                acc.Open++;
            } else if (status === 'Closed') {
                acc.Closed++;
            }
            return acc;
        }, { 'Open': 0, 'Closed': 0 });
        
        return {
            labels: labels,
            datasets: [{
                data: labels.map(label => statusCounts[label]),
                backgroundColor: ['#80d8ff', '#ff8a80'], // Open = blue, Closed = red
                borderColor: '#ffffff',
                borderWidth: 3
            }]
        };
    }, [allWorkOrdersForStatusChart]);
    // END: Updated logic for the status pie chart
 
    const sectorBarChartData = useMemo(() => {
        const sectorData = uniqueWorkOrders.reduce((acc, wo) => {
            const sectorName = wo.sector_name || 'Unknown Sector';
            acc[sectorName] = acc[sectorName] || { count: 0, totalValue: 0 };
            acc[sectorName].count++;
            acc[sectorName].totalValue += wo.tot_value;
            return acc;
        }, {});
        const labels = Object.keys(sectorData).sort();
        return { labels, datasets: [
            { label: 'Number of Orders', data: labels.map(l => sectorData[l].count), backgroundColor: 'rgba(255, 159, 64, 0.8)' },
            { label: 'Total Value', data: labels.map(l => sectorData[l].totalValue), backgroundColor: 'rgba(75, 192, 192, 0.8)' }
        ] };
    }, [uniqueWorkOrders]);
   
    const topCustomersData = useMemo(() => {
        const customerAggregates = uniqueWorkOrders.reduce((acc, wo) => {
            acc[wo.customer_name || 'Unknown Customer'] = (acc[wo.customer_name || 'Unknown Customer'] || 0) + wo.tot_value;
            return acc;
        }, {});
        const sortedCustomers = Object.entries(customerAggregates).sort(([, a], [, b]) => b - a).slice(0, 5);
        return { labels: sortedCustomers.map(([label]) => label), datasets: [{ label: 'Total Order Value', data: sortedCustomers.map(([, value]) => value), backgroundColor: 'rgba(54, 162, 235, 0.8)' }] };
    }, [uniqueWorkOrders]);
 
    const filteredWorkOrders = useMemo(() => {
        if (Object.keys(filters).length === 0) return workOrderTableReport.data || [];
        const woIdsToKeep = new Set(uniqueWorkOrders
            .filter(wo => (!filters.status || wo.wo_open_close === filters.status) && (!filters.sector || wo.sector_name === filters.sector) && (!filters.customer || wo.customer_name === filters.customer))
            .map(wo => wo.wo_id)
        );
        return (workOrderTableReport.data || []).filter(order => woIdsToKeep.has(order.wo_id));
    }, [workOrderTableReport.data, uniqueWorkOrders, filters]);
 
    return (
        <div className="dashboard-container">
            <div className="tabs-container">
                <button className={`tab-button ${activeTab === 'workOrder' ? 'active' : ''}`} onClick={() => setActiveTab('workOrder')}>Work Orders</button>
                <button className={`tab-button ${activeTab === 'invoice' ? 'active' : ''}`} onClick={() => setActiveTab('invoice')}>Invoices</button>
            </div>
            <div className="tab-content">
                {activeTab === 'workOrder' && (
                    <WorkOrderDashboardContent
                        loading={loading} error={error} statusPieChartData={statusPieChartData}
                        sectorBarChartData={sectorBarChartData}
                        topCustomersData={topCustomersData} filteredWorkOrders={filteredWorkOrders}
                        filters={filters} onChartClick={handleChartClick} onClearFilters={clearFilters}
                        apiToken={API_TOKEN}
                        onSetFullScreen={handleSetFullScreen}
                    />
                )}
                {activeTab === 'invoice' && (
                    <InvoiceDashboardContent 
                        invoices={invoices} 
                        workOrders={workOrderTableReport.data}
                        loading={loading} 
                        error={error}
                        customerMap={customerMap}
                        userMap={userMap}
                        onSetFullScreen={handleSetFullScreen}
                    />
                )}
            </div>

            {fullScreenChart && (
                <div className="fullscreen-modal-overlay" onClick={handleCloseFullScreen}>
                  <div className="fullscreen-modal-content" onClick={(e) => e.stopPropagation()}>
                    <button className="fullscreen-modal-close" onClick={handleCloseFullScreen}>&times;</button>
                    <h3 className="fullscreen-modal-title">{fullScreenChart.title}</h3>
                    <div className="fullscreen-chart-container">
                      {fullScreenChart.type === 'bar' && <Bar data={fullScreenChart.data} options={{...fullScreenChart.options, maintainAspectRatio: false}} />}
                      {fullScreenChart.type === 'pie' && <Pie data={fullScreenChart.data} options={{...fullScreenChart.options, maintainAspectRatio: false}} />}
                      {fullScreenChart.type === 'doughnut' && <Doughnut data={fullScreenChart.data} options={{...fullScreenChart.options, maintainAspectRatio: false}} />}
                    </div>
                  </div>
                </div>
              )}
        </div>
    );
};
 
export default Dashboard;
